import { jsx as pt } from "react/jsx-runtime";
import Ps, { createElement as _e, isValidElement as Ds, cloneElement as Fa, Children as qi, Fragment as $i, createContext as Gi, useContext as Ia, useCallback as Wi, useState as La, useRef as Ma, useEffect as dt, useMemo as Ki, forwardRef as lt, memo as ct } from "react";
import { unstable_batchedUpdates as Yi } from "react-dom";
const A = (s) => typeof s == "string", Xe = () => {
  let s, e;
  const a = new Promise((t, i) => {
    s = t, e = i;
  });
  return a.resolve = s, a.reject = e, a;
}, Bt = (s) => s == null ? "" : "" + s, Qi = (s, e, a) => {
  s.forEach((t) => {
    e[t] && (a[t] = e[t]);
  });
}, Ji = /###/g, jt = (s) => s && s.indexOf("###") > -1 ? s.replace(Ji, ".") : s, zt = (s) => !s || A(s), es = (s, e, a) => {
  const t = A(e) ? e.split(".") : e;
  let i = 0;
  for (; i < t.length - 1; ) {
    if (zt(s)) return {};
    const n = jt(t[i]);
    !s[n] && a && (s[n] = new a()), Object.prototype.hasOwnProperty.call(s, n) ? s = s[n] : s = {}, ++i;
  }
  return zt(s) ? {} : {
    obj: s,
    k: jt(t[i])
  };
}, qt = (s, e, a) => {
  const {
    obj: t,
    k: i
  } = es(s, e, Object);
  if (t !== void 0 || e.length === 1) {
    t[i] = a;
    return;
  }
  let n = e[e.length - 1], o = e.slice(0, e.length - 1), r = es(s, o, Object);
  for (; r.obj === void 0 && o.length; )
    n = `${o[o.length - 1]}.${n}`, o = o.slice(0, o.length - 1), r = es(s, o, Object), r != null && r.obj && typeof r.obj[`${r.k}.${n}`] < "u" && (r.obj = void 0);
  r.obj[`${r.k}.${n}`] = a;
}, Xi = (s, e, a, t) => {
  const {
    obj: i,
    k: n
  } = es(s, e, Object);
  i[n] = i[n] || [], i[n].push(a);
}, Ns = (s, e) => {
  const {
    obj: a,
    k: t
  } = es(s, e);
  if (a && Object.prototype.hasOwnProperty.call(a, t))
    return a[t];
}, Zi = (s, e, a) => {
  const t = Ns(s, a);
  return t !== void 0 ? t : Ns(e, a);
}, Va = (s, e, a) => {
  for (const t in e)
    t !== "__proto__" && t !== "constructor" && (t in s ? A(s[t]) || s[t] instanceof String || A(e[t]) || e[t] instanceof String ? a && (s[t] = e[t]) : Va(s[t], e[t], a) : s[t] = e[t]);
  return s;
}, Ve = (s) => s.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var en = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const sn = (s) => A(s) ? s.replace(/[&<>"'\/]/g, (e) => en[e]) : s;
class tn {
  constructor(e) {
    this.capacity = e, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(e) {
    const a = this.regExpMap.get(e);
    if (a !== void 0)
      return a;
    const t = new RegExp(e);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(e, t), this.regExpQueue.push(e), t;
  }
}
const an = [" ", ",", "?", "!", ";"], nn = new tn(20), on = (s, e, a) => {
  e = e || "", a = a || "";
  const t = an.filter((o) => e.indexOf(o) < 0 && a.indexOf(o) < 0);
  if (t.length === 0) return !0;
  const i = nn.getRegExp(`(${t.map((o) => o === "?" ? "\\?" : o).join("|")})`);
  let n = !i.test(s);
  if (!n) {
    const o = s.indexOf(a);
    o > 0 && !i.test(s.substring(0, o)) && (n = !0);
  }
  return n;
}, mt = (s, e, a = ".") => {
  if (!s) return;
  if (s[e])
    return Object.prototype.hasOwnProperty.call(s, e) ? s[e] : void 0;
  const t = e.split(a);
  let i = s;
  for (let n = 0; n < t.length; ) {
    if (!i || typeof i != "object")
      return;
    let o, r = "";
    for (let p = n; p < t.length; ++p)
      if (p !== n && (r += a), r += t[p], o = i[r], o !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof o) > -1 && p < t.length - 1)
          continue;
        n += p - n + 1;
        break;
      }
    i = o;
  }
  return i;
}, ts = (s) => s == null ? void 0 : s.replace("_", "-"), rn = {
  type: "logger",
  log(s) {
    this.output("log", s);
  },
  warn(s) {
    this.output("warn", s);
  },
  error(s) {
    this.output("error", s);
  },
  output(s, e) {
    var a, t;
    (t = (a = console == null ? void 0 : console[s]) == null ? void 0 : a.apply) == null || t.call(a, console, e);
  }
};
class Os {
  constructor(e, a = {}) {
    this.init(e, a);
  }
  init(e, a = {}) {
    this.prefix = a.prefix || "i18next:", this.logger = e || rn, this.options = a, this.debug = a.debug;
  }
  log(...e) {
    return this.forward(e, "log", "", !0);
  }
  warn(...e) {
    return this.forward(e, "warn", "", !0);
  }
  error(...e) {
    return this.forward(e, "error", "");
  }
  deprecate(...e) {
    return this.forward(e, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(e, a, t, i) {
    return i && !this.debug ? null : (A(e[0]) && (e[0] = `${t}${this.prefix} ${e[0]}`), this.logger[a](e));
  }
  create(e) {
    return new Os(this.logger, {
      prefix: `${this.prefix}:${e}:`,
      ...this.options
    });
  }
  clone(e) {
    return e = e || this.options, e.prefix = e.prefix || this.prefix, new Os(this.logger, e);
  }
}
var ce = new Os();
class Us {
  constructor() {
    this.observers = {};
  }
  on(e, a) {
    return e.split(" ").forEach((t) => {
      this.observers[t] || (this.observers[t] = /* @__PURE__ */ new Map());
      const i = this.observers[t].get(a) || 0;
      this.observers[t].set(a, i + 1);
    }), this;
  }
  off(e, a) {
    if (this.observers[e]) {
      if (!a) {
        delete this.observers[e];
        return;
      }
      this.observers[e].delete(a);
    }
  }
  emit(e, ...a) {
    this.observers[e] && Array.from(this.observers[e].entries()).forEach(([i, n]) => {
      for (let o = 0; o < n; o++)
        i(...a);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach(([i, n]) => {
      for (let o = 0; o < n; o++)
        i.apply(i, [e, ...a]);
    });
  }
}
class $t extends Us {
  constructor(e, a = {
    ns: ["translation"],
    defaultNS: "translation"
  }) {
    super(), this.data = e || {}, this.options = a, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(e) {
    this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
  }
  removeNamespaces(e) {
    const a = this.options.ns.indexOf(e);
    a > -1 && this.options.ns.splice(a, 1);
  }
  getResource(e, a, t, i = {}) {
    var d, l;
    const n = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator, o = i.ignoreJSONStructure !== void 0 ? i.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let r;
    e.indexOf(".") > -1 ? r = e.split(".") : (r = [e, a], t && (Array.isArray(t) ? r.push(...t) : A(t) && n ? r.push(...t.split(n)) : r.push(t)));
    const p = Ns(this.data, r);
    return !p && !a && !t && e.indexOf(".") > -1 && (e = r[0], a = r[1], t = r.slice(2).join(".")), p || !o || !A(t) ? p : mt((l = (d = this.data) == null ? void 0 : d[e]) == null ? void 0 : l[a], t, n);
  }
  addResource(e, a, t, i, n = {
    silent: !1
  }) {
    const o = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator;
    let r = [e, a];
    t && (r = r.concat(o ? t.split(o) : t)), e.indexOf(".") > -1 && (r = e.split("."), i = a, a = r[1]), this.addNamespaces(a), qt(this.data, r, i), n.silent || this.emit("added", e, a, t, i);
  }
  addResources(e, a, t, i = {
    silent: !1
  }) {
    for (const n in t)
      (A(t[n]) || Array.isArray(t[n])) && this.addResource(e, a, n, t[n], {
        silent: !0
      });
    i.silent || this.emit("added", e, a, t);
  }
  addResourceBundle(e, a, t, i, n, o = {
    silent: !1,
    skipCopy: !1
  }) {
    let r = [e, a];
    e.indexOf(".") > -1 && (r = e.split("."), i = t, t = a, a = r[1]), this.addNamespaces(a);
    let p = Ns(this.data, r) || {};
    o.skipCopy || (t = JSON.parse(JSON.stringify(t))), i ? Va(p, t, n) : p = {
      ...p,
      ...t
    }, qt(this.data, r, p), o.silent || this.emit("added", e, a, t);
  }
  removeResourceBundle(e, a) {
    this.hasResourceBundle(e, a) && delete this.data[e][a], this.removeNamespaces(a), this.emit("removed", e, a);
  }
  hasResourceBundle(e, a) {
    return this.getResource(e, a) !== void 0;
  }
  getResourceBundle(e, a) {
    return a || (a = this.options.defaultNS), this.getResource(e, a);
  }
  getDataByLanguage(e) {
    return this.data[e];
  }
  hasLanguageSomeTranslations(e) {
    const a = this.getDataByLanguage(e);
    return !!(a && Object.keys(a) || []).find((i) => a[i] && Object.keys(a[i]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var Ua = {
  processors: {},
  addPostProcessor(s) {
    this.processors[s.name] = s;
  },
  handle(s, e, a, t, i) {
    return s.forEach((n) => {
      var o;
      e = ((o = this.processors[n]) == null ? void 0 : o.process(e, a, t, i)) ?? e;
    }), e;
  }
};
const Gt = {}, Wt = (s) => !A(s) && typeof s != "boolean" && typeof s != "number";
class ks extends Us {
  constructor(e, a = {}) {
    super(), Qi(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], e, this), this.options = a, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = ce.create("translator");
  }
  changeLanguage(e) {
    e && (this.language = e);
  }
  exists(e, a = {
    interpolation: {}
  }) {
    const t = {
      ...a
    };
    if (e == null) return !1;
    const i = this.resolve(e, t);
    return (i == null ? void 0 : i.res) !== void 0;
  }
  extractFromKey(e, a) {
    let t = a.nsSeparator !== void 0 ? a.nsSeparator : this.options.nsSeparator;
    t === void 0 && (t = ":");
    const i = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator;
    let n = a.ns || this.options.defaultNS || [];
    const o = t && e.indexOf(t) > -1, r = !this.options.userDefinedKeySeparator && !a.keySeparator && !this.options.userDefinedNsSeparator && !a.nsSeparator && !on(e, t, i);
    if (o && !r) {
      const p = e.match(this.interpolator.nestingRegexp);
      if (p && p.length > 0)
        return {
          key: e,
          namespaces: A(n) ? [n] : n
        };
      const d = e.split(t);
      (t !== i || t === i && this.options.ns.indexOf(d[0]) > -1) && (n = d.shift()), e = d.join(i);
    }
    return {
      key: e,
      namespaces: A(n) ? [n] : n
    };
  }
  translate(e, a, t) {
    let i = typeof a == "object" ? {
      ...a
    } : a;
    if (typeof i != "object" && this.options.overloadTranslationOptionHandler && (i = this.options.overloadTranslationOptionHandler(arguments)), typeof options == "object" && (i = {
      ...i
    }), i || (i = {}), e == null) return "";
    Array.isArray(e) || (e = [String(e)]);
    const n = i.returnDetails !== void 0 ? i.returnDetails : this.options.returnDetails, o = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator, {
      key: r,
      namespaces: p
    } = this.extractFromKey(e[e.length - 1], i), d = p[p.length - 1];
    let l = i.nsSeparator !== void 0 ? i.nsSeparator : this.options.nsSeparator;
    l === void 0 && (l = ":");
    const c = i.lng || this.language, f = i.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if ((c == null ? void 0 : c.toLowerCase()) === "cimode")
      return f ? n ? {
        res: `${d}${l}${r}`,
        usedKey: r,
        exactUsedKey: r,
        usedLng: c,
        usedNS: d,
        usedParams: this.getUsedParamsDetails(i)
      } : `${d}${l}${r}` : n ? {
        res: r,
        usedKey: r,
        exactUsedKey: r,
        usedLng: c,
        usedNS: d,
        usedParams: this.getUsedParamsDetails(i)
      } : r;
    const u = this.resolve(e, i);
    let m = u == null ? void 0 : u.res;
    const h = (u == null ? void 0 : u.usedKey) || r, w = (u == null ? void 0 : u.exactUsedKey) || r, b = ["[object Number]", "[object Function]", "[object RegExp]"], D = i.joinArrays !== void 0 ? i.joinArrays : this.options.joinArrays, P = !this.i18nFormat || this.i18nFormat.handleAsObject, _ = i.count !== void 0 && !A(i.count), k = ks.hasDefaultValue(i), N = _ ? this.pluralResolver.getSuffix(c, i.count, i) : "", y = i.ordinal && _ ? this.pluralResolver.getSuffix(c, i.count, {
      ordinal: !1
    }) : "", E = _ && !i.ordinal && i.count === 0, T = E && i[`defaultValue${this.options.pluralSeparator}zero`] || i[`defaultValue${N}`] || i[`defaultValue${y}`] || i.defaultValue;
    let C = m;
    P && !m && k && (C = T);
    const M = Wt(C), B = Object.prototype.toString.apply(C);
    if (P && C && M && b.indexOf(B) < 0 && !(A(D) && Array.isArray(C))) {
      if (!i.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const x = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(h, C, {
          ...i,
          ns: p
        }) : `key '${r} (${this.language})' returned an object instead of string.`;
        return n ? (u.res = x, u.usedParams = this.getUsedParamsDetails(i), u) : x;
      }
      if (o) {
        const x = Array.isArray(C), L = x ? [] : {}, Ne = x ? w : h;
        for (const j in C)
          if (Object.prototype.hasOwnProperty.call(C, j)) {
            const z = `${Ne}${o}${j}`;
            k && !m ? L[j] = this.translate(z, {
              ...i,
              defaultValue: Wt(T) ? T[j] : void 0,
              joinArrays: !1,
              ns: p
            }) : L[j] = this.translate(z, {
              ...i,
              joinArrays: !1,
              ns: p
            }), L[j] === z && (L[j] = C[j]);
          }
        m = L;
      }
    } else if (P && A(D) && Array.isArray(m))
      m = m.join(D), m && (m = this.extendTranslation(m, e, i, t));
    else {
      let x = !1, L = !1;
      !this.isValidLookup(m) && k && (x = !0, m = T), this.isValidLookup(m) || (L = !0, m = r);
      const j = (i.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && L ? void 0 : m, z = k && T !== m && this.options.updateMissing;
      if (L || x || z) {
        if (this.logger.log(z ? "updateKey" : "missingKey", c, d, r, z ? T : m), o) {
          const $ = this.resolve(r, {
            ...i,
            keySeparator: !1
          });
          $ && $.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let F = [];
        const Oe = this.languageUtils.getFallbackCodes(this.options.fallbackLng, i.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && Oe && Oe[0])
          for (let $ = 0; $ < Oe.length; $++)
            F.push(Oe[$]);
        else this.options.saveMissingTo === "all" ? F = this.languageUtils.toResolveHierarchy(i.lng || this.language) : F.push(i.lng || this.language);
        const fs = ($, ke, Je) => {
          var Ht;
          const Ut = k && Je !== m ? Je : j;
          this.options.missingKeyHandler ? this.options.missingKeyHandler($, d, ke, Ut, z, i) : (Ht = this.backendConnector) != null && Ht.saveMissing && this.backendConnector.saveMissing($, d, ke, Ut, z, i), this.emit("missingKey", $, d, ke, m);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && _ ? F.forEach(($) => {
          const ke = this.pluralResolver.getSuffixes($, i);
          E && i[`defaultValue${this.options.pluralSeparator}zero`] && ke.indexOf(`${this.options.pluralSeparator}zero`) < 0 && ke.push(`${this.options.pluralSeparator}zero`), ke.forEach((Je) => {
            fs([$], r + Je, i[`defaultValue${Je}`] || T);
          });
        }) : fs(F, r, T));
      }
      m = this.extendTranslation(m, e, i, u, t), L && m === r && this.options.appendNamespaceToMissingKey && (m = `${d}${l}${r}`), (L || x) && this.options.parseMissingKeyHandler && (m = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${d}${l}${r}` : r, x ? m : void 0, i));
    }
    return n ? (u.res = m, u.usedParams = this.getUsedParamsDetails(i), u) : m;
  }
  extendTranslation(e, a, t, i, n) {
    var p, d;
    if ((p = this.i18nFormat) != null && p.parse)
      e = this.i18nFormat.parse(e, {
        ...this.options.interpolation.defaultVariables,
        ...t
      }, t.lng || this.language || i.usedLng, i.usedNS, i.usedKey, {
        resolved: i
      });
    else if (!t.skipInterpolation) {
      t.interpolation && this.interpolator.init({
        ...t,
        interpolation: {
          ...this.options.interpolation,
          ...t.interpolation
        }
      });
      const l = A(e) && (((d = t == null ? void 0 : t.interpolation) == null ? void 0 : d.skipOnVariables) !== void 0 ? t.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let c;
      if (l) {
        const u = e.match(this.interpolator.nestingRegexp);
        c = u && u.length;
      }
      let f = t.replace && !A(t.replace) ? t.replace : t;
      if (this.options.interpolation.defaultVariables && (f = {
        ...this.options.interpolation.defaultVariables,
        ...f
      }), e = this.interpolator.interpolate(e, f, t.lng || this.language || i.usedLng, t), l) {
        const u = e.match(this.interpolator.nestingRegexp), m = u && u.length;
        c < m && (t.nest = !1);
      }
      !t.lng && i && i.res && (t.lng = this.language || i.usedLng), t.nest !== !1 && (e = this.interpolator.nest(e, (...u) => (n == null ? void 0 : n[0]) === u[0] && !t.context ? (this.logger.warn(`It seems you are nesting recursively key: ${u[0]} in key: ${a[0]}`), null) : this.translate(...u, a), t)), t.interpolation && this.interpolator.reset();
    }
    const o = t.postProcess || this.options.postProcess, r = A(o) ? [o] : o;
    return e != null && (r != null && r.length) && t.applyPostProcessor !== !1 && (e = Ua.handle(r, e, a, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...i,
        usedParams: this.getUsedParamsDetails(t)
      },
      ...t
    } : t, this)), e;
  }
  resolve(e, a = {}) {
    let t, i, n, o, r;
    return A(e) && (e = [e]), e.forEach((p) => {
      if (this.isValidLookup(t)) return;
      const d = this.extractFromKey(p, a), l = d.key;
      i = l;
      let c = d.namespaces;
      this.options.fallbackNS && (c = c.concat(this.options.fallbackNS));
      const f = a.count !== void 0 && !A(a.count), u = f && !a.ordinal && a.count === 0, m = a.context !== void 0 && (A(a.context) || typeof a.context == "number") && a.context !== "", h = a.lngs ? a.lngs : this.languageUtils.toResolveHierarchy(a.lng || this.language, a.fallbackLng);
      c.forEach((w) => {
        var b, D;
        this.isValidLookup(t) || (r = w, !Gt[`${h[0]}-${w}`] && ((b = this.utils) != null && b.hasLoadedNamespace) && !((D = this.utils) != null && D.hasLoadedNamespace(r)) && (Gt[`${h[0]}-${w}`] = !0, this.logger.warn(`key "${i}" for languages "${h.join(", ")}" won't get resolved as namespace "${r}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), h.forEach((P) => {
          var N;
          if (this.isValidLookup(t)) return;
          o = P;
          const _ = [l];
          if ((N = this.i18nFormat) != null && N.addLookupKeys)
            this.i18nFormat.addLookupKeys(_, l, P, w, a);
          else {
            let y;
            f && (y = this.pluralResolver.getSuffix(P, a.count, a));
            const E = `${this.options.pluralSeparator}zero`, T = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (f && (a.ordinal && y.indexOf(T) === 0 && _.push(l + y.replace(T, this.options.pluralSeparator)), _.push(l + y), u && _.push(l + E)), m) {
              const C = `${l}${this.options.contextSeparator || "_"}${a.context}`;
              _.push(C), f && (a.ordinal && y.indexOf(T) === 0 && _.push(C + y.replace(T, this.options.pluralSeparator)), _.push(C + y), u && _.push(C + E));
            }
          }
          let k;
          for (; k = _.pop(); )
            this.isValidLookup(t) || (n = k, t = this.getResource(P, w, k, a));
        }));
      });
    }), {
      res: t,
      usedKey: i,
      exactUsedKey: n,
      usedLng: o,
      usedNS: r
    };
  }
  isValidLookup(e) {
    return e !== void 0 && !(!this.options.returnNull && e === null) && !(!this.options.returnEmptyString && e === "");
  }
  getResource(e, a, t, i = {}) {
    var n;
    return (n = this.i18nFormat) != null && n.getResource ? this.i18nFormat.getResource(e, a, t, i) : this.resourceStore.getResource(e, a, t, i);
  }
  getUsedParamsDetails(e = {}) {
    const a = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], t = e.replace && !A(e.replace);
    let i = t ? e.replace : e;
    if (t && typeof e.count < "u" && (i.count = e.count), this.options.interpolation.defaultVariables && (i = {
      ...this.options.interpolation.defaultVariables,
      ...i
    }), !t) {
      i = {
        ...i
      };
      for (const n of a)
        delete i[n];
    }
    return i;
  }
  static hasDefaultValue(e) {
    const a = "defaultValue";
    for (const t in e)
      if (Object.prototype.hasOwnProperty.call(e, t) && a === t.substring(0, a.length) && e[t] !== void 0)
        return !0;
    return !1;
  }
}
class Kt {
  constructor(e) {
    this.options = e, this.supportedLngs = this.options.supportedLngs || !1, this.logger = ce.create("languageUtils");
  }
  getScriptPartFromCode(e) {
    if (e = ts(e), !e || e.indexOf("-") < 0) return null;
    const a = e.split("-");
    return a.length === 2 || (a.pop(), a[a.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(a.join("-"));
  }
  getLanguagePartFromCode(e) {
    if (e = ts(e), !e || e.indexOf("-") < 0) return e;
    const a = e.split("-");
    return this.formatLanguageCode(a[0]);
  }
  formatLanguageCode(e) {
    if (A(e) && e.indexOf("-") > -1) {
      let a;
      try {
        a = Intl.getCanonicalLocales(e)[0];
      } catch {
      }
      return a && this.options.lowerCaseLng && (a = a.toLowerCase()), a || (this.options.lowerCaseLng ? e.toLowerCase() : e);
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? e.toLowerCase() : e;
  }
  isSupportedCode(e) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (e = this.getLanguagePartFromCode(e)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e) > -1;
  }
  getBestMatchFromCodes(e) {
    if (!e) return null;
    let a;
    return e.forEach((t) => {
      if (a) return;
      const i = this.formatLanguageCode(t);
      (!this.options.supportedLngs || this.isSupportedCode(i)) && (a = i);
    }), !a && this.options.supportedLngs && e.forEach((t) => {
      if (a) return;
      const i = this.getScriptPartFromCode(t);
      if (this.isSupportedCode(i)) return a = i;
      const n = this.getLanguagePartFromCode(t);
      if (this.isSupportedCode(n)) return a = n;
      a = this.options.supportedLngs.find((o) => {
        if (o === n) return o;
        if (!(o.indexOf("-") < 0 && n.indexOf("-") < 0) && (o.indexOf("-") > 0 && n.indexOf("-") < 0 && o.substring(0, o.indexOf("-")) === n || o.indexOf(n) === 0 && n.length > 1))
          return o;
      });
    }), a || (a = this.getFallbackCodes(this.options.fallbackLng)[0]), a;
  }
  getFallbackCodes(e, a) {
    if (!e) return [];
    if (typeof e == "function" && (e = e(a)), A(e) && (e = [e]), Array.isArray(e)) return e;
    if (!a) return e.default || [];
    let t = e[a];
    return t || (t = e[this.getScriptPartFromCode(a)]), t || (t = e[this.formatLanguageCode(a)]), t || (t = e[this.getLanguagePartFromCode(a)]), t || (t = e.default), t || [];
  }
  toResolveHierarchy(e, a) {
    const t = this.getFallbackCodes((a === !1 ? [] : a) || this.options.fallbackLng || [], e), i = [], n = (o) => {
      o && (this.isSupportedCode(o) ? i.push(o) : this.logger.warn(`rejecting language code not found in supportedLngs: ${o}`));
    };
    return A(e) && (e.indexOf("-") > -1 || e.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && n(this.formatLanguageCode(e)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && n(this.getScriptPartFromCode(e)), this.options.load !== "currentOnly" && n(this.getLanguagePartFromCode(e))) : A(e) && n(this.formatLanguageCode(e)), t.forEach((o) => {
      i.indexOf(o) < 0 && n(this.formatLanguageCode(o));
    }), i;
  }
}
const Yt = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, Qt = {
  select: (s) => s === 1 ? "one" : "other",
  resolvedOptions: () => ({
    pluralCategories: ["one", "other"]
  })
};
class pn {
  constructor(e, a = {}) {
    this.languageUtils = e, this.options = a, this.logger = ce.create("pluralResolver"), this.pluralRulesCache = {};
  }
  addRule(e, a) {
    this.rules[e] = a;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(e, a = {}) {
    const t = ts(e === "dev" ? "en" : e), i = a.ordinal ? "ordinal" : "cardinal", n = JSON.stringify({
      cleanedCode: t,
      type: i
    });
    if (n in this.pluralRulesCache)
      return this.pluralRulesCache[n];
    let o;
    try {
      o = new Intl.PluralRules(t, {
        type: i
      });
    } catch {
      if (!Intl)
        return this.logger.error("No Intl support, please use an Intl polyfill!"), Qt;
      if (!e.match(/-|_/)) return Qt;
      const p = this.languageUtils.getLanguagePartFromCode(e);
      o = this.getRule(p, a);
    }
    return this.pluralRulesCache[n] = o, o;
  }
  needsPlural(e, a = {}) {
    let t = this.getRule(e, a);
    return t || (t = this.getRule("dev", a)), (t == null ? void 0 : t.resolvedOptions().pluralCategories.length) > 1;
  }
  getPluralFormsOfKey(e, a, t = {}) {
    return this.getSuffixes(e, t).map((i) => `${a}${i}`);
  }
  getSuffixes(e, a = {}) {
    let t = this.getRule(e, a);
    return t || (t = this.getRule("dev", a)), t ? t.resolvedOptions().pluralCategories.sort((i, n) => Yt[i] - Yt[n]).map((i) => `${this.options.prepend}${a.ordinal ? `ordinal${this.options.prepend}` : ""}${i}`) : [];
  }
  getSuffix(e, a, t = {}) {
    const i = this.getRule(e, t);
    return i ? `${this.options.prepend}${t.ordinal ? `ordinal${this.options.prepend}` : ""}${i.select(a)}` : (this.logger.warn(`no plural rule found for: ${e}`), this.getSuffix("dev", a, t));
  }
}
const Jt = (s, e, a, t = ".", i = !0) => {
  let n = Zi(s, e, a);
  return !n && i && A(a) && (n = mt(s, a, t), n === void 0 && (n = mt(e, a, t))), n;
}, Js = (s) => s.replace(/\$/g, "$$$$");
class dn {
  constructor(e = {}) {
    var a;
    this.logger = ce.create("interpolator"), this.options = e, this.format = ((a = e == null ? void 0 : e.interpolation) == null ? void 0 : a.format) || ((t) => t), this.init(e);
  }
  init(e = {}) {
    e.interpolation || (e.interpolation = {
      escapeValue: !0
    });
    const {
      escape: a,
      escapeValue: t,
      useRawValueToEscape: i,
      prefix: n,
      prefixEscaped: o,
      suffix: r,
      suffixEscaped: p,
      formatSeparator: d,
      unescapeSuffix: l,
      unescapePrefix: c,
      nestingPrefix: f,
      nestingPrefixEscaped: u,
      nestingSuffix: m,
      nestingSuffixEscaped: h,
      nestingOptionsSeparator: w,
      maxReplaces: b,
      alwaysFormat: D
    } = e.interpolation;
    this.escape = a !== void 0 ? a : sn, this.escapeValue = t !== void 0 ? t : !0, this.useRawValueToEscape = i !== void 0 ? i : !1, this.prefix = n ? Ve(n) : o || "{{", this.suffix = r ? Ve(r) : p || "}}", this.formatSeparator = d || ",", this.unescapePrefix = l ? "" : c || "-", this.unescapeSuffix = this.unescapePrefix ? "" : l || "", this.nestingPrefix = f ? Ve(f) : u || Ve("$t("), this.nestingSuffix = m ? Ve(m) : h || Ve(")"), this.nestingOptionsSeparator = w || ",", this.maxReplaces = b || 1e3, this.alwaysFormat = D !== void 0 ? D : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const e = (a, t) => (a == null ? void 0 : a.source) === t ? (a.lastIndex = 0, a) : new RegExp(t, "g");
    this.regexp = e(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = e(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = e(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
  }
  interpolate(e, a, t, i) {
    var u;
    let n, o, r;
    const p = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, d = (m) => {
      if (m.indexOf(this.formatSeparator) < 0) {
        const D = Jt(a, p, m, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(D, void 0, t, {
          ...i,
          ...a,
          interpolationkey: m
        }) : D;
      }
      const h = m.split(this.formatSeparator), w = h.shift().trim(), b = h.join(this.formatSeparator).trim();
      return this.format(Jt(a, p, w, this.options.keySeparator, this.options.ignoreJSONStructure), b, t, {
        ...i,
        ...a,
        interpolationkey: w
      });
    };
    this.resetRegExp();
    const l = (i == null ? void 0 : i.missingInterpolationHandler) || this.options.missingInterpolationHandler, c = ((u = i == null ? void 0 : i.interpolation) == null ? void 0 : u.skipOnVariables) !== void 0 ? i.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (m) => Js(m)
    }, {
      regex: this.regexp,
      safeValue: (m) => this.escapeValue ? Js(this.escape(m)) : Js(m)
    }].forEach((m) => {
      for (r = 0; n = m.regex.exec(e); ) {
        const h = n[1].trim();
        if (o = d(h), o === void 0)
          if (typeof l == "function") {
            const b = l(e, n, i);
            o = A(b) ? b : "";
          } else if (i && Object.prototype.hasOwnProperty.call(i, h))
            o = "";
          else if (c) {
            o = n[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${h} for interpolating ${e}`), o = "";
        else !A(o) && !this.useRawValueToEscape && (o = Bt(o));
        const w = m.safeValue(o);
        if (e = e.replace(n[0], w), c ? (m.regex.lastIndex += o.length, m.regex.lastIndex -= n[0].length) : m.regex.lastIndex = 0, r++, r >= this.maxReplaces)
          break;
      }
    }), e;
  }
  nest(e, a, t = {}) {
    let i, n, o;
    const r = (p, d) => {
      const l = this.nestingOptionsSeparator;
      if (p.indexOf(l) < 0) return p;
      const c = p.split(new RegExp(`${l}[ ]*{`));
      let f = `{${c[1]}`;
      p = c[0], f = this.interpolate(f, o);
      const u = f.match(/'/g), m = f.match(/"/g);
      (((u == null ? void 0 : u.length) ?? 0) % 2 === 0 && !m || m.length % 2 !== 0) && (f = f.replace(/'/g, '"'));
      try {
        o = JSON.parse(f), d && (o = {
          ...d,
          ...o
        });
      } catch (h) {
        return this.logger.warn(`failed parsing options string in nesting for key ${p}`, h), `${p}${l}${f}`;
      }
      return o.defaultValue && o.defaultValue.indexOf(this.prefix) > -1 && delete o.defaultValue, p;
    };
    for (; i = this.nestingRegexp.exec(e); ) {
      let p = [];
      o = {
        ...t
      }, o = o.replace && !A(o.replace) ? o.replace : o, o.applyPostProcessor = !1, delete o.defaultValue;
      const d = /{.*}/.test(i[1]) ? i[1].lastIndexOf("}") + 1 : i[1].indexOf(this.formatSeparator);
      if (d !== -1 && (p = i[1].slice(d).split(this.formatSeparator).map((l) => l.trim()).filter(Boolean), i[1] = i[1].slice(0, d)), n = a(r.call(this, i[1].trim(), o), o), n && i[0] === e && !A(n)) return n;
      A(n) || (n = Bt(n)), n || (this.logger.warn(`missed to resolve ${i[1]} for nesting ${e}`), n = ""), p.length && (n = p.reduce((l, c) => this.format(l, c, t.lng, {
        ...t,
        interpolationkey: i[1].trim()
      }), n.trim())), e = e.replace(i[0], n), this.regexp.lastIndex = 0;
    }
    return e;
  }
}
const ln = (s) => {
  let e = s.toLowerCase().trim();
  const a = {};
  if (s.indexOf("(") > -1) {
    const t = s.split("(");
    e = t[0].toLowerCase().trim();
    const i = t[1].substring(0, t[1].length - 1);
    e === "currency" && i.indexOf(":") < 0 ? a.currency || (a.currency = i.trim()) : e === "relativetime" && i.indexOf(":") < 0 ? a.range || (a.range = i.trim()) : i.split(";").forEach((o) => {
      if (o) {
        const [r, ...p] = o.split(":"), d = p.join(":").trim().replace(/^'+|'+$/g, ""), l = r.trim();
        a[l] || (a[l] = d), d === "false" && (a[l] = !1), d === "true" && (a[l] = !0), isNaN(d) || (a[l] = parseInt(d, 10));
      }
    });
  }
  return {
    formatName: e,
    formatOptions: a
  };
}, Xt = (s) => {
  const e = {};
  return (a, t, i) => {
    let n = i;
    i && i.interpolationkey && i.formatParams && i.formatParams[i.interpolationkey] && i[i.interpolationkey] && (n = {
      ...n,
      [i.interpolationkey]: void 0
    });
    const o = t + JSON.stringify(n);
    let r = e[o];
    return r || (r = s(ts(t), i), e[o] = r), r(a);
  };
}, cn = (s) => (e, a, t) => s(ts(a), t)(e);
class mn {
  constructor(e = {}) {
    this.logger = ce.create("formatter"), this.options = e, this.init(e);
  }
  init(e, a = {
    interpolation: {}
  }) {
    this.formatSeparator = a.interpolation.formatSeparator || ",";
    const t = a.cacheInBuiltFormats ? Xt : cn;
    this.formats = {
      number: t((i, n) => {
        const o = new Intl.NumberFormat(i, {
          ...n
        });
        return (r) => o.format(r);
      }),
      currency: t((i, n) => {
        const o = new Intl.NumberFormat(i, {
          ...n,
          style: "currency"
        });
        return (r) => o.format(r);
      }),
      datetime: t((i, n) => {
        const o = new Intl.DateTimeFormat(i, {
          ...n
        });
        return (r) => o.format(r);
      }),
      relativetime: t((i, n) => {
        const o = new Intl.RelativeTimeFormat(i, {
          ...n
        });
        return (r) => o.format(r, n.range || "day");
      }),
      list: t((i, n) => {
        const o = new Intl.ListFormat(i, {
          ...n
        });
        return (r) => o.format(r);
      })
    };
  }
  add(e, a) {
    this.formats[e.toLowerCase().trim()] = a;
  }
  addCached(e, a) {
    this.formats[e.toLowerCase().trim()] = Xt(a);
  }
  format(e, a, t, i = {}) {
    const n = a.split(this.formatSeparator);
    if (n.length > 1 && n[0].indexOf("(") > 1 && n[0].indexOf(")") < 0 && n.find((r) => r.indexOf(")") > -1)) {
      const r = n.findIndex((p) => p.indexOf(")") > -1);
      n[0] = [n[0], ...n.splice(1, r)].join(this.formatSeparator);
    }
    return n.reduce((r, p) => {
      var c;
      const {
        formatName: d,
        formatOptions: l
      } = ln(p);
      if (this.formats[d]) {
        let f = r;
        try {
          const u = ((c = i == null ? void 0 : i.formatParams) == null ? void 0 : c[i.interpolationkey]) || {}, m = u.locale || u.lng || i.locale || i.lng || t;
          f = this.formats[d](r, m, {
            ...l,
            ...i,
            ...u
          });
        } catch (u) {
          this.logger.warn(u);
        }
        return f;
      } else
        this.logger.warn(`there was no format function for ${d}`);
      return r;
    }, e);
  }
}
const un = (s, e) => {
  s.pending[e] !== void 0 && (delete s.pending[e], s.pendingCount--);
};
class fn extends Us {
  constructor(e, a, t, i = {}) {
    var n, o;
    super(), this.backend = e, this.store = a, this.services = t, this.languageUtils = t.languageUtils, this.options = i, this.logger = ce.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = i.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = i.maxRetries >= 0 ? i.maxRetries : 5, this.retryTimeout = i.retryTimeout >= 1 ? i.retryTimeout : 350, this.state = {}, this.queue = [], (o = (n = this.backend) == null ? void 0 : n.init) == null || o.call(n, t, i.backend, i);
  }
  queueLoad(e, a, t, i) {
    const n = {}, o = {}, r = {}, p = {};
    return e.forEach((d) => {
      let l = !0;
      a.forEach((c) => {
        const f = `${d}|${c}`;
        !t.reload && this.store.hasResourceBundle(d, c) ? this.state[f] = 2 : this.state[f] < 0 || (this.state[f] === 1 ? o[f] === void 0 && (o[f] = !0) : (this.state[f] = 1, l = !1, o[f] === void 0 && (o[f] = !0), n[f] === void 0 && (n[f] = !0), p[c] === void 0 && (p[c] = !0)));
      }), l || (r[d] = !0);
    }), (Object.keys(n).length || Object.keys(o).length) && this.queue.push({
      pending: o,
      pendingCount: Object.keys(o).length,
      loaded: {},
      errors: [],
      callback: i
    }), {
      toLoad: Object.keys(n),
      pending: Object.keys(o),
      toLoadLanguages: Object.keys(r),
      toLoadNamespaces: Object.keys(p)
    };
  }
  loaded(e, a, t) {
    const i = e.split("|"), n = i[0], o = i[1];
    a && this.emit("failedLoading", n, o, a), !a && t && this.store.addResourceBundle(n, o, t, void 0, void 0, {
      skipCopy: !0
    }), this.state[e] = a ? -1 : 2, a && t && (this.state[e] = 0);
    const r = {};
    this.queue.forEach((p) => {
      Xi(p.loaded, [n], o), un(p, e), a && p.errors.push(a), p.pendingCount === 0 && !p.done && (Object.keys(p.loaded).forEach((d) => {
        r[d] || (r[d] = {});
        const l = p.loaded[d];
        l.length && l.forEach((c) => {
          r[d][c] === void 0 && (r[d][c] = !0);
        });
      }), p.done = !0, p.errors.length ? p.callback(p.errors) : p.callback());
    }), this.emit("loaded", r), this.queue = this.queue.filter((p) => !p.done);
  }
  read(e, a, t, i = 0, n = this.retryTimeout, o) {
    if (!e.length) return o(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: e,
        ns: a,
        fcName: t,
        tried: i,
        wait: n,
        callback: o
      });
      return;
    }
    this.readingCalls++;
    const r = (d, l) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const c = this.waitingReads.shift();
        this.read(c.lng, c.ns, c.fcName, c.tried, c.wait, c.callback);
      }
      if (d && l && i < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, e, a, t, i + 1, n * 2, o);
        }, n);
        return;
      }
      o(d, l);
    }, p = this.backend[t].bind(this.backend);
    if (p.length === 2) {
      try {
        const d = p(e, a);
        d && typeof d.then == "function" ? d.then((l) => r(null, l)).catch(r) : r(null, d);
      } catch (d) {
        r(d);
      }
      return;
    }
    return p(e, a, r);
  }
  prepareLoading(e, a, t = {}, i) {
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), i && i();
    A(e) && (e = this.languageUtils.toResolveHierarchy(e)), A(a) && (a = [a]);
    const n = this.queueLoad(e, a, t, i);
    if (!n.toLoad.length)
      return n.pending.length || i(), null;
    n.toLoad.forEach((o) => {
      this.loadOne(o);
    });
  }
  load(e, a, t) {
    this.prepareLoading(e, a, {}, t);
  }
  reload(e, a, t) {
    this.prepareLoading(e, a, {
      reload: !0
    }, t);
  }
  loadOne(e, a = "") {
    const t = e.split("|"), i = t[0], n = t[1];
    this.read(i, n, "read", void 0, void 0, (o, r) => {
      o && this.logger.warn(`${a}loading namespace ${n} for language ${i} failed`, o), !o && r && this.logger.log(`${a}loaded namespace ${n} for language ${i}`, r), this.loaded(e, o, r);
    });
  }
  saveMissing(e, a, t, i, n, o = {}, r = () => {
  }) {
    var p, d, l, c, f;
    if ((d = (p = this.services) == null ? void 0 : p.utils) != null && d.hasLoadedNamespace && !((c = (l = this.services) == null ? void 0 : l.utils) != null && c.hasLoadedNamespace(a))) {
      this.logger.warn(`did not save key "${t}" as the namespace "${a}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(t == null || t === "")) {
      if ((f = this.backend) != null && f.create) {
        const u = {
          ...o,
          isUpdate: n
        }, m = this.backend.create.bind(this.backend);
        if (m.length < 6)
          try {
            let h;
            m.length === 5 ? h = m(e, a, t, i, u) : h = m(e, a, t, i), h && typeof h.then == "function" ? h.then((w) => r(null, w)).catch(r) : r(null, h);
          } catch (h) {
            r(h);
          }
        else
          m(e, a, t, i, r, u);
      }
      !e || !e[0] || this.store.addResource(e[0], a, t, i);
    }
  }
}
const Zt = () => ({
  debug: !1,
  initAsync: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (s) => {
    let e = {};
    if (typeof s[1] == "object" && (e = s[1]), A(s[1]) && (e.defaultValue = s[1]), A(s[2]) && (e.tDescription = s[2]), typeof s[2] == "object" || typeof s[3] == "object") {
      const a = s[3] || s[2];
      Object.keys(a).forEach((t) => {
        e[t] = a[t];
      });
    }
    return e;
  },
  interpolation: {
    escapeValue: !0,
    format: (s) => s,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  },
  cacheInBuiltFormats: !0
}), ea = (s) => {
  var e, a;
  return A(s.ns) && (s.ns = [s.ns]), A(s.fallbackLng) && (s.fallbackLng = [s.fallbackLng]), A(s.fallbackNS) && (s.fallbackNS = [s.fallbackNS]), ((a = (e = s.supportedLngs) == null ? void 0 : e.indexOf) == null ? void 0 : a.call(e, "cimode")) < 0 && (s.supportedLngs = s.supportedLngs.concat(["cimode"])), typeof s.initImmediate == "boolean" && (s.initAsync = s.initImmediate), s;
}, gs = () => {
}, gn = (s) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(s)).forEach((a) => {
    typeof s[a] == "function" && (s[a] = s[a].bind(s));
  });
};
class as extends Us {
  constructor(e = {}, a) {
    if (super(), this.options = ea(e), this.services = {}, this.logger = ce, this.modules = {
      external: []
    }, gn(this), a && !this.isInitialized && !e.isClone) {
      if (!this.options.initAsync)
        return this.init(e, a), this;
      setTimeout(() => {
        this.init(e, a);
      }, 0);
    }
  }
  init(e = {}, a) {
    this.isInitializing = !0, typeof e == "function" && (a = e, e = {}), e.defaultNS == null && e.ns && (A(e.ns) ? e.defaultNS = e.ns : e.ns.indexOf("translation") < 0 && (e.defaultNS = e.ns[0]));
    const t = Zt();
    this.options = {
      ...t,
      ...this.options,
      ...ea(e)
    }, this.options.interpolation = {
      ...t.interpolation,
      ...this.options.interpolation
    }, e.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = e.keySeparator), e.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = e.nsSeparator);
    const i = (d) => d ? typeof d == "function" ? new d() : d : null;
    if (!this.options.isClone) {
      this.modules.logger ? ce.init(i(this.modules.logger), this.options) : ce.init(null, this.options);
      let d;
      this.modules.formatter ? d = this.modules.formatter : d = mn;
      const l = new Kt(this.options);
      this.store = new $t(this.options.resources, this.options);
      const c = this.services;
      c.logger = ce, c.resourceStore = this.store, c.languageUtils = l, c.pluralResolver = new pn(l, {
        prepend: this.options.pluralSeparator,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), this.options.interpolation.format && this.options.interpolation.format !== t.interpolation.format && this.logger.warn("init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting"), d && (!this.options.interpolation.format || this.options.interpolation.format === t.interpolation.format) && (c.formatter = i(d), c.formatter.init && c.formatter.init(c, this.options), this.options.interpolation.format = c.formatter.format.bind(c.formatter)), c.interpolator = new dn(this.options), c.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, c.backendConnector = new fn(i(this.modules.backend), c.resourceStore, c, this.options), c.backendConnector.on("*", (u, ...m) => {
        this.emit(u, ...m);
      }), this.modules.languageDetector && (c.languageDetector = i(this.modules.languageDetector), c.languageDetector.init && c.languageDetector.init(c, this.options.detection, this.options)), this.modules.i18nFormat && (c.i18nFormat = i(this.modules.i18nFormat), c.i18nFormat.init && c.i18nFormat.init(this)), this.translator = new ks(this.services, this.options), this.translator.on("*", (u, ...m) => {
        this.emit(u, ...m);
      }), this.modules.external.forEach((u) => {
        u.init && u.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, a || (a = gs), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const d = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      d.length > 0 && d[0] !== "dev" && (this.options.lng = d[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((d) => {
      this[d] = (...l) => this.store[d](...l);
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((d) => {
      this[d] = (...l) => (this.store[d](...l), this);
    });
    const r = Xe(), p = () => {
      const d = (l, c) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), r.resolve(c), a(l, c);
      };
      if (this.languages && !this.isInitialized) return d(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, d);
    };
    return this.options.resources || !this.options.initAsync ? p() : setTimeout(p, 0), r;
  }
  loadResources(e, a = gs) {
    var n, o;
    let t = a;
    const i = A(e) ? e : this.language;
    if (typeof e == "function" && (t = e), !this.options.resources || this.options.partialBundledLanguages) {
      if ((i == null ? void 0 : i.toLowerCase()) === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return t();
      const r = [], p = (d) => {
        if (!d || d === "cimode") return;
        this.services.languageUtils.toResolveHierarchy(d).forEach((c) => {
          c !== "cimode" && r.indexOf(c) < 0 && r.push(c);
        });
      };
      i ? p(i) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((l) => p(l)), (o = (n = this.options.preload) == null ? void 0 : n.forEach) == null || o.call(n, (d) => p(d)), this.services.backendConnector.load(r, this.options.ns, (d) => {
        !d && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), t(d);
      });
    } else
      t(null);
  }
  reloadResources(e, a, t) {
    const i = Xe();
    return typeof e == "function" && (t = e, e = void 0), typeof a == "function" && (t = a, a = void 0), e || (e = this.languages), a || (a = this.options.ns), t || (t = gs), this.services.backendConnector.reload(e, a, (n) => {
      i.resolve(), t(n);
    }), i;
  }
  use(e) {
    if (!e) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!e.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return e.type === "backend" && (this.modules.backend = e), (e.type === "logger" || e.log && e.warn && e.error) && (this.modules.logger = e), e.type === "languageDetector" && (this.modules.languageDetector = e), e.type === "i18nFormat" && (this.modules.i18nFormat = e), e.type === "postProcessor" && Ua.addPostProcessor(e), e.type === "formatter" && (this.modules.formatter = e), e.type === "3rdParty" && this.modules.external.push(e), this;
  }
  setResolvedLanguage(e) {
    if (!(!e || !this.languages) && !(["cimode", "dev"].indexOf(e) > -1)) {
      for (let a = 0; a < this.languages.length; a++) {
        const t = this.languages[a];
        if (!(["cimode", "dev"].indexOf(t) > -1) && this.store.hasLanguageSomeTranslations(t)) {
          this.resolvedLanguage = t;
          break;
        }
      }
      !this.resolvedLanguage && this.languages.indexOf(e) < 0 && this.store.hasLanguageSomeTranslations(e) && (this.resolvedLanguage = e, this.languages.unshift(e));
    }
  }
  changeLanguage(e, a) {
    this.isLanguageChangingTo = e;
    const t = Xe();
    this.emit("languageChanging", e);
    const i = (r) => {
      this.language = r, this.languages = this.services.languageUtils.toResolveHierarchy(r), this.resolvedLanguage = void 0, this.setResolvedLanguage(r);
    }, n = (r, p) => {
      p ? this.isLanguageChangingTo === e && (i(p), this.translator.changeLanguage(p), this.isLanguageChangingTo = void 0, this.emit("languageChanged", p), this.logger.log("languageChanged", p)) : this.isLanguageChangingTo = void 0, t.resolve((...d) => this.t(...d)), a && a(r, (...d) => this.t(...d));
    }, o = (r) => {
      var l, c;
      !e && !r && this.services.languageDetector && (r = []);
      const p = A(r) ? r : r && r[0], d = this.store.hasLanguageSomeTranslations(p) ? p : this.services.languageUtils.getBestMatchFromCodes(A(r) ? [r] : r);
      d && (this.language || i(d), this.translator.language || this.translator.changeLanguage(d), (c = (l = this.services.languageDetector) == null ? void 0 : l.cacheUserLanguage) == null || c.call(l, d)), this.loadResources(d, (f) => {
        n(f, d);
      });
    };
    return !e && this.services.languageDetector && !this.services.languageDetector.async ? o(this.services.languageDetector.detect()) : !e && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(o) : this.services.languageDetector.detect(o) : o(e), t;
  }
  getFixedT(e, a, t) {
    const i = (n, o, ...r) => {
      let p;
      typeof o != "object" ? p = this.options.overloadTranslationOptionHandler([n, o].concat(r)) : p = {
        ...o
      }, p.lng = p.lng || i.lng, p.lngs = p.lngs || i.lngs, p.ns = p.ns || i.ns, p.keyPrefix !== "" && (p.keyPrefix = p.keyPrefix || t || i.keyPrefix);
      const d = this.options.keySeparator || ".";
      let l;
      return p.keyPrefix && Array.isArray(n) ? l = n.map((c) => `${p.keyPrefix}${d}${c}`) : l = p.keyPrefix ? `${p.keyPrefix}${d}${n}` : n, this.t(l, p);
    };
    return A(e) ? i.lng = e : i.lngs = e, i.ns = a, i.keyPrefix = t, i;
  }
  t(...e) {
    var a;
    return (a = this.translator) == null ? void 0 : a.translate(...e);
  }
  exists(...e) {
    var a;
    return (a = this.translator) == null ? void 0 : a.exists(...e);
  }
  setDefaultNamespace(e) {
    this.options.defaultNS = e;
  }
  hasLoadedNamespace(e, a = {}) {
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const t = a.lng || this.resolvedLanguage || this.languages[0], i = this.options ? this.options.fallbackLng : !1, n = this.languages[this.languages.length - 1];
    if (t.toLowerCase() === "cimode") return !0;
    const o = (r, p) => {
      const d = this.services.backendConnector.state[`${r}|${p}`];
      return d === -1 || d === 0 || d === 2;
    };
    if (a.precheck) {
      const r = a.precheck(this, o);
      if (r !== void 0) return r;
    }
    return !!(this.hasResourceBundle(t, e) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || o(t, e) && (!i || o(n, e)));
  }
  loadNamespaces(e, a) {
    const t = Xe();
    return this.options.ns ? (A(e) && (e = [e]), e.forEach((i) => {
      this.options.ns.indexOf(i) < 0 && this.options.ns.push(i);
    }), this.loadResources((i) => {
      t.resolve(), a && a(i);
    }), t) : (a && a(), Promise.resolve());
  }
  loadLanguages(e, a) {
    const t = Xe();
    A(e) && (e = [e]);
    const i = this.options.preload || [], n = e.filter((o) => i.indexOf(o) < 0 && this.services.languageUtils.isSupportedCode(o));
    return n.length ? (this.options.preload = i.concat(n), this.loadResources((o) => {
      t.resolve(), a && a(o);
    }), t) : (a && a(), Promise.resolve());
  }
  dir(e) {
    var i, n;
    if (e || (e = this.resolvedLanguage || (((i = this.languages) == null ? void 0 : i.length) > 0 ? this.languages[0] : this.language)), !e) return "rtl";
    try {
      const o = new Intl.Locale(e);
      if (o && o.getTextInfo) {
        const r = o.getTextInfo();
        if (r && r.direction) return r.direction;
      }
    } catch {
    }
    const a = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], t = ((n = this.services) == null ? void 0 : n.languageUtils) || new Kt(Zt());
    return e.toLowerCase().indexOf("-latn") > 1 ? "ltr" : a.indexOf(t.getLanguagePartFromCode(e)) > -1 || e.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance(e = {}, a) {
    return new as(e, a);
  }
  cloneInstance(e = {}, a = gs) {
    const t = e.forkResourceStore;
    t && delete e.forkResourceStore;
    const i = {
      ...this.options,
      ...e,
      isClone: !0
    }, n = new as(i);
    if ((e.debug !== void 0 || e.prefix !== void 0) && (n.logger = n.logger.clone(e)), ["store", "services", "language"].forEach((r) => {
      n[r] = this[r];
    }), n.services = {
      ...this.services
    }, n.services.utils = {
      hasLoadedNamespace: n.hasLoadedNamespace.bind(n)
    }, t) {
      const r = Object.keys(this.store.data).reduce((p, d) => (p[d] = {
        ...this.store.data[d]
      }, p[d] = Object.keys(p[d]).reduce((l, c) => (l[c] = {
        ...p[d][c]
      }, l), p[d]), p), {});
      n.store = new $t(r, i), n.services.resourceStore = n.store;
    }
    return n.translator = new ks(n.services, i), n.translator.on("*", (r, ...p) => {
      n.emit(r, ...p);
    }), n.init(i, a), n.translator.options = i, n.translator.backendConnector.services.utils = {
      hasLoadedNamespace: n.hasLoadedNamespace.bind(n)
    }, n;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const H = as.createInstance();
H.createInstance = as.createInstance;
H.createInstance;
H.dir;
H.init;
H.loadResources;
H.reloadResources;
H.use;
H.changeLanguage;
H.getFixedT;
H.t;
H.exists;
H.setDefaultNamespace;
H.hasLoadedNamespace;
H.loadNamespaces;
H.loadLanguages;
function hn(s) {
  return s && s.__esModule && Object.prototype.hasOwnProperty.call(s, "default") ? s.default : s;
}
var Xs, sa;
function vn() {
  return sa || (sa = 1, Xs = {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
  }), Xs;
}
var wn = vn();
const bn = /* @__PURE__ */ hn(wn);
var yn = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function ta(s) {
  var e = { type: "tag", name: "", voidElement: !1, attrs: {}, children: [] }, a = s.match(/<\/?([^\s]+?)[/\s>]/);
  if (a && (e.name = a[1], (bn[a[1]] || s.charAt(s.length - 2) === "/") && (e.voidElement = !0), e.name.startsWith("!--"))) {
    var t = s.indexOf("-->");
    return { type: "comment", comment: t !== -1 ? s.slice(4, t) : "" };
  }
  for (var i = new RegExp(yn), n = null; (n = i.exec(s)) !== null; ) if (n[0].trim()) if (n[1]) {
    var o = n[1].trim(), r = [o, ""];
    o.indexOf("=") > -1 && (r = o.split("=")), e.attrs[r[0]] = r[1], i.lastIndex--;
  } else n[2] && (e.attrs[n[2]] = n[3].trim().substring(1, n[3].length - 1));
  return e;
}
var _n = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, An = /^\s*$/, Sn = /* @__PURE__ */ Object.create(null);
function Ha(s, e) {
  switch (e.type) {
    case "text":
      return s + e.content;
    case "tag":
      return s += "<" + e.name + (e.attrs ? function(a) {
        var t = [];
        for (var i in a) t.push(i + '="' + a[i] + '"');
        return t.length ? " " + t.join(" ") : "";
      }(e.attrs) : "") + (e.voidElement ? "/>" : ">"), e.voidElement ? s : s + e.children.reduce(Ha, "") + "</" + e.name + ">";
    case "comment":
      return s + "<!--" + e.comment + "-->";
  }
}
var Pn = { parse: function(s, e) {
  e || (e = {}), e.components || (e.components = Sn);
  var a, t = [], i = [], n = -1, o = !1;
  if (s.indexOf("<") !== 0) {
    var r = s.indexOf("<");
    t.push({ type: "text", content: r === -1 ? s : s.substring(0, r) });
  }
  return s.replace(_n, function(p, d) {
    if (o) {
      if (p !== "</" + a.name + ">") return;
      o = !1;
    }
    var l, c = p.charAt(1) !== "/", f = p.startsWith("<!--"), u = d + p.length, m = s.charAt(u);
    if (f) {
      var h = ta(p);
      return n < 0 ? (t.push(h), t) : ((l = i[n]).children.push(h), t);
    }
    if (c && (n++, (a = ta(p)).type === "tag" && e.components[a.name] && (a.type = "component", o = !0), a.voidElement || o || !m || m === "<" || a.children.push({ type: "text", content: s.slice(u, s.indexOf("<", u)) }), n === 0 && t.push(a), (l = i[n - 1]) && l.children.push(a), i[n] = a), (!c || a.voidElement) && (n > -1 && (a.voidElement || a.name === p.slice(2, -1)) && (n--, a = n === -1 ? t : i[n]), !o && m !== "<" && m)) {
      l = n === -1 ? t : i[n].children;
      var w = s.indexOf("<", u), b = s.slice(u, w === -1 ? void 0 : w);
      An.test(b) && (b = " "), (w > -1 && n + l.length >= 0 || b !== " ") && l.push({ type: "text", content: b });
    }
  }), t;
}, stringify: function(s) {
  return s.reduce(function(e, a) {
    return e + Ha("", a);
  }, "");
} };
const ys = (s, e, a, t) => {
  var n, o, r, p;
  const i = [a, {
    code: e,
    ...t || {}
  }];
  if ((o = (n = s == null ? void 0 : s.services) == null ? void 0 : n.logger) != null && o.forward)
    return s.services.logger.forward(i, "warn", "react-i18next::", !0);
  se(i[0]) && (i[0] = `react-i18next:: ${i[0]}`), (p = (r = s == null ? void 0 : s.services) == null ? void 0 : r.logger) != null && p.warn ? s.services.logger.warn(...i) : console != null && console.warn && console.warn(...i);
}, aa = {}, is = (s, e, a, t) => {
  se(a) && aa[a] || (se(a) && (aa[a] = /* @__PURE__ */ new Date()), ys(s, e, a, t));
}, Ba = (s, e) => () => {
  if (s.isInitialized)
    e();
  else {
    const a = () => {
      setTimeout(() => {
        s.off("initialized", a);
      }, 0), e();
    };
    s.on("initialized", a);
  }
}, ut = (s, e, a) => {
  s.loadNamespaces(e, Ba(s, a));
}, ia = (s, e, a, t) => {
  if (se(a) && (a = [a]), s.options.preload && s.options.preload.indexOf(e) > -1) return ut(s, a, t);
  a.forEach((i) => {
    s.options.ns.indexOf(i) < 0 && s.options.ns.push(i);
  }), s.loadLanguages(e, Ba(s, t));
}, Dn = (s, e, a = {}) => !e.languages || !e.languages.length ? (is(e, "NO_LANGUAGES", "i18n.languages were undefined or empty", {
  languages: e.languages
}), !0) : e.hasLoadedNamespace(s, {
  lng: a.lng,
  precheck: (t, i) => {
    if (a.bindI18n && a.bindI18n.indexOf("languageChanging") > -1 && t.services.backendConnector.backend && t.isLanguageChangingTo && !i(t.isLanguageChangingTo, s)) return !1;
  }
}), se = (s) => typeof s == "string", Ae = (s) => typeof s == "object" && s !== null, Nn = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, On = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, kn = (s) => On[s], En = (s) => s.replace(Nn, kn);
let ft = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: En
};
const Tn = (s = {}) => {
  ft = {
    ...ft,
    ...s
  };
}, ja = () => ft;
let za;
const Cn = (s) => {
  za = s;
}, Ot = () => za, Zs = (s, e) => {
  var t;
  if (!s) return !1;
  const a = ((t = s.props) == null ? void 0 : t.children) ?? s.children;
  return e ? a.length > 0 : !!a;
}, et = (s) => {
  var a, t;
  if (!s) return [];
  const e = ((a = s.props) == null ? void 0 : a.children) ?? s.children;
  return (t = s.props) != null && t.i18nIsDynamicList ? Be(e) : e;
}, xn = (s) => Array.isArray(s) && s.every(Ds), Be = (s) => Array.isArray(s) ? s : [s], Rn = (s, e) => {
  const a = {
    ...e
  };
  return a.props = Object.assign(s.props, e.props), a;
}, qa = (s, e, a, t) => {
  if (!s) return "";
  let i = "";
  const n = Be(s), o = e != null && e.transSupportBasicHtmlNodes ? e.transKeepBasicHtmlNodesFor ?? [] : [];
  return n.forEach((r, p) => {
    if (se(r)) {
      i += `${r}`;
      return;
    }
    if (Ds(r)) {
      const {
        props: d,
        type: l
      } = r, c = Object.keys(d).length, f = o.indexOf(l) > -1, u = d.children;
      if (!u && f && !c) {
        i += `<${l}/>`;
        return;
      }
      if (!u && (!f || c) || d.i18nIsDynamicList) {
        i += `<${p}></${p}>`;
        return;
      }
      if (f && c === 1 && se(u)) {
        i += `<${l}>${u}</${l}>`;
        return;
      }
      const m = qa(u, e, a, t);
      i += `<${p}>${m}</${p}>`;
      return;
    }
    if (r === null) {
      ys(a, "TRANS_NULL_VALUE", "Passed in a null value as child", {
        i18nKey: t
      });
      return;
    }
    if (Ae(r)) {
      const {
        format: d,
        ...l
      } = r, c = Object.keys(l);
      if (c.length === 1) {
        const f = d ? `${c[0]}, ${d}` : c[0];
        i += `{{${f}}}`;
        return;
      }
      ys(a, "TRANS_INVALID_OBJ", "Invalid child - Object should only have keys {{ value, format }} (format is optional).", {
        i18nKey: t,
        child: r
      });
      return;
    }
    ys(a, "TRANS_INVALID_VAR", "Passed in a variable like {number} - pass variables for interpolation as full objects like {{number}}.", {
      i18nKey: t,
      child: r
    });
  }), i;
}, Fn = (s, e, a, t, i, n, o) => {
  if (a === "") return [];
  const r = i.transKeepBasicHtmlNodesFor || [], p = a && new RegExp(r.map((b) => `<${b}`).join("|")).test(a);
  if (!s && !e && !p && !o) return [a];
  const d = e ?? {}, l = (b) => {
    Be(b).forEach((P) => {
      se(P) || (Zs(P) ? l(et(P)) : Ae(P) && !Ds(P) && Object.assign(d, P));
    });
  };
  l(s);
  const c = Pn.parse(`<0>${a}</0>`), f = {
    ...d,
    ...n
  }, u = (b, D, P) => {
    var N;
    const _ = et(b), k = h(_, D.children, P);
    return xn(_) && k.length === 0 || (N = b.props) != null && N.i18nIsDynamicList ? _ : k;
  }, m = (b, D, P, _, k) => {
    b.dummy ? (b.children = D, P.push(Fa(b, {
      key: _
    }, k ? void 0 : D))) : P.push(...qi.map([b], (N) => {
      const y = {
        ...N.props
      };
      return delete y.i18nIsDynamicList, _e(N.type, {
        ...y,
        key: _,
        ref: N.props.ref ?? N.ref
      }, k ? null : D);
    }));
  }, h = (b, D, P) => {
    const _ = Be(b);
    return Be(D).reduce((N, y, E) => {
      var C, M;
      const T = ((M = (C = y.children) == null ? void 0 : C[0]) == null ? void 0 : M.content) && t.services.interpolator.interpolate(y.children[0].content, f, t.language);
      if (y.type === "tag") {
        let B = _[parseInt(y.name, 10)];
        !B && e && (B = e[y.name]), P.length === 1 && !B && (B = P[0][y.name]), B || (B = {});
        const x = Object.keys(y.attrs).length !== 0 ? Rn({
          props: y.attrs
        }, B) : B, L = Ds(x), Ne = L && Zs(y, !0) && !y.voidElement, j = p && Ae(x) && x.dummy && !L, z = Ae(e) && Object.hasOwnProperty.call(e, y.name);
        if (se(x)) {
          const F = t.services.interpolator.interpolate(x, f, t.language);
          N.push(F);
        } else if (Zs(x) || Ne) {
          const F = u(x, y, P);
          m(x, F, N, E);
        } else if (j) {
          const F = h(_, y.children, P);
          m(x, F, N, E);
        } else if (Number.isNaN(parseFloat(y.name)))
          if (z) {
            const F = u(x, y, P);
            m(x, F, N, E, y.voidElement);
          } else if (i.transSupportBasicHtmlNodes && r.indexOf(y.name) > -1)
            if (y.voidElement)
              N.push(_e(y.name, {
                key: `${y.name}-${E}`
              }));
            else {
              const F = h(_, y.children, P);
              N.push(_e(y.name, {
                key: `${y.name}-${E}`
              }, F));
            }
          else if (y.voidElement)
            N.push(`<${y.name} />`);
          else {
            const F = h(_, y.children, P);
            N.push(`<${y.name}>${F}</${y.name}>`);
          }
        else if (Ae(x) && !L) {
          const F = y.children[0] ? T : null;
          F && N.push(F);
        } else
          m(x, T, N, E, y.children.length !== 1 || !T);
      } else if (y.type === "text") {
        const B = i.transWrapTextNodes, x = o ? i.unescape(t.services.interpolator.interpolate(y.content, f, t.language)) : t.services.interpolator.interpolate(y.content, f, t.language);
        B ? N.push(_e(B, {
          key: `${y.name}-${E}`
        }, x)) : N.push(x);
      }
      return N;
    }, []);
  }, w = h([{
    dummy: !0,
    children: s || []
  }], c, Be(s || []));
  return et(w[0]);
}, $a = (s, e, a) => {
  const t = s.key || e, i = Fa(s, {
    key: t
  });
  if (!i.props || !i.props.children || a.indexOf(`${e}/>`) < 0 && a.indexOf(`${e} />`) < 0)
    return i;
  function n() {
    return _e($i, null, i);
  }
  return _e(n, {
    key: t
  });
}, In = (s, e) => s.map((a, t) => $a(a, t, e)), Ln = (s, e) => {
  const a = {};
  return Object.keys(s).forEach((t) => {
    Object.assign(a, {
      [t]: $a(s[t], t, e)
    });
  }), a;
}, Mn = (s, e, a, t) => s ? Array.isArray(s) ? In(s, e) : Ae(s) ? Ln(s, e) : (is(a, "TRANS_INVALID_COMPONENTS", '<Trans /> "components" prop expects an object or array', {
  i18nKey: t
}), null) : null, Vn = (s) => !Ae(s) || Array.isArray(s) ? !1 : Object.keys(s).reduce((e, a) => e && Number.isNaN(Number.parseFloat(a)), !0);
function Un({
  children: s,
  count: e,
  parent: a,
  i18nKey: t,
  context: i,
  tOptions: n = {},
  values: o,
  defaults: r,
  components: p,
  ns: d,
  i18n: l,
  t: c,
  shouldUnescape: f,
  ...u
}) {
  var L, Ne, j, z, F, Oe;
  const m = l || Ot();
  if (!m)
    return is(m, "NO_I18NEXT_INSTANCE", "Trans: You need to pass in an i18next instance using i18nextReactModule", {
      i18nKey: t
    }), s;
  const h = c || m.t.bind(m) || ((fs) => fs), w = {
    ...ja(),
    ...(L = m.options) == null ? void 0 : L.react
  };
  let b = d || h.ns || ((Ne = m.options) == null ? void 0 : Ne.defaultNS);
  b = se(b) ? [b] : b || ["translation"];
  const D = qa(s, w, m, t), P = r || D || w.transEmptyNodeValue || t, {
    hashTransKey: _
  } = w, k = t || (_ ? _(D || P) : D || P);
  (z = (j = m.options) == null ? void 0 : j.interpolation) != null && z.defaultVariables && (o = o && Object.keys(o).length > 0 ? {
    ...o,
    ...m.options.interpolation.defaultVariables
  } : {
    ...m.options.interpolation.defaultVariables
  });
  const N = o || e !== void 0 && !((Oe = (F = m.options) == null ? void 0 : F.interpolation) != null && Oe.alwaysFormat) || !s ? n.interpolation : {
    interpolation: {
      ...n.interpolation,
      prefix: "#$?",
      suffix: "?$#"
    }
  }, y = {
    ...n,
    context: i || n.context,
    count: e,
    ...o,
    ...N,
    defaultValue: P,
    ns: b
  }, E = k ? h(k, y) : P, T = Mn(p, E, m, t);
  let C = T || s, M = null;
  Vn(T) && (M = T, C = s);
  const B = Fn(C, M, E, m, w, y, f), x = a ?? w.defaultTransParent;
  return x ? _e(x, u, B) : B;
}
const Hn = {
  type: "3rdParty",
  init(s) {
    Tn(s.options.react), Cn(s);
  }
}, kt = Gi();
class Bn {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(e) {
    e.forEach((a) => {
      this.usedNamespaces[a] || (this.usedNamespaces[a] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
function na({
  children: s,
  count: e,
  parent: a,
  i18nKey: t,
  context: i,
  tOptions: n = {},
  values: o,
  defaults: r,
  components: p,
  ns: d,
  i18n: l,
  t: c,
  shouldUnescape: f,
  ...u
}) {
  var D;
  const {
    i18n: m,
    defaultNS: h
  } = Ia(kt) || {}, w = l || m || Ot(), b = c || (w == null ? void 0 : w.t.bind(w));
  return Un({
    children: s,
    count: e,
    parent: a,
    i18nKey: t,
    context: i,
    tOptions: n,
    values: o,
    defaults: r,
    components: p,
    ns: d || (b == null ? void 0 : b.ns) || h || ((D = w == null ? void 0 : w.options) == null ? void 0 : D.defaultNS),
    i18n: w,
    t: c,
    shouldUnescape: f,
    ...u
  });
}
const jn = (s, e) => {
  const a = Ma();
  return dt(() => {
    a.current = s;
  }, [s, e]), a.current;
}, Ga = (s, e, a, t) => s.getFixedT(e, a, t), zn = (s, e, a, t) => Wi(Ga(s, e, a, t), [s, e, a, t]), Wa = (s, e = {}) => {
  var _, k, N, y;
  const {
    i18n: a
  } = e, {
    i18n: t,
    defaultNS: i
  } = Ia(kt) || {}, n = a || t || Ot();
  if (n && !n.reportNamespaces && (n.reportNamespaces = new Bn()), !n) {
    is(n, "NO_I18NEXT_INSTANCE", "useTranslation: You will need to pass in an i18next instance by using initReactI18next");
    const E = (C, M) => se(M) ? M : Ae(M) && se(M.defaultValue) ? M.defaultValue : Array.isArray(C) ? C[C.length - 1] : C, T = [E, {}, !1];
    return T.t = E, T.i18n = {}, T.ready = !1, T;
  }
  (_ = n.options.react) != null && _.wait && is(n, "DEPRECATED_OPTION", "useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const o = {
    ...ja(),
    ...n.options.react,
    ...e
  }, {
    useSuspense: r,
    keyPrefix: p
  } = o;
  let d = i || ((k = n.options) == null ? void 0 : k.defaultNS);
  d = se(d) ? [d] : d || ["translation"], (y = (N = n.reportNamespaces).addUsedNamespaces) == null || y.call(N, d);
  const l = (n.isInitialized || n.initializedStoreOnce) && d.every((E) => Dn(E, n, o)), c = zn(n, e.lng || null, o.nsMode === "fallback" ? d : d[0], p), f = () => c, u = () => Ga(n, e.lng || null, o.nsMode === "fallback" ? d : d[0], p), [m, h] = La(f);
  let w = d.join();
  e.lng && (w = `${e.lng}${w}`);
  const b = jn(w), D = Ma(!0);
  dt(() => {
    const {
      bindI18n: E,
      bindI18nStore: T
    } = o;
    D.current = !0, !l && !r && (e.lng ? ia(n, e.lng, d, () => {
      D.current && h(u);
    }) : ut(n, d, () => {
      D.current && h(u);
    })), l && b && b !== w && D.current && h(u);
    const C = () => {
      D.current && h(u);
    };
    return E && (n == null || n.on(E, C)), T && (n == null || n.store.on(T, C)), () => {
      D.current = !1, n && E && (E == null || E.split(" ").forEach((M) => n.off(M, C))), T && n && T.split(" ").forEach((M) => n.store.off(M, C));
    };
  }, [n, w]), dt(() => {
    D.current && l && h(f);
  }, [n, p, l]);
  const P = [m, n, l];
  if (P.t = m, P.i18n = n, P.ready = l, l || !l && !r) return P;
  throw new Promise((E) => {
    e.lng ? ia(n, e.lng, d, () => E()) : ut(n, d, () => E());
  });
};
function qn({
  i18n: s,
  defaultNS: e,
  children: a
}) {
  const t = Ki(() => ({
    i18n: s,
    defaultNS: e
  }), [s, e]);
  return _e(kt.Provider, {
    value: t
  }, a);
}
const {
  slice: $n,
  forEach: Gn
} = [];
function Wn(s) {
  return Gn.call($n.call(arguments, 1), (e) => {
    if (e)
      for (const a in e)
        s[a] === void 0 && (s[a] = e[a]);
  }), s;
}
function Kn(s) {
  return typeof s != "string" ? !1 : [/<\s*script.*?>/i, /<\s*\/\s*script\s*>/i, /<\s*img.*?on\w+\s*=/i, /<\s*\w+\s*on\w+\s*=.*?>/i, /javascript\s*:/i, /vbscript\s*:/i, /expression\s*\(/i, /eval\s*\(/i, /alert\s*\(/i, /document\.cookie/i, /document\.write\s*\(/i, /window\.location/i, /innerHTML/i].some((a) => a.test(s));
}
const oa = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/, Yn = function(s, e) {
  const t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    path: "/"
  }, i = encodeURIComponent(e);
  let n = `${s}=${i}`;
  if (t.maxAge > 0) {
    const o = t.maxAge - 0;
    if (Number.isNaN(o)) throw new Error("maxAge should be a Number");
    n += `; Max-Age=${Math.floor(o)}`;
  }
  if (t.domain) {
    if (!oa.test(t.domain))
      throw new TypeError("option domain is invalid");
    n += `; Domain=${t.domain}`;
  }
  if (t.path) {
    if (!oa.test(t.path))
      throw new TypeError("option path is invalid");
    n += `; Path=${t.path}`;
  }
  if (t.expires) {
    if (typeof t.expires.toUTCString != "function")
      throw new TypeError("option expires is invalid");
    n += `; Expires=${t.expires.toUTCString()}`;
  }
  if (t.httpOnly && (n += "; HttpOnly"), t.secure && (n += "; Secure"), t.sameSite)
    switch (typeof t.sameSite == "string" ? t.sameSite.toLowerCase() : t.sameSite) {
      case !0:
        n += "; SameSite=Strict";
        break;
      case "lax":
        n += "; SameSite=Lax";
        break;
      case "strict":
        n += "; SameSite=Strict";
        break;
      case "none":
        n += "; SameSite=None";
        break;
      default:
        throw new TypeError("option sameSite is invalid");
    }
  return t.partitioned && (n += "; Partitioned"), n;
}, ra = {
  create(s, e, a, t) {
    let i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      path: "/",
      sameSite: "strict"
    };
    a && (i.expires = /* @__PURE__ */ new Date(), i.expires.setTime(i.expires.getTime() + a * 60 * 1e3)), t && (i.domain = t), document.cookie = Yn(s, e, i);
  },
  read(s) {
    const e = `${s}=`, a = document.cookie.split(";");
    for (let t = 0; t < a.length; t++) {
      let i = a[t];
      for (; i.charAt(0) === " "; ) i = i.substring(1, i.length);
      if (i.indexOf(e) === 0) return i.substring(e.length, i.length);
    }
    return null;
  },
  remove(s, e) {
    this.create(s, "", -1, e);
  }
};
var Qn = {
  name: "cookie",
  // Deconstruct the options object and extract the lookupCookie property
  lookup(s) {
    let {
      lookupCookie: e
    } = s;
    if (e && typeof document < "u")
      return ra.read(e) || void 0;
  },
  // Deconstruct the options object and extract the lookupCookie, cookieMinutes, cookieDomain, and cookieOptions properties
  cacheUserLanguage(s, e) {
    let {
      lookupCookie: a,
      cookieMinutes: t,
      cookieDomain: i,
      cookieOptions: n
    } = e;
    a && typeof document < "u" && ra.create(a, s, t, i, n);
  }
}, Jn = {
  name: "querystring",
  // Deconstruct the options object and extract the lookupQuerystring property
  lookup(s) {
    var t;
    let {
      lookupQuerystring: e
    } = s, a;
    if (typeof window < "u") {
      let {
        search: i
      } = window.location;
      !window.location.search && ((t = window.location.hash) == null ? void 0 : t.indexOf("?")) > -1 && (i = window.location.hash.substring(window.location.hash.indexOf("?")));
      const o = i.substring(1).split("&");
      for (let r = 0; r < o.length; r++) {
        const p = o[r].indexOf("=");
        p > 0 && o[r].substring(0, p) === e && (a = o[r].substring(p + 1));
      }
    }
    return a;
  }
}, Xn = {
  name: "hash",
  // Deconstruct the options object and extract the lookupHash property and the lookupFromHashIndex property
  lookup(s) {
    var i;
    let {
      lookupHash: e,
      lookupFromHashIndex: a
    } = s, t;
    if (typeof window < "u") {
      const {
        hash: n
      } = window.location;
      if (n && n.length > 2) {
        const o = n.substring(1);
        if (e) {
          const r = o.split("&");
          for (let p = 0; p < r.length; p++) {
            const d = r[p].indexOf("=");
            d > 0 && r[p].substring(0, d) === e && (t = r[p].substring(d + 1));
          }
        }
        if (t) return t;
        if (!t && a > -1) {
          const r = n.match(/\/([a-zA-Z-]*)/g);
          return Array.isArray(r) ? (i = r[typeof a == "number" ? a : 0]) == null ? void 0 : i.replace("/", "") : void 0;
        }
      }
    }
    return t;
  }
};
let Ue = null;
const pa = () => {
  if (Ue !== null) return Ue;
  try {
    if (Ue = typeof window < "u" && window.localStorage !== null, !Ue)
      return !1;
    const s = "i18next.translate.boo";
    window.localStorage.setItem(s, "foo"), window.localStorage.removeItem(s);
  } catch {
    Ue = !1;
  }
  return Ue;
};
var Zn = {
  name: "localStorage",
  // Deconstruct the options object and extract the lookupLocalStorage property
  lookup(s) {
    let {
      lookupLocalStorage: e
    } = s;
    if (e && pa())
      return window.localStorage.getItem(e) || void 0;
  },
  // Deconstruct the options object and extract the lookupLocalStorage property
  cacheUserLanguage(s, e) {
    let {
      lookupLocalStorage: a
    } = e;
    a && pa() && window.localStorage.setItem(a, s);
  }
};
let He = null;
const da = () => {
  if (He !== null) return He;
  try {
    if (He = typeof window < "u" && window.sessionStorage !== null, !He)
      return !1;
    const s = "i18next.translate.boo";
    window.sessionStorage.setItem(s, "foo"), window.sessionStorage.removeItem(s);
  } catch {
    He = !1;
  }
  return He;
};
var eo = {
  name: "sessionStorage",
  lookup(s) {
    let {
      lookupSessionStorage: e
    } = s;
    if (e && da())
      return window.sessionStorage.getItem(e) || void 0;
  },
  cacheUserLanguage(s, e) {
    let {
      lookupSessionStorage: a
    } = e;
    a && da() && window.sessionStorage.setItem(a, s);
  }
}, so = {
  name: "navigator",
  lookup(s) {
    const e = [];
    if (typeof navigator < "u") {
      const {
        languages: a,
        userLanguage: t,
        language: i
      } = navigator;
      if (a)
        for (let n = 0; n < a.length; n++)
          e.push(a[n]);
      t && e.push(t), i && e.push(i);
    }
    return e.length > 0 ? e : void 0;
  }
}, to = {
  name: "htmlTag",
  // Deconstruct the options object and extract the htmlTag property
  lookup(s) {
    let {
      htmlTag: e
    } = s, a;
    const t = e || (typeof document < "u" ? document.documentElement : null);
    return t && typeof t.getAttribute == "function" && (a = t.getAttribute("lang")), a;
  }
}, ao = {
  name: "path",
  // Deconstruct the options object and extract the lookupFromPathIndex property
  lookup(s) {
    var i;
    let {
      lookupFromPathIndex: e
    } = s;
    if (typeof window > "u") return;
    const a = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
    return Array.isArray(a) ? (i = a[typeof e == "number" ? e : 0]) == null ? void 0 : i.replace("/", "") : void 0;
  }
}, io = {
  name: "subdomain",
  lookup(s) {
    var i, n;
    let {
      lookupFromSubdomainIndex: e
    } = s;
    const a = typeof e == "number" ? e + 1 : 1, t = typeof window < "u" && ((n = (i = window.location) == null ? void 0 : i.hostname) == null ? void 0 : n.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i));
    if (t)
      return t[a];
  }
};
let Ka = !1;
try {
  document.cookie, Ka = !0;
} catch {
}
const Ya = ["querystring", "cookie", "localStorage", "sessionStorage", "navigator", "htmlTag"];
Ka || Ya.splice(1, 1);
const no = () => ({
  order: Ya,
  lookupQuerystring: "lng",
  lookupCookie: "i18next",
  lookupLocalStorage: "i18nextLng",
  lookupSessionStorage: "i18nextLng",
  // cache user language
  caches: ["localStorage"],
  excludeCacheFor: ["cimode"],
  // cookieMinutes: 10,
  // cookieDomain: 'myDomain'
  convertDetectedLanguage: (s) => s
});
class Qa {
  constructor(e) {
    let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.type = "languageDetector", this.detectors = {}, this.init(e, a);
  }
  init() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
      languageUtils: {}
    }, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    this.services = e, this.options = Wn(a, this.options || {}, no()), typeof this.options.convertDetectedLanguage == "string" && this.options.convertDetectedLanguage.indexOf("15897") > -1 && (this.options.convertDetectedLanguage = (i) => i.replace("-", "_")), this.options.lookupFromUrlIndex && (this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex), this.i18nOptions = t, this.addDetector(Qn), this.addDetector(Jn), this.addDetector(Zn), this.addDetector(eo), this.addDetector(so), this.addDetector(to), this.addDetector(ao), this.addDetector(io), this.addDetector(Xn);
  }
  addDetector(e) {
    return this.detectors[e.name] = e, this;
  }
  detect() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.options.order, a = [];
    return e.forEach((t) => {
      if (this.detectors[t]) {
        let i = this.detectors[t].lookup(this.options);
        i && typeof i == "string" && (i = [i]), i && (a = a.concat(i));
      }
    }), a = a.filter((t) => t != null && !Kn(t)).map((t) => this.options.convertDetectedLanguage(t)), this.services && this.services.languageUtils && this.services.languageUtils.getBestMatchFromCodes ? a : a.length > 0 ? a[0] : null;
  }
  cacheUserLanguage(e) {
    let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.options.caches;
    a && (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(e) > -1 || a.forEach((t) => {
      this.detectors[t] && this.detectors[t].cacheUserLanguage(e, this.options);
    }));
  }
}
Qa.type = "languageDetector";
var oo = {
  0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
  1: function(e, a) {
    return "Cannot apply '" + e + "' to '" + a.toString() + "': Field not found.";
  },
  /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */
  5: "'keys()' can only be used on observable objects, arrays, sets and maps",
  6: "'values()' can only be used on observable objects, arrays, sets and maps",
  7: "'entries()' can only be used on observable objects, arrays and maps",
  8: "'set()' can only be used on observable objects, arrays and maps",
  9: "'remove()' can only be used on observable objects, arrays and maps",
  10: "'has()' can only be used on observable objects, arrays and maps",
  11: "'get()' can only be used on observable objects, arrays and maps",
  12: "Invalid annotation",
  13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
  14: "Intercept handlers should return nothing or a change object",
  15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
  16: "Modification exception: the internal structure of an observable array was changed.",
  17: function(e, a) {
    return "[mobx.array] Index out of bounds, " + e + " is larger than " + a;
  },
  18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
  19: function(e) {
    return "Cannot initialize from classes that inherit from Map: " + e.constructor.name;
  },
  20: function(e) {
    return "Cannot initialize map from " + e;
  },
  21: function(e) {
    return "Cannot convert to map from '" + e + "'";
  },
  22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
  23: "It is not possible to get index atoms from arrays",
  24: function(e) {
    return "Cannot obtain administration from " + e;
  },
  25: function(e, a) {
    return "the entry '" + e + "' does not exist in the observable map '" + a + "'";
  },
  26: "please specify a property",
  27: function(e, a) {
    return "no observable property '" + e.toString() + "' found on the observable object '" + a + "'";
  },
  28: function(e) {
    return "Cannot obtain atom from " + e;
  },
  29: "Expecting some object",
  30: "invalid action stack. did you forget to finish an action?",
  31: "missing option for computed: get",
  32: function(e, a) {
    return "Cycle detected in computation " + e + ": " + a;
  },
  33: function(e) {
    return "The setter of computed value '" + e + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
  },
  34: function(e) {
    return "[ComputedValue '" + e + "'] It is not possible to assign a new value to a computed value.";
  },
  35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
  36: "isolateGlobalState should be called before MobX is running any reactions",
  37: function(e) {
    return "[mobx] `observableArray." + e + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + e + "()` instead";
  },
  38: "'ownKeys()' can only be used on observable objects",
  39: "'defineProperty()' can only be used on observable objects"
}, ro = process.env.NODE_ENV !== "production" ? oo : {};
function v(s) {
  for (var e = arguments.length, a = new Array(e > 1 ? e - 1 : 0), t = 1; t < e; t++)
    a[t - 1] = arguments[t];
  if (process.env.NODE_ENV !== "production") {
    var i = typeof s == "string" ? s : ro[s];
    throw typeof i == "function" && (i = i.apply(null, a)), new Error("[MobX] " + i);
  }
  throw new Error(typeof s == "number" ? "[MobX] minified error nr: " + s + (a.length ? " " + a.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + s);
}
var po = {};
function Hs() {
  return typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : po;
}
var Ja = Object.assign, Es = Object.getOwnPropertyDescriptor, ue = Object.defineProperty, Bs = Object.prototype, Ts = [];
Object.freeze(Ts);
var Xa = {};
Object.freeze(Xa);
var lo = typeof Proxy < "u", co = /* @__PURE__ */ Object.toString();
function Za() {
  lo || v(process.env.NODE_ENV !== "production" ? "`Proxy` objects are not available in the current environment. Please configure MobX to enable a fallback implementation.`" : "Proxy not available");
}
function Ze(s) {
  process.env.NODE_ENV !== "production" && g.verifyProxies && v("MobX is currently configured to be able to run in ES5 mode, but in ES5 MobX won't be able to " + s);
}
function pe() {
  return ++g.mobxGuid;
}
function Et(s) {
  var e = !1;
  return function() {
    if (!e)
      return e = !0, s.apply(this, arguments);
  };
}
var je = function() {
};
function I(s) {
  return typeof s == "function";
}
function Ce(s) {
  var e = typeof s;
  switch (e) {
    case "string":
    case "symbol":
    case "number":
      return !0;
  }
  return !1;
}
function js(s) {
  return s !== null && typeof s == "object";
}
function ge(s) {
  if (!js(s))
    return !1;
  var e = Object.getPrototypeOf(s);
  if (e == null)
    return !0;
  var a = Object.hasOwnProperty.call(e, "constructor") && e.constructor;
  return typeof a == "function" && a.toString() === co;
}
function ei(s) {
  var e = s == null ? void 0 : s.constructor;
  return e ? e.name === "GeneratorFunction" || e.displayName === "GeneratorFunction" : !1;
}
function zs(s, e, a) {
  ue(s, e, {
    enumerable: !1,
    writable: !0,
    configurable: !0,
    value: a
  });
}
function si(s, e, a) {
  ue(s, e, {
    enumerable: !1,
    writable: !1,
    configurable: !0,
    value: a
  });
}
function Ie(s, e) {
  var a = "isMobX" + s;
  return e.prototype[a] = !0, function(t) {
    return js(t) && t[a] === !0;
  };
}
function Ke(s) {
  return s != null && Object.prototype.toString.call(s) === "[object Map]";
}
function mo(s) {
  var e = Object.getPrototypeOf(s), a = Object.getPrototypeOf(e), t = Object.getPrototypeOf(a);
  return t === null;
}
function he(s) {
  return s != null && Object.prototype.toString.call(s) === "[object Set]";
}
var ti = typeof Object.getOwnPropertySymbols < "u";
function uo(s) {
  var e = Object.keys(s);
  if (!ti)
    return e;
  var a = Object.getOwnPropertySymbols(s);
  return a.length ? [].concat(e, a.filter(function(t) {
    return Bs.propertyIsEnumerable.call(s, t);
  })) : e;
}
var qs = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : ti ? function(s) {
  return Object.getOwnPropertyNames(s).concat(Object.getOwnPropertySymbols(s));
} : (
  /* istanbul ignore next */
  Object.getOwnPropertyNames
);
function gt(s) {
  return typeof s == "string" ? s : typeof s == "symbol" ? s.toString() : new String(s).toString();
}
function ai(s) {
  return s === null ? null : typeof s == "object" ? "" + s : s;
}
function te(s, e) {
  return Bs.hasOwnProperty.call(s, e);
}
var fo = Object.getOwnPropertyDescriptors || function(e) {
  var a = {};
  return qs(e).forEach(function(t) {
    a[t] = Es(e, t);
  }), a;
};
function G(s, e) {
  return !!(s & e);
}
function W(s, e, a) {
  return a ? s |= e : s &= ~e, s;
}
function la(s, e) {
  (e == null || e > s.length) && (e = s.length);
  for (var a = 0, t = Array(e); a < e; a++) t[a] = s[a];
  return t;
}
function go(s, e) {
  for (var a = 0; a < e.length; a++) {
    var t = e[a];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(s, vo(t.key), t);
  }
}
function Ye(s, e, a) {
  return e && go(s.prototype, e), Object.defineProperty(s, "prototype", {
    writable: !1
  }), s;
}
function ze(s, e) {
  var a = typeof Symbol < "u" && s[Symbol.iterator] || s["@@iterator"];
  if (a) return (a = a.call(s)).next.bind(a);
  if (Array.isArray(s) || (a = wo(s)) || e) {
    a && (s = a);
    var t = 0;
    return function() {
      return t >= s.length ? {
        done: !0
      } : {
        done: !1,
        value: s[t++]
      };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function be() {
  return be = Object.assign ? Object.assign.bind() : function(s) {
    for (var e = 1; e < arguments.length; e++) {
      var a = arguments[e];
      for (var t in a) ({}).hasOwnProperty.call(a, t) && (s[t] = a[t]);
    }
    return s;
  }, be.apply(null, arguments);
}
function ii(s, e) {
  s.prototype = Object.create(e.prototype), s.prototype.constructor = s, ht(s, e);
}
function ht(s, e) {
  return ht = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(a, t) {
    return a.__proto__ = t, a;
  }, ht(s, e);
}
function ho(s, e) {
  if (typeof s != "object" || !s) return s;
  var a = s[Symbol.toPrimitive];
  if (a !== void 0) {
    var t = a.call(s, e);
    if (typeof t != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(s);
}
function vo(s) {
  var e = ho(s, "string");
  return typeof e == "symbol" ? e : e + "";
}
function wo(s, e) {
  if (s) {
    if (typeof s == "string") return la(s, e);
    var a = {}.toString.call(s).slice(8, -1);
    return a === "Object" && s.constructor && (a = s.constructor.name), a === "Map" || a === "Set" ? Array.from(s) : a === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? la(s, e) : void 0;
  }
}
var q = /* @__PURE__ */ Symbol("mobx-stored-annotations");
function fe(s) {
  function e(a, t) {
    if (ds(t))
      return s.decorate_20223_(a, t);
    ps(a, t, s);
  }
  return Object.assign(e, s);
}
function ps(s, e, a) {
  if (te(s, q) || zs(s, q, be({}, s[q])), process.env.NODE_ENV !== "production" && xs(a) && !te(s[q], e)) {
    var t = s.constructor.name + ".prototype." + e.toString();
    v("'" + t + "' is decorated with 'override', but no such decorated member was found on prototype.");
  }
  bo(s, a, e), xs(a) || (s[q][e] = a);
}
function bo(s, e, a) {
  if (process.env.NODE_ENV !== "production" && !xs(e) && te(s[q], a)) {
    var t = s.constructor.name + ".prototype." + a.toString(), i = s[q][a].annotationType_, n = e.annotationType_;
    v("Cannot apply '@" + n + "' to '" + t + "':" + (`
The field is already decorated with '@` + i + "'.") + `
Re-decorating fields is not allowed.
Use '@override' decorator for methods overridden by subclass.`);
  }
}
function yo(s) {
  return te(s, q) || zs(s, q, be({}, s[q])), s[q];
}
function ds(s) {
  return typeof s == "object" && typeof s.kind == "string";
}
function $s(s, e) {
  process.env.NODE_ENV !== "production" && !e.includes(s.kind) && v("The decorator applied to '" + String(s.name) + "' cannot be used on a " + s.kind + " element");
}
var S = /* @__PURE__ */ Symbol("mobx administration"), Pe = /* @__PURE__ */ function() {
  function s(a) {
    a === void 0 && (a = process.env.NODE_ENV !== "production" ? "Atom@" + pe() : "Atom"), this.name_ = void 0, this.flags_ = 0, this.observers_ = /* @__PURE__ */ new Set(), this.lastAccessedBy_ = 0, this.lowestObserverState_ = O.NOT_TRACKING_, this.onBOL = void 0, this.onBUOL = void 0, this.name_ = a;
  }
  var e = s.prototype;
  return e.onBO = function() {
    this.onBOL && this.onBOL.forEach(function(t) {
      return t();
    });
  }, e.onBUO = function() {
    this.onBUOL && this.onBUOL.forEach(function(t) {
      return t();
    });
  }, e.reportObserved = function() {
    return yi(this);
  }, e.reportChanged = function() {
    Z(), _i(this), ee();
  }, e.toString = function() {
    return this.name_;
  }, Ye(s, [{
    key: "isBeingObserved",
    get: function() {
      return G(this.flags_, s.isBeingObservedMask_);
    },
    set: function(t) {
      this.flags_ = W(this.flags_, s.isBeingObservedMask_, t);
    }
  }, {
    key: "isPendingUnobservation",
    get: function() {
      return G(this.flags_, s.isPendingUnobservationMask_);
    },
    set: function(t) {
      this.flags_ = W(this.flags_, s.isPendingUnobservationMask_, t);
    }
  }, {
    key: "diffValue",
    get: function() {
      return G(this.flags_, s.diffValueMask_) ? 1 : 0;
    },
    set: function(t) {
      this.flags_ = W(this.flags_, s.diffValueMask_, t === 1);
    }
  }]);
}();
Pe.isBeingObservedMask_ = 1;
Pe.isPendingUnobservationMask_ = 2;
Pe.diffValueMask_ = 4;
var Tt = /* @__PURE__ */ Ie("Atom", Pe);
function ni(s, e, a) {
  e === void 0 && (e = je), a === void 0 && (a = je);
  var t = new Pe(s);
  return e !== je && xr(t, e), a !== je && Oi(t, a), t;
}
function _o(s, e) {
  return Ui(s, e);
}
function Ao(s, e) {
  return Object.is ? Object.is(s, e) : s === e ? s !== 0 || 1 / s === 1 / e : s !== s && e !== e;
}
var Cs = {
  structural: _o,
  default: Ao
};
function xe(s, e, a) {
  return rs(s) ? s : Array.isArray(s) ? V.array(s, {
    name: a
  }) : ge(s) ? V.object(s, void 0, {
    name: a
  }) : Ke(s) ? V.map(s, {
    name: a
  }) : he(s) ? V.set(s, {
    name: a
  }) : typeof s == "function" && !$e(s) && !os(s) ? ei(s) ? Ge(s) : ns(a, s) : s;
}
function So(s, e, a) {
  if (s == null || us(s) || Qs(s) || De(s) || le(s))
    return s;
  if (Array.isArray(s))
    return V.array(s, {
      name: a,
      deep: !1
    });
  if (ge(s))
    return V.object(s, void 0, {
      name: a,
      deep: !1
    });
  if (Ke(s))
    return V.map(s, {
      name: a,
      deep: !1
    });
  if (he(s))
    return V.set(s, {
      name: a,
      deep: !1
    });
  process.env.NODE_ENV !== "production" && v("The shallow modifier / decorator can only used in combination with arrays, objects, maps and sets");
}
function Gs(s) {
  return s;
}
function Po(s, e) {
  return process.env.NODE_ENV !== "production" && rs(s) && v("observable.struct should not be used with observable values"), Ui(s, e) ? e : s;
}
var Do = "override";
function xs(s) {
  return s.annotationType_ === Do;
}
function ls(s, e) {
  return {
    annotationType_: s,
    options_: e,
    make_: No,
    extend_: Oo,
    decorate_20223_: ko
  };
}
function No(s, e, a, t) {
  var i;
  if ((i = this.options_) != null && i.bound)
    return this.extend_(s, e, a, !1) === null ? 0 : 1;
  if (t === s.target_)
    return this.extend_(s, e, a, !1) === null ? 0 : 2;
  if ($e(a.value))
    return 1;
  var n = oi(s, this, e, a, !1);
  return ue(t, e, n), 2;
}
function Oo(s, e, a, t) {
  var i = oi(s, this, e, a);
  return s.defineProperty_(e, i, t);
}
function ko(s, e) {
  process.env.NODE_ENV !== "production" && $s(e, ["method", "field"]);
  var a = e.kind, t = e.name, i = e.addInitializer, n = this, o = function(d) {
    var l, c, f, u;
    return Re((l = (c = n.options_) == null ? void 0 : c.name) != null ? l : t.toString(), d, (f = (u = n.options_) == null ? void 0 : u.autoAction) != null ? f : !1);
  };
  if (a == "field")
    return function(p) {
      var d, l = p;
      return $e(l) || (l = o(l)), (d = n.options_) != null && d.bound && (l = l.bind(this), l.isMobxAction = !0), l;
    };
  if (a == "method") {
    var r;
    return $e(s) || (s = o(s)), (r = this.options_) != null && r.bound && i(function() {
      var p = this, d = p[t].bind(p);
      d.isMobxAction = !0, p[t] = d;
    }), s;
  }
  v("Cannot apply '" + n.annotationType_ + "' to '" + String(t) + "' (kind: " + a + "):" + (`
'` + n.annotationType_ + "' can only be used on properties with a function value."));
}
function Eo(s, e, a, t) {
  var i = e.annotationType_, n = t.value;
  process.env.NODE_ENV !== "production" && !I(n) && v("Cannot apply '" + i + "' to '" + s.name_ + "." + a.toString() + "':" + (`
'` + i + "' can only be used on properties with a function value."));
}
function oi(s, e, a, t, i) {
  var n, o, r, p, d, l, c;
  i === void 0 && (i = g.safeDescriptors), Eo(s, e, a, t);
  var f = t.value;
  if ((n = e.options_) != null && n.bound) {
    var u;
    f = f.bind((u = s.proxy_) != null ? u : s.target_);
  }
  return {
    value: Re(
      (o = (r = e.options_) == null ? void 0 : r.name) != null ? o : a.toString(),
      f,
      (p = (d = e.options_) == null ? void 0 : d.autoAction) != null ? p : !1,
      // https://github.com/mobxjs/mobx/discussions/3140
      (l = e.options_) != null && l.bound ? (c = s.proxy_) != null ? c : s.target_ : void 0
    ),
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: i ? s.isPlainObject_ : !0,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: !1,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: !i
  };
}
function ri(s, e) {
  return {
    annotationType_: s,
    options_: e,
    make_: To,
    extend_: Co,
    decorate_20223_: xo
  };
}
function To(s, e, a, t) {
  var i;
  if (t === s.target_)
    return this.extend_(s, e, a, !1) === null ? 0 : 2;
  if ((i = this.options_) != null && i.bound && (!te(s.target_, e) || !os(s.target_[e])) && this.extend_(s, e, a, !1) === null)
    return 0;
  if (os(a.value))
    return 1;
  var n = pi(s, this, e, a, !1, !1);
  return ue(t, e, n), 2;
}
function Co(s, e, a, t) {
  var i, n = pi(s, this, e, a, (i = this.options_) == null ? void 0 : i.bound);
  return s.defineProperty_(e, n, t);
}
function xo(s, e) {
  var a;
  process.env.NODE_ENV !== "production" && $s(e, ["method"]);
  var t = e.name, i = e.addInitializer;
  return os(s) || (s = Ge(s)), (a = this.options_) != null && a.bound && i(function() {
    var n = this, o = n[t].bind(n);
    o.isMobXFlow = !0, n[t] = o;
  }), s;
}
function Ro(s, e, a, t) {
  var i = e.annotationType_, n = t.value;
  process.env.NODE_ENV !== "production" && !I(n) && v("Cannot apply '" + i + "' to '" + s.name_ + "." + a.toString() + "':" + (`
'` + i + "' can only be used on properties with a generator function value."));
}
function pi(s, e, a, t, i, n) {
  n === void 0 && (n = g.safeDescriptors), Ro(s, e, a, t);
  var o = t.value;
  if (os(o) || (o = Ge(o)), i) {
    var r;
    o = o.bind((r = s.proxy_) != null ? r : s.target_), o.isMobXFlow = !0;
  }
  return {
    value: o,
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: n ? s.isPlainObject_ : !0,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: !1,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: !n
  };
}
function Ct(s, e) {
  return {
    annotationType_: s,
    options_: e,
    make_: Fo,
    extend_: Io,
    decorate_20223_: Lo
  };
}
function Fo(s, e, a) {
  return this.extend_(s, e, a, !1) === null ? 0 : 1;
}
function Io(s, e, a, t) {
  return Mo(s, this, e, a), s.defineComputedProperty_(e, be({}, this.options_, {
    get: a.get,
    set: a.set
  }), t);
}
function Lo(s, e) {
  process.env.NODE_ENV !== "production" && $s(e, ["getter"]);
  var a = this, t = e.name, i = e.addInitializer;
  return i(function() {
    var n = Qe(this)[S], o = be({}, a.options_, {
      get: s,
      context: this
    });
    o.name || (o.name = process.env.NODE_ENV !== "production" ? n.name_ + "." + t.toString() : "ObservableObject." + t.toString()), n.values_.set(t, new ie(o));
  }), function() {
    return this[S].getObservablePropValue_(t);
  };
}
function Mo(s, e, a, t) {
  var i = e.annotationType_, n = t.get;
  process.env.NODE_ENV !== "production" && !n && v("Cannot apply '" + i + "' to '" + s.name_ + "." + a.toString() + "':" + (`
'` + i + "' can only be used on getter(+setter) properties."));
}
function Ws(s, e) {
  return {
    annotationType_: s,
    options_: e,
    make_: Vo,
    extend_: Uo,
    decorate_20223_: Ho
  };
}
function Vo(s, e, a) {
  return this.extend_(s, e, a, !1) === null ? 0 : 1;
}
function Uo(s, e, a, t) {
  var i, n;
  return Bo(s, this, e, a), s.defineObservableProperty_(e, a.value, (i = (n = this.options_) == null ? void 0 : n.enhancer) != null ? i : xe, t);
}
function Ho(s, e) {
  if (process.env.NODE_ENV !== "production") {
    if (e.kind === "field")
      throw v("Please use `@observable accessor " + String(e.name) + "` instead of `@observable " + String(e.name) + "`");
    $s(e, ["accessor"]);
  }
  var a = this, t = e.kind, i = e.name, n = /* @__PURE__ */ new WeakSet();
  function o(r, p) {
    var d, l, c = Qe(r)[S], f = new Te(p, (d = (l = a.options_) == null ? void 0 : l.enhancer) != null ? d : xe, process.env.NODE_ENV !== "production" ? c.name_ + "." + i.toString() : "ObservableObject." + i.toString(), !1);
    c.values_.set(i, f), n.add(r);
  }
  if (t == "accessor")
    return {
      get: function() {
        return n.has(this) || o(this, s.get.call(this)), this[S].getObservablePropValue_(i);
      },
      set: function(p) {
        return n.has(this) || o(this, p), this[S].setObservablePropValue_(i, p);
      },
      init: function(p) {
        return n.has(this) || o(this, p), p;
      }
    };
}
function Bo(s, e, a, t) {
  var i = e.annotationType_;
  process.env.NODE_ENV !== "production" && !("value" in t) && v("Cannot apply '" + i + "' to '" + s.name_ + "." + a.toString() + "':" + (`
'` + i + "' cannot be used on getter/setter properties"));
}
var jo = "true", zo = /* @__PURE__ */ di();
function di(s) {
  return {
    annotationType_: jo,
    options_: s,
    make_: qo,
    extend_: $o,
    decorate_20223_: Go
  };
}
function qo(s, e, a, t) {
  var i, n;
  if (a.get)
    return Ks.make_(s, e, a, t);
  if (a.set) {
    var o = Re(e.toString(), a.set);
    return t === s.target_ ? s.defineProperty_(e, {
      configurable: g.safeDescriptors ? s.isPlainObject_ : !0,
      set: o
    }) === null ? 0 : 2 : (ue(t, e, {
      configurable: !0,
      set: o
    }), 2);
  }
  if (t !== s.target_ && typeof a.value == "function") {
    var r;
    if (ei(a.value)) {
      var p, d = (p = this.options_) != null && p.autoBind ? Ge.bound : Ge;
      return d.make_(s, e, a, t);
    }
    var l = (r = this.options_) != null && r.autoBind ? ns.bound : ns;
    return l.make_(s, e, a, t);
  }
  var c = ((i = this.options_) == null ? void 0 : i.deep) === !1 ? V.ref : V;
  if (typeof a.value == "function" && (n = this.options_) != null && n.autoBind) {
    var f;
    a.value = a.value.bind((f = s.proxy_) != null ? f : s.target_);
  }
  return c.make_(s, e, a, t);
}
function $o(s, e, a, t) {
  var i, n;
  if (a.get)
    return Ks.extend_(s, e, a, t);
  if (a.set)
    return s.defineProperty_(e, {
      configurable: g.safeDescriptors ? s.isPlainObject_ : !0,
      set: Re(e.toString(), a.set)
    }, t);
  if (typeof a.value == "function" && (i = this.options_) != null && i.autoBind) {
    var o;
    a.value = a.value.bind((o = s.proxy_) != null ? o : s.target_);
  }
  var r = ((n = this.options_) == null ? void 0 : n.deep) === !1 ? V.ref : V;
  return r.extend_(s, e, a, t);
}
function Go(s, e) {
  v("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var Wo = "observable", Ko = "observable.ref", Yo = "observable.shallow", Qo = "observable.struct", li = {
  deep: !0,
  name: void 0,
  defaultDecorator: void 0,
  proxy: !0
};
Object.freeze(li);
function hs(s) {
  return s || li;
}
var vt = /* @__PURE__ */ Ws(Wo), Jo = /* @__PURE__ */ Ws(Ko, {
  enhancer: Gs
}), Xo = /* @__PURE__ */ Ws(Yo, {
  enhancer: So
}), Zo = /* @__PURE__ */ Ws(Qo, {
  enhancer: Po
}), ci = /* @__PURE__ */ fe(vt);
function vs(s) {
  return s.deep === !0 ? xe : s.deep === !1 ? Gs : sr(s.defaultDecorator);
}
function er(s) {
  var e;
  return s ? (e = s.defaultDecorator) != null ? e : di(s) : void 0;
}
function sr(s) {
  var e, a;
  return s && (e = (a = s.options_) == null ? void 0 : a.enhancer) != null ? e : xe;
}
function mi(s, e, a) {
  if (ds(e))
    return vt.decorate_20223_(s, e);
  if (Ce(e)) {
    ps(s, e, vt);
    return;
  }
  return rs(s) ? s : ge(s) ? V.object(s, e, a) : Array.isArray(s) ? V.array(s, e) : Ke(s) ? V.map(s, e) : he(s) ? V.set(s, e) : typeof s == "object" && s !== null ? s : V.box(s, e);
}
Ja(mi, ci);
var tr = {
  box: function(e, a) {
    var t = hs(a);
    return new Te(e, vs(t), t.name, !0, t.equals);
  },
  array: function(e, a) {
    var t = hs(a);
    return (g.useProxies === !1 || t.proxy === !1 ? ip : Kr)(e, vs(t), t.name);
  },
  map: function(e, a) {
    var t = hs(a);
    return new Ri(e, vs(t), t.name);
  },
  set: function(e, a) {
    var t = hs(a);
    return new Fi(e, vs(t), t.name);
  },
  object: function(e, a, t) {
    return Me(function() {
      return Lr(g.useProxies === !1 || (t == null ? void 0 : t.proxy) === !1 ? Qe({}, t) : qr({}, t), e, a);
    });
  },
  ref: /* @__PURE__ */ fe(Jo),
  shallow: /* @__PURE__ */ fe(Xo),
  deep: ci,
  struct: /* @__PURE__ */ fe(Zo)
}, V = /* @__PURE__ */ Ja(mi, tr), ui = "computed", ar = "computed.struct", wt = /* @__PURE__ */ Ct(ui), ir = /* @__PURE__ */ Ct(ar, {
  equals: Cs.structural
}), Ks = function(e, a) {
  if (ds(a))
    return wt.decorate_20223_(e, a);
  if (Ce(a))
    return ps(e, a, wt);
  if (ge(e))
    return fe(Ct(ui, e));
  process.env.NODE_ENV !== "production" && (I(e) || v("First argument to `computed` should be an expression."), I(a) && v("A setter as second argument is no longer supported, use `{ set: fn }` option instead"));
  var t = ge(a) ? a : {};
  return t.get = e, t.name || (t.name = e.name || ""), new ie(t);
};
Object.assign(Ks, wt);
Ks.struct = /* @__PURE__ */ fe(ir);
var ca, ma, Rs = 0, nr = 1, or = (ca = (ma = /* @__PURE__ */ Es(function() {
}, "name")) == null ? void 0 : ma.configurable) != null ? ca : !1, ua = {
  value: "action",
  configurable: !0,
  writable: !1,
  enumerable: !1
};
function Re(s, e, a, t) {
  a === void 0 && (a = !1), process.env.NODE_ENV !== "production" && (I(e) || v("`action` can only be invoked on functions"), (typeof s != "string" || !s) && v("actions should have valid names, got: '" + s + "'"));
  function i() {
    return rr(s, a, e, t || this, arguments);
  }
  return i.isMobxAction = !0, i.toString = function() {
    return e.toString();
  }, or && (ua.value = s, ue(i, "name", ua)), i;
}
function rr(s, e, a, t, i) {
  var n = pr(s, e, t, i);
  try {
    return a.apply(t, i);
  } catch (o) {
    throw n.error_ = o, o;
  } finally {
    dr(n);
  }
}
function pr(s, e, a, t) {
  var i = process.env.NODE_ENV !== "production" && U() && !!s, n = 0;
  if (process.env.NODE_ENV !== "production" && i) {
    n = Date.now();
    var o = t ? Array.from(t) : Ts;
    K({
      type: It,
      name: s,
      object: a,
      arguments: o
    });
  }
  var r = g.trackingDerivation, p = !e || !r;
  Z();
  var d = g.allowStateChanges;
  p && (Le(), d = xt(!0));
  var l = Ft(!0), c = {
    runAsAction_: p,
    prevDerivation_: r,
    prevAllowStateChanges_: d,
    prevAllowStateReads_: l,
    notifySpy_: i,
    startTime_: n,
    actionId_: nr++,
    parentActionId_: Rs
  };
  return Rs = c.actionId_, c;
}
function dr(s) {
  Rs !== s.actionId_ && v(30), Rs = s.parentActionId_, s.error_ !== void 0 && (g.suppressReactionErrors = !0), Rt(s.prevAllowStateChanges_), ss(s.prevAllowStateReads_), ee(), s.runAsAction_ && we(s.prevDerivation_), process.env.NODE_ENV !== "production" && s.notifySpy_ && Y({
    time: Date.now() - s.startTime_
  }), g.suppressReactionErrors = !1;
}
function xt(s) {
  var e = g.allowStateChanges;
  return g.allowStateChanges = s, e;
}
function Rt(s) {
  g.allowStateChanges = s;
}
var lr = "create", Te = /* @__PURE__ */ function(s) {
  function e(t, i, n, o, r) {
    var p;
    return n === void 0 && (n = process.env.NODE_ENV !== "production" ? "ObservableValue@" + pe() : "ObservableValue"), o === void 0 && (o = !0), r === void 0 && (r = Cs.default), p = s.call(this, n) || this, p.enhancer = void 0, p.name_ = void 0, p.equals = void 0, p.hasUnreportedChange_ = !1, p.interceptors_ = void 0, p.changeListeners_ = void 0, p.value_ = void 0, p.dehancer = void 0, p.enhancer = i, p.name_ = n, p.equals = r, p.value_ = i(t, void 0, n), process.env.NODE_ENV !== "production" && o && U() && Fe({
      type: lr,
      object: p,
      observableKind: "value",
      debugObjectName: p.name_,
      newValue: "" + p.value_
    }), p;
  }
  ii(e, s);
  var a = e.prototype;
  return a.dehanceValue = function(i) {
    return this.dehancer !== void 0 ? this.dehancer(i) : i;
  }, a.set = function(i) {
    var n = this.value_;
    if (i = this.prepareNewValue_(i), i !== g.UNCHANGED) {
      var o = U();
      process.env.NODE_ENV !== "production" && o && K({
        type: ne,
        object: this,
        observableKind: "value",
        debugObjectName: this.name_,
        newValue: i,
        oldValue: n
      }), this.setNewValue_(i), process.env.NODE_ENV !== "production" && o && Y();
    }
  }, a.prepareNewValue_ = function(i) {
    if (me(this), J(this)) {
      var n = X(this, {
        object: this,
        type: ne,
        newValue: i
      });
      if (!n)
        return g.UNCHANGED;
      i = n.newValue;
    }
    return i = this.enhancer(i, this.value_, this.name_), this.equals(this.value_, i) ? g.UNCHANGED : i;
  }, a.setNewValue_ = function(i) {
    var n = this.value_;
    this.value_ = i, this.reportChanged(), oe(this) && re(this, {
      type: ne,
      object: this,
      newValue: i,
      oldValue: n
    });
  }, a.get = function() {
    return this.reportObserved(), this.dehanceValue(this.value_);
  }, a.intercept_ = function(i) {
    return cs(this, i);
  }, a.observe_ = function(i, n) {
    return n && i({
      observableKind: "value",
      debugObjectName: this.name_,
      object: this,
      type: ne,
      newValue: this.value_,
      oldValue: void 0
    }), ms(this, i);
  }, a.raw = function() {
    return this.value_;
  }, a.toJSON = function() {
    return this.get();
  }, a.toString = function() {
    return this.name_ + "[" + this.value_ + "]";
  }, a.valueOf = function() {
    return ai(this.get());
  }, a[Symbol.toPrimitive] = function() {
    return this.valueOf();
  }, e;
}(Pe), ie = /* @__PURE__ */ function() {
  function s(a) {
    this.dependenciesState_ = O.NOT_TRACKING_, this.observing_ = [], this.newObserving_ = null, this.observers_ = /* @__PURE__ */ new Set(), this.runId_ = 0, this.lastAccessedBy_ = 0, this.lowestObserverState_ = O.UP_TO_DATE_, this.unboundDepsCount_ = 0, this.value_ = new Fs(null), this.name_ = void 0, this.triggeredBy_ = void 0, this.flags_ = 0, this.derivation = void 0, this.setter_ = void 0, this.isTracing_ = ae.NONE, this.scope_ = void 0, this.equals_ = void 0, this.requiresReaction_ = void 0, this.keepAlive_ = void 0, this.onBOL = void 0, this.onBUOL = void 0, a.get || v(31), this.derivation = a.get, this.name_ = a.name || (process.env.NODE_ENV !== "production" ? "ComputedValue@" + pe() : "ComputedValue"), a.set && (this.setter_ = Re(process.env.NODE_ENV !== "production" ? this.name_ + "-setter" : "ComputedValue-setter", a.set)), this.equals_ = a.equals || (a.compareStructural || a.struct ? Cs.structural : Cs.default), this.scope_ = a.context, this.requiresReaction_ = a.requiresReaction, this.keepAlive_ = !!a.keepAlive;
  }
  var e = s.prototype;
  return e.onBecomeStale_ = function() {
    vr(this);
  }, e.onBO = function() {
    this.onBOL && this.onBOL.forEach(function(t) {
      return t();
    });
  }, e.onBUO = function() {
    this.onBUOL && this.onBUOL.forEach(function(t) {
      return t();
    });
  }, e.get = function() {
    if (this.isComputing && v(32, this.name_, this.derivation), g.inBatch === 0 && // !globalState.trackingDerivatpion &&
    this.observers_.size === 0 && !this.keepAlive_)
      bt(this) && (this.warnAboutUntrackedRead_(), Z(), this.value_ = this.computeValue_(!1), ee());
    else if (yi(this), bt(this)) {
      var t = g.trackingContext;
      this.keepAlive_ && !t && (g.trackingContext = this), this.trackAndCompute() && hr(this), g.trackingContext = t;
    }
    var i = this.value_;
    if (_s(i))
      throw i.cause;
    return i;
  }, e.set = function(t) {
    if (this.setter_) {
      this.isRunningSetter && v(33, this.name_), this.isRunningSetter = !0;
      try {
        this.setter_.call(this.scope_, t);
      } finally {
        this.isRunningSetter = !1;
      }
    } else
      v(34, this.name_);
  }, e.trackAndCompute = function() {
    var t = this.value_, i = (
      /* see #1208 */
      this.dependenciesState_ === O.NOT_TRACKING_
    ), n = this.computeValue_(!0), o = i || _s(t) || _s(n) || !this.equals_(t, n);
    return o && (this.value_ = n, process.env.NODE_ENV !== "production" && U() && Fe({
      observableKind: "computed",
      debugObjectName: this.name_,
      object: this.scope_,
      type: "update",
      oldValue: t,
      newValue: n
    })), o;
  }, e.computeValue_ = function(t) {
    this.isComputing = !0;
    var i = xt(!1), n;
    if (t)
      n = fi(this, this.derivation, this.scope_);
    else if (g.disableErrorBoundaries === !0)
      n = this.derivation.call(this.scope_);
    else
      try {
        n = this.derivation.call(this.scope_);
      } catch (o) {
        n = new Fs(o);
      }
    return Rt(i), this.isComputing = !1, n;
  }, e.suspend_ = function() {
    this.keepAlive_ || (yt(this), this.value_ = void 0, process.env.NODE_ENV !== "production" && this.isTracing_ !== ae.NONE && console.log("[mobx.trace] Computed value '" + this.name_ + "' was suspended and it will recompute on the next access."));
  }, e.observe_ = function(t, i) {
    var n = this, o = !0, r = void 0;
    return Or(function() {
      var p = n.get();
      if (!o || i) {
        var d = Le();
        t({
          observableKind: "computed",
          debugObjectName: n.name_,
          type: ne,
          object: n,
          newValue: p,
          oldValue: r
        }), we(d);
      }
      o = !1, r = p;
    });
  }, e.warnAboutUntrackedRead_ = function() {
    process.env.NODE_ENV !== "production" && (this.isTracing_ !== ae.NONE && console.log("[mobx.trace] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute."), (typeof this.requiresReaction_ == "boolean" ? this.requiresReaction_ : g.computedRequiresReaction) && console.warn("[mobx] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute."));
  }, e.toString = function() {
    return this.name_ + "[" + this.derivation.toString() + "]";
  }, e.valueOf = function() {
    return ai(this.get());
  }, e[Symbol.toPrimitive] = function() {
    return this.valueOf();
  }, Ye(s, [{
    key: "isComputing",
    get: function() {
      return G(this.flags_, s.isComputingMask_);
    },
    set: function(t) {
      this.flags_ = W(this.flags_, s.isComputingMask_, t);
    }
  }, {
    key: "isRunningSetter",
    get: function() {
      return G(this.flags_, s.isRunningSetterMask_);
    },
    set: function(t) {
      this.flags_ = W(this.flags_, s.isRunningSetterMask_, t);
    }
  }, {
    key: "isBeingObserved",
    get: function() {
      return G(this.flags_, s.isBeingObservedMask_);
    },
    set: function(t) {
      this.flags_ = W(this.flags_, s.isBeingObservedMask_, t);
    }
  }, {
    key: "isPendingUnobservation",
    get: function() {
      return G(this.flags_, s.isPendingUnobservationMask_);
    },
    set: function(t) {
      this.flags_ = W(this.flags_, s.isPendingUnobservationMask_, t);
    }
  }, {
    key: "diffValue",
    get: function() {
      return G(this.flags_, s.diffValueMask_) ? 1 : 0;
    },
    set: function(t) {
      this.flags_ = W(this.flags_, s.diffValueMask_, t === 1);
    }
  }]);
}();
ie.isComputingMask_ = 1;
ie.isRunningSetterMask_ = 2;
ie.isBeingObservedMask_ = 4;
ie.isPendingUnobservationMask_ = 8;
ie.diffValueMask_ = 16;
var Ys = /* @__PURE__ */ Ie("ComputedValue", ie), O;
(function(s) {
  s[s.NOT_TRACKING_ = -1] = "NOT_TRACKING_", s[s.UP_TO_DATE_ = 0] = "UP_TO_DATE_", s[s.POSSIBLY_STALE_ = 1] = "POSSIBLY_STALE_", s[s.STALE_ = 2] = "STALE_";
})(O || (O = {}));
var ae;
(function(s) {
  s[s.NONE = 0] = "NONE", s[s.LOG = 1] = "LOG", s[s.BREAK = 2] = "BREAK";
})(ae || (ae = {}));
var Fs = function(e) {
  this.cause = void 0, this.cause = e;
};
function _s(s) {
  return s instanceof Fs;
}
function bt(s) {
  switch (s.dependenciesState_) {
    case O.UP_TO_DATE_:
      return !1;
    case O.NOT_TRACKING_:
    case O.STALE_:
      return !0;
    case O.POSSIBLY_STALE_: {
      for (var e = Ft(!0), a = Le(), t = s.observing_, i = t.length, n = 0; n < i; n++) {
        var o = t[n];
        if (Ys(o)) {
          if (g.disableErrorBoundaries)
            o.get();
          else
            try {
              o.get();
            } catch {
              return we(a), ss(e), !0;
            }
          if (s.dependenciesState_ === O.STALE_)
            return we(a), ss(e), !0;
        }
      }
      return hi(s), we(a), ss(e), !1;
    }
  }
}
function me(s) {
  if (process.env.NODE_ENV !== "production") {
    var e = s.observers_.size > 0;
    !g.allowStateChanges && (e || g.enforceActions === "always") && console.warn("[MobX] " + (g.enforceActions ? "Since strict-mode is enabled, changing (observed) observable values without using an action is not allowed. Tried to modify: " : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, a computed value or the render function of a React component? You can wrap side effects in 'runInAction' (or decorate functions with 'action') if needed. Tried to modify: ") + s.name_);
  }
}
function cr(s) {
  process.env.NODE_ENV !== "production" && !g.allowStateReads && g.observableRequiresReaction && console.warn("[mobx] Observable '" + s.name_ + "' being read outside a reactive context.");
}
function fi(s, e, a) {
  var t = Ft(!0);
  hi(s), s.newObserving_ = new Array(
    // Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    s.runId_ === 0 ? 100 : s.observing_.length
  ), s.unboundDepsCount_ = 0, s.runId_ = ++g.runId;
  var i = g.trackingDerivation;
  g.trackingDerivation = s, g.inBatch++;
  var n;
  if (g.disableErrorBoundaries === !0)
    n = e.call(a);
  else
    try {
      n = e.call(a);
    } catch (o) {
      n = new Fs(o);
    }
  return g.inBatch--, g.trackingDerivation = i, ur(s), mr(s), ss(t), n;
}
function mr(s) {
  process.env.NODE_ENV !== "production" && s.observing_.length === 0 && (typeof s.requiresObservable_ == "boolean" ? s.requiresObservable_ : g.reactionRequiresObservable) && console.warn("[mobx] Derivation '" + s.name_ + "' is created/updated without reading any observable value.");
}
function ur(s) {
  for (var e = s.observing_, a = s.observing_ = s.newObserving_, t = O.UP_TO_DATE_, i = 0, n = s.unboundDepsCount_, o = 0; o < n; o++) {
    var r = a[o];
    r.diffValue === 0 && (r.diffValue = 1, i !== o && (a[i] = r), i++), r.dependenciesState_ > t && (t = r.dependenciesState_);
  }
  for (a.length = i, s.newObserving_ = null, n = e.length; n--; ) {
    var p = e[n];
    p.diffValue === 0 && wi(p, s), p.diffValue = 0;
  }
  for (; i--; ) {
    var d = a[i];
    d.diffValue === 1 && (d.diffValue = 0, gr(d, s));
  }
  t !== O.UP_TO_DATE_ && (s.dependenciesState_ = t, s.onBecomeStale_());
}
function yt(s) {
  var e = s.observing_;
  s.observing_ = [];
  for (var a = e.length; a--; )
    wi(e[a], s);
  s.dependenciesState_ = O.NOT_TRACKING_;
}
function gi(s) {
  var e = Le();
  try {
    return s();
  } finally {
    we(e);
  }
}
function Le() {
  var s = g.trackingDerivation;
  return g.trackingDerivation = null, s;
}
function we(s) {
  g.trackingDerivation = s;
}
function Ft(s) {
  var e = g.allowStateReads;
  return g.allowStateReads = s, e;
}
function ss(s) {
  g.allowStateReads = s;
}
function hi(s) {
  if (s.dependenciesState_ !== O.UP_TO_DATE_) {
    s.dependenciesState_ = O.UP_TO_DATE_;
    for (var e = s.observing_, a = e.length; a--; )
      e[a].lowestObserverState_ = O.UP_TO_DATE_;
  }
}
var As = function() {
  this.version = 6, this.UNCHANGED = {}, this.trackingDerivation = null, this.trackingContext = null, this.runId = 0, this.mobxGuid = 0, this.inBatch = 0, this.pendingUnobservations = [], this.pendingReactions = [], this.isRunningReactions = !1, this.allowStateChanges = !1, this.allowStateReads = !0, this.enforceActions = !0, this.spyListeners = [], this.globalReactionErrorHandlers = [], this.computedRequiresReaction = !1, this.reactionRequiresObservable = !1, this.observableRequiresReaction = !1, this.disableErrorBoundaries = !1, this.suppressReactionErrors = !1, this.useProxies = !0, this.verifyProxies = !1, this.safeDescriptors = !0;
}, Ss = !0, vi = !1, g = /* @__PURE__ */ function() {
  var s = /* @__PURE__ */ Hs();
  return s.__mobxInstanceCount > 0 && !s.__mobxGlobals && (Ss = !1), s.__mobxGlobals && s.__mobxGlobals.version !== new As().version && (Ss = !1), Ss ? s.__mobxGlobals ? (s.__mobxInstanceCount += 1, s.__mobxGlobals.UNCHANGED || (s.__mobxGlobals.UNCHANGED = {}), s.__mobxGlobals) : (s.__mobxInstanceCount = 1, s.__mobxGlobals = /* @__PURE__ */ new As()) : (setTimeout(function() {
    vi || v(35);
  }, 1), new As());
}();
function fr() {
  if ((g.pendingReactions.length || g.inBatch || g.isRunningReactions) && v(36), vi = !0, Ss) {
    var s = Hs();
    --s.__mobxInstanceCount === 0 && (s.__mobxGlobals = void 0), g = new As();
  }
}
function gr(s, e) {
  s.observers_.add(e), s.lowestObserverState_ > e.dependenciesState_ && (s.lowestObserverState_ = e.dependenciesState_);
}
function wi(s, e) {
  s.observers_.delete(e), s.observers_.size === 0 && bi(s);
}
function bi(s) {
  s.isPendingUnobservation === !1 && (s.isPendingUnobservation = !0, g.pendingUnobservations.push(s));
}
function Z() {
  g.inBatch++;
}
function ee() {
  if (--g.inBatch === 0) {
    Pi();
    for (var s = g.pendingUnobservations, e = 0; e < s.length; e++) {
      var a = s[e];
      a.isPendingUnobservation = !1, a.observers_.size === 0 && (a.isBeingObserved && (a.isBeingObserved = !1, a.onBUO()), a instanceof ie && a.suspend_());
    }
    g.pendingUnobservations = [];
  }
}
function yi(s) {
  cr(s);
  var e = g.trackingDerivation;
  return e !== null ? (e.runId_ !== s.lastAccessedBy_ && (s.lastAccessedBy_ = e.runId_, e.newObserving_[e.unboundDepsCount_++] = s, !s.isBeingObserved && g.trackingContext && (s.isBeingObserved = !0, s.onBO())), s.isBeingObserved) : (s.observers_.size === 0 && g.inBatch > 0 && bi(s), !1);
}
function _i(s) {
  s.lowestObserverState_ !== O.STALE_ && (s.lowestObserverState_ = O.STALE_, s.observers_.forEach(function(e) {
    e.dependenciesState_ === O.UP_TO_DATE_ && (process.env.NODE_ENV !== "production" && e.isTracing_ !== ae.NONE && Ai(e, s), e.onBecomeStale_()), e.dependenciesState_ = O.STALE_;
  }));
}
function hr(s) {
  s.lowestObserverState_ !== O.STALE_ && (s.lowestObserverState_ = O.STALE_, s.observers_.forEach(function(e) {
    e.dependenciesState_ === O.POSSIBLY_STALE_ ? (e.dependenciesState_ = O.STALE_, process.env.NODE_ENV !== "production" && e.isTracing_ !== ae.NONE && Ai(e, s)) : e.dependenciesState_ === O.UP_TO_DATE_ && (s.lowestObserverState_ = O.UP_TO_DATE_);
  }));
}
function vr(s) {
  s.lowestObserverState_ === O.UP_TO_DATE_ && (s.lowestObserverState_ = O.POSSIBLY_STALE_, s.observers_.forEach(function(e) {
    e.dependenciesState_ === O.UP_TO_DATE_ && (e.dependenciesState_ = O.POSSIBLY_STALE_, e.onBecomeStale_());
  }));
}
function Ai(s, e) {
  if (console.log("[mobx.trace] '" + s.name_ + "' is invalidated due to a change in: '" + e.name_ + "'"), s.isTracing_ === ae.BREAK) {
    var a = [];
    Si(Ei(s), a, 1), new Function(`debugger;
/*
Tracing '` + s.name_ + `'

You are entering this break point because derivation '` + s.name_ + "' is being traced and '" + e.name_ + `' is now forcing it to update.
Just follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update
The stackframe you are looking for is at least ~6-8 stack-frames up.

` + (s instanceof ie ? s.derivation.toString().replace(/[*]\//g, "/") : "") + `

The dependencies for this derivation are:

` + a.join(`
`) + `
*/
    `)();
  }
}
function Si(s, e, a) {
  if (e.length >= 1e3) {
    e.push("(and many more)");
    return;
  }
  e.push("" + "	".repeat(a - 1) + s.name), s.dependencies && s.dependencies.forEach(function(t) {
    return Si(t, e, a + 1);
  });
}
var ye = /* @__PURE__ */ function() {
  function s(a, t, i, n) {
    a === void 0 && (a = process.env.NODE_ENV !== "production" ? "Reaction@" + pe() : "Reaction"), this.name_ = void 0, this.onInvalidate_ = void 0, this.errorHandler_ = void 0, this.requiresObservable_ = void 0, this.observing_ = [], this.newObserving_ = [], this.dependenciesState_ = O.NOT_TRACKING_, this.runId_ = 0, this.unboundDepsCount_ = 0, this.flags_ = 0, this.isTracing_ = ae.NONE, this.name_ = a, this.onInvalidate_ = t, this.errorHandler_ = i, this.requiresObservable_ = n;
  }
  var e = s.prototype;
  return e.onBecomeStale_ = function() {
    this.schedule_();
  }, e.schedule_ = function() {
    this.isScheduled || (this.isScheduled = !0, g.pendingReactions.push(this), Pi());
  }, e.runReaction_ = function() {
    if (!this.isDisposed) {
      Z(), this.isScheduled = !1;
      var t = g.trackingContext;
      if (g.trackingContext = this, bt(this)) {
        this.isTrackPending = !0;
        try {
          this.onInvalidate_(), process.env.NODE_ENV !== "production" && this.isTrackPending && U() && Fe({
            name: this.name_,
            type: "scheduled-reaction"
          });
        } catch (i) {
          this.reportExceptionInDerivation_(i);
        }
      }
      g.trackingContext = t, ee();
    }
  }, e.track = function(t) {
    if (!this.isDisposed) {
      Z();
      var i = U(), n;
      process.env.NODE_ENV !== "production" && i && (n = Date.now(), K({
        name: this.name_,
        type: "reaction"
      })), this.isRunning = !0;
      var o = g.trackingContext;
      g.trackingContext = this;
      var r = fi(this, t, void 0);
      g.trackingContext = o, this.isRunning = !1, this.isTrackPending = !1, this.isDisposed && yt(this), _s(r) && this.reportExceptionInDerivation_(r.cause), process.env.NODE_ENV !== "production" && i && Y({
        time: Date.now() - n
      }), ee();
    }
  }, e.reportExceptionInDerivation_ = function(t) {
    var i = this;
    if (this.errorHandler_) {
      this.errorHandler_(t, this);
      return;
    }
    if (g.disableErrorBoundaries)
      throw t;
    var n = process.env.NODE_ENV !== "production" ? "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this + "'" : "[mobx] uncaught error in '" + this + "'";
    g.suppressReactionErrors ? process.env.NODE_ENV !== "production" && console.warn("[mobx] (error in reaction '" + this.name_ + "' suppressed, fix error of causing action below)") : console.error(n, t), process.env.NODE_ENV !== "production" && U() && Fe({
      type: "error",
      name: this.name_,
      message: n,
      error: "" + t
    }), g.globalReactionErrorHandlers.forEach(function(o) {
      return o(t, i);
    });
  }, e.dispose = function() {
    this.isDisposed || (this.isDisposed = !0, this.isRunning || (Z(), yt(this), ee()));
  }, e.getDisposer_ = function(t) {
    var i = this, n = function o() {
      i.dispose(), t == null || t.removeEventListener == null || t.removeEventListener("abort", o);
    };
    return t == null || t.addEventListener == null || t.addEventListener("abort", n), n[S] = this, n;
  }, e.toString = function() {
    return "Reaction[" + this.name_ + "]";
  }, e.trace = function(t) {
    t === void 0 && (t = !1), Br(this, t);
  }, Ye(s, [{
    key: "isDisposed",
    get: function() {
      return G(this.flags_, s.isDisposedMask_);
    },
    set: function(t) {
      this.flags_ = W(this.flags_, s.isDisposedMask_, t);
    }
  }, {
    key: "isScheduled",
    get: function() {
      return G(this.flags_, s.isScheduledMask_);
    },
    set: function(t) {
      this.flags_ = W(this.flags_, s.isScheduledMask_, t);
    }
  }, {
    key: "isTrackPending",
    get: function() {
      return G(this.flags_, s.isTrackPendingMask_);
    },
    set: function(t) {
      this.flags_ = W(this.flags_, s.isTrackPendingMask_, t);
    }
  }, {
    key: "isRunning",
    get: function() {
      return G(this.flags_, s.isRunningMask_);
    },
    set: function(t) {
      this.flags_ = W(this.flags_, s.isRunningMask_, t);
    }
  }, {
    key: "diffValue",
    get: function() {
      return G(this.flags_, s.diffValueMask_) ? 1 : 0;
    },
    set: function(t) {
      this.flags_ = W(this.flags_, s.diffValueMask_, t === 1);
    }
  }]);
}();
ye.isDisposedMask_ = 1;
ye.isScheduledMask_ = 2;
ye.isTrackPendingMask_ = 4;
ye.isRunningMask_ = 8;
ye.diffValueMask_ = 16;
var fa = 100, _t = function(e) {
  return e();
};
function Pi() {
  g.inBatch > 0 || g.isRunningReactions || _t(wr);
}
function wr() {
  g.isRunningReactions = !0;
  for (var s = g.pendingReactions, e = 0; s.length > 0; ) {
    ++e === fa && (console.error(process.env.NODE_ENV !== "production" ? "Reaction doesn't converge to a stable state after " + fa + " iterations." + (" Probably there is a cycle in the reactive function: " + s[0]) : "[mobx] cycle in reaction: " + s[0]), s.splice(0));
    for (var a = s.splice(0), t = 0, i = a.length; t < i; t++)
      a[t].runReaction_();
  }
  g.isRunningReactions = !1;
}
var Is = /* @__PURE__ */ Ie("Reaction", ye);
function br(s) {
  var e = _t;
  _t = function(t) {
    return s(function() {
      return e(t);
    });
  };
}
function U() {
  return process.env.NODE_ENV !== "production" && !!g.spyListeners.length;
}
function Fe(s) {
  if (process.env.NODE_ENV !== "production" && g.spyListeners.length)
    for (var e = g.spyListeners, a = 0, t = e.length; a < t; a++)
      e[a](s);
}
function K(s) {
  if (process.env.NODE_ENV !== "production") {
    var e = be({}, s, {
      spyReportStart: !0
    });
    Fe(e);
  }
}
var yr = {
  type: "report-end",
  spyReportEnd: !0
};
function Y(s) {
  process.env.NODE_ENV !== "production" && Fe(s ? be({}, s, {
    type: "report-end",
    spyReportEnd: !0
  }) : yr);
}
function _r(s) {
  return process.env.NODE_ENV === "production" ? (console.warn("[mobx.spy] Is a no-op in production builds"), function() {
  }) : (g.spyListeners.push(s), Et(function() {
    g.spyListeners = g.spyListeners.filter(function(e) {
      return e !== s;
    });
  }));
}
var It = "action", Ar = "action.bound", Di = "autoAction", Sr = "autoAction.bound", Pr = "<unnamed action>", At = /* @__PURE__ */ ls(It), Dr = /* @__PURE__ */ ls(Ar, {
  bound: !0
}), St = /* @__PURE__ */ ls(Di, {
  autoAction: !0
}), Nr = /* @__PURE__ */ ls(Sr, {
  autoAction: !0,
  bound: !0
});
function Ni(s) {
  var e = function(t, i) {
    if (I(t))
      return Re(t.name || Pr, t, s);
    if (I(i))
      return Re(t, i, s);
    if (ds(i))
      return (s ? St : At).decorate_20223_(t, i);
    if (Ce(i))
      return ps(t, i, s ? St : At);
    if (Ce(t))
      return fe(ls(s ? Di : It, {
        name: t,
        autoAction: s
      }));
    process.env.NODE_ENV !== "production" && v("Invalid arguments for `action`");
  };
  return e;
}
var qe = /* @__PURE__ */ Ni(!1);
Object.assign(qe, At);
var ns = /* @__PURE__ */ Ni(!0);
Object.assign(ns, St);
qe.bound = /* @__PURE__ */ fe(Dr);
ns.bound = /* @__PURE__ */ fe(Nr);
function $e(s) {
  return I(s) && s.isMobxAction === !0;
}
function Or(s, e) {
  var a, t, i, n;
  e === void 0 && (e = Xa), process.env.NODE_ENV !== "production" && (I(s) || v("Autorun expects a function as first argument"), $e(s) && v("Autorun does not accept actions since actions are untrackable"));
  var o = (a = (t = e) == null ? void 0 : t.name) != null ? a : process.env.NODE_ENV !== "production" ? s.name || "Autorun@" + pe() : "Autorun", r = !e.scheduler && !e.delay, p;
  if (r)
    p = new ye(o, function() {
      this.track(c);
    }, e.onError, e.requiresObservable);
  else {
    var d = Er(e), l = !1;
    p = new ye(o, function() {
      l || (l = !0, d(function() {
        l = !1, p.isDisposed || p.track(c);
      }));
    }, e.onError, e.requiresObservable);
  }
  function c() {
    s(p);
  }
  return (i = e) != null && (i = i.signal) != null && i.aborted || p.schedule_(), p.getDisposer_((n = e) == null ? void 0 : n.signal);
}
var kr = function(e) {
  return e();
};
function Er(s) {
  return s.scheduler ? s.scheduler : s.delay ? function(e) {
    return setTimeout(e, s.delay);
  } : kr;
}
var Tr = "onBO", Cr = "onBUO";
function xr(s, e, a) {
  return ki(Tr, s, e, a);
}
function Oi(s, e, a) {
  return ki(Cr, s, e, a);
}
function ki(s, e, a, t) {
  var i = We(e), n = I(t) ? t : a, o = s + "L";
  return i[o] ? i[o].add(n) : i[o] = /* @__PURE__ */ new Set([n]), function() {
    var r = i[o];
    r && (r.delete(n), r.size === 0 && delete i[o]);
  };
}
var Rr = "never", ws = "always", Fr = "observed";
function Ir(s) {
  s.isolateGlobalState === !0 && fr();
  var e = s.useProxies, a = s.enforceActions;
  if (e !== void 0 && (g.useProxies = e === ws ? !0 : e === Rr ? !1 : typeof Proxy < "u"), e === "ifavailable" && (g.verifyProxies = !0), a !== void 0) {
    var t = a === ws ? ws : a === Fr;
    g.enforceActions = t, g.allowStateChanges = !(t === !0 || t === ws);
  }
  ["computedRequiresReaction", "reactionRequiresObservable", "observableRequiresReaction", "disableErrorBoundaries", "safeDescriptors"].forEach(function(i) {
    i in s && (g[i] = !!s[i]);
  }), g.allowStateReads = !g.observableRequiresReaction, process.env.NODE_ENV !== "production" && g.disableErrorBoundaries === !0 && console.warn("WARNING: Debug feature only. MobX will NOT recover from errors when `disableErrorBoundaries` is enabled."), s.reactionScheduler && br(s.reactionScheduler);
}
function Lr(s, e, a, t) {
  process.env.NODE_ENV !== "production" && (arguments.length > 4 && v("'extendObservable' expected 2-4 arguments"), typeof s != "object" && v("'extendObservable' expects an object as first argument"), De(s) && v("'extendObservable' should not be used on maps, use map.merge instead"), ge(e) || v("'extendObservable' only accepts plain objects as second argument"), (rs(e) || rs(a)) && v("Extending an object with another observable (object) is not supported"));
  var i = fo(e);
  return Me(function() {
    var n = Qe(s, t)[S];
    qs(i).forEach(function(o) {
      n.extend_(
        o,
        i[o],
        // must pass "undefined" for { key: undefined }
        a && o in a ? a[o] : !0
      );
    });
  }), s;
}
function Ei(s, e) {
  return Ti(We(s, e));
}
function Ti(s) {
  var e = {
    name: s.name_
  };
  return s.observing_ && s.observing_.length > 0 && (e.dependencies = Mr(s.observing_).map(Ti)), e;
}
function Mr(s) {
  return Array.from(new Set(s));
}
var Vr = 0;
function Ci() {
  this.message = "FLOW_CANCELLED";
}
Ci.prototype = /* @__PURE__ */ Object.create(Error.prototype);
var st = /* @__PURE__ */ ri("flow"), Ur = /* @__PURE__ */ ri("flow.bound", {
  bound: !0
}), Ge = /* @__PURE__ */ Object.assign(function(e, a) {
  if (ds(a))
    return st.decorate_20223_(e, a);
  if (Ce(a))
    return ps(e, a, st);
  process.env.NODE_ENV !== "production" && arguments.length !== 1 && v("Flow expects single argument with generator function");
  var t = e, i = t.name || "<unnamed flow>", n = function() {
    var r = this, p = arguments, d = ++Vr, l = qe(i + " - runid: " + d + " - init", t).apply(r, p), c, f = void 0, u = new Promise(function(m, h) {
      var w = 0;
      c = h;
      function b(_) {
        f = void 0;
        var k;
        try {
          k = qe(i + " - runid: " + d + " - yield " + w++, l.next).call(l, _);
        } catch (N) {
          return h(N);
        }
        P(k);
      }
      function D(_) {
        f = void 0;
        var k;
        try {
          k = qe(i + " - runid: " + d + " - yield " + w++, l.throw).call(l, _);
        } catch (N) {
          return h(N);
        }
        P(k);
      }
      function P(_) {
        if (I(_ == null ? void 0 : _.then)) {
          _.then(P, h);
          return;
        }
        return _.done ? m(_.value) : (f = Promise.resolve(_.value), f.then(b, D));
      }
      b(void 0);
    });
    return u.cancel = qe(i + " - runid: " + d + " - cancel", function() {
      try {
        f && ga(f);
        var m = l.return(void 0), h = Promise.resolve(m.value);
        h.then(je, je), ga(h), c(new Ci());
      } catch (w) {
        c(w);
      }
    }), u;
  };
  return n.isMobXFlow = !0, n;
}, st);
Ge.bound = /* @__PURE__ */ fe(Ur);
function ga(s) {
  I(s.cancel) && s.cancel();
}
function os(s) {
  return (s == null ? void 0 : s.isMobXFlow) === !0;
}
function Hr(s, e) {
  return s ? us(s) || !!s[S] || Tt(s) || Is(s) || Ys(s) : !1;
}
function rs(s) {
  return process.env.NODE_ENV !== "production" && arguments.length !== 1 && v("isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property"), Hr(s);
}
function Br() {
  if (process.env.NODE_ENV !== "production") {
    for (var s = !1, e = arguments.length, a = new Array(e), t = 0; t < e; t++)
      a[t] = arguments[t];
    typeof a[a.length - 1] == "boolean" && (s = a.pop());
    var i = jr(a);
    if (!i)
      return v("'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
    i.isTracing_ === ae.NONE && console.log("[mobx.trace] '" + i.name_ + "' tracing enabled"), i.isTracing_ = s ? ae.BREAK : ae.LOG;
  }
}
function jr(s) {
  switch (s.length) {
    case 0:
      return g.trackingDerivation;
    case 1:
      return We(s[0]);
    case 2:
      return We(s[0], s[1]);
  }
}
function ve(s, e) {
  e === void 0 && (e = void 0), Z();
  try {
    return s.apply(e);
  } finally {
    ee();
  }
}
function Ee(s) {
  return s[S];
}
var zr = {
  has: function(e, a) {
    return process.env.NODE_ENV !== "production" && g.trackingDerivation && Ze("detect new properties using the 'in' operator. Use 'has' from 'mobx' instead."), Ee(e).has_(a);
  },
  get: function(e, a) {
    return Ee(e).get_(a);
  },
  set: function(e, a, t) {
    var i;
    return Ce(a) ? (process.env.NODE_ENV !== "production" && !Ee(e).values_.has(a) && Ze("add a new observable property through direct assignment. Use 'set' from 'mobx' instead."), (i = Ee(e).set_(a, t, !0)) != null ? i : !0) : !1;
  },
  deleteProperty: function(e, a) {
    var t;
    return process.env.NODE_ENV !== "production" && Ze("delete properties from an observable object. Use 'remove' from 'mobx' instead."), Ce(a) ? (t = Ee(e).delete_(a, !0)) != null ? t : !0 : !1;
  },
  defineProperty: function(e, a, t) {
    var i;
    return process.env.NODE_ENV !== "production" && Ze("define property on an observable object. Use 'defineProperty' from 'mobx' instead."), (i = Ee(e).defineProperty_(a, t)) != null ? i : !0;
  },
  ownKeys: function(e) {
    return process.env.NODE_ENV !== "production" && g.trackingDerivation && Ze("iterate keys to detect added / removed properties. Use 'keys' from 'mobx' instead."), Ee(e).ownKeys_();
  },
  preventExtensions: function(e) {
    v(13);
  }
};
function qr(s, e) {
  var a, t;
  return Za(), s = Qe(s, e), (t = (a = s[S]).proxy_) != null ? t : a.proxy_ = new Proxy(s, zr);
}
function J(s) {
  return s.interceptors_ !== void 0 && s.interceptors_.length > 0;
}
function cs(s, e) {
  var a = s.interceptors_ || (s.interceptors_ = []);
  return a.push(e), Et(function() {
    var t = a.indexOf(e);
    t !== -1 && a.splice(t, 1);
  });
}
function X(s, e) {
  var a = Le();
  try {
    for (var t = [].concat(s.interceptors_ || []), i = 0, n = t.length; i < n && (e = t[i](e), e && !e.type && v(14), !!e); i++)
      ;
    return e;
  } finally {
    we(a);
  }
}
function oe(s) {
  return s.changeListeners_ !== void 0 && s.changeListeners_.length > 0;
}
function ms(s, e) {
  var a = s.changeListeners_ || (s.changeListeners_ = []);
  return a.push(e), Et(function() {
    var t = a.indexOf(e);
    t !== -1 && a.splice(t, 1);
  });
}
function re(s, e) {
  var a = Le(), t = s.changeListeners_;
  if (t) {
    t = t.slice();
    for (var i = 0, n = t.length; i < n; i++)
      t[i](e);
    we(a);
  }
}
function $r(s, e, a) {
  return Me(function() {
    var t, i = Qe(s, a)[S];
    process.env.NODE_ENV !== "production" && e && s[q] && v("makeObservable second arg must be nullish when using decorators. Mixing @decorator syntax with annotations is not supported."), (t = e) != null || (e = yo(s)), qs(e).forEach(function(n) {
      return i.make_(n, e[n]);
    });
  }), s;
}
var ha = "splice", ne = "update", Gr = 1e4, Wr = {
  get: function(e, a) {
    var t = e[S];
    return a === S ? t : a === "length" ? t.getArrayLength_() : typeof a == "string" && !isNaN(a) ? t.get_(parseInt(a)) : te(Ls, a) ? Ls[a] : e[a];
  },
  set: function(e, a, t) {
    var i = e[S];
    return a === "length" && i.setArrayLength_(t), typeof a == "symbol" || isNaN(a) ? e[a] = t : i.set_(parseInt(a), t), !0;
  },
  preventExtensions: function() {
    v(15);
  }
}, Lt = /* @__PURE__ */ function() {
  function s(a, t, i, n) {
    a === void 0 && (a = process.env.NODE_ENV !== "production" ? "ObservableArray@" + pe() : "ObservableArray"), this.owned_ = void 0, this.legacyMode_ = void 0, this.atom_ = void 0, this.values_ = [], this.interceptors_ = void 0, this.changeListeners_ = void 0, this.enhancer_ = void 0, this.dehancer = void 0, this.proxy_ = void 0, this.lastKnownLength_ = 0, this.owned_ = i, this.legacyMode_ = n, this.atom_ = new Pe(a), this.enhancer_ = function(o, r) {
      return t(o, r, process.env.NODE_ENV !== "production" ? a + "[..]" : "ObservableArray[..]");
    };
  }
  var e = s.prototype;
  return e.dehanceValue_ = function(t) {
    return this.dehancer !== void 0 ? this.dehancer(t) : t;
  }, e.dehanceValues_ = function(t) {
    return this.dehancer !== void 0 && t.length > 0 ? t.map(this.dehancer) : t;
  }, e.intercept_ = function(t) {
    return cs(this, t);
  }, e.observe_ = function(t, i) {
    return i === void 0 && (i = !1), i && t({
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: "splice",
      index: 0,
      added: this.values_.slice(),
      addedCount: this.values_.length,
      removed: [],
      removedCount: 0
    }), ms(this, t);
  }, e.getArrayLength_ = function() {
    return this.atom_.reportObserved(), this.values_.length;
  }, e.setArrayLength_ = function(t) {
    (typeof t != "number" || isNaN(t) || t < 0) && v("Out of range: " + t);
    var i = this.values_.length;
    if (t !== i)
      if (t > i) {
        for (var n = new Array(t - i), o = 0; o < t - i; o++)
          n[o] = void 0;
        this.spliceWithArray_(i, 0, n);
      } else
        this.spliceWithArray_(t, i - t);
  }, e.updateArrayLength_ = function(t, i) {
    t !== this.lastKnownLength_ && v(16), this.lastKnownLength_ += i, this.legacyMode_ && i > 0 && Mi(t + i + 1);
  }, e.spliceWithArray_ = function(t, i, n) {
    var o = this;
    me(this.atom_);
    var r = this.values_.length;
    if (t === void 0 ? t = 0 : t > r ? t = r : t < 0 && (t = Math.max(0, r + t)), arguments.length === 1 ? i = r - t : i == null ? i = 0 : i = Math.max(0, Math.min(i, r - t)), n === void 0 && (n = Ts), J(this)) {
      var p = X(this, {
        object: this.proxy_,
        type: ha,
        index: t,
        removedCount: i,
        added: n
      });
      if (!p)
        return Ts;
      i = p.removedCount, n = p.added;
    }
    if (n = n.length === 0 ? n : n.map(function(c) {
      return o.enhancer_(c, void 0);
    }), this.legacyMode_ || process.env.NODE_ENV !== "production") {
      var d = n.length - i;
      this.updateArrayLength_(r, d);
    }
    var l = this.spliceItemsIntoValues_(t, i, n);
    return (i !== 0 || n.length !== 0) && this.notifyArraySplice_(t, n, l), this.dehanceValues_(l);
  }, e.spliceItemsIntoValues_ = function(t, i, n) {
    if (n.length < Gr) {
      var o;
      return (o = this.values_).splice.apply(o, [t, i].concat(n));
    } else {
      var r = this.values_.slice(t, t + i), p = this.values_.slice(t + i);
      this.values_.length += n.length - i;
      for (var d = 0; d < n.length; d++)
        this.values_[t + d] = n[d];
      for (var l = 0; l < p.length; l++)
        this.values_[t + n.length + l] = p[l];
      return r;
    }
  }, e.notifyArrayChildUpdate_ = function(t, i, n) {
    var o = !this.owned_ && U(), r = oe(this), p = r || o ? {
      observableKind: "array",
      object: this.proxy_,
      type: ne,
      debugObjectName: this.atom_.name_,
      index: t,
      newValue: i,
      oldValue: n
    } : null;
    process.env.NODE_ENV !== "production" && o && K(p), this.atom_.reportChanged(), r && re(this, p), process.env.NODE_ENV !== "production" && o && Y();
  }, e.notifyArraySplice_ = function(t, i, n) {
    var o = !this.owned_ && U(), r = oe(this), p = r || o ? {
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: ha,
      index: t,
      removed: n,
      added: i,
      removedCount: n.length,
      addedCount: i.length
    } : null;
    process.env.NODE_ENV !== "production" && o && K(p), this.atom_.reportChanged(), r && re(this, p), process.env.NODE_ENV !== "production" && o && Y();
  }, e.get_ = function(t) {
    if (this.legacyMode_ && t >= this.values_.length) {
      console.warn(process.env.NODE_ENV !== "production" ? "[mobx.array] Attempt to read an array index (" + t + ") that is out of bounds (" + this.values_.length + "). Please check length first. Out of bound indices will not be tracked by MobX" : "[mobx] Out of bounds read: " + t);
      return;
    }
    return this.atom_.reportObserved(), this.dehanceValue_(this.values_[t]);
  }, e.set_ = function(t, i) {
    var n = this.values_;
    if (this.legacyMode_ && t > n.length && v(17, t, n.length), t < n.length) {
      me(this.atom_);
      var o = n[t];
      if (J(this)) {
        var r = X(this, {
          type: ne,
          object: this.proxy_,
          // since "this" is the real array we need to pass its proxy
          index: t,
          newValue: i
        });
        if (!r)
          return;
        i = r.newValue;
      }
      i = this.enhancer_(i, o);
      var p = i !== o;
      p && (n[t] = i, this.notifyArrayChildUpdate_(t, i, o));
    } else {
      for (var d = new Array(t + 1 - n.length), l = 0; l < d.length - 1; l++)
        d[l] = void 0;
      d[d.length - 1] = i, this.spliceWithArray_(n.length, 0, d);
    }
  }, s;
}();
function Kr(s, e, a, t) {
  return a === void 0 && (a = process.env.NODE_ENV !== "production" ? "ObservableArray@" + pe() : "ObservableArray"), t === void 0 && (t = !1), Za(), Me(function() {
    var i = new Lt(a, e, t, !1);
    si(i.values_, S, i);
    var n = new Proxy(i.values_, Wr);
    return i.proxy_ = n, s && s.length && i.spliceWithArray_(0, 0, s), n;
  });
}
var Ls = {
  clear: function() {
    return this.splice(0);
  },
  replace: function(e) {
    var a = this[S];
    return a.spliceWithArray_(0, a.values_.length, e);
  },
  // Used by JSON.stringify
  toJSON: function() {
    return this.slice();
  },
  /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */
  splice: function(e, a) {
    for (var t = arguments.length, i = new Array(t > 2 ? t - 2 : 0), n = 2; n < t; n++)
      i[n - 2] = arguments[n];
    var o = this[S];
    switch (arguments.length) {
      case 0:
        return [];
      case 1:
        return o.spliceWithArray_(e);
      case 2:
        return o.spliceWithArray_(e, a);
    }
    return o.spliceWithArray_(e, a, i);
  },
  spliceWithArray: function(e, a, t) {
    return this[S].spliceWithArray_(e, a, t);
  },
  push: function() {
    for (var e = this[S], a = arguments.length, t = new Array(a), i = 0; i < a; i++)
      t[i] = arguments[i];
    return e.spliceWithArray_(e.values_.length, 0, t), e.values_.length;
  },
  pop: function() {
    return this.splice(Math.max(this[S].values_.length - 1, 0), 1)[0];
  },
  shift: function() {
    return this.splice(0, 1)[0];
  },
  unshift: function() {
    for (var e = this[S], a = arguments.length, t = new Array(a), i = 0; i < a; i++)
      t[i] = arguments[i];
    return e.spliceWithArray_(0, 0, t), e.values_.length;
  },
  reverse: function() {
    return g.trackingDerivation && v(37, "reverse"), this.replace(this.slice().reverse()), this;
  },
  sort: function() {
    g.trackingDerivation && v(37, "sort");
    var e = this.slice();
    return e.sort.apply(e, arguments), this.replace(e), this;
  },
  remove: function(e) {
    var a = this[S], t = a.dehanceValues_(a.values_).indexOf(e);
    return t > -1 ? (this.splice(t, 1), !0) : !1;
  }
};
R("at", Q);
R("concat", Q);
R("flat", Q);
R("includes", Q);
R("indexOf", Q);
R("join", Q);
R("lastIndexOf", Q);
R("slice", Q);
R("toString", Q);
R("toLocaleString", Q);
R("toSorted", Q);
R("toSpliced", Q);
R("with", Q);
R("every", de);
R("filter", de);
R("find", de);
R("findIndex", de);
R("findLast", de);
R("findLastIndex", de);
R("flatMap", de);
R("forEach", de);
R("map", de);
R("some", de);
R("toReversed", de);
R("reduce", xi);
R("reduceRight", xi);
function R(s, e) {
  typeof Array.prototype[s] == "function" && (Ls[s] = e(s));
}
function Q(s) {
  return function() {
    var e = this[S];
    e.atom_.reportObserved();
    var a = e.dehanceValues_(e.values_);
    return a[s].apply(a, arguments);
  };
}
function de(s) {
  return function(e, a) {
    var t = this, i = this[S];
    i.atom_.reportObserved();
    var n = i.dehanceValues_(i.values_);
    return n[s](function(o, r) {
      return e.call(a, o, r, t);
    });
  };
}
function xi(s) {
  return function() {
    var e = this, a = this[S];
    a.atom_.reportObserved();
    var t = a.dehanceValues_(a.values_), i = arguments[0];
    return arguments[0] = function(n, o, r) {
      return i(n, o, r, e);
    }, t[s].apply(t, arguments);
  };
}
var Yr = /* @__PURE__ */ Ie("ObservableArrayAdministration", Lt);
function Qs(s) {
  return js(s) && Yr(s[S]);
}
var Qr = {}, Se = "add", Ms = "delete", Ri = /* @__PURE__ */ function() {
  function s(a, t, i) {
    var n = this;
    t === void 0 && (t = xe), i === void 0 && (i = process.env.NODE_ENV !== "production" ? "ObservableMap@" + pe() : "ObservableMap"), this.enhancer_ = void 0, this.name_ = void 0, this[S] = Qr, this.data_ = void 0, this.hasMap_ = void 0, this.keysAtom_ = void 0, this.interceptors_ = void 0, this.changeListeners_ = void 0, this.dehancer = void 0, this.enhancer_ = t, this.name_ = i, I(Map) || v(18), Me(function() {
      n.keysAtom_ = ni(process.env.NODE_ENV !== "production" ? n.name_ + ".keys()" : "ObservableMap.keys()"), n.data_ = /* @__PURE__ */ new Map(), n.hasMap_ = /* @__PURE__ */ new Map(), a && n.merge(a);
    });
  }
  var e = s.prototype;
  return e.has_ = function(t) {
    return this.data_.has(t);
  }, e.has = function(t) {
    var i = this;
    if (!g.trackingDerivation)
      return this.has_(t);
    var n = this.hasMap_.get(t);
    if (!n) {
      var o = n = new Te(this.has_(t), Gs, process.env.NODE_ENV !== "production" ? this.name_ + "." + gt(t) + "?" : "ObservableMap.key?", !1);
      this.hasMap_.set(t, o), Oi(o, function() {
        return i.hasMap_.delete(t);
      });
    }
    return n.get();
  }, e.set = function(t, i) {
    var n = this.has_(t);
    if (J(this)) {
      var o = X(this, {
        type: n ? ne : Se,
        object: this,
        newValue: i,
        name: t
      });
      if (!o)
        return this;
      i = o.newValue;
    }
    return n ? this.updateValue_(t, i) : this.addValue_(t, i), this;
  }, e.delete = function(t) {
    var i = this;
    if (me(this.keysAtom_), J(this)) {
      var n = X(this, {
        type: Ms,
        object: this,
        name: t
      });
      if (!n)
        return !1;
    }
    if (this.has_(t)) {
      var o = U(), r = oe(this), p = r || o ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: Ms,
        object: this,
        oldValue: this.data_.get(t).value_,
        name: t
      } : null;
      return process.env.NODE_ENV !== "production" && o && K(p), ve(function() {
        var d;
        i.keysAtom_.reportChanged(), (d = i.hasMap_.get(t)) == null || d.setNewValue_(!1);
        var l = i.data_.get(t);
        l.setNewValue_(void 0), i.data_.delete(t);
      }), r && re(this, p), process.env.NODE_ENV !== "production" && o && Y(), !0;
    }
    return !1;
  }, e.updateValue_ = function(t, i) {
    var n = this.data_.get(t);
    if (i = n.prepareNewValue_(i), i !== g.UNCHANGED) {
      var o = U(), r = oe(this), p = r || o ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: ne,
        object: this,
        oldValue: n.value_,
        name: t,
        newValue: i
      } : null;
      process.env.NODE_ENV !== "production" && o && K(p), n.setNewValue_(i), r && re(this, p), process.env.NODE_ENV !== "production" && o && Y();
    }
  }, e.addValue_ = function(t, i) {
    var n = this;
    me(this.keysAtom_), ve(function() {
      var d, l = new Te(i, n.enhancer_, process.env.NODE_ENV !== "production" ? n.name_ + "." + gt(t) : "ObservableMap.key", !1);
      n.data_.set(t, l), i = l.value_, (d = n.hasMap_.get(t)) == null || d.setNewValue_(!0), n.keysAtom_.reportChanged();
    });
    var o = U(), r = oe(this), p = r || o ? {
      observableKind: "map",
      debugObjectName: this.name_,
      type: Se,
      object: this,
      name: t,
      newValue: i
    } : null;
    process.env.NODE_ENV !== "production" && o && K(p), r && re(this, p), process.env.NODE_ENV !== "production" && o && Y();
  }, e.get = function(t) {
    return this.has(t) ? this.dehanceValue_(this.data_.get(t).get()) : this.dehanceValue_(void 0);
  }, e.dehanceValue_ = function(t) {
    return this.dehancer !== void 0 ? this.dehancer(t) : t;
  }, e.keys = function() {
    return this.keysAtom_.reportObserved(), this.data_.keys();
  }, e.values = function() {
    var t = this, i = this.keys();
    return va({
      next: function() {
        var o = i.next(), r = o.done, p = o.value;
        return {
          done: r,
          value: r ? void 0 : t.get(p)
        };
      }
    });
  }, e.entries = function() {
    var t = this, i = this.keys();
    return va({
      next: function() {
        var o = i.next(), r = o.done, p = o.value;
        return {
          done: r,
          value: r ? void 0 : [p, t.get(p)]
        };
      }
    });
  }, e[Symbol.iterator] = function() {
    return this.entries();
  }, e.forEach = function(t, i) {
    for (var n = ze(this), o; !(o = n()).done; ) {
      var r = o.value, p = r[0], d = r[1];
      t.call(i, d, p, this);
    }
  }, e.merge = function(t) {
    var i = this;
    return De(t) && (t = new Map(t)), ve(function() {
      ge(t) ? uo(t).forEach(function(n) {
        return i.set(n, t[n]);
      }) : Array.isArray(t) ? t.forEach(function(n) {
        var o = n[0], r = n[1];
        return i.set(o, r);
      }) : Ke(t) ? (mo(t) || v(19, t), t.forEach(function(n, o) {
        return i.set(o, n);
      })) : t != null && v(20, t);
    }), this;
  }, e.clear = function() {
    var t = this;
    ve(function() {
      gi(function() {
        for (var i = ze(t.keys()), n; !(n = i()).done; ) {
          var o = n.value;
          t.delete(o);
        }
      });
    });
  }, e.replace = function(t) {
    var i = this;
    return ve(function() {
      for (var n = Jr(t), o = /* @__PURE__ */ new Map(), r = !1, p = ze(i.data_.keys()), d; !(d = p()).done; ) {
        var l = d.value;
        if (!n.has(l)) {
          var c = i.delete(l);
          if (c)
            r = !0;
          else {
            var f = i.data_.get(l);
            o.set(l, f);
          }
        }
      }
      for (var u = ze(n.entries()), m; !(m = u()).done; ) {
        var h = m.value, w = h[0], b = h[1], D = i.data_.has(w);
        if (i.set(w, b), i.data_.has(w)) {
          var P = i.data_.get(w);
          o.set(w, P), D || (r = !0);
        }
      }
      if (!r)
        if (i.data_.size !== o.size)
          i.keysAtom_.reportChanged();
        else
          for (var _ = i.data_.keys(), k = o.keys(), N = _.next(), y = k.next(); !N.done; ) {
            if (N.value !== y.value) {
              i.keysAtom_.reportChanged();
              break;
            }
            N = _.next(), y = k.next();
          }
      i.data_ = o;
    }), this;
  }, e.toString = function() {
    return "[object ObservableMap]";
  }, e.toJSON = function() {
    return Array.from(this);
  }, e.observe_ = function(t, i) {
    return process.env.NODE_ENV !== "production" && i === !0 && v("`observe` doesn't support fireImmediately=true in combination with maps."), ms(this, t);
  }, e.intercept_ = function(t) {
    return cs(this, t);
  }, Ye(s, [{
    key: "size",
    get: function() {
      return this.keysAtom_.reportObserved(), this.data_.size;
    }
  }, {
    key: Symbol.toStringTag,
    get: function() {
      return "Map";
    }
  }]);
}(), De = /* @__PURE__ */ Ie("ObservableMap", Ri);
function va(s) {
  return s[Symbol.toStringTag] = "MapIterator", Vt(s);
}
function Jr(s) {
  if (Ke(s) || De(s))
    return s;
  if (Array.isArray(s))
    return new Map(s);
  if (ge(s)) {
    var e = /* @__PURE__ */ new Map();
    for (var a in s)
      e.set(a, s[a]);
    return e;
  } else
    return v(21, s);
}
var Xr = {}, Fi = /* @__PURE__ */ function() {
  function s(a, t, i) {
    var n = this;
    t === void 0 && (t = xe), i === void 0 && (i = process.env.NODE_ENV !== "production" ? "ObservableSet@" + pe() : "ObservableSet"), this.name_ = void 0, this[S] = Xr, this.data_ = /* @__PURE__ */ new Set(), this.atom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.dehancer = void 0, this.enhancer_ = void 0, this.name_ = i, I(Set) || v(22), this.enhancer_ = function(o, r) {
      return t(o, r, i);
    }, Me(function() {
      n.atom_ = ni(n.name_), a && n.replace(a);
    });
  }
  var e = s.prototype;
  return e.dehanceValue_ = function(t) {
    return this.dehancer !== void 0 ? this.dehancer(t) : t;
  }, e.clear = function() {
    var t = this;
    ve(function() {
      gi(function() {
        for (var i = ze(t.data_.values()), n; !(n = i()).done; ) {
          var o = n.value;
          t.delete(o);
        }
      });
    });
  }, e.forEach = function(t, i) {
    for (var n = ze(this), o; !(o = n()).done; ) {
      var r = o.value;
      t.call(i, r, r, this);
    }
  }, e.add = function(t) {
    var i = this;
    if (me(this.atom_), J(this)) {
      var n = X(this, {
        type: Se,
        object: this,
        newValue: t
      });
      if (!n)
        return this;
      t = n.newValue;
    }
    if (!this.has(t)) {
      ve(function() {
        i.data_.add(i.enhancer_(t, void 0)), i.atom_.reportChanged();
      });
      var o = process.env.NODE_ENV !== "production" && U(), r = oe(this), p = r || o ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: Se,
        object: this,
        newValue: t
      } : null;
      o && process.env.NODE_ENV !== "production" && K(p), r && re(this, p), o && process.env.NODE_ENV !== "production" && Y();
    }
    return this;
  }, e.delete = function(t) {
    var i = this;
    if (J(this)) {
      var n = X(this, {
        type: Ms,
        object: this,
        oldValue: t
      });
      if (!n)
        return !1;
    }
    if (this.has(t)) {
      var o = process.env.NODE_ENV !== "production" && U(), r = oe(this), p = r || o ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: Ms,
        object: this,
        oldValue: t
      } : null;
      return o && process.env.NODE_ENV !== "production" && K(p), ve(function() {
        i.atom_.reportChanged(), i.data_.delete(t);
      }), r && re(this, p), o && process.env.NODE_ENV !== "production" && Y(), !0;
    }
    return !1;
  }, e.has = function(t) {
    return this.atom_.reportObserved(), this.data_.has(this.dehanceValue_(t));
  }, e.entries = function() {
    var t = this.values();
    return wa({
      next: function() {
        var n = t.next(), o = n.value, r = n.done;
        return r ? {
          value: void 0,
          done: r
        } : {
          value: [o, o],
          done: r
        };
      }
    });
  }, e.keys = function() {
    return this.values();
  }, e.values = function() {
    this.atom_.reportObserved();
    var t = this, i = this.data_.values();
    return wa({
      next: function() {
        var o = i.next(), r = o.value, p = o.done;
        return p ? {
          value: void 0,
          done: p
        } : {
          value: t.dehanceValue_(r),
          done: p
        };
      }
    });
  }, e.intersection = function(t) {
    if (he(t) && !le(t))
      return t.intersection(this);
    var i = new Set(this);
    return i.intersection(t);
  }, e.union = function(t) {
    if (he(t) && !le(t))
      return t.union(this);
    var i = new Set(this);
    return i.union(t);
  }, e.difference = function(t) {
    return new Set(this).difference(t);
  }, e.symmetricDifference = function(t) {
    if (he(t) && !le(t))
      return t.symmetricDifference(this);
    var i = new Set(this);
    return i.symmetricDifference(t);
  }, e.isSubsetOf = function(t) {
    return new Set(this).isSubsetOf(t);
  }, e.isSupersetOf = function(t) {
    return new Set(this).isSupersetOf(t);
  }, e.isDisjointFrom = function(t) {
    if (he(t) && !le(t))
      return t.isDisjointFrom(this);
    var i = new Set(this);
    return i.isDisjointFrom(t);
  }, e.replace = function(t) {
    var i = this;
    return le(t) && (t = new Set(t)), ve(function() {
      Array.isArray(t) ? (i.clear(), t.forEach(function(n) {
        return i.add(n);
      })) : he(t) ? (i.clear(), t.forEach(function(n) {
        return i.add(n);
      })) : t != null && v("Cannot initialize set from " + t);
    }), this;
  }, e.observe_ = function(t, i) {
    return process.env.NODE_ENV !== "production" && i === !0 && v("`observe` doesn't support fireImmediately=true in combination with sets."), ms(this, t);
  }, e.intercept_ = function(t) {
    return cs(this, t);
  }, e.toJSON = function() {
    return Array.from(this);
  }, e.toString = function() {
    return "[object ObservableSet]";
  }, e[Symbol.iterator] = function() {
    return this.values();
  }, Ye(s, [{
    key: "size",
    get: function() {
      return this.atom_.reportObserved(), this.data_.size;
    }
  }, {
    key: Symbol.toStringTag,
    get: function() {
      return "Set";
    }
  }]);
}(), le = /* @__PURE__ */ Ie("ObservableSet", Fi);
function wa(s) {
  return s[Symbol.toStringTag] = "SetIterator", Vt(s);
}
var ba = /* @__PURE__ */ Object.create(null), ya = "remove", Pt = /* @__PURE__ */ function() {
  function s(a, t, i, n) {
    t === void 0 && (t = /* @__PURE__ */ new Map()), n === void 0 && (n = zo), this.target_ = void 0, this.values_ = void 0, this.name_ = void 0, this.defaultAnnotation_ = void 0, this.keysAtom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.proxy_ = void 0, this.isPlainObject_ = void 0, this.appliedAnnotations_ = void 0, this.pendingKeys_ = void 0, this.target_ = a, this.values_ = t, this.name_ = i, this.defaultAnnotation_ = n, this.keysAtom_ = new Pe(process.env.NODE_ENV !== "production" ? this.name_ + ".keys" : "ObservableObject.keys"), this.isPlainObject_ = ge(this.target_), process.env.NODE_ENV !== "production" && !Hi(this.defaultAnnotation_) && v("defaultAnnotation must be valid annotation"), process.env.NODE_ENV !== "production" && (this.appliedAnnotations_ = {});
  }
  var e = s.prototype;
  return e.getObservablePropValue_ = function(t) {
    return this.values_.get(t).get();
  }, e.setObservablePropValue_ = function(t, i) {
    var n = this.values_.get(t);
    if (n instanceof ie)
      return n.set(i), !0;
    if (J(this)) {
      var o = X(this, {
        type: ne,
        object: this.proxy_ || this.target_,
        name: t,
        newValue: i
      });
      if (!o)
        return null;
      i = o.newValue;
    }
    if (i = n.prepareNewValue_(i), i !== g.UNCHANGED) {
      var r = oe(this), p = process.env.NODE_ENV !== "production" && U(), d = r || p ? {
        type: ne,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        oldValue: n.value_,
        name: t,
        newValue: i
      } : null;
      process.env.NODE_ENV !== "production" && p && K(d), n.setNewValue_(i), r && re(this, d), process.env.NODE_ENV !== "production" && p && Y();
    }
    return !0;
  }, e.get_ = function(t) {
    return g.trackingDerivation && !te(this.target_, t) && this.has_(t), this.target_[t];
  }, e.set_ = function(t, i, n) {
    return n === void 0 && (n = !1), te(this.target_, t) ? this.values_.has(t) ? this.setObservablePropValue_(t, i) : n ? Reflect.set(this.target_, t, i) : (this.target_[t] = i, !0) : this.extend_(t, {
      value: i,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }, this.defaultAnnotation_, n);
  }, e.has_ = function(t) {
    if (!g.trackingDerivation)
      return t in this.target_;
    this.pendingKeys_ || (this.pendingKeys_ = /* @__PURE__ */ new Map());
    var i = this.pendingKeys_.get(t);
    return i || (i = new Te(t in this.target_, Gs, process.env.NODE_ENV !== "production" ? this.name_ + "." + gt(t) + "?" : "ObservableObject.key?", !1), this.pendingKeys_.set(t, i)), i.get();
  }, e.make_ = function(t, i) {
    if (i === !0 && (i = this.defaultAnnotation_), i !== !1) {
      if (Sa(this, i, t), !(t in this.target_)) {
        var n;
        if ((n = this.target_[q]) != null && n[t])
          return;
        v(1, i.annotationType_, this.name_ + "." + t.toString());
      }
      for (var o = this.target_; o && o !== Bs; ) {
        var r = Es(o, t);
        if (r) {
          var p = i.make_(this, t, r, o);
          if (p === 0)
            return;
          if (p === 1)
            break;
        }
        o = Object.getPrototypeOf(o);
      }
      Aa(this, i, t);
    }
  }, e.extend_ = function(t, i, n, o) {
    if (o === void 0 && (o = !1), n === !0 && (n = this.defaultAnnotation_), n === !1)
      return this.defineProperty_(t, i, o);
    Sa(this, n, t);
    var r = n.extend_(this, t, i, o);
    return r && Aa(this, n, t), r;
  }, e.defineProperty_ = function(t, i, n) {
    n === void 0 && (n = !1), me(this.keysAtom_);
    try {
      Z();
      var o = this.delete_(t);
      if (!o)
        return o;
      if (J(this)) {
        var r = X(this, {
          object: this.proxy_ || this.target_,
          name: t,
          type: Se,
          newValue: i.value
        });
        if (!r)
          return null;
        var p = r.newValue;
        i.value !== p && (i = be({}, i, {
          value: p
        }));
      }
      if (n) {
        if (!Reflect.defineProperty(this.target_, t, i))
          return !1;
      } else
        ue(this.target_, t, i);
      this.notifyPropertyAddition_(t, i.value);
    } finally {
      ee();
    }
    return !0;
  }, e.defineObservableProperty_ = function(t, i, n, o) {
    o === void 0 && (o = !1), me(this.keysAtom_);
    try {
      Z();
      var r = this.delete_(t);
      if (!r)
        return r;
      if (J(this)) {
        var p = X(this, {
          object: this.proxy_ || this.target_,
          name: t,
          type: Se,
          newValue: i
        });
        if (!p)
          return null;
        i = p.newValue;
      }
      var d = _a(t), l = {
        configurable: g.safeDescriptors ? this.isPlainObject_ : !0,
        enumerable: !0,
        get: d.get,
        set: d.set
      };
      if (o) {
        if (!Reflect.defineProperty(this.target_, t, l))
          return !1;
      } else
        ue(this.target_, t, l);
      var c = new Te(i, n, process.env.NODE_ENV !== "production" ? this.name_ + "." + t.toString() : "ObservableObject.key", !1);
      this.values_.set(t, c), this.notifyPropertyAddition_(t, c.value_);
    } finally {
      ee();
    }
    return !0;
  }, e.defineComputedProperty_ = function(t, i, n) {
    n === void 0 && (n = !1), me(this.keysAtom_);
    try {
      Z();
      var o = this.delete_(t);
      if (!o)
        return o;
      if (J(this)) {
        var r = X(this, {
          object: this.proxy_ || this.target_,
          name: t,
          type: Se,
          newValue: void 0
        });
        if (!r)
          return null;
      }
      i.name || (i.name = process.env.NODE_ENV !== "production" ? this.name_ + "." + t.toString() : "ObservableObject.key"), i.context = this.proxy_ || this.target_;
      var p = _a(t), d = {
        configurable: g.safeDescriptors ? this.isPlainObject_ : !0,
        enumerable: !1,
        get: p.get,
        set: p.set
      };
      if (n) {
        if (!Reflect.defineProperty(this.target_, t, d))
          return !1;
      } else
        ue(this.target_, t, d);
      this.values_.set(t, new ie(i)), this.notifyPropertyAddition_(t, void 0);
    } finally {
      ee();
    }
    return !0;
  }, e.delete_ = function(t, i) {
    if (i === void 0 && (i = !1), me(this.keysAtom_), !te(this.target_, t))
      return !0;
    if (J(this)) {
      var n = X(this, {
        object: this.proxy_ || this.target_,
        name: t,
        type: ya
      });
      if (!n)
        return null;
    }
    try {
      var o;
      Z();
      var r = oe(this), p = process.env.NODE_ENV !== "production" && U(), d = this.values_.get(t), l = void 0;
      if (!d && (r || p)) {
        var c;
        l = (c = Es(this.target_, t)) == null ? void 0 : c.value;
      }
      if (i) {
        if (!Reflect.deleteProperty(this.target_, t))
          return !1;
      } else
        delete this.target_[t];
      if (process.env.NODE_ENV !== "production" && delete this.appliedAnnotations_[t], d && (this.values_.delete(t), d instanceof Te && (l = d.value_), _i(d)), this.keysAtom_.reportChanged(), (o = this.pendingKeys_) == null || (o = o.get(t)) == null || o.set(t in this.target_), r || p) {
        var f = {
          type: ya,
          observableKind: "object",
          object: this.proxy_ || this.target_,
          debugObjectName: this.name_,
          oldValue: l,
          name: t
        };
        process.env.NODE_ENV !== "production" && p && K(f), r && re(this, f), process.env.NODE_ENV !== "production" && p && Y();
      }
    } finally {
      ee();
    }
    return !0;
  }, e.observe_ = function(t, i) {
    return process.env.NODE_ENV !== "production" && i === !0 && v("`observe` doesn't support the fire immediately property for observable objects."), ms(this, t);
  }, e.intercept_ = function(t) {
    return cs(this, t);
  }, e.notifyPropertyAddition_ = function(t, i) {
    var n, o = oe(this), r = process.env.NODE_ENV !== "production" && U();
    if (o || r) {
      var p = o || r ? {
        type: Se,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        name: t,
        newValue: i
      } : null;
      process.env.NODE_ENV !== "production" && r && K(p), o && re(this, p), process.env.NODE_ENV !== "production" && r && Y();
    }
    (n = this.pendingKeys_) == null || (n = n.get(t)) == null || n.set(!0), this.keysAtom_.reportChanged();
  }, e.ownKeys_ = function() {
    return this.keysAtom_.reportObserved(), qs(this.target_);
  }, e.keys_ = function() {
    return this.keysAtom_.reportObserved(), Object.keys(this.target_);
  }, s;
}();
function Qe(s, e) {
  var a;
  if (process.env.NODE_ENV !== "production" && e && us(s) && v("Options can't be provided for already observable objects."), te(s, S))
    return process.env.NODE_ENV !== "production" && !(Vi(s) instanceof Pt) && v("Cannot convert '" + Vs(s) + `' into observable object:
The target is already observable of different type.
Extending builtins is not supported.`), s;
  process.env.NODE_ENV !== "production" && !Object.isExtensible(s) && v("Cannot make the designated object observable; it is not extensible");
  var t = (a = e == null ? void 0 : e.name) != null ? a : process.env.NODE_ENV !== "production" ? (ge(s) ? "ObservableObject" : s.constructor.name) + "@" + pe() : "ObservableObject", i = new Pt(s, /* @__PURE__ */ new Map(), String(t), er(e));
  return zs(s, S, i), s;
}
var Zr = /* @__PURE__ */ Ie("ObservableObjectAdministration", Pt);
function _a(s) {
  return ba[s] || (ba[s] = {
    get: function() {
      return this[S].getObservablePropValue_(s);
    },
    set: function(a) {
      return this[S].setObservablePropValue_(s, a);
    }
  });
}
function us(s) {
  return js(s) ? Zr(s[S]) : !1;
}
function Aa(s, e, a) {
  var t;
  process.env.NODE_ENV !== "production" && (s.appliedAnnotations_[a] = e), (t = s.target_[q]) == null || delete t[a];
}
function Sa(s, e, a) {
  if (process.env.NODE_ENV !== "production" && !Hi(e) && v("Cannot annotate '" + s.name_ + "." + a.toString() + "': Invalid annotation."), process.env.NODE_ENV !== "production" && !xs(e) && te(s.appliedAnnotations_, a)) {
    var t = s.name_ + "." + a.toString(), i = s.appliedAnnotations_[a].annotationType_, n = e.annotationType_;
    v("Cannot apply '" + n + "' to '" + t + "':" + (`
The field is already annotated with '` + i + "'.") + `
Re-annotating fields is not allowed.
Use 'override' annotation for methods overridden by subclass.`);
  }
}
var ep = /* @__PURE__ */ Li(0), sp = /* @__PURE__ */ function() {
  var s = !1, e = {};
  return Object.defineProperty(e, "0", {
    set: function() {
      s = !0;
    }
  }), Object.create(e)[0] = 1, s === !1;
}(), tt = 0, Ii = function() {
};
function tp(s, e) {
  Object.setPrototypeOf ? Object.setPrototypeOf(s.prototype, e) : s.prototype.__proto__ !== void 0 ? s.prototype.__proto__ = e : s.prototype = e;
}
tp(Ii, Array.prototype);
var Mt = /* @__PURE__ */ function(s) {
  function e(t, i, n, o) {
    var r;
    return n === void 0 && (n = process.env.NODE_ENV !== "production" ? "ObservableArray@" + pe() : "ObservableArray"), o === void 0 && (o = !1), r = s.call(this) || this, Me(function() {
      var p = new Lt(n, i, o, !0);
      p.proxy_ = r, si(r, S, p), t && t.length && r.spliceWithArray(0, 0, t), sp && Object.defineProperty(r, "0", ep);
    }), r;
  }
  ii(e, s);
  var a = e.prototype;
  return a.concat = function() {
    this[S].atom_.reportObserved();
    for (var i = arguments.length, n = new Array(i), o = 0; o < i; o++)
      n[o] = arguments[o];
    return Array.prototype.concat.apply(
      this.slice(),
      //@ts-ignore
      n.map(function(r) {
        return Qs(r) ? r.slice() : r;
      })
    );
  }, a[Symbol.iterator] = function() {
    var t = this, i = 0;
    return Vt({
      next: function() {
        return i < t.length ? {
          value: t[i++],
          done: !1
        } : {
          done: !0,
          value: void 0
        };
      }
    });
  }, Ye(e, [{
    key: "length",
    get: function() {
      return this[S].getArrayLength_();
    },
    set: function(i) {
      this[S].setArrayLength_(i);
    }
  }, {
    key: Symbol.toStringTag,
    get: function() {
      return "Array";
    }
  }]);
}(Ii);
Object.entries(Ls).forEach(function(s) {
  var e = s[0], a = s[1];
  e !== "concat" && zs(Mt.prototype, e, a);
});
function Li(s) {
  return {
    enumerable: !1,
    configurable: !0,
    get: function() {
      return this[S].get_(s);
    },
    set: function(a) {
      this[S].set_(s, a);
    }
  };
}
function ap(s) {
  ue(Mt.prototype, "" + s, Li(s));
}
function Mi(s) {
  if (s > tt) {
    for (var e = tt; e < s + 100; e++)
      ap(e);
    tt = s;
  }
}
Mi(1e3);
function ip(s, e, a) {
  return new Mt(s, e, a);
}
function We(s, e) {
  if (typeof s == "object" && s !== null) {
    if (Qs(s))
      return e !== void 0 && v(23), s[S].atom_;
    if (le(s))
      return s.atom_;
    if (De(s)) {
      if (e === void 0)
        return s.keysAtom_;
      var a = s.data_.get(e) || s.hasMap_.get(e);
      return a || v(25, e, Vs(s)), a;
    }
    if (us(s)) {
      if (!e)
        return v(26);
      var t = s[S].values_.get(e);
      return t || v(27, e, Vs(s)), t;
    }
    if (Tt(s) || Ys(s) || Is(s))
      return s;
  } else if (I(s) && Is(s[S]))
    return s[S];
  v(28);
}
function Vi(s, e) {
  if (s || v(29), Tt(s) || Ys(s) || Is(s) || De(s) || le(s))
    return s;
  if (s[S])
    return s[S];
  v(24, s);
}
function Vs(s, e) {
  var a;
  if (e !== void 0)
    a = We(s, e);
  else {
    if ($e(s))
      return s.name;
    us(s) || De(s) || le(s) ? a = Vi(s) : a = We(s);
  }
  return a.name_;
}
function Me(s) {
  var e = Le(), a = xt(!0);
  Z();
  try {
    return s();
  } finally {
    ee(), Rt(a), we(e);
  }
}
var Pa = Bs.toString;
function Ui(s, e, a) {
  return a === void 0 && (a = -1), Dt(s, e, a);
}
function Dt(s, e, a, t, i) {
  if (s === e)
    return s !== 0 || 1 / s === 1 / e;
  if (s == null || e == null)
    return !1;
  if (s !== s)
    return e !== e;
  var n = typeof s;
  if (n !== "function" && n !== "object" && typeof e != "object")
    return !1;
  var o = Pa.call(s);
  if (o !== Pa.call(e))
    return !1;
  switch (o) {
    // Strings, numbers, regular expressions, dates, and booleans are compared by value.
    case "[object RegExp]":
    // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
    case "[object String]":
      return "" + s == "" + e;
    case "[object Number]":
      return +s != +s ? +e != +e : +s == 0 ? 1 / +s === 1 / e : +s == +e;
    case "[object Date]":
    case "[object Boolean]":
      return +s == +e;
    case "[object Symbol]":
      return typeof Symbol < "u" && Symbol.valueOf.call(s) === Symbol.valueOf.call(e);
    case "[object Map]":
    case "[object Set]":
      a >= 0 && a++;
      break;
  }
  s = Da(s), e = Da(e);
  var r = o === "[object Array]";
  if (!r) {
    if (typeof s != "object" || typeof e != "object")
      return !1;
    var p = s.constructor, d = e.constructor;
    if (p !== d && !(I(p) && p instanceof p && I(d) && d instanceof d) && "constructor" in s && "constructor" in e)
      return !1;
  }
  if (a === 0)
    return !1;
  a < 0 && (a = -1), t = t || [], i = i || [];
  for (var l = t.length; l--; )
    if (t[l] === s)
      return i[l] === e;
  if (t.push(s), i.push(e), r) {
    if (l = s.length, l !== e.length)
      return !1;
    for (; l--; )
      if (!Dt(s[l], e[l], a - 1, t, i))
        return !1;
  } else {
    var c = Object.keys(s), f = c.length;
    if (Object.keys(e).length !== f)
      return !1;
    for (var u = 0; u < f; u++) {
      var m = c[u];
      if (!(te(e, m) && Dt(s[m], e[m], a - 1, t, i)))
        return !1;
    }
  }
  return t.pop(), i.pop(), !0;
}
function Da(s) {
  return Qs(s) ? s.slice() : Ke(s) || De(s) || he(s) || le(s) ? Array.from(s.entries()) : s;
}
var Na, np = ((Na = Hs().Iterator) == null ? void 0 : Na.prototype) || {};
function Vt(s) {
  return s[Symbol.iterator] = op, Object.assign(Object.create(np), s);
}
function op() {
  return this;
}
function Hi(s) {
  return (
    // Can be function
    s instanceof Object && typeof s.annotationType_ == "string" && I(s.make_) && I(s.extend_)
  );
}
["Symbol", "Map", "Set"].forEach(function(s) {
  var e = Hs();
  typeof e[s] > "u" && v("MobX requires global '" + s + "' to be available or polyfilled");
});
typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ == "object" && __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
  spy: _r,
  extras: {
    getDebugName: Vs
  },
  $mobx: S
});
if (!La)
  throw new Error("mobx-react-lite requires React with Hooks support");
if (!$r)
  throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");
function rp(s) {
  s();
}
function pp(s) {
  s || (s = rp, process.env.NODE_ENV !== "production" && console.warn("[MobX] Failed to get unstable_batched updates from react-dom / react-native")), Ir({ reactionScheduler: s });
}
function dp(s) {
  return Ei(s);
}
var lp = 1e4, cp = 1e4, mp = (
  /** @class */
  function() {
    function s(e) {
      var a = this;
      Object.defineProperty(this, "finalize", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
      }), Object.defineProperty(this, "registrations", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: /* @__PURE__ */ new Map()
      }), Object.defineProperty(this, "sweepTimeout", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: void 0
      }), Object.defineProperty(this, "sweep", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: function(t) {
          t === void 0 && (t = lp), clearTimeout(a.sweepTimeout), a.sweepTimeout = void 0;
          var i = Date.now();
          a.registrations.forEach(function(n, o) {
            i - n.registeredAt >= t && (a.finalize(n.value), a.registrations.delete(o));
          }), a.registrations.size > 0 && a.scheduleSweep();
        }
      }), Object.defineProperty(this, "finalizeAllImmediately", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: function() {
          a.sweep(0);
        }
      });
    }
    return Object.defineProperty(s.prototype, "register", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function(e, a, t) {
        this.registrations.set(t, {
          value: a,
          registeredAt: Date.now()
        }), this.scheduleSweep();
      }
    }), Object.defineProperty(s.prototype, "unregister", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function(e) {
        this.registrations.delete(e);
      }
    }), Object.defineProperty(s.prototype, "scheduleSweep", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function() {
        this.sweepTimeout === void 0 && (this.sweepTimeout = setTimeout(this.sweep, cp));
      }
    }), s;
  }()
), up = typeof FinalizationRegistry < "u" ? FinalizationRegistry : mp, Nt = new up(function(s) {
  var e;
  (e = s.reaction) === null || e === void 0 || e.dispose(), s.reaction = null;
}), bs = { exports: {} }, at = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Oa;
function fp() {
  if (Oa) return at;
  Oa = 1;
  var s = Ps;
  function e(c, f) {
    return c === f && (c !== 0 || 1 / c === 1 / f) || c !== c && f !== f;
  }
  var a = typeof Object.is == "function" ? Object.is : e, t = s.useState, i = s.useEffect, n = s.useLayoutEffect, o = s.useDebugValue;
  function r(c, f) {
    var u = f(), m = t({ inst: { value: u, getSnapshot: f } }), h = m[0].inst, w = m[1];
    return n(
      function() {
        h.value = u, h.getSnapshot = f, p(h) && w({ inst: h });
      },
      [c, u, f]
    ), i(
      function() {
        return p(h) && w({ inst: h }), c(function() {
          p(h) && w({ inst: h });
        });
      },
      [c]
    ), o(u), u;
  }
  function p(c) {
    var f = c.getSnapshot;
    c = c.value;
    try {
      var u = f();
      return !a(c, u);
    } catch {
      return !0;
    }
  }
  function d(c, f) {
    return f();
  }
  var l = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? d : r;
  return at.useSyncExternalStore = s.useSyncExternalStore !== void 0 ? s.useSyncExternalStore : l, at;
}
var it = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ka;
function gp() {
  return ka || (ka = 1, process.env.NODE_ENV !== "production" && function() {
    function s(u, m) {
      return u === m && (u !== 0 || 1 / u === 1 / m) || u !== u && m !== m;
    }
    function e(u, m) {
      l || i.startTransition === void 0 || (l = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var h = m();
      if (!c) {
        var w = m();
        n(h, w) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), c = !0);
      }
      w = o({
        inst: { value: h, getSnapshot: m }
      });
      var b = w[0].inst, D = w[1];
      return p(
        function() {
          b.value = h, b.getSnapshot = m, a(b) && D({ inst: b });
        },
        [u, h, m]
      ), r(
        function() {
          return a(b) && D({ inst: b }), u(function() {
            a(b) && D({ inst: b });
          });
        },
        [u]
      ), d(h), h;
    }
    function a(u) {
      var m = u.getSnapshot;
      u = u.value;
      try {
        var h = m();
        return !n(u, h);
      } catch {
        return !0;
      }
    }
    function t(u, m) {
      return m();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var i = Ps, n = typeof Object.is == "function" ? Object.is : s, o = i.useState, r = i.useEffect, p = i.useLayoutEffect, d = i.useDebugValue, l = !1, c = !1, f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? t : e;
    it.useSyncExternalStore = i.useSyncExternalStore !== void 0 ? i.useSyncExternalStore : f, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), it;
}
var Ea;
function hp() {
  return Ea || (Ea = 1, process.env.NODE_ENV === "production" ? bs.exports = fp() : bs.exports = gp()), bs.exports;
}
var vp = hp();
function Ta(s) {
  s.reaction = new ye("observer".concat(s.name), function() {
    var e;
    s.stateVersion = Symbol(), (e = s.onStoreChange) === null || e === void 0 || e.call(s);
  });
}
function wp(s, e) {
  e === void 0 && (e = "observed");
  var a = Ps.useRef(null);
  if (!a.current) {
    var t = {
      reaction: null,
      onStoreChange: null,
      stateVersion: Symbol(),
      name: e,
      subscribe: function(r) {
        return Nt.unregister(t), t.onStoreChange = r, t.reaction || (Ta(t), t.stateVersion = Symbol()), function() {
          var p;
          t.onStoreChange = null, (p = t.reaction) === null || p === void 0 || p.dispose(), t.reaction = null;
        };
      },
      getSnapshot: function() {
        return t.stateVersion;
      }
    };
    a.current = t;
  }
  var i = a.current;
  i.reaction || (Ta(i), Nt.register(a, i, i)), Ps.useDebugValue(i.reaction, dp), vp.useSyncExternalStore(
    // Both of these must be stable, otherwise it would keep resubscribing every render.
    i.subscribe,
    i.getSnapshot,
    i.getSnapshot
  );
  var n, o;
  if (i.reaction.track(function() {
    try {
      n = s();
    } catch (r) {
      o = r;
    }
  }), o)
    throw o;
  return n;
}
var nt, ot, bp = !0, Ca = !0, Bi = typeof Symbol == "function" && Symbol.for, yp = (ot = (nt = Object.getOwnPropertyDescriptor(function() {
}, "name")) === null || nt === void 0 ? void 0 : nt.configurable) !== null && ot !== void 0 ? ot : !1, xa = Bi ? Symbol.for("react.forward_ref") : typeof lt == "function" && lt(function(s) {
  return null;
}).$$typeof, Ra = Bi ? Symbol.for("react.memo") : typeof ct == "function" && ct(function(s) {
  return null;
}).$$typeof;
function ji(s, e) {
  var a;
  if (process.env.NODE_ENV, Ra && s.$$typeof === Ra)
    throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
  var t = (a = void 0) !== null && a !== void 0 ? a : !1, i = s, n = s.displayName || s.name;
  if (xa && s.$$typeof === xa && (t = !0, i = s.render, typeof i != "function"))
    throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
  var o = function(r, p) {
    return wp(function() {
      return i(r, p);
    }, n);
  };
  return o.displayName = s.displayName, yp && Object.defineProperty(o, "name", {
    value: s.name,
    writable: !0,
    configurable: !0
  }), s.contextTypes && (o.contextTypes = s.contextTypes, process.env.NODE_ENV !== "production" && Ca && (Ca = !1, console.warn("[mobx-react-lite] Support for Legacy Context in function components will be removed in the next major release."))), t && (o = lt(o)), o = ct(o), Ap(s, o), process.env.NODE_ENV !== "production" && Object.defineProperty(o, "contextTypes", {
    set: function() {
      var r, p;
      throw new Error("[mobx-react-lite] `".concat(this.displayName || ((r = this.type) === null || r === void 0 ? void 0 : r.displayName) || ((p = this.type) === null || p === void 0 ? void 0 : p.name) || "Component", ".contextTypes` must be set before applying `observer`."));
    }
  }), o;
}
var _p = {
  $$typeof: !0,
  render: !0,
  compare: !0,
  type: !0,
  // Don't redefine `displayName`,
  // it's defined as getter-setter pair on `memo` (see #3192).
  displayName: !0
};
function Ap(s, e) {
  Object.keys(s).forEach(function(a) {
    _p[a] || Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(s, a));
  });
}
process.env.NODE_ENV;
var rt;
pp(Yi);
rt = Nt.finalizeAllImmediately;
const Sp = {
  "app.dashboard.error": "تعذّر تحميل لوحة المعلومات. يرجى المحاولة مرة أخرى.",
  "app.dashboard.welcome.greeting": "مرحبًا بعودتك، {{name}}",
  "app.dashboard.welcome.subtitle": "نظرة عامة على الامتثال لنظام حماية البيانات الشخصية",
  "app.dashboard.welcome.today": "اليوم · {{date}}",
  "app.dashboard.stats.total": "إجمالي التقييمات",
  "app.dashboard.stats.totalSub": "منذ البداية",
  "app.dashboard.stats.completed": "مكتملة",
  "app.dashboard.stats.completedSub": "مُقيَّمة وموثّقة",
  "app.dashboard.stats.processing": "قيد المعالجة",
  "app.dashboard.stats.processingSub": "قيد التحليل",
  "app.dashboard.stats.drafts": "مسودات",
  "app.dashboard.stats.draftsSub": "لم تُقدَّم بعد",
  "app.dashboard.maturity.title": "نضج الامتثال لنظام حماية البيانات",
  "app.dashboard.maturity.subtitle": "سجلّ الامتثال المرجعي لمؤسستك",
  "app.dashboard.maturity.latest": "آخر تقييم مكتمل · {{date}}",
  "app.dashboard.maturity.label": "النضج",
  "app.dashboard.maturity.export": "تصدير التقرير",
  "app.dashboard.maturity.domainBreakdown": "تفصيل المجالات",
  "app.dashboard.maturity.domainsCount": "{{count}} مجالات",
  "app.dashboard.maturity.loadMore": "تحميل {{count}} إضافية",
  "app.dashboard.maturity.showLess": "عرض أقل",
  "app.dashboard.maturity.viewAllDomains": "عرض جميع المجالات",
  "app.dashboard.maturity.criticalGap": "فجوة حرجة",
  "app.dashboard.maturity.completedAssessments": "التقييمات المكتملة",
  "app.dashboard.maturity.empty.title": "لا توجد تقييمات مكتملة",
  "app.dashboard.maturity.empty.body": "ابدأ أول تقييم لنظام حماية البيانات لعرض درجة نضج مؤسستك وتفصيل الفجوات لكل مجال هنا.",
  "app.dashboard.maturity.empty.run": "ابدأ أول تقييم",
  "app.dashboard.activeWork.title": "مساحة العمل النشطة",
  "app.dashboard.activeWork.subtitle": "تقييماتك الجارية",
  "app.dashboard.activeWork.processing": "قيد المعالجة",
  "app.dashboard.activeWork.draft": "مسودة",
  "app.dashboard.activeWork.resumeDraft": "متابعة المسودة",
  "app.dashboard.activeWork.launch": "بدء تقييم جديد لنظام حماية البيانات",
  "app.dashboard.activeWork.empty": "لا يوجد عمل قيد التنفيذ. ابدأ تقييمًا للبدء.",
  "app.dashboard.activeWork.viewAll": "عرض الكل",
  "app.dashboard.activeWork.loadMore": "تحميل {{count}} إضافية",
  "app.dashboard.orgProfile.title": "ملف المؤسسة",
  "app.dashboard.orgProfile.subtitle": "البيانات الأساسية التي تُغذّي تقييماتك",
  "app.dashboard.orgProfile.open": "فتح",
  "app.dashboard.orgProfile.completion": "اكتمال الملف",
  "app.dashboard.orgProfile.categoriesApproved": "{{approved}} من {{total}} فئات معتمدة",
  "app.dashboard.orgProfile.documents": "المستندات المرفوعة",
  "app.dashboard.orgProfile.documentsBreakdown": "{{approved}} معتمدة · {{processing}} قيد المعالجة",
  "app.dashboard.orgProfile.fields": "الحقول المعبّأة",
  "app.dashboard.orgProfile.fieldsRemaining": "{{count}} متبقية",
  "app.dashboard.orgProfile.reviews": "مراجعات معلّقة",
  "app.dashboard.orgProfile.reviewsHint": "فتح مركز المستندات",
  "app.dashboard.ai.title": "اسأل komplyance AI",
  "app.dashboard.ai.subtitle": "مدعوم بقاعدة معرفة نظام حماية البيانات",
  "app.dashboard.ai.placeholder": "اسأل عن نظام حماية البيانات…",
  "app.dashboard.ai.quickPrompts": "أسئلة سريعة",
  "app.dashboard.ai.prompt1": "ما العقوبات الصريحة بموجب نظام حماية البيانات عند اختراق البيانات؟",
  "app.dashboard.ai.prompt2": "ما متطلبات التوثيق لنقل البيانات عبر الحدود؟",
  "app.layout.sidebar.dashboard": "لوحة المعلومات",
  "app.assessment.classification.aiReasoning": "تفسير الذكاء الاصطناعي",
  "app.assessment.classification.classifiedAt": "تم التصنيف في: {{date}}",
  "app.assessment.classification.classifying": "جاري تصنيف المستند...",
  "app.assessment.classification.confidence.high": "ثقة عالية",
  "app.assessment.classification.confidence.low": "ثقة منخفضة",
  "app.assessment.classification.confidence.medium": "ثقة متوسطة",
  "app.assessment.classification.confidence.unknown": "غير معروف",
  "app.assessment.classification.invalid.description": "لم يتمكن الذكاء الاصطناعي من التحقق من هذا المستند. لن يُدرج في تقديم التقييم. يُرجى حذفه ورفع المستند الصحيح.",
  "app.assessment.classification.invalid.lowConfidenceSuggestion.description": "حددنا أن هذا الملف يتبع {{detectedDomain}} وليس المجال الحالي. ولن يُدرج في هذا التقييم.",
  "app.assessment.classification.invalid.title": "مستند غير صالح",
  "app.assessment.classification.matchedBadge": "طابق هذا الملف أحد المستندات المتوقعة",
  "app.assessment.classification.nonStandardFormat.title": "مقبول — يُفضّل استخدام الصيغة المعتمدة",
  "app.assessment.classification.nonStandardFormat.description": "تمت مطابقته كـ {{document}} وأُدرج بالكامل ضمن تقييمك. رفعه بالصيغة المعتمدة يمنح التقييم بنية أوضح للعمل عليها، مما يرفع دقة التحليل ويتيح إنتاج النسخة المعتمدة.",
  "app.assessment.classification.unsupportedFormat.title": "صيغة ملف غير مدعومة",
  "app.assessment.classification.unsupportedFormat.description": "لا يمكن التحقق من صيغة هذا الملف لهذا المستند، ولن يُدرج ضمن تقييمك. يرجى إعادة رفعه بإحدى الصيغ المقبولة.",
  "app.assessment.classification.invalid.wrongDomain.description": "هذا المستند لا ينتمي إلى المجال الحالي. اكتشفنا أنه أقرب إلى {{suggestedDomain}}.{{matchedDocumentSection}} لذلك لن يتم تضمينه ضمن تسليم هذا المجال. يُرجى حذفه ورفعه في المجال الصحيح.",
  "app.assessment.classification.invalid.wrongDomain.title": "هذا المستند لا ينتمي إلى هذا المجال",
  "app.assessment.classification.language": "اللغة",
  "app.assessment.classification.matched": "المطابق:",
  "app.assessment.classification.matchedDomain": "المجال المطابق",
  "app.assessment.classification.mismatch.description": "تمت مطابقة هذا المستند مع <bold>{{documentName}}</bold>{{domainPart}}، وهو <bold>غير مطلوب</bold> في المجال الحالي. فكر في رفعه في قسم المجال الصحيح.",
  "app.assessment.classification.mismatch.descriptionWithDomain": " (من المجال: <bold>{{domainName}}</bold>)",
  "app.assessment.classification.mismatch.infoTooltip": "طابق الذكاء الاصطناعي هذا الملف مع مستند معياري غير مطلوب في المجال الحالي. ربما تم رفعه في القسم الخطأ. راجعه وانقله إذا لزم الأمر.",
  "app.assessment.classification.mismatch.title": "مجال خاطئ",
  "app.assessment.classification.moreInfo": "مزيد من المعلومات",
  "app.assessment.classification.na": "غير متاح",
  "app.assessment.classification.pageCount": "عدد الصفحات",
  "app.assessment.classification.processing": "الذكاء الاصطناعي يحلّل المستند الآن...",
  "app.assessment.classification.processingFailed.description": "تعذّر على الذكاء الاصطناعي تصنيف هذا المستند. يُرجى إعادة المحاولة أو حذفه ورفع مستند آخر.",
  "app.assessment.classification.processingFailed.timedOut": "تصنيف هذا المستند يستغرق وقتًا أطول من المتوقع. يُرجى إعادة المحاولة أو التحقق مجددًا بعد بضع دقائق.",
  "app.assessment.classification.processingFailed.title": "فشل التصنيف",
  "app.assessment.classification.queued": "في انتظار بدء التصنيف...",
  "app.assessment.classification.retry": "إعادة التصنيف",
  "app.assessment.classification.standardDocument": "المستند المعياري",
  "app.assessment.classification.standardDocumentKey": "المعرف: {{key}}",
  "app.assessment.classification.suggestion.description": "لم يتمكن الذكاء الاصطناعي من تصنيف هذا المستند بثقة عالية، لكنه يقترح أنه قد ينتمي إلى مجال أو نوع مستند مختلف.",
  "app.assessment.classification.suggestion.moveButton": "نقل إلى {{domain}}",
  "app.assessment.classification.suggestion.moveConfirmCta": "نقل المستند",
  "app.assessment.classification.suggestion.moveConfirmMessage": "سيتم نقل هذا المستند إلى {{domain}} والتحقق منه وفق المستندات المطلوبة في ذلك المجال.",
  "app.assessment.classification.suggestion.moveConfirmTitle": "نقل المستند إلى المجال المقترح؟",
  "app.assessment.classification.suggestion.moveError": "تعذّر نقل المستند إلى المجال المقترح",
  "app.assessment.classification.suggestion.moveSuccess": "تم نقل المستند إلى المجال المقترح",
  "app.assessment.classification.suggestion.moving": "جارٍ النقل…",
  "app.assessment.classification.suggestion.suggestedConfidence": "الثقة المقترحة",
  "app.assessment.classification.suggestion.suggestedDocument": "المستند المقترح",
  "app.assessment.classification.suggestion.suggestedDomain": "المجال المقترح",
  "app.assessment.classification.suggestion.suggestedReasoning": "التفسير المقترح",
  "app.assessment.classification.suggestion.title": "اقتراح الذكاء الاصطناعي",
  "app.assessment.classification.unknownDocument": "مستند معياري غير معروف",
  "app.assessment.classification.warning.cancel": "إلغاء",
  "app.assessment.classification.warning.reason.failed.label": "فشل التصنيف",
  "app.assessment.classification.warning.reason.failed_few": "{{count}} مستندات فشل تصنيفها",
  "app.assessment.classification.warning.reason.failed_many": "{{count}} مستنداً فشل تصنيفه",
  "app.assessment.classification.warning.reason.failed_one": "مستند واحد فشل في التصنيف",
  "app.assessment.classification.warning.reason.failed_other": "{{count}} مستند فشل تصنيفه",
  "app.assessment.classification.warning.reason.failed_two": "مستندان فشل تصنيفهما",
  "app.assessment.classification.warning.reason.failed_zero": "لا توجد مستندات فشل تصنيفها",
  "app.assessment.classification.warning.reason.mismatch.label": "مجال خاطئ",
  "app.assessment.classification.warning.reason.mismatch_few": "{{count}} مستندات رُفعت في مجال خاطئ",
  "app.assessment.classification.warning.reason.mismatch_many": "{{count}} مستنداً رُفع في مجال خاطئ",
  "app.assessment.classification.warning.reason.mismatch_one": "مستند واحد رُفع في مجال خاطئ",
  "app.assessment.classification.warning.reason.mismatch_other": "{{count}} مستند رُفع في مجال خاطئ",
  "app.assessment.classification.warning.reason.mismatch_two": "مستندان رُفعا في مجال خاطئ",
  "app.assessment.classification.warning.reason.mismatch_zero": "لا توجد مستندات مرفوعة في مجال خاطئ",
  "app.assessment.classification.warning.reason.unclassified.label": "غير مصنف",
  "app.assessment.classification.warning.reason.unclassified_few": "{{count}} مستندات لم تُصنَّف بعد",
  "app.assessment.classification.warning.reason.unclassified_many": "{{count}} مستنداً لم يُصنَّف بعد",
  "app.assessment.classification.warning.reason.unclassified_one": "مستند واحد لم يُصنَّف بعد",
  "app.assessment.classification.warning.reason.unclassified_other": "{{count}} مستند لم يُصنَّف بعد",
  "app.assessment.classification.warning.reason.unclassified_two": "مستندان لم يُصنَّفا بعد",
  "app.assessment.classification.warning.reason.unclassified_zero": "لا توجد مستندات غير مصنَّفة",
  "app.assessment.classification.warning.saveAnyway": "حفظ على أي حال",
  "app.assessment.classification.warning.summary": "قبل الحفظ، اكتشفنا {{parts}}. يمكنك الحفظ على أي حال أو الإلغاء لمراجعة مستنداتك.",
  "app.assessment.classification.warning.title": "مشكلات تصنيف المستندات",
  "app.assessment.classification.wordCount": "عدد الكلمات",
  "app.assessment.document.downloadAll": "تنزيل كل المستندات",
  "app.assessment.document.downloadAllFailed": "فشل تنزيل المستندات. يرجى المحاولة مرة أخرى.",
  "app.assessment.document.downloadStarted": "بدأ تحميل المستند",
  "app.assessment.notStarted": "لم يبدأ التقييم",
  "app.assessment.summary.changesDiscarded": "تم تجاهل التغييرات",
  "app.assessment.summary.completed": "تم الإكمال",
  "app.assessment.summary.deleted": "تم الحذف",
  "app.assessment.summary.deleting": "جاري الحذف",
  "app.assessment.summary.documentUploaded": "تم رفع المستند",
  "app.assessment.summary.domainReopened": "تم إعادة فتح المجال",
  "app.assessment.summary.maxFilesAllowed": "تم الوصول إلى الحد الأقصى للملفات المسموح بها",
  "app.assessment.summary.nameUpdated": "تم تحديث الاسم",
  "app.assessment.summary.noApiDocumentFound": "لم يتم العثور على مستند API",
  "app.assessment.summary.noNextDomain": "لا يوجد مجال تالي",
  "app.assessment.summary.notAccessible": "غير قابل للوصول",
  "app.assessment.summary.notCompleted": "لم يكتمل",
  "app.assessment.summary.notStarted": "لم يبدأ",
  "app.assessment.workflow.changesDiscarded": "تم تجاهل التغييرات",
  "app.assessment.workflow.completed": "تم الإكمال",
  "app.assessment.workflow.deleted": "تم الحذف",
  "app.assessment.workflow.deleting": "جاري الحذف",
  "app.assessment.workflow.deletionCancelled": "تم إلغاء الحذف",
  "app.assessment.workflow.deletionFailed": "فشل الحذف",
  "app.assessment.workflow.documentBadge.fromVersion": "من الإصدار V{{parentVersion}}",
  "app.assessment.workflow.documentBadge.newInThisVersion": "جديد",
  "app.assessment.workflow.documentDeleted": "تم حذف المستند",
  "app.assessment.workflow.documentIdNotFound": "لم يتم العثور على معرف المستند",
  "app.assessment.workflow.documentNotFound": "لم يتم العثور على المستند",
  "app.assessment.workflow.documentUploaded": "تم رفع المستند",
  "app.assessment.workflow.domain.expectedDocumentsCount_few": "{{count}} متوقعة",
  "app.assessment.workflow.domain.expectedDocumentsCount_many": "{{count}} متوقعاً",
  "app.assessment.workflow.domain.expectedDocumentsCount_one": "{{count}} متوقع",
  "app.assessment.workflow.domain.expectedDocumentsCount_other": "{{count}} متوقع",
  "app.assessment.workflow.domain.expectedDocumentsCount_two": "{{count}} متوقعان",
  "app.assessment.workflow.domain.expectedDocumentsCount_zero": "لا شيء متوقع",
  "app.assessment.workflow.domainReopened": "تم إعادة فتح المجال",
  "app.assessment.workflow.duplicate": "مكرر",
  "app.assessment.workflow.duplicateFileSkipped": "تم رفعه مسبقاً إلى هذا المجال، لذا تم تجاهله: {{fileNames}}",
  "app.assessment.workflow.failedToDeleteAssessment": "فشل حذف التقييم",
  "app.assessment.workflow.failedToDeleteDocument": "فشل حذف المستند",
  "app.assessment.workflow.failedToDiscardChanges": "فشل تجاهل التغييرات",
  "app.assessment.workflow.failedToSaveAndExit": "فشل الحفظ والخروج",
  "app.assessment.workflow.failedToStartEditingDomain": "فشل بدء تعديل المجال",
  "app.assessment.workflow.failedToUpdateAssessmentName": "فشل تحديث اسم التقييم",
  "app.assessment.workflow.fileRestored": "تم استعادة الملف",
  "app.assessment.workflow.maxFilesAllowed": "الحد الأقصى المسموح به في هذا المجال هو {{maxRequiredDocuments}} ملف. يرجى حذف ملفات قبل رفع المزيد.",
  "app.assessment.workflow.nameUpdated": "تم تحديث الاسم",
  "app.assessment.workflow.needsToSave": "يجب الحفظ",
  "app.assessment.workflow.noApiDocumentFound": "لم يتم العثور على مستند API",
  "app.assessment.workflow.noDomainDetailsData": "لا توجد بيانات تفاصيل المجال",
  "app.assessment.workflow.noDomainId": "لا يوجد معرف مجال",
  "app.assessment.workflow.noNextDomain": "لا يوجد مجال تالي",
  "app.assessment.workflow.notAccessible": "غير قابل للوصول",
  "app.assessment.workflow.notCompleted": "لم يكتمل",
  "app.assessment.workflow.notStarted": "لم يبدأ",
  "app.assessment.workflow.reassessmentBanner.description": "تم تحميل المستندات من الإصدار V{{parentVersion}} مسبقاً. يمكنك استبدال أو حذف أو إضافة مستندات في أي مجال — المجالات التي لم تُعدّل ستحتفظ بدرجة الإصدار V{{parentVersion}}. سيظل الإصدار V{{parentVersion}} كما هو عند الإرسال.",
  "app.assessment.workflow.reassessmentBanner.fromVersion": "من الإصدار V{{parentVersion}}",
  "app.assessment.workflow.reassessmentBanner.fromVersionWithDate": "من الإصدار V{{parentVersion}} · {{parentSubmittedDate}}",
  "app.assessment.workflow.reassessmentBanner.title": "تحرير لإعادة التقييم",
  "app.assessment.workflow.reassessmentBanner.toVersion": "V{{currentVersion}} (مسودة)",
  "app.assessment.workflow.reassessmentDomainBanner.scoreChip": "درجة الإصدار V{{parentVersion}} · {{percentage}}٪",
  "app.assessment.workflow.reassessmentDomainBanner.scoreChipPending": "درجة الإصدار V{{parentVersion}} · قيد الانتظار",
  "app.assessment.workflow.reassessmentDomainBanner.summary": "{{documentCount}} مستندات من الإصدار V{{parentVersion}} محمّلة لهذا المجال. يمكنك استبدالها أو حذفها أو إضافة مستندات جديدة.",
  "app.assessment.workflow.retryUploadFailed": "لا يمكن إعادة المحاولة. الملف الأصلي لم يعد متاحاً.",
  "app.assessment.workflow.uploadCancelled": "تم إلغاء الرفع",
  "app.assessment.workflow.validation.classificationFailed": "فشل تصنيف بعض المستندات. يُرجى إعادة المحاولة أو حذفها قبل الحفظ.",
  "app.assessment.workflow.validation.classificationInProgress": "جاري تصنيف المستندات. يُرجى الانتظار قبل الحفظ.",
  "app.assessment.workflow.validation.classificationPending": "لم يتم تصنيف بعض المستندات بعد. يُرجى الانتظار أو إعادة محاولة التصنيف.",
  "app.assessment.workflow.validation.duplicateClassification": "تم تصنيف مستندَين أو أكثر كنفس المستند المعياري ({{name}}). لا يمكن ملء كل خانة مستند إلا مرة واحدة. يُرجى حذف المكرر قبل الحفظ.",
  "app.assessment.workflow.validation.invalidClassification_few": "{{count}} مستندات لا تحتوي على تصنيف أو ثقتها منخفضة ولن يتم إرسالها. يُرجى إعادة تصنيفها أو حذفها قبل الحفظ.",
  "app.assessment.workflow.validation.invalidClassification_many": "{{count}} مستنداً لا تحتوي على تصنيف أو ثقتها منخفضة ولن يتم إرسالها. يُرجى إعادة تصنيفها أو حذفها قبل الحفظ.",
  "app.assessment.workflow.validation.invalidClassification_one": "مستند واحد لا يحتوي على تصنيف أو ثقته منخفضة ولن يتم إرساله. يُرجى إعادة تصنيفه أو حذفه قبل الحفظ.",
  "app.assessment.workflow.validation.invalidClassification_other": "{{count}} مستند لا تحتوي على تصنيف أو ثقتها منخفضة ولن يتم إرسالها. يُرجى إعادة تصنيفها أو حذفها قبل الحفظ.",
  "app.assessment.workflow.validation.invalidClassification_two": "مستندان لا يحتويان على تصنيف أو ثقتهما منخفضة ولن يتم إرسالهما. يُرجى إعادة تصنيفهما أو حذفهما قبل الحفظ.",
  "app.assessment.workflow.validation.invalidClassification_zero": "لا توجد مستندات صالحة للإرسال. يُرجى التأكد من تصنيف المستندات بثقة متوسطة أو عالية.",
  "app.assessment.workflow.validation.maxFiles_few": "يُسمح بـ {{count}} مستندات كحد أقصى. يُرجى حذف بعض الملفات قبل الحفظ.",
  "app.assessment.workflow.validation.maxFiles_many": "يُسمح بـ {{count}} مستنداً كحد أقصى. يُرجى حذف بعض الملفات قبل الحفظ.",
  "app.assessment.workflow.validation.maxFiles_one": "يُسمح بمستند واحد فقط كحد أقصى. يُرجى حذف بعض الملفات قبل الحفظ.",
  "app.assessment.workflow.validation.maxFiles_other": "يُسمح بـ {{count}} مستند كحد أقصى. يُرجى حذف بعض الملفات قبل الحفظ.",
  "app.assessment.workflow.validation.maxFiles_two": "يُسمح بمستندين فقط كحد أقصى. يُرجى حذف بعض الملفات قبل الحفظ.",
  "app.assessment.workflow.validation.maxFiles_zero": "لا يُسمح برفع أي مستندات. يُرجى حذف جميع الملفات قبل الحفظ.",
  "app.assessment.workflow.validation.minFiles_few": "يُرجى رفع {{count}} مستندات على الأقل قبل الحفظ.",
  "app.assessment.workflow.validation.minFiles_many": "يُرجى رفع {{count}} مستنداً على الأقل قبل الحفظ.",
  "app.assessment.workflow.validation.minFiles_one": "يُرجى رفع مستند واحد على الأقل قبل الحفظ.",
  "app.assessment.workflow.validation.minFiles_other": "يُرجى رفع {{count}} مستند على الأقل قبل الحفظ.",
  "app.assessment.workflow.validation.minFiles_two": "يُرجى رفع مستندين على الأقل قبل الحفظ.",
  "app.assessment.workflow.validation.minFiles_zero": "يُرجى رفع مستند واحد على الأقل قبل الحفظ.",
  "app.assessment.workflow.validation.noFilesOrNoEvidence": "يُرجى رفع مستند واحد على الأقل، أو تحديد خيار 'لا يوجد دليل متاح' إن لم يكن لديك ما ترفعه.",
  "app.assessment.workflow.validation.noValidClassification": "جميع المستندات المرفوعة غير صالحة. يُرجى رفع مستند واحد على الأقل يحمل تصنيفاً صحيحاً، أو حذف جميع المستندات غير الصالحة وتخطي هذا المجال.",
  "app.assessment.workflow.validation.waitForUploads": "يُرجى الانتظار حتى اكتمال رفع جميع الملفات قبل الحفظ.",
  "app.assessments.actions.continueAssessment": "متابعة",
  "app.assessments.actions.delete": "حذف",
  "app.assessments.actions.deleteAssessment": "حذف التقييم",
  "app.assessments.actions.deleting": "جاري الحذف...",
  "app.assessments.actions.downloadReport": "تحميل التقرير",
  "app.assessments.actions.duplicate": "تكرار",
  "app.assessments.actions.resume": "متابعة",
  "app.assessments.actions.retry": "إعادة المحاولة",
  "app.assessments.actions.startNewVersion": "بدء إصدار جديد",
  "app.assessments.actions.viewFailureReason": "عرض سبب الفشل",
  "app.assessments.actions.viewResults": "عرض النتائج",
  "app.assessments.actions.viewSummary": "عرض ملخص النتائج",
  "app.assessments.ariaLabel.cancelEditName": "إلغاء تعديل اسم التقييم",
  "app.assessments.ariaLabel.confirmEditName": "تأكيد اسم التقييم",
  "app.assessments.ariaLabel.downloadDocument": "تحميل المستند",
  "app.assessments.ariaLabel.editDomain": "تعديل المجال",
  "app.assessments.ariaLabel.editTitle": "تعديل عنوان التقييم",
  "app.assessments.ariaLabel.viewDocument": "عرض المستند",
  "app.assessments.clearAll": "مسح الكل",
  "app.assessments.delete.assessmentTitle": "عنوان التقييم:",
  "app.assessments.delete.confirmMessage": "هل أنت متأكد أنك تريد حذف هذا التقييم؟",
  "app.assessments.delete.title": "حذف التقييم",
  "app.assessments.delete.warning": "لا يمكن التراجع عن هذا الإجراء. سيتم حذف التقييم وجميع نسخه ونتائجه والمستندات المرفوعة بشكل دائم.",
  "app.assessments.duplicate.confirm": "تكرار",
  "app.assessments.duplicate.confirmMessage": "اختر اسمًا للتقييم المكرر.",
  "app.assessments.duplicate.duplicating": "جاري التكرار...",
  "app.assessments.duplicate.error": "فشل تكرار التقييم",
  "app.assessments.duplicate.info": "سيتم نسخ جميع المستندات المرفوعة ومحتواها إلى التقييم الجديد.",
  "app.assessments.duplicate.sourceLabel": "المصدر:",
  "app.assessments.duplicate.success": "تم تكرار التقييم بنجاح",
  "app.assessments.duplicate.title": "تكرار التقييم",
  "app.assessments.duplicate.titleLabel": "اسم التقييم الجديد",
  "app.assessments.duplicate.titlePrefill": "نسخة من {{title}}",
  "app.assessments.duplicate.titleTooLong": "يجب ألا يزيد الاسم عن {{max}} حرفًا",
  "app.assessments.emptyState.adjustFilters": "حاول تعديل المرشحات لرؤية المزيد من النتائج",
  "app.assessments.emptyState.getStarted": "ابدأ بإنشاء تقييمك الأول",
  "app.assessments.emptyState.noAssessments": "لم يتم العثور على تقييمات",
  "app.assessments.error.completeAllDomains": "يرجى إكمال جميع المجالات قبل إنهاء التقييم.",
  "app.assessments.error.domainNotFound": "المجال غير موجود",
  "app.assessments.error.domainNotFoundDescription": "تعذر تحميل المجال المطلوب. يرجى المحاولة مرة أخرى أو الاتصال بالدعم.",
  "app.assessments.error.domainsNotCompleted": "لم يتم إكمال جميع المجالات. يرجى إكمال جميع المجالات قبل عرض الملخص.",
  "app.assessments.error.failedToCreate": "فشل إنشاء التقييم. يرجى المحاولة مرة أخرى.",
  "app.assessments.error.failedToLoad": "فشل تحميل التقييم. يرجى المحاولة مرة أخرى.",
  "app.assessments.error.failedToLoadFramework": "فشل تحميل تفاصيل الإطار",
  "app.assessments.error.frameworkLoadError": "حدث خطأ أثناء تحميل الإطار. يرجى المحاولة مرة أخرى.",
  "app.assessments.error.genericError": "حدث خطأ",
  "app.assessments.error.invalidAssessmentId": "معرف التقييم غير صالح.",
  "app.assessments.error.noAssessmentId": "معرف التقييم غير موجود",
  "app.assessments.error.noNextDomain": "لا يوجد مجال تالي متاح.",
  "app.assessments.error.notDraftStatus": "حالة التقييم ليست مسودة. يرجى التأكد من أن التقييم في حالة مسودة.",
  "app.assessments.error.retry": "إعادة المحاولة",
  "app.assessments.failureReason.noReason": "لم يُسجَّل سبب لفشل هذا التقييم.",
  "app.assessments.failureReason.title": "سبب الفشل",
  "app.assessments.filters.allTime": "كل الوقت",
  "app.assessments.filters.label": "ترتيب",
  "app.assessments.filters.thisMonth": "هذا الشهر",
  "app.assessments.filters.thisQuarter": "هذا الربع",
  "app.assessments.filters.thisWeek": "هذا الأسبوع",
  "app.assessments.filters.today": "اليوم",
  "app.assessments.loading": "جاري تحميل التقييمات...",
  "app.assessments.newVersion.confirm": "بدء إصدار جديد",
  "app.assessments.newVersion.confirmMessage": 'سيؤدي ذلك إلى إنشاء مسودة إصدار جديدة من "{{title}}". يمكنك متابعة العمل عليها مع بقاء الإصدار المكتمل السابق قابلاً للوصول.',
  "app.assessments.newVersion.error": "فشل بدء الإصدار الجديد",
  "app.assessments.newVersion.starting": "جاري البدء...",
  "app.assessments.newVersion.success": "تم بدء مسودة الإصدار الجديد",
  "app.assessments.newVersion.title": "بدء إصدار جديد",
  "app.assessments.newVersion.blockedTitle": "أنهِ المعالجة أولاً",
  "app.assessments.newVersion.blockedRunning": "لا تزال هناك معالجة مفتوحة لهذا التقييم. لا يمكن بدء إصدار جديد إلا بعد تطبيقها أو إلغائها.",
  "app.assessments.newVersion.blockedNeedsReview_one": "لا يزال مستند واحد معالَج بانتظار قرارك. راجعه وطبّقه، ثم ابدأ الإصدار الجديد.",
  "app.assessments.newVersion.blockedNeedsReview_other": "لا يزال {{count}} مستند معالَج بانتظار قرارك. راجعها وطبّقها، ثم ابدأ الإصدار الجديد.",
  "app.assessments.newVersion.blockedNeedsReview_zero": "لا توجد مستندات معالَجة بانتظار قرارك.",
  "app.assessments.newVersion.blockedNeedsReview_two": "لا يزال مستندان معالَجان بانتظار قرارك. راجعهما وطبّقهما، ثم ابدأ الإصدار الجديد.",
  "app.assessments.newVersion.blockedNeedsReview_few": "لا تزال {{count}} مستندات معالَجة بانتظار قرارك. راجعها وطبّقها، ثم ابدأ الإصدار الجديد.",
  "app.assessments.newVersion.blockedNeedsReview_many": "لا يزال {{count}} مستنداً معالَجاً بانتظار قرارك. راجعها وطبّقها، ثم ابدأ الإصدار الجديد.",
  "app.assessments.newVersion.openRemediation": "فتح المعالجة",
  "app.assessments.pagination.summary": "صفحة {{page}} من {{totalPages}} · {{totalCount}} في المجموع",
  "app.assessments.polling.updating": "جاري التحقق من تحديثات الحالة...",
  "app.assessments.preparing": "يتم تجهيز تقييمك",
  "app.assessments.prerequisites.pendingUpload.cancel": "البقاء في الصفحة",
  "app.assessments.prerequisites.pendingUpload.confirm": "مغادرة الصفحة",
  "app.assessments.prerequisites.pendingUpload.message": "لديك عمليات تحميل قيد التقدم. مغادرة هذه الصفحة ستلغيها. هل أنت متأكد أنك تريد المغادرة؟",
  "app.assessments.prerequisites.pendingUpload.title": "عمليات تحميل قيد التقدم",
  "app.assessments.retry.confirm": "إعادة المحاولة",
  "app.assessments.retry.confirmMessage": "سيتم إعادة تقديم التقييم للمعالجة بواسطة الذكاء الاصطناعي باستخدام المجالات والمستندات الحالية.",
  "app.assessments.retry.error": "فشلت إعادة محاولة التقييم",
  "app.assessments.retry.retrying": "جاري إعادة المحاولة...",
  "app.assessments.retry.success": "تمت إعادة تقديم التقييم بنجاح وهو الآن قيد التقييم.",
  "app.assessments.retry.title": "إعادة تقديم التقييم",
  "app.assessments.searchPlaceholder": "البحث في التقييمات...",
  "app.assessments.showingResults": "عرض {{showing}} من أصل {{total}} تقييم",
  "app.assessments.sort.nameAsc": "الاسم من أ إلى ي",
  "app.assessments.sort.nameDesc": "الاسم من ي إلى أ",
  "app.assessments.sort.updatedAsc": "الأحدث أولاً",
  "app.assessments.sort.updatedDesc": "الأقدم أولاً",
  "app.assessments.startNew": "بدء تقييم جديد",
  "app.assessments.status.all": "جميع الحالات",
  "app.assessments.status.completed": "مكتمل",
  "app.assessments.status.draft": "مسودة",
  "app.assessments.status.failed": "فشل",
  "app.assessments.status.processing": "قيد المعالجة",
  "app.assessments.status.submitted": "تم الإرسال",
  "app.assessments.table.actions": "الإجراءات",
  "app.assessments.table.created": "تاريخ الإنشاء",
  "app.assessments.table.latest": "الأحدث",
  "app.assessments.table.name": "اسم التقييم",
  "app.assessments.table.progress": "التقدم",
  "app.assessments.table.score": "النتيجة",
  "app.assessments.table.status": "الحالة",
  "app.assessments.table.submitted": "تاريخ التقديم",
  "app.assessments.table.completed": "المدة",
  "app.assessments.table.updated": "آخر تحديث",
  "app.assessments.duration.lessThanMinute": "< 1 د",
  "app.assessments.duration.minutes_few": "{{count}} د",
  "app.assessments.duration.minutes_many": "{{count}} د",
  "app.assessments.duration.minutes_one": "{{count}} د",
  "app.assessments.duration.minutes_other": "{{count}} د",
  "app.assessments.duration.minutes_two": "{{count}} د",
  "app.assessments.duration.minutes_zero": "< 1 د",
  "app.assessments.duration.hours_few": "{{count}} س",
  "app.assessments.duration.hours_many": "{{count}} س",
  "app.assessments.duration.hours_one": "{{count}} س",
  "app.assessments.duration.hours_other": "{{count}} س",
  "app.assessments.duration.hours_two": "{{count}} س",
  "app.assessments.duration.hours_zero": "{{count}} س",
  "app.assessments.duration.hoursMinutes": "{{hours}} س {{minutes}} د",
  "app.assessments.duration.days_few": "{{count}} أيام",
  "app.assessments.duration.days_many": "{{count}} يوم",
  "app.assessments.duration.days_one": "{{count}} يوم",
  "app.assessments.duration.days_other": "{{count}} يوم",
  "app.assessments.duration.days_two": "{{count}} يوم",
  "app.assessments.duration.days_zero": "{{count}} يوم",
  "app.assessments.time.hoursAgo_few": "منذ {{count}} ساعات",
  "app.assessments.time.hoursAgo_many": "منذ {{count}} ساعة",
  "app.assessments.time.hoursAgo_one": "منذ {{count}} ساعة",
  "app.assessments.time.hoursAgo_other": "منذ {{count}} ساعة",
  "app.assessments.time.hoursAgo_two": "منذ ساعتين",
  "app.assessments.time.hoursAgo_zero": "الآن",
  "app.assessments.time.minutesAgo_few": "منذ {{count}} دقائق",
  "app.assessments.time.minutesAgo_many": "منذ {{count}} دقيقة",
  "app.assessments.time.minutesAgo_one": "منذ {{count}} دقيقة",
  "app.assessments.time.minutesAgo_other": "منذ {{count}} دقيقة",
  "app.assessments.time.minutesAgo_two": "منذ دقيقتين",
  "app.assessments.time.minutesAgo_zero": "الآن",
  "app.assessments.time.now": "الآن",
  "app.assessments.title": "التقييمات",
  "app.assessments.titleDescription": "إجراء فحوصات جاهزية قانون حماية البيانات الشخصية بتقييم قائم على الأدلة",
  "app.assessments.untitled": "تقييم بدون عنوان",
  "app.assessments.versionHistory.draftInProgress": "إصدار مسودة قيد التقدم",
  "app.assessments.versionHistory.title": "سجل الإصدارات",
  "app.assessments.versionHistory.versionLabel": "الإصدار {{n}}",
  "app.assessments.versions_few": "{{count}} إصدارات",
  "app.assessments.versions_many": "{{count}} إصداراً",
  "app.assessments.versions_one": "إصدار واحد",
  "app.assessments.versions_other": "{{count}} إصدار",
  "app.assessments.versions_two": "إصداران",
  "app.assessments.versions_zero": "لا توجد إصدارات",
  "app.assessments.workflow.nameDefault": "تقييم",
  "app.assessments.workflow.nameRequired": "اسم التقييم مطلوب",
  "app.assessments.workflow.removeDocumentsFirst": 'يرجى إزالة جميع المستندات المرفوعة قبل وضع علامة "لا توجد أدلة متاحة".',
  "app.common.back": "رجوع",
  "app.common.cancel": "إلغاء",
  "app.common.close": "إغلاق",
  "app.common.continue": "متابعة",
  "app.common.goBack": "العودة",
  "app.common.loading": "جاري التحميل...",
  "app.common.min": "دقيقة",
  "app.common.next": "التالي",
  "app.common.of": "من",
  "app.common.optional": "اختياري",
  "app.common.previous": "السابق",
  "app.common.skip": "تخطي",
  "app.settings.description": "إدارة حسابك ومستنداتك وتفضيلاتك الإعدادات",
  "app.settings.section.language.applang": "اللغة الحالية",
  "app.settings.section.language.desc": "اختر اللغة المفضلة لديك",
  "app.settings.section.language.title": " اللغة",
  "app.settings.tabs.ariaLabel": "تبويبات الإعدادات",
  "app.settings.tabs.language": "اللغة",
  "app.settings.tabs.myDocuments": "المستندات",
  "app.settings.tabs.notifications": "الاشعارات",
  "app.settings.tabs.profile": "الملف الشخصي",
  "app.settings.tabs.security": "الامان",
  "app.settings.title": "الإعدادات",
  "assessment.workflow.domain.applicabilityHelper": "يرجى التأكد من ما إذا كان هذا المجال ينطبق على أنشطة المعالجة البيانات لمنظمتك.",
  "assessment.workflow.domain.applicabilityNoLabel": "لا، غير قابل للتطبيق (هذا المجال لا ينطبق على مؤسستي وسيتم استبعاده من التقييم.)",
  "assessment.workflow.domain.applicabilityNoTooltip": "اختيارك 'لا' سيتم تحديد هذا المجال كغير منطبق ولن يؤثر على نتيجة التقييم العام.",
  "assessment.workflow.domain.applicabilityQuestion": "هل هذا المجال ينطبق على منظمتك؟",
  "assessment.workflow.domain.applicabilityYesLabel": "نعم، ينطبق (سأكمل هذا المجال وأرفع الأدلة المطلوبة.)",
  "assessment.workflow.domain.applicabilityYesTooltip": "اختيارك 'نعم' سيتم تحديد هذا المجال كمنطبق وسيتم تضمينه في نتيجة التقييم العام.",
  "assessment.workflow.domain.domainApplicabilityTitle": "تطبيق المجال",
  "assessment.workflow.domain.edit": "تعديل",
  "assessment.workflow.domain.editToStart": 'اضغط على "تعديل" لبدء هذا المجال قبل إجراء أي تغييرات.',
  "assessment.workflow.domain.evidenceFiles": "الوثائق المطلوبة",
  "assessment.workflow.domain.expectedDocuments": "المستندات المتوقعة",
  "assessment.workflow.domain.documentsDone": "{{matched}}/{{total}} مكتمل",
  "assessment.workflow.domain.finishAssessment": "إنهاء التقييم",
  "assessment.workflow.domain.markAsNoEvidenceAvailable": "وضع علامة 'لا توجد أدلة متاحة'",
  "assessment.workflow.domain.next": "التالي",
  "assessment.workflow.domain.noEvidenceAvailable": "لا توجد أدلة متاحة",
  "assessment.workflow.domain.noEvidenceTooltip": "سيؤدي تحديد هذا الخيار إلى وضع علامة على هذا السؤال كمكتمل وقد يقلل من درجتك النهائية.",
  "assessment.workflow.domain.resume": "المتابعة",
  "assessment.workflow.domain.resumeLater": "المتابعة لاحقاً",
  "assessment.workflow.domain.saveAndNext": "حفظ والتالي",
  "assessment.workflow.domain.showLess": "إخفاء",
  "assessment.workflow.domain.showMore": "عرض",
  "assessment.workflow.domain.standardFormat": "الصيغة المعتمدة:",
  "assessment.workflow.domain.wrongFormat": "صيغة غير صحيحة",
  "assessment.workflow.domain.wrongFormatHint": "المستند صحيح، لكنه مرفوع بصيغة {{uploaded}} — أعد رفعه بصيغة {{expected}} للحصول على النسخة المعتمدة.",
  "assessment.workflow.domain.unsupportedFormat": "صيغة ملف غير مدعومة — لا يمكن التحقق منها",
  "assessment.workflow.domain.filterAll": "الكل",
  "assessment.workflow.domain.filterMissing": "غير مرفوع",
  "assessment.workflow.domain.filterMatched": "مطابق",
  "assessment.workflow.domain.requiredNotUploaded": "مطلوب — لم يُرفع بعد",
  "assessment.workflow.domain.optionalNotUploaded": "اختياري — لم يُرفع بعد",
  "assessment.workflow.domain.optionalShort": "اختياري",
  "assessment.workflow.domain.skipAndNext": "تخطي",
  "assessment.workflow.editName.label": "اسم التقييم",
  "assessment.workflow.editName.title": "تعديل اسم التقييم",
  "assessment.workflow.exitAssessment.cancel": "إلغاء",
  "assessment.workflow.exitAssessment.deleteAndExit": "حذف الكل والخروج",
  "assessment.workflow.exitAssessment.domainsCompleted": "المجالات المكتملة",
  "assessment.workflow.exitAssessment.domainsCount": "{{completed}} من {{total}}",
  "assessment.workflow.exitAssessment.evidenceUploaded": "الأدلة المرفوعة",
  "assessment.workflow.exitAssessment.filesAttachedLabel": "ملفات مرفقة",
  "assessment.workflow.exitAssessment.filesAttached_few": "{{count}} ملفات مرفقة",
  "assessment.workflow.exitAssessment.filesAttached_many": "{{count}} ملفاً مرفقاً",
  "assessment.workflow.exitAssessment.filesAttached_one": "ملف واحد مرفق",
  "assessment.workflow.exitAssessment.filesAttached_other": "{{count}} ملف مرفق",
  "assessment.workflow.exitAssessment.filesAttached_two": "ملفان مرفقان",
  "assessment.workflow.exitAssessment.filesAttached_zero": "لا توجد ملفات مرفقة",
  "assessment.workflow.exitAssessment.helpText": "يمكنك الحفظ والمتابعة لاحقًا، أو حذف تقدمك نهائيًا.",
  "assessment.workflow.exitAssessment.message": "لديك تقدم يمكن حفظه قبل المغادرة.",
  "assessment.workflow.exitAssessment.overallProgress": "التقدم الإجمالي",
  "assessment.workflow.exitAssessment.saveAndExit": "حفظ التقدم والخروج",
  "assessment.workflow.exitAssessment.title": "الخروج من التقييم؟",
  "assessment.workflow.unsavedChanges.cancel": "إلغاء",
  "assessment.workflow.unsavedChanges.changesInclude": "تشمل التغييرات غير المحفوظة:",
  "assessment.workflow.unsavedChanges.discard": "تجاهل التغييرات",
  "assessment.workflow.unsavedChanges.fieldChanges": "تغييرات في حقول المجال",
  "assessment.workflow.unsavedChanges.message": "لديك تغييرات غير محفوظة في هذا المجال. ماذا تريد أن تفعل قبل الانتقال؟",
  "assessment.workflow.unsavedChanges.pendingDeletions": "مستندات محددة للحذف",
  "assessment.workflow.unsavedChanges.pendingUploads": "رفع مستندات معلقة",
  "assessment.workflow.unsavedChanges.save": "حفظ والمتابعة",
  "assessment.workflow.unsavedChanges.stay": "البقاء هنا",
  "assessment.workflow.unsavedChanges.title": "تغييرات غير محفوظة",
  "assessments.new.back": "العودة إلى التقييمات",
  "assessments.new.button.description": "سيتم فتح التقييم في عرض مركز على الجانب",
  "assessments.new.button.startAssessment": "بدء تقييم جديد",
  "assessments.new.card.evidenceCount": "الوثائق المطلوبة",
  "assessments.new.description": "إعداد تقييم الامتثال الخاص بك في خطوة واحدة",
  "assessments.new.details.name": "الاسم",
  "assessments.new.details.note": "سيظهر هذا في قائمة التقييمات والتقارير.",
  "assessments.new.details.title": "تفاصيل التقييم",
  "assessments.new.languages.description": "اختر اللغة التي تريد استقبال تقرير التقييم والوثائق المرتبطة.",
  "assessments.new.languages.title": "لغة التقييم",
  "assessments.new.list.description": "اختر المجالات التي تريد تقييمها",
  "assessments.new.list.title": "نطاق التقييم",
  "assessments.new.progressFlow.completed": " مكتمل",
  "assessments.new.progressFlow.domain": "مجال",
  "assessments.new.progressFlow.domainNumber": "المجال {{number}} من {{total}}",
  "assessments.new.progressFlow.domains": "مجالات",
  "assessments.new.progressFlow.optional": "اختياري",
  "assessments.new.progressFlow.progress": "التقدم",
  "assessments.new.progressFlow.required": "مطلوب",
  "assessments.new.summary.aiTime": "60-75 دقيقة",
  "assessments.new.summary.aiTimeDescription": "الوقت المقدر للإكمال بواسطة ذكاء كومبلاينس الاصطناعي",
  "assessments.new.summary.description": "اكمل جاهزية نظام حماية البيانات الشخصية الخاص بك في حوالي ساعة بدلاً من أسابيع.",
  "assessments.new.summary.optimizedTip1": "أسرع بنسبة تصل إلى 70% من مراجعات الامتثال التقليدية",
  "assessments.new.summary.optimizedTip2": "الأدلة الرئيسية فقط هي المطلوبة",
  "assessments.new.summary.optimizedTip3": "تحليل آلي للفجوات",
  "assessments.new.summary.optimizedTitle": "تقييم مُحسّن بالذكاء الاصطناعي:",
  "assessments.new.summary.questions": "الوثائق المطلوبة للأدلة",
  "assessments.new.summary.tip1": "يتم حفظ التقدم تلقائيًا",
  "assessments.new.summary.tip2": "إنشاء التقارير عند الانتهاء",
  "assessments.new.summary.title": "تقييم سريع موجه بالذكاء الاصطناعي",
  "assessments.new.summary.traditionalReview": "مراجعة الامتثال التقليدية",
  "assessments.new.summary.traditionalTime": "4-6 أسابيع",
  "assessments.new.tips.BeforeAssessment.description1": "جمع الوثائق المتعلقة",
  "assessments.new.tips.BeforeAssessment.description2": "إشراك أصحاب المصلحة الرئيسيين",
  "assessments.new.tips.BeforeAssessment.description3": "مراجعة السياسات الحالية",
  "assessments.new.tips.BeforeAssessment.title": "قبل البدء:",
  "assessments.new.tips.DuringAssessment.description1": "أجب بصدق لضمان نتائج دقيقة",
  "assessments.new.tips.DuringAssessment.description2": "استخدم “غير منطبق (N/A)” عندما لا ينطبق",
  "assessments.new.tips.DuringAssessment.description3": "أضف تعليقات للتوضيح والسياق، وأرفق جميع المستندات المطلوبة",
  "assessments.new.tips.DuringAssessment.title": "أثناء التقييم:",
  "assessments.new.tips.title": "نصائح التقييم",
  "assessments.new.title": "بدء تقييم جديد",
  "assessments.onboarding.button.description": "يستغرق التقييم تقريبًا 15-30 دقيقة حسب نوع التقييم",
  "assessments.onboarding.button.start": "ابدأ تقييمك الأول",
  "assessments.onboarding.card1.description": "تقييم الامتثال عبر جميع المجالات التنظيمية",
  "assessments.onboarding.card1.title": "تحليل شامل",
  "assessments.onboarding.card2.description": "تحديد فجوات الامتثال والمخاطر المحتملة مبكرًا",
  "assessments.onboarding.card2.title": "تحديد المخاطر",
  "assessments.onboarding.card3.description": "تتبع تقدمك في الامتثال على مر الزمن",
  "assessments.onboarding.card3.title": "تتبع التقدم",
  "assessments.onboarding.description": "ابدأ رحلتك في الامتثال بإجراء تقييمك الأول. منصتنا تساعدك على تحديد الفجوات وتتبع التقدم والحفاظ على الامتثال التنظيمي.",
  "assessments.onboarding.footer.item1": "مراجعة المقررات التنظيمية",
  "assessments.onboarding.footer.item2": "تقييم النضج",
  "assessments.onboarding.footer.item3": "تحليل الفجوات",
  "assessments.onboarding.footer.title": "ما يمكنك توقعه:",
  "assessments.onboarding.title": "مرحبًا بك في تقييمات الامتثال",
  "assessments.overview.NewAssessment": "تقييم جديد",
  "assessments.overview.charts.domainScoresSubtitle": "درجة النضج لكل نطاق امتثال",
  "assessments.overview.charts.domainScoresTitle": "درجات نضج النطاقات",
  "assessments.overview.charts.maturityDistSubtitle": "النطاقات مجمّعة حسب مستوى النضج",
  "assessments.overview.charts.maturityDistTitle": "توزيع مستويات النضج",
  "assessments.overview.charts.levelDistTitle": "توزيع نضج النطاقات",
  "assessments.overview.charts.levelDistSubtitle": "عدد النطاقات في كل مستوى نضج",
  "assessments.overview.charts.noData": "لا توجد بيانات نطاقات",
  "assessments.overview.charts.domain": "نطاق",
  "assessments.overview.charts.domains": "نطاقات",
  "assessments.overview.charts.settings.title": "إعدادات المخططات",
  "assessments.overview.charts.settings.subtitle": "تخصيص ما تعرضه المخططات وكيفية عرضه",
  "assessments.overview.charts.settings.visibility": "الرؤية",
  "assessments.overview.charts.settings.showRadar": "مخطط الرادار",
  "assessments.overview.charts.settings.showBar": "المخطط الشريطي",
  "assessments.overview.charts.settings.barSection": "خيارات المخطط الشريطي",
  "assessments.overview.charts.settings.filterGaps": "النطاقات ذات الثغرات فقط",
  "assessments.overview.charts.settings.filterGapsHint": "إخفاء النطاقات الممتثلة بالكامل",
  "assessments.overview.charts.settings.sortLabel": "ترتيب الفرز",
  "assessments.overview.charts.settings.sortScoreDesc": "الدرجة ↓",
  "assessments.overview.charts.settings.sortScoreAsc": "الدرجة ↑",
  "assessments.overview.charts.settings.sortName": "الاسم",
  "assessments.overview.charts.settings.noChartsVisible": "جميع المخططات مخفية — فعّل أحدها أعلاه",
  "assessments.overview.charts.gapsTitle": "نظرة عامة على الثغرات",
  "assessments.overview.charts.gapsSubtitle": "الثغرات الحرجة مقابل الثغرات الأخرى",
  "assessments.overview.charts.noGaps": "لا توجد ثغرات",
  "assessments.overview.charts.noGapsSubtitle": "جميع النطاقات تستوفي متطلبات الامتثال",
  "assessments.overview.charts.totalGaps": "إجمالي",
  "assessments.overview.charts.criticalGaps": "حرجة",
  "assessments.overview.charts.otherGaps": "أخرى",
  "assessments.overview.charts.stat.domainsCovered": "النطاقات المشمولة",
  "assessments.overview.charts.stat.maturityScore": "درجة النضج الإجمالية",
  "assessments.overview.charts.stat.missingDocs": "المستندات المفقودة",
  "assessments.overview.charts.stat.totalGaps": "إجمالي الثغرات المحددة",
  "assessments.overview.radar.subtitle": "تغطية النضج عبر جميع نطاقات الامتثال",
  "assessments.overview.radar.subtitleComparing": "مقارنة تغطية النضج بين الإصدارات",
  "assessments.overview.radar.title": "رادار تغطية النطاقات",
  "assessments.overview.tabs.detailedGaps": "الثغرات التفصيلية",
  "assessments.overview.tabs.overview": "نظرة عامة",
  "assessments.overview.acrossAllDomains": "عبر جميع المجالات",
  "assessments.overview.articlesAssessed": "المواد المُقيّمة",
  "assessments.overview.assessedDocuments": "المستندات المُقيّمة",
  "assessments.overview.assessmentCompletedSuccessfully": "اكتمل التقييم بنجاح",
  "assessments.overview.classifiedAs": "مُصنَّف بوصفه",
  "assessments.overview.completedOn": "تم الانتهاء في • {{date}}",
  "assessments.overview.completionSummary": "تم تحديد {{gaps}} فجوة من أصل {{controlPoints}} نقطة تحكم تم تقييمها",
  "assessments.overview.comprehensiveBreakdownByDomain": "تفصيل شامل حسب مجال الامتثال",
  "assessments.overview.criticalGapsIdentified_few": "{{count}} فجوات حرجة محددة",
  "assessments.overview.criticalGapsIdentified_many": "{{count}} فجوة حرجة محددة",
  "assessments.overview.criticalGapsIdentified_one": "فجوة حرجة واحدة محددة",
  "assessments.overview.criticalGapsIdentified_other": "{{count}} فجوة حرجة محددة",
  "assessments.overview.criticalGapsIdentified_two": "فجوتان حرجتان محددتان",
  "assessments.overview.criticalGapsIdentified_zero": "لا توجد فجوات حرجة محددة",
  "assessments.overview.dashboardViewComingSoon": "عرض لوحة المعلومات سيكون متاحًا قريبًا",
  "assessments.overview.detailedDomainBreakdown": "تفصيل تفصيلي للمجالات",
  "assessments.overview.documentsAssessed": "{{count}} مستندات تم تقييمها",
  "assessments.overview.documentsBadge_few": "{{count}} / {{total}} مستندات مرفوعة",
  "assessments.overview.documentsBadge_many": "{{count}} / {{total}} مستنداً مرفوعاً",
  "assessments.overview.documentsBadge_one": "{{count}} / {{total}} مستند مرفوع",
  "assessments.overview.documentsBadge_other": "{{count}} / {{total}} مستند مرفوع",
  "assessments.overview.documentsBadge_two": "{{count}} / {{total}} مستندان مرفوعان",
  "assessments.overview.documentsBadge_zero": "{{count}} / {{total}} مستند مرفوع",
  "assessments.overview.domainNotApplicableBadge": "غير منطبق",
  "assessments.overview.domainNotApplicableCaption": "تم وضع علامة عليه كغير منطبق على مؤسستك",
  "assessments.overview.domainNotApplicableDescription": "تم تحديد هذا المجال كغير منطبق على مؤسستك في بداية التقييم. لذا تم استبعاده من احتساب الدرجة وتحليل الفجوات، ولم تُطلب أي مستندات بشأنه.",
  "assessments.overview.domainNotApplicableTitle": "غير منطبق على مؤسستك",
  "assessments.overview.domainNotAssessed": "لم يُقيَّم المجال — لم تُرفع أي مستندات",
  "assessments.overview.domainSkippedDescription": "لم تُرفع أي مستندات لهذا المجال، لذلك لم يتم تقييم الفجوات الفردية. ارفع المستندات المعيارية أدناه لإجراء تقييم شامل وإظهار الفجوات والمخاطر وأولويات التحسين.",
  "assessments.overview.domainSkippedTitle": "تم تخطي هذا المجال",
  "assessments.overview.domainWeight": "وزن المجال {{weight}}%",
  "assessments.overview.domainsCovered": "{{count}} مجالات مغطاة",
  "assessments.overview.downloadDetailedGaps": "تنزيل الفجوات التفصيلية",
  "assessments.overview.downloadDetailedGapsOrStartNew": "تنزيل الفجوات التفصيلية أو بدء جديد",
  "assessments.overview.duplicate.confirmButton": "نعم، قم بالتكرار",
  "assessments.overview.duplicate.confirmDescription": "سيتم إنشاء تقييم جديد مع نسخ جميع المستندات المرفوعة.",
  "assessments.overview.duplicate.confirmTitle": "هل تريد تكرار هذا التقييم؟",
  "assessments.overview.duplicate.loadingDescription": "جارٍ نسخ المستندات وإعداد تقييمك الجديد.",
  "assessments.overview.duplicate.loadingTitle": "جارٍ تكرار التقييم…",
  "assessments.overview.duplicate.menuItem": "تكرار التقييم",
  "assessments.overview.duplicate.statDocuments": "المستندات",
  "assessments.overview.duplicate.statDomains": "المجالات",
  "assessments.overview.duplicate.statLanguage": "اللغة",
  "assessments.overview.duplicate.warningText": "لن يتم نقل النتائج والفجوات والمخاطر والأولويات السابقة — يتم نسخ المستندات المرفوعة فقط.",
  "assessments.overview.editDomain.button": "تعديل",
  "assessments.overview.editDomain.tooltip": "افتح المسودة V{{version}} لإعادة رفع مستندات هذا المجال",
  "assessments.overview.editDomain.tooltipNoDraft": "ابدأ نسخة جديدة أولاً لتعديل المستندات وإعادة رفعها",
  "assessments.overview.editDomain.startVersionHint": 'اضغط على "بدء نسخة جديدة" لإنشاء مسودة يمكنك تعديلها، ثم أعد رفع مستنداتك.',
  "assessments.overview.error.failedToLoadResults": "فشل تحميل نتائج التقييم",
  "assessments.overview.exportFunctionalityComingSoon": "وظيفة التصدير ستكون متاحة قريبًا",
  "assessments.overview.gapsCount": "الفجوات: {{count}}",
  "assessments.overview.gapsCount_few": "{{count}} فجوات",
  "assessments.overview.gapsCount_many": "{{count}} فجوة",
  "assessments.overview.gapsCount_one": "فجوة واحدة",
  "assessments.overview.gapsCount_other": "{{count}} فجوة",
  "assessments.overview.gapsCount_two": "فجوتان",
  "assessments.overview.gapsCount_zero": "لا توجد فجوات",
  "assessments.overview.gapsIdentified": "الفجوات في المستندات المرفوعة",
  "assessments.overview.gapsIdentifiedSubtitle": "من المستندات التي رفعتها — يتم تتبع المستندات المفقودة بشكل منفصل",
  "assessments.overview.gapsSummary": "ملخص الفجوات",
  "assessments.overview.ifLeftUnaddressed": "إذا تُركت دون معالجة",
  "assessments.overview.improvementPriorities": "أولويات التحسين",
  "assessments.overview.charts.howToRead": "كيف تقرأ هذا الرسم البياني",
  "assessments.overview.contentLanguage.ar": "العربية",
  "assessments.overview.contentLanguage.en": "الإنجليزية",
  "assessments.overview.resultsGeneratedIn": "النتائج بـ{{language}}",
  "assessments.overview.resultsGeneratedInHelp": "أُجري هذا التقييم بـ{{language}}، لذلك كُتبت نتائجه وتوصياته بتلك اللغة. تغيير لغة التطبيق يترجم الواجهة فقط — ولا يعيد ترجمة النتائج التي أُنشئت بالفعل.",
  "assessments.overview.resultsNotReady.body": "لم يكتمل هذا التقييم بعد، أو ما زال قيد المعالجة. ستظهر النتائج هنا فور انتهاء المعالجة.",
  "assessments.overview.resultsNotReady.title": "نتائج التقييم غير متاحة بعد",
  "assessments.overview.maturityLevel": "{{levelName}} (المستوى {{level}} من {{maxLevel}})",
  "assessments.overview.missingBadge": "مفقود",
  "assessments.overview.missingDocuments": "المستندات المفقودة",
  "assessments.overview.missingDocumentsBadge_few": "{{count}} مستندات مفقودة",
  "assessments.overview.missingDocumentsBadge_many": "{{count}} مستنداً مفقوداً",
  "assessments.overview.missingDocumentsBadge_one": "{{count}} مستند مفقود",
  "assessments.overview.missingDocumentsBadge_other": "{{count}} مستندات مفقودة",
  "assessments.overview.missingDocumentsBadge_two": "{{count}} مستندان مفقودان",
  "assessments.overview.missingDocumentsBadge_zero": "{{count}} مستند مفقود",
  "assessments.overview.missingDocumentsCount": "{{count}} مستندات مفقودة",
  "assessments.overview.missingStandardDocuments": "المستندات المفقودة",
  "assessments.overview.overallMaturityScore": "درجة النضج الإجمالية",
  "assessments.overview.overallResults": "النتائج الإجمالية",
  "assessments.overview.readyToContinue": "هل أنت مستعد للمتابعة؟",
  "assessments.overview.reportDownloadComingSoon": "تحميل التقرير سيكون متاحًا قريبًا",
  "assessments.overview.standardsAwaitingUpload_few": "{{count}} معايير في انتظار الرفع",
  "assessments.overview.standardsAwaitingUpload_many": "{{count}} معياراً في انتظار الرفع",
  "assessments.overview.standardsAwaitingUpload_one": "معيار واحد في انتظار الرفع",
  "assessments.overview.standardsAwaitingUpload_other": "{{count}} معيار في انتظار الرفع",
  "assessments.overview.standardsAwaitingUpload_two": "معياران في انتظار الرفع",
  "assessments.overview.standardsAwaitingUpload_zero": "لا توجد معايير في انتظار الرفع",
  "assessments.overview.theRisk": "المخاطر",
  "assessments.overview.uploadedFile": "ملف مرفوع",
  "assessments.overview.uploadedOn": "رُفع في {{date}} · {{size}} كيلوبايت",
  "assessments.overview.versioning.compareTo.label": "قارن مع:",
  "assessments.overview.versioning.compareTo.none": "— بدون —",
  "assessments.overview.versioning.documents.removedFromBaseline": "تم الحذف منذ {{baseline}} · {{size}} ك.ب",
  "assessments.overview.versioning.documents.tag.carriedOver": "محتفظ به",
  "assessments.overview.versioning.documents.tag.new": "جديد",
  "assessments.overview.versioning.documents.tag.removed": "محذوف",
  "assessments.overview.versioning.domainBreakdown.comparingSubtitle": "مقارنة {{active}} مع {{baseline}} · ▲ تحسن، ▼ تراجع",
  "assessments.overview.versioning.domainBreakdown.editedIn": "تم تعديله في {{version}}",
  "assessments.overview.versioning.domainBreakdown.sameAs": "نفس {{version}}",
  "assessments.overview.versioning.header.menu.startNewVersion": "بدء إصدار جديد",
  "assessments.overview.versioning.header.subtitle.reassessment": "اطّلع على أحدث النتائج، أو ابدأ إصدارًا جديدًا لإعادة التقييم",
  "assessments.overview.versioning.hero.domainsEditedFromPrev_few": "تم تعديل {{count}} مجالات من {{version}}",
  "assessments.overview.versioning.hero.domainsEditedFromPrev_many": "تم تعديل {{count}} مجالاً من {{version}}",
  "assessments.overview.versioning.hero.domainsEditedFromPrev_one": "تم تعديل مجال واحد من {{version}}",
  "assessments.overview.versioning.hero.domainsEditedFromPrev_other": "تم تعديل {{count}} مجال من {{version}}",
  "assessments.overview.versioning.hero.domainsEditedFromPrev_two": "تم تعديل مجالين من {{version}}",
  "assessments.overview.versioning.hero.domainsEditedFromPrev_zero": "لم يتم تعديل أي مجال من {{version}}",
  "assessments.overview.versioning.hero.reassessmentCompleted": "اكتملت إعادة التقييم بنجاح",
  "assessments.overview.versioning.kpi.deltaFlat": "مطابق لـ {{baseline}} ({{baselineValue}})",
  "assessments.overview.versioning.kpi.deltaVs": "{{sign}}{{value}} مقارنة بـ {{baseline}} ({{baselineValue}})",
  "assessments.overview.versioning.oldVersionBanner.jumpToLatest": "الانتقال إلى الأحدث",
  "assessments.overview.versioning.oldVersionBanner.text": "أنت تعرض {{activeVersion}} — {{latestVersion}} ({{latestDate}}) هو الأحدث",
  "assessments.overview.versioning.versionSelector.heading": "الإصدارات",
  "assessments.overview.versioning.versionSelector.initial": "الأولي",
  "assessments.overview.versioning.versionSelector.latest": "الأحدث",
  "assessments.overview.viewDashboard": "عرض لوحة المعلومات",
  "assessments.overview.weightBadge": "الوزن {{weight}}%",
  "assessments.overview.whatIsNeeded": "ما المطلوب",
  "assessments.overview.gaps.critical": "حرجة",
  "assessments.overview.gaps.regulatoryExposure": "مخاطر التعرض التنظيمي",
  "assessments.overview.gaps.noCritical": "لا توجد ثغرات حرجة",
  "assessments.overview.gaps.viewDetailed": "عرض الثغرات ←",
  "assessments.overview.missingDocs.summary_one": "مستند واحد مفقود في {{domains}} نطاق",
  "assessments.overview.missingDocs.summary_other": "{{count}} مستند مفقود في {{domains}} نطاق",
  "assessments.overview.missingDocs.summary_zero": "لا توجد مستندات مفقودة في {{domains}} نطاق",
  "assessments.overview.missingDocs.summary_two": "مستندان مفقودان في {{domains}} نطاق",
  "assessments.overview.missingDocs.summary_few": "{{count}} مستندات مفقودة في {{domains}} نطاق",
  "assessments.overview.missingDocs.summary_many": "{{count}} مستنداً مفقوداً في {{domains}} نطاق",
  "assessments.overview.charts.barView": "عرض المخطط:",
  "assessments.overview.charts.versions": "الإصدارات",
  "assessments.overview.charts.filter": "تصفية",
  "assessments.overview.charts.barStacked": "متراكمة",
  "assessments.overview.charts.barGrouped": "مجمّعة",
  "assessments.overview.charts.worstFive": "الأضعف 5",
  "assessments.overview.charts.bestFive": "الأفضل 5",
  "assessments.overview.charts.versionCurrent": "إصدار {{version}} (الحالي)",
  "assessments.overview.charts.versionBaseline": "إصدار {{version}} (المرجعي)",
  "assessments.overview.charts.addComparison": "إضافة مقارنة",
  "assessments.overview.radar.maxOverlays": "الحد الأقصى {{count}} طبقات",
  "assessments.overview.charts.empty.title": "لا توجد بيانات نطاقات بعد",
  "assessments.overview.charts.empty.subtitle": "بمجرد تقييم النطاقات، ستظهر هنا الدرجات وتحليل الثغرات.",
  "assessments.overview.charts.radar.needMoreDomains": "يتطلب عرض الرادار 3 نطاقات على الأقل",
  "assessments.overview.charts.radar.needMoreDomainsSubtitle": "يتم عرض قائمة الدرجات بدلاً من ذلك — تم تقييم {{count}} نطاق حتى الآن",
  "assessments.overview.charts.radar.needMoreDomainsSubtitle_other": "يتم عرض قائمة الدرجات بدلاً من ذلك — تم تقييم {{count}} نطاق حتى الآن",
  "assessments.overview.charts.radar.needMoreDomainsSubtitle_zero": "يتم عرض قائمة الدرجات بدلاً من ذلك — لم يتم تقييم أي نطاق بعد",
  "assessments.overview.charts.radar.needMoreDomainsSubtitle_one": "يتم عرض قائمة الدرجات بدلاً من ذلك — تم تقييم نطاق واحد حتى الآن",
  "assessments.overview.charts.radar.needMoreDomainsSubtitle_two": "يتم عرض قائمة الدرجات بدلاً من ذلك — تم تقييم نطاقين حتى الآن",
  "assessments.overview.charts.radar.needMoreDomainsSubtitle_few": "يتم عرض قائمة الدرجات بدلاً من ذلك — تم تقييم {{count}} نطاقات حتى الآن",
  "assessments.overview.charts.radar.needMoreDomainsSubtitle_many": "يتم عرض قائمة الدرجات بدلاً من ذلك — تم تقييم {{count}} نطاقاً حتى الآن",
  "assessments.overview.charts.domainsShown_one": "عرض {{shown}} من {{total}} نطاق",
  "assessments.overview.charts.domainsShown_other": "عرض {{shown}} من {{total}} نطاق",
  "assessments.overview.charts.domainsShown_zero": "عرض {{shown}} من {{total}} نطاق",
  "assessments.overview.charts.domainsShown_two": "عرض {{shown}} من {{total}} نطاقين",
  "assessments.overview.charts.domainsShown_few": "عرض {{shown}} من {{total}} نطاقات",
  "assessments.overview.charts.domainsShown_many": "عرض {{shown}} من {{total}} نطاقاً",
  "assessments.overview.charts.noScore": "لم يتم التقييم",
  "assessments.overview.charts.notAssessedSuffix": "(لم يُقيَّم)",
  "assessments.overview.charts.notAssessedCount_one": "{{count}} لم يُقيَّم بعد",
  "assessments.overview.charts.notAssessedCount_other": "{{count}} لم يُقيَّم بعد",
  "assessments.overview.charts.notAssessedCount_zero": "لا شيء دون تقييم",
  "assessments.overview.charts.notAssessedCount_two": "{{count}} لم يُقيَّما بعد",
  "assessments.overview.charts.notAssessedCount_few": "{{count}} لم تُقيَّم بعد",
  "assessments.overview.charts.notAssessedCount_many": "{{count}} لم يُقيَّم بعد",
  "assessments.overview.gapsFilter.all": "الكل ({{count}})",
  "assessments.overview.gapsFilter.hasGaps": "يحتوي ثغرات ({{count}})",
  "assessments.overview.gapsFilter.missingDocs": "وثائق مفقودة ({{count}})",
  "assessments.overview.gapsFilter.complete": "مكتمل ({{count}})",
  "assessments.overview.gapsFilter.empty": "لا توجد نطاقات تطابق هذا التصفية.",
  "assessments.overview.showAll": "عرض جميع {{count}} نطاقات",
  "assessments.overview.showLess": "عرض أقل",
  "assessments.overview.priorityActions.title": "الإجراءات ذات الأولوية",
  "assessments.overview.priorityActions.subtitle": "خطوات معالجة مولّدة بالذكاء الاصطناعي لأضعف {{count}} نطاقات — مرتبة حسب الأولوية",
  "assessments.overview.priorityActions.show": "عرض",
  "assessments.overview.priorityActions.hide": "إخفاء",
  "assessments.overview.priorityActions.recommendedActions": "الإجراءات الموصى بها",
  "assessments.overview.priorityActions.noActions": "لا توجد إجراءات محددة متاحة بعد.",
  "assessments.overview.priorityActions.urgency.critical": "حرجة",
  "assessments.overview.priorityActions.urgency.high": "عالية",
  "assessments.overview.priorityActions.urgency.medium": "متوسطة",
  "assessments.overview.priorityActions.urgency.low": "منخفضة",
  "assessments.overview.priorityActions.effort": "~{{time}} تقديراً",
  "assessments.overview.priorityActions.effortRange": "النطاق التقديري: {{range}} — يتفاوت حسب حجم الفريق ومستوى التوثيق الحالي",
  "app.layout.sidebar.expand": "توسيع",
  "app.layout.sidebar.ask": "اسأل",
  "app.layout.sidebar.assessments": "التقييمات",
  "app.layout.sidebar.documentsRemediation": "معالجة المستندات — جديد",
  "app.layout.sidebar.newChat": "محادثة جديدة",
  "app.layout.sidebar.settings": "الإعدادات",
  "assessments.progressFlow.progress": "التقدم",
  "assessments.summary.allComplete": "جميع المجالات مكتملة",
  "assessments.summary.back": "رجوع",
  "assessments.summary.classification.invalidDocument": "مستند غير صالح",
  "assessments.summary.classification.noMatch": "لم يتطابق أي مستند معياري",
  "assessments.summary.classification.wontBeSubmitted": "لن يتم تقديمه",
  "assessments.summary.completion": "نسبة الإكمال",
  "assessments.summary.completionMessage": "تهانينا! تم اكتمال تقييمك وهو جاهز للتقديم.",
  "assessments.summary.completionSubtitle": "لقد أجبت عبر {{domainCount}} من المجالات ورفعت {{documentCount}} مستندات داعمة. يرجى مراجعة إجاباتك أدناه ثم إرسال التقييم عند الجاهزية.",
  "assessments.summary.confirmModal.cancel": "إلغاء",
  "assessments.summary.confirmModal.confirm": "إرسال التقييم",
  "assessments.summary.confirmModal.evaluationInfo": "سيبدأ النظام في تقييم إجاباتك والمستندات المرفوعة.",
  "assessments.summary.confirmModal.submitting": "جاري الإرسال...",
  "assessments.summary.confirmModal.title": "إرسال التقييم للمراجعة؟",
  "assessments.summary.confirmModal.warningMessage": "بعد الإرسال لن تتمكن من تعديل هذا التقييم. إذا احتجت لتغييرات لاحقًا، ستحتاج لبدء نسخة جديدة من التقييم.",
  "assessments.summary.documents": "المستندات",
  "assessments.summary.domainSummary": "ملخص المجالات",
  "assessments.summary.domainsEdited": "المجالات المعدّلة",
  "assessments.summary.domainsKept": "{{count}} كما هي",
  "assessments.summary.edit": "تعديل",
  "assessments.summary.editedForVersion": "معدّل للإصدار V{{version}}",
  "assessments.summary.evidenceUploaded": "الأدلة المرفوعة",
  "assessments.summary.fewerMissing": "{{count}} أقل في المفقود",
  "assessments.summary.generateWithAI": "توليد مستندات بالذكاء الاصطناعي",
  "assessments.summary.mandatory": "{{mandatoryDomains}} إلزامي، {{optionalDomains}} اختياري",
  "assessments.summary.missingBadge": "مفقود",
  "assessments.summary.missingDocsLegend.better": "أقل في المفقود من V{{version}} (تحسّن)",
  "assessments.summary.missingDocsLegend.title": "مؤشر المستندات المفقودة:",
  "assessments.summary.missingDocsLegend.worse": "أكثر في المفقود من V{{version}} (يحتاج انتباه)",
  "assessments.summary.missingDocumentsBadge_few": "{{count}} مستندات مفقودة",
  "assessments.summary.missingDocumentsBadge_many": "{{count}} مستنداً مفقوداً",
  "assessments.summary.missingDocumentsBadge_one": "{{count}} مستند مفقود",
  "assessments.summary.missingDocumentsBadge_other": "{{count}} مستندات مفقودة",
  "assessments.summary.missingDocumentsBadge_two": "{{count}} مستندان مفقودان",
  "assessments.summary.missingDocumentsBadge_zero": "{{count}} مستند مفقود",
  "assessments.summary.missingDocumentsCard": "المستندات المفقودة",
  "assessments.summary.missingDocumentsCardSubtitle": "عبر جميع المجالات",
  "assessments.summary.missingDocumentsImproving": "كان {{parentTotalMissing}} سابقًا · تحسّن",
  "assessments.summary.missingDocumentsRegressing": "كان {{parentTotalMissing}} سابقًا · يحتاج انتباه",
  "assessments.summary.missingDocumentsSection": "المستندات المعيارية المفقودة",
  "assessments.summary.missingDocumentsUnchanged": "لم يتغيّر عن الإصدار السابق",
  "assessments.summary.missingDocuments_few": "{{count}} مفقودة",
  "assessments.summary.missingDocuments_many": "{{count}} مفقوداً",
  "assessments.summary.missingDocuments_one": "{{count}} مفقود",
  "assessments.summary.missingDocuments_other": "{{count}} مفقود",
  "assessments.summary.missingDocuments_two": "{{count}} مفقودان",
  "assessments.summary.missingDocuments_zero": "{{count}} مفقود",
  "assessments.summary.moreMissing": "{{count}} أكثر في المفقود",
  "assessments.summary.noDocuments": "لم يتم رفع مستندات",
  "assessments.summary.parentDomainScore": "الإصدار {{version}}: {{percentage}}%",
  "assessments.summary.removedFromParent": "{{count}} محذوف منذ V{{version}}",
  "assessments.summary.skipped": "تم التخطي",
  "assessments.summary.skippedDocumentsBadge_few": "{{count}} مستندات متخطاة",
  "assessments.summary.skippedDocumentsBadge_many": "{{count}} مستنداً متخطى",
  "assessments.summary.skippedDocumentsBadge_one": "{{count}} مستند متخطى",
  "assessments.summary.skippedDocumentsBadge_other": "{{count}} مستند متخطى",
  "assessments.summary.skippedDocumentsBadge_two": "{{count}} مستندان متخطيان",
  "assessments.summary.skippedDocumentsBadge_zero": "{{count}} مستند متخطى",
  "assessments.summary.submitAssessment": "إرسال التقييم",
  "assessments.summary.totalDomains": "إجمالي المجالات",
  "assessments.summary.uploadedOn": "تم الرفع في {{date}}",
  "assessments.summary.warningMessage": "يرجى مراجعة جميع المجالات بعناية قبل الإرسال. بعد الإرسال لن تتمكن من تعديل هذا التقييم، وإذا احتجت لتغييرات لاحقًا فستحتاج لبدء تقييم جديد.",
  "assessments.summary.wasInParent": "كان في V{{version}}",
  "assessments.workflow.domain.applicabilityNoTooltip": "سيؤدي تحديد 'لا' إلى وضع علامة على هذا المجال كمتخطى ولن يؤثر على درجة التقييم الإجمالية.",
  "assessments.workflow.domain.applicabilityQuestion": "قابلية تطبيق المجال",
  "assessments.workflow.domain.applicabilityYesTooltip": "ينطبق هذا المجال على مؤسستك وتحتاج إلى إكماله وتقديم أدلة.",
  "assessments.workflow.domain.edit": "تعديل",
  "assessments.workflow.domain.evidenceFiles": "الوثائق المطلوبة",
  "assessments.workflow.domain.finishAssessment": "إنهاء التقييم",
  "assessments.workflow.domain.goToSummary": "الذهاب إلى الملخص",
  "assessments.workflow.domain.markAsNoEvidenceAvailable": "وضع علامة 'لا توجد أدلة متاحة'",
  "assessments.workflow.domain.next": "التالي",
  "assessments.workflow.domain.noEvidenceAvailable": "لا توجد أدلة متاحة",
  "assessments.workflow.domain.noEvidenceTooltip": "سيؤدي تحديد هذا الخيار إلى وضع علامة على هذا السؤال كمكتمل وقد يقلل من درجتك النهائية.",
  "assessments.workflow.domain.resume": "المتابعة",
  "assessments.workflow.domain.resumeLater": "المتابعة لاحقاً",
  "assessments.workflow.domain.saveAndNext": "حفظ والتالي",
  "assessments.workflow.header.editAssessmentName": "تعديل اسم التقييم",
  "assessments.workflow.header.editAssessmentNameButton": "تعديل",
  "assessments.workflow.header.editAssessmentNameButtonIcon": "تعديل",
  "assessments.workflow.header.editAssessmentNamePlaceholder": "أدخل اسم التقييم",
  "assessments.workflow.header.exitAssessment": "الخروج من التقييم",
  "auth.internalLogin.backToHome": "العودة إلى الرئيسية",
  "auth.internalLogin.form.button.signIn": "المتابعة باستخدام البريد الإلكتروني",
  "auth.internalLogin.form.description": "اختر طريقة تسجيل الدخول",
  "auth.internalLogin.form.title": "تسجيل الدخول",
  "auth.login.description1": "تبسيط الامتثال",
  "auth.login.description2": "ذكاء اصطناعي يفهم متطلبات الامتثال",
  "auth.login.failed": "فشل تسجيل الدخول. يرجى المحاولة مرة أخرى.",
  "auth.login.form.button.google": "المتابعة باستخدام Google",
  "auth.login.form.button.loading": "جاري التسجيل...",
  "auth.login.form.button.submit": "تسجيل الدخول",
  "auth.login.form.description": "دعنا نسجل الدخول لإنشاء حساب Komplyance القوي لك.",
  "auth.login.form.email.label": "بريد إلكتروني",
  "auth.login.form.email.placeholder": "أدخل بريدك الإلكتروني",
  "auth.login.form.password.label": "كلمة السر",
  "auth.login.form.password.placeholder": "أدخل كلمة السر ",
  "auth.login.form.title": "تسجيل الدخول في قوة مؤسستك الامتثالية",
  "auth.login.form.validation.email.invalid": "يرجى إدخال بريد إلكتروني صحيح",
  "auth.login.form.validation.password.required": "كلمة السر مطلوبة",
  "auth.login.instruction": "تسجيل الدخول إلى لوحة معلومات الامتثال الخاصة بك",
  "auth.login.title": "إدارة قوية وفعالة لامتثال المؤسسات",
  "auth.login.welcome": "مرحبًا بكم في الذكاء القانوني الموجه بالذكاء الاصطناعي",
  "auth.profilePanel.button.logout": "تسجيل الخروج",
  "auth.profilePanel.button.settings": "الإعدادات",
  "auth.profilePanel.email.fallback": "لا يوجد بريد إلكتروني",
  "auth.profilePanel.user.fallback": "مستخدم",
  "chat.attachment.download": "تنزيل",
  "chat.attachment.downloadError": "فشل تنزيل الملف",
  "chat.empty.title": "لا توجد رسائل بعد. ابدأ محادثة!",
  "chat.errors.genericError": "حدث خطأ",
  "chat.errors.rateLimitCountdown": "يمكنك الإرسال مرة أخرى بعد {{seconds}} ثانية",
  "chat.errors.rateLimitExceeded": "أنت ترسل الرسائل بسرعة كبيرة. يرجى الانتظار {{seconds}} ثانية.",
  "chat.errors.retry": "إعادة المحاولة",
  "chat.errors.serviceUnavailable": "خدمة الذكاء الاصطناعي غير متاحة مؤقتاً. يرجى المحاولة لاحقاً.",
  "chat.errors.unexpectedError": "حدث خطأ غير متوقع",
  "chat.file.type.document": "مستند",
  "chat.file.type.excel": "مستند Excel",
  "chat.file.type.pdf": "مستند PDF",
  "chat.file.type.word": "مستند Word",
  "chat.input.addFilesAndDocuments": "إضافة الملفات والمستندات",
  "chat.input.attachFile": "إرفاق الملفات",
  "chat.input.checkDocumentsPlaceholder": "اسأل عن المستند...",
  "chat.input.deepResearch": "بحث متقدم",
  "chat.input.dropFilesHere": "أسقط الملفات هنا للتحميل",
  "chat.input.placeholder": "اكتب رسالتك...",
  "chat.input.send": "إرسال رسالة",
  "chat.input.stop": "إيقاف التوليد",
  "chat.input.uploadFailed": "فشل الرفع",
  "chat.input.uploading": "جارٍ الرفع",
  "chat.loadError.button": "إعادة المحاولة",
  "chat.loadError.description": "يرجى التحقق من اتصالك وإعادة المحاولة.",
  "chat.loadError.title": "حدث خطأ أثناء تحميل هذه المحادثة.",
  "chat.loading.title": "جاري تحميل المحادثة...",
  "chat.new.description": "اسأل أسئلة عن PDPL واحصل على الإجابات من مساعد الامتثال للذكاء الاصطناعي الخاص بك",
  "chat.new.form.placeholder": "اسأل عن أفضل ممارسات PDPL...",
  "chat.new.title": "مساعدك الذكي للامتثال",
  "chat.references.title": "المراجع التي تم التحقق منها",
  "chat.scrollToBottom.ariaLabel": "تمرير للأسفل",
  "chat.scrollToBottom.newMessage": "رسالة جديدة",
  "chat.scrollToBottom.scrollDown": "التمرير للأسفل",
  "chat.streaming.stage.assessing": "جارٍ تقييم المستند...",
  "chat.streaming.stage.assessment_completed": "اكتمل التقييم...",
  "chat.streaming.stage.assessment_started": "جارٍ بدء التقييم...",
  "chat.streaming.stage.classifying": "جارٍ تصنيف المستند...",
  "chat.streaming.stage.completing": "جارٍ إنشاء الرد...",
  "chat.streaming.stage.deep_researching": "جارٍ البحث في أحدث المصادر العامة…",
  "chat.streaming.stage.downloading": "جارٍ تحميل المستند...",
  "chat.streaming.stage.extracting": "جارٍ استخراج المحتوى...",
  "chat.streaming.stage.filtering_kb": "جارٍ اختيار أكثر المصادر صلة…",
  "chat.streaming.stage.finalizing_answer": "جارٍ إنهاء إجابتك…",
  "chat.streaming.stage.generating_response": "جارٍ صياغة إجابتك…",
  "chat.streaming.stage.grading": "جارٍ تقييم المستند...",
  "chat.streaming.stage.indexing": "جارٍ فهرسة المستند...",
  "chat.streaming.stage.ingesting": "جارٍ معالجة المستند...",
  "chat.streaming.stage.processing": "جارٍ التفكير...",
  "chat.streaming.stage.quality_check": "جارٍ مراجعة جودة الإجابة…",
  "chat.streaming.stage.retrieving_kb": "جارٍ استكشاف قاعدة المعرفة…",
  "chat.streaming.stage.summarizing": "جارٍ تلخيص المستند...",
  "chat.streaming.stage.understanding_query": "جارٍ فهم سؤالك…",
  "chat.suggestedQuestions.question1": "ما هو قانون حماية البيانات الشخصية؟",
  "chat.suggestedQuestions.question2": "من ينظم قانون حماية البيانات الشخصية في المملكة؟",
  "chat.suggestedQuestions.question3": "ماذا يفرض قانون حماية البيانات الشخصية على المنظمات؟",
  "chatHistory.delete.body": 'سيتم حذف "{{name}}" وجميع رسائلها نهائيًا. لا يمكن التراجع عن هذا الإجراء.',
  "chatHistory.delete.confirm": "حذف",
  "chatHistory.delete.menuItem": "حذف",
  "chatHistory.delete.title": "حذف المحادثة؟",
  "chatHistory.emptyState.noConversations": "لا توجد محادثات بعد. ابدأ محادثة جديدة لتراها هنا.",
  "chatHistory.emptyState.noSearchResults": "لا توجد محادثات تطابق بحثك.",
  "chatHistory.errors.failedToLoad": "فشل تحميل المحادثات",
  "chatHistory.loadingConversations": " ...جاري تحميل المحادثات",
  "chatHistory.moreActions": "إجراءات إضافية",
  "chatHistory.sidePanel.title": "سجل المحادثات",
  "chatHistory.toast.deleteFailed": "فشل حذف المحادثة",
  "chatHistory.toast.deleted": "تم حذف المحادثة",
  "common.cancelButton": "إلغاء",
  "common.no": "لا",
  "common.saveButton": "حفظ",
  "common.new": "جديد",
  "common.soon": "قريبا",
  "common.yes": "نعم",
  "components.copyButton.failedToCopy": "فشل نسخ النص",
  "components.loading.text": "جاري التحميل...",
  "errors.ASSESSMENT.AI_RESPONSE_INVALID": "أرجعت خدمة معالجة التقييم استجابة غير صالحة.",
  "errors.ASSESSMENT.CREATION_FAILED": "فشل في إنشاء التقييم. يرجى المحاولة مرة أخرى.",
  "errors.ASSESSMENT.DOMAINS_INCOMPLETE": "يجب إكمال جميع المجالات قبل تقديم التقييم.",
  "errors.ASSESSMENT.HAS_PENDING_DOCUMENTS": "يحتوي التقييم على مستندات معلقة أو محذوفة. يرجى إنهاء جميع المستندات قبل التقديم.",
  "errors.ASSESSMENT.INVALID_STATUS": "لا يمكن تنفيذ هذا الإجراء في حالة التقييم الحالية.",
  "errors.ASSESSMENT.NOT_FOUND": "التقييم غير موجود أو ليس لديك صلاحية الوصول إليه.",
  "errors.ASSESSMENT.STATUS_CHECK_FAILED": "فشل في التحقق من حالة معالجة التقييم. قد تكون الخدمة غير متاحة مؤقتاً.",
  "errors.ASSESSMENT.UNSUPPORTED_LANGUAGE": "اللغة المحددة غير مدعومة لهذا التقييم.",
  "errors.COMMON.FORBIDDEN": "ليس لديك الإذن لتنفيذ هذا الإجراء.",
  "errors.COMMON.INTERNAL_ERROR": "حدث خطأ داخلي. يرجى المحاولة مرة أخرى لاحقاً.",
  "errors.COMMON.NOT_FOUND": "المورد غير موجود",
  "errors.COMMON.UNAUTHORIZED": "غير مصرح. يرجى تسجيل الدخول للمتابعة.",
  "errors.COMMON.TOO_MANY_REQUESTS": "طلبات كثيرة جدًا. يرجى الانتظار لحظة ثم المحاولة مرة أخرى.",
  "errors.COMMON.VALIDATION_ERROR": "خطأ في التحقق من الصحة. يرجى التحقق من المدخلات.",
  "errors.DOCUMENT.ALREADY_IN_TARGET_DOMAIN": "هذا الملف موجود بالفعل في ذلك المجال. افتح المجال لمراجعة النسخة الموجودة هناك، ثم احذف هذه النسخة إذا لم تعد بحاجة إليها.",
  "errors.DOCUMENT.DUPLICATE_FILE_IN_DOMAIN": "لقد رفعت هذا الملف إلى هذا المجال من قبل. احذف الملف الموجود أولًا إذا أردت استبداله.",
  "errors.DOCUMENT.DUPLICATE_FILE_IN_TARGET_DOMAIN": "ذلك المجال يحتوي بالفعل على ملف بالاسم والحجم نفسيهما. احذف النسخة الموجودة هناك أولًا إذا أردت نقل هذا الملف، أو احذف هذا الملف إذا كان نسخة مكررة.",
  "errors.DOCUMENT.INVALID_FORMAT": "صيغة المستند غير صالحة. يرجى رفع ملف بإحدى الصيغ المقبولة.",
  "errors.DOCUMENT.SIZE_EXCEEDED": "المستند يتجاوز الحد الأقصى المسموح به لحجم الملف.",
  "errors.DOCUMENT.STANDARD_DOCUMENT_TAKEN": "يوجد ملف آخر مطابق بالفعل لذلك المستند المعياري. المستند المعياري الواحد يقابله ملف واحد، لذا اختر مطابقة أخرى أو غيّر مطابقة الملف الآخر أولًا.",
  "errors.DOMAIN.APPLICABILITY_REQUIRED": "يرجى تحديد ما إذا كان هذا المجال الاختياري قابلاً للتطبيق أم لا.",
  "errors.DOMAIN.CANNOT_START": "يمكنك فقط بدء المجال التالي المتاح أو إعادة فتح مجال مكتمل.",
  "errors.DOMAIN.DOCUMENTS_INVALID_CLASSIFICATION": "تعذّر على النظام التعرف على بعض المستندات المرفوعة. يرجى حذفها وإعادة رفع المستندات الصحيحة، أو حذفها وتحديد هذا المجال كمتخطى.",
  "errors.DOMAIN.DOCUMENTS_NOT_ACCEPTED": "هذا المجال لا يقبل مستندات. يرجى إزالة جميع المستندات المرفوعة.",
  "errors.DOMAIN.DOCUMENTS_REQUIRED": "مطلوب مستند واحد على الأقل. يرجى رفع مستند أو تخطي المجال.",
  "errors.DOMAIN.HAS_PENDING_CHANGES": "المجال الحالي يحتوي على تغييرات معلقة. يرجى الحفظ أو الإلغاء قبل بدء مجال آخر.",
  "errors.DOMAIN.INAPPLICABLE_AND_SKIPPED": "لا يمكن تحديد المجال على أنه غير قابل للتطبيق ومتخطى في نفس الوقت.",
  "errors.DOMAIN.INAPPLICABLE_HAS_DOCUMENTS": "لا يمكن تحديد المجال على أنه غير قابل للتطبيق أثناء وجود مستندات مرفقة. يرجى إزالة جميع المستندات أولاً.",
  "errors.DOMAIN.NOT_FOUND": "المجال غير موجود أو ليس لديك صلاحية الوصول إليه.",
  "errors.DOMAIN.NOT_IN_PROGRESS": "لا يمكن تنفيذ هذا الإجراء إلا على مجال قيد التنفيذ حالياً.",
  "errors.DOMAIN.RELOAD_FAILED": "فشل في إعادة تحميل بيانات المجال. يرجى المحاولة مرة أخرى.",
  "errors.DOMAIN.REQUIRED_NOT_INAPPLICABLE": "لا يمكن تحديد المجالات المطلوبة على أنها غير قابلة للتطبيق. يجب إما التخطي أو تقديم المستندات المطلوبة.",
  "errors.DOMAIN.SKIPPED_HAS_DOCUMENTS": "لا يمكن تخطي المجال أثناء وجود مستندات مرفقة. يرجى إزالة جميع المستندات قبل التخطي.",
  "errors.DOMAIN.STATUS_TRANSITION_FAILED": "لا يمكن نقل المجال السابق. يرجى الحفظ أو الإلغاء قبل بدء مجال جديد.",
  "errors.DOMAIN.VALIDATION_FAILED": "فشل التحقق من صحة المجال. يرجى التحقق من متطلبات المجال.",
  "errors.FRAMEWORK.NOT_FOUND": "الإطار غير موجود.",
  "errors.FRAMEWORK.NO_DOMAINS": "هذا الإطار لا يحتوي على مجالات مهيأة.",
  "fileUpload.ariaLabel.cancelDeletion": "إلغاء حذف {{fileName}}",
  "fileUpload.ariaLabel.cancelUpload": "إلغاء رفع {{fileName}}",
  "fileUpload.ariaLabel.delete": "حذف {{fileName}}",
  "fileUpload.ariaLabel.deleting": "جاري حذف {{fileName}}",
  "fileUpload.ariaLabel.file": "ملف {{fileName}}",
  "fileUpload.ariaLabel.fileDropZone": "منطقة ارفاق الملف",
  "fileUpload.ariaLabel.fileInput": "تحميل الملف",
  "fileUpload.ariaLabel.preparing": "جاري التحضير",
  "fileUpload.ariaLabel.removeFailedUpload": "إزالة الملف الفاشل {{fileName}}",
  "fileUpload.ariaLabel.retryDeletion": "إعادة محاولة حذف {{fileName}}",
  "fileUpload.ariaLabel.retryUpload": "إعادة محاولة رفع {{fileName}}",
  "fileUpload.ariaLabel.undoDeletion": "تراجع عن حذف {{fileName}}",
  "fileUpload.ariaLabel.uploaded": "تم الرفع",
  "fileUpload.dragDrop.dropHere": "افلت الملفات هنا",
  "fileUpload.dragDrop.text": "انقر لتحميل الملف او اسحب وأفلت الملف هنا",
  "fileUpload.errors.fileDuplicateFound": 'الملف "{{fileName}}" تم تحميله من قبل',
  "fileUpload.errors.fileSizeExceeded": 'الملف "{{fileName}}" يتجاوز الحد الأقصى المسموح به وهو {{maxSize}} ميجابايت',
  "fileUpload.errors.fileTypeNotAllowed": 'نوع الملف "{{fileExtension}}" غير مسموح به. الصيغ المدعومة: {{allowedTypes}}',
  "fileUpload.errors.maxFilesExceeded": "تم الوصول إلى الحد الأقصى من الملفات ({{maxFiles}}). يرجى حذف ملف قبل تحميل المزيد.",
  "fileUpload.errors.maxFilesExceededPerDomain": "لقد تجاوزت الحد المسموح به لعدد الملفات لكل مجال",
  "fileUpload.errors.uploadFailed": "فشل رفع الملف",
  "fileUpload.messages.fileRemoved": 'تم إزالة الملف "{{fileName}}"',
  "fileUpload.messages.fileUploaded": 'تم رفع الملف "{{fileName}}" بنجاح',
  "fileUpload.messages.uploadCancelled": 'تم إلغاء رفع الملف "{{fileName}}"',
  "fileUpload.status.deleteFailed": "فشل الحذف",
  "fileUpload.status.deleted": "تم الإزالة",
  "fileUpload.status.deleting": "جاري الحذف...",
  "fileUpload.status.failed": "فشل",
  "fileUpload.status.notSaved": "غير محفوظ",
  "fileUpload.status.pendingDelete": "جاري الحذف",
  "fileUpload.status.queued": "جاري التحضير",
  "fileUpload.status.uploaded": "تم الرفع",
  "fileUpload.status.uploading": "جاري الرفع",
  "fileUpload.supportedFormats": "الملفات المسموح بها: {{fileTypes}} (الحد الأقصى {{maxFileSize}} ميجابايت لكل ملف)",
  "home.title": "الرئيسية",
  "search.panel.button.ask": "اسأل",
  "search.panel.button.assesments": "التقييمات",
  "search.panel.button.documentsRemediation": "إصلاح المستندات",
  "search.panel.button.organizationHub": "مركز المؤسسة",
  "search.panel.button.newchat": "محادثة جديدة",
  "search.panel.search.placeholder": "بحث",
  "section.descriptionKey": "وصف القسم",
  "section.titleKey": "عنوان القسم",
  "tenant.prerequisites.description": "ساعدنا في فهم منظمتك بشكل أفضل",
  "tenant.prerequisites.errors.deleteFailed": "فشل حذف المستند",
  "tenant.prerequisites.errors.documentExists": "المستند موجود بالفعل. يرجى حذفه أولاً لتحميل مستند جديد.",
  "tenant.prerequisites.errors.uploadFailed": "فشل التحميل: {{error}}",
  "tenant.prerequisites.info.description": "تساعدنا هذه الوثائق على فهم هيكل منظمتك وسياساتها ووضع الامتثال الحالي. تتيح لنا هذه المعلومات تقديم توصيات أكثر دقة وتخصيص التقييم وفقًا لسياقك المحدد.",
  "tenant.prerequisites.info.item1": "لا تأثير على الدرجة",
  "tenant.prerequisites.info.item2": "توصيات مخصصة",
  "tenant.prerequisites.info.item3": "دقة محسّنة",
  "tenant.prerequisites.info.note": "ملاحظة: هذه الوثائق تختلف عن ملفات الأدلة ولن تساهم في درجة الامتثال الخاصة بك. يتم تخزينها بشكل آمن ويمكن الوصول إليها في أي وقت عبر الإعدادات → مستنداتي.",
  "tenant.prerequisites.info.title": "لماذا نحتاج إلى هذه الوثائق؟",
  "tenant.prerequisites.progress": "أنواع الوثائق تم تحميلها",
  "tenant.prerequisites.skip.benefits.item1": "توصيات سياقية بناءً على هيكل منظمتك",
  "tenant.prerequisites.skip.benefits.item2": "تحديد الفجوات بدقة أكبر",
  "tenant.prerequisites.skip.benefits.item3": "خارطة طريق مخصصة للامتثال",
  "tenant.prerequisites.skip.benefits.title": "الفوائد التي ستفتقدها:",
  "tenant.prerequisites.skip.button.skip": "تخطى على أي حال",
  "tenant.prerequisites.skip.description": "رفع هذه الوثائق يعزز بشكل كبير دقة نتائج تقييمك ويساعدنا في تقديم توصيات أكثر تخصيصًا لمنظمتك.",
  "tenant.prerequisites.skip.footer": "يمكنك دائمًا رفع هذه الوثائق لاحقًا عبر الإعدادات → مستنداتي.",
  "tenant.prerequisites.skip.title": "تخطي المتطلبات الأساسية؟",
  "tenant.prerequisites.success.documentDeleted": 'تم حذف المستند "{{fileName}}" بنجاح',
  "tenant.prerequisites.success.documentUploaded": 'تم تحميل المستند "{{fileName}}" بنجاح',
  "tenant.prerequisites.title": "متطلبات التقييم ",
  "tenant.prerequisites.upload.cybersecurity.description": "بروتوكولات الأمان، وخطط الاستجابة للحوادث، وأطر الأمان",
  "tenant.prerequisites.upload.cybersecurity.title": "سياسات الأمن السيبراني",
  "tenant.prerequisites.upload.dataManagement.description": "سياسات الاحتفاظ بالبيانات وتصنيفها وإدارة دورة حياتها",
  "tenant.prerequisites.upload.dataManagement.title": "سياسات إدارة البيانات",
  "tenant.prerequisites.upload.dpoPlacement.description": "توثيق تعيين مسؤول حماية البيانات ومسؤولياته",
  "tenant.prerequisites.upload.dpoPlacement.title": "قرار تعيين مسؤول حماية البيانات",
  "tenant.prerequisites.upload.itPolicy.description": "حوكمة تكنولوجيا المعلومات، والتحكم في الوصول، وسياسات استخدام التكنولوجيا",
  "tenant.prerequisites.upload.itPolicy.title": "سياسة تكنولوجيا المعلومات",
  "tenant.prerequisites.upload.orgStructure.description": "مخطط المنظمة، تقسيم الأقسام، أو وثيقة هيكل الشركة",
  "tenant.prerequisites.upload.orgStructure.title": "الهيكل التنظيمي",
  "testing.button.default": "افتراضي (EN)",
  "testing.button.error": "خطأ (AR)",
  "testing.button.info": "معلومات (EN)",
  "testing.button.success": "نجاح (AR)",
  "testing.button.warning": "تحذير (EN)",
  "testing.message": "اختبار",
  "testing.title": "اختبار الإشعارات",
  "website.aiPowered.badge": "مدعوم بالذكاء الاصطناعي",
  "website.aiPowered.ctaPrimary": "طلب عرض توضيحي",
  "website.aiPowered.ctaSecondary": "اعرف المزيد",
  "website.aiPowered.feature1": "دعم مخصص",
  "website.aiPowered.feature2": "نشر سريع",
  "website.aiPowered.feature3": "دعم الخبراء",
  "website.aiPowered.feature4": "بدون رسوم إعداد",
  "website.aiPowered.subtitle": "انضم إلى آلاف الشركات التي تثق بـ Komplyance لتلبية احتياجات الامتثال الخاصة بها. جرب قوة إدارة اللوائح التنظيمية المدعومة بالذكاء الاصطناعي اليوم.",
  "website.aiPowered.tagline": "موثوق به من قبل الشركات الرائدة عالمياً",
  "website.aiPowered.title": "هل أنت مستعد لتحويل عملية الامتثال الخاصة بك؟",
  "website.businessImpact.badge": "تأثير الأعمال",
  "website.businessImpact.cta": "ابدأ اليوم",
  "website.businessImpact.item1.desc": "قلل بشكل كبير من الوقت المستغرق في أبحاث وتوثيق الامتثال. ما كان يستغرق أسابيع أصبح الآن يستغرق ساعات.",
  "website.businessImpact.item1.title": "تخفيض الوقت بنسبة 85%",
  "website.businessImpact.item2.desc": "تضمن التحليلات المدعومة بالذكاء الاصطناعي دقة الامتثال مع تقليل الأخطاء البشرية ومخاطر السهو.",
  "website.businessImpact.item2.title": "معدل دقة 99.9%",
  "website.businessImpact.item3.desc": "خفض تكاليف الامتثال بنسبة تصل إلى 70% من خلال العمليات الآلية وتقليل الاعتماد على المستشارين الخارجيين.",
  "website.businessImpact.item3.title": "توفير التكاليف",
  "website.businessImpact.item4.desc": "الوصول إلى خبراء الامتثال والدعم المخصص يضمن أنك لن تواجه اللوائح بمفردك أبداً.",
  "website.businessImpact.item4.title": "دعم الخبراء",
  "website.businessImpact.title": "حوّل عملية الامتثال الخاصة بك",
  "website.comingSoon": "قريباً",
  "website.contact.demo.step1": "جولة حية في المنصة",
  "website.contact.demo.step1.desc": "شاهد منصة Komplyance قيد العمل من خلال عرض توضيحي مخصص يعتمد على احتياجات وأطر الامتثال الخاصة بك",
  "website.contact.demo.step2": "عرض المعالجة بالذكاء الاصطناعي",
  "website.contact.demo.step2.desc": "شاهد كيف يقوم الذكاء الاصطناعي لدينا بتحديث مستندات الامتثال الخاصة بك تلقائياً في الوقت الفعلي",
  "website.contact.demo.step3": "نظرة متعمقة على التقييم",
  "website.contact.demo.step3.desc": "جرب نظام التقييم ثنائي اللغة الخاص بنا مع تسجيل مستوى النضج",
  "website.contact.demo.step4": "خطة تنفيذ مخصصة",
  "website.contact.demo.step4.desc": "احصل على خارطة طريق مصممة خصيصاً لتنفيذ Komplyance في مؤسستك",
  "website.contact.demo.subtitle": "من الإعداد إلى الجاهزية للامتثال غضون ساعات ، وليس أشهراً",
  "website.contact.demo.title": "ما ستراه في العرض التوضيحي الخاص بك",
  "website.contact.form.company": "اسم الشركة",
  "website.contact.form.company.required": "اسم الشركة مطلوب",
  "website.contact.form.companyIndustry": "قطاع الشركة",
  "website.contact.form.companyIndustry.required": "قطاع الشركة مطلوب",
  "website.contact.form.companyIndustryEducation": "التعليم",
  "website.contact.form.companyIndustryFinance": "التمويل",
  "website.contact.form.companyIndustryGovernment": "القطاع الحكومي",
  "website.contact.form.companyIndustryHealthcare": "الرعاية الصحية",
  "website.contact.form.companyIndustryOther": "أخرى",
  "website.contact.form.companyIndustryPlaceholder": "اختر قطاع الشركة",
  "website.contact.form.companyIndustryTechnology": "التكنولوجيا",
  "website.contact.form.companyPlaceholder": "شركة أكمي",
  "website.contact.form.companySize": "حجم الشركة",
  "website.contact.form.companySizePlaceholder": "أدخل حجم الشركة",
  "website.contact.form.email": "البريد الإلكتروني للعمل",
  "website.contact.form.email.invalid": "عنوان البريد الإلكتروني غير صالح",
  "website.contact.form.email.required": "البريد الإلكتروني للعمل مطلوب",
  "website.contact.form.emailPlaceholder": "أدخل عنوان البريد الإلكتروني للعمل",
  "website.contact.form.errorFallback": "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
  "website.contact.form.fullName": "الاسم الكامل",
  "website.contact.form.fullName.required": "الاسم الكامل مطلوب",
  "website.contact.form.fullNamePlaceholder": "أدخل الاسم الكامل",
  "website.contact.form.goals": "ما الذي تتطلع إلى تحقيقه؟",
  "website.contact.form.goalsPlaceholder": "أخبرنا عن أهداف وتحديات الامتثال الخاصة بك...",
  "website.contact.form.jobTitle": "المسمى الوظيفي",
  "website.contact.form.jobTitlePlaceholder": "مثل: مسؤول امتثال، قائد خصوصية، مستشار قانوني",
  "website.contact.form.phone": "رقم الهاتف",
  "website.contact.form.phonePlaceholder": "+1 (555) 123-4567",
  "website.contact.form.privacy": "بإرسال هذا النموذج، فإنك توافق على",
  "website.contact.form.privacyNote": "سنستخدم معلوماتك للاتصال بك بشأن منتجاتنا وخدماتنا. يمكنك إلغاء الاشتراك في أي وقت.",
  "website.contact.form.privacyPolicy": "سياسة الخصوصية.",
  "website.contact.form.responseTime": "يسعدنا أن نعرض عليكم ما قمنا ببنائه. سنقوم بالرد عليكم في غضون يومي عمل.",
  "website.contact.form.submit": "طلب عرض توضيحي",
  "website.contact.form.submitting": "جاري الإرسال...",
  "website.contact.subtitle": "شاهد كيف يمكن لـ Komplyance تبسيط رحلة الامتثال الخاصة بك في 30 دقيقة فقط",
  "website.contact.success.title": "شكراً لك!",
  "website.contact.title": "اطلب عرضك التوضيحي المخصص",
  "website.contactUs.ctaA11y": "اذهب إلى صفحة الاتصال",
  "website.contactUs.subtitle": "نود أن نسمع منك! سنضيفه إلى قسم الأسئلة الشائعة لمساعدة الآخرين في العثور على المعلومات التي يحتاجون إليها.",
  "website.contactUs.title": "هل لديك بعض <br/>الأسئلة لنا؟",
  "website.cta.primary": "طلب عرض توضيحي",
  "website.cta.secondary": "اعرف المزيد",
  "website.cta.subtitle": "انضم إلى أكثر من 100 مؤسسة تستخدم بالفعل Komplyance لتحقيق الامتثال بشكل أسرع.",
  "website.cta.title": "هل أنت مستعد لتبسيط رحلة الامتثال الخاصة بك؟",
  "website.features.badge": "ميزات المنصة",
  "website.features.item1.badge": "دقة 99%",
  "website.features.item1.desc": "تعمل خوارزميات التعلم الآلي المتقدمة على تحليل اللوائح التنظيمية وتقديم إجابات سياقية ودقيقة مع مراجع كاملة للمصادر.",
  "website.features.item1.title": "الذكاء الاصطناعي في خدمة الامتثال",
  "website.features.item2.badge": "وفر أكثر من 100 ساعة",
  "website.features.item2.desc": "تقييمات شاملة لمستوى النضج تقوم بمراجعة مستنداتك تلقائياً وتحديد فجوات الامتثال.",
  "website.features.item2.title": "تقييمات آلية",
  "website.features.item3.badge": "مدعوم بالذكاء الاصطناعي",
  "website.features.item3.desc": "إنشاء وتعديل ذكي للمستندات يضمن الامتثال عبر أطر تنظيمية متعددة.",
  "website.features.item3.title": "إنشاء ذكي للمستندات",
  "website.features.item4.badge": "أكثر من 50 إطار عمل",
  "website.features.item4.badge2": "قريباً",
  "website.features.item4.desc": "دعم أطر امتثال متعددة في منصة واحدة، مع المزيد من الأطر قريباً.",
  "website.features.item4.title": "دعم أطر عمل متعددة",
  "website.features.item5.desc": "إنشاء تقارير جاهزة للتدقيق مع تقييمات النضج وخرائط طريق قابلة للتنفيذ.",
  "website.features.item5.title": "تقارير مفصلة",
  "website.features.item6.desc": "أمان على المستوى المصرفي مع تحكم في الوصول قائم على الأدوار ومسارات تدقيق كاملة.",
  "website.features.item6.title": "أمان المؤسسات",
  "website.features.subtitle": "من الإعداد إلى الجاهزية للامتثال غضون ساعات ، وليس أشهراً",
  "website.features.tagline1": "تحليل المستندات بالذكاء الاصطناعي",
  "website.features.tagline2": "أسال عن اي امر يخص الامتثال",
  "website.features.tagline3": "اكتشف سير عمل التقييم الآلي",
  "website.features.title": "لماذا تختار Komplyance؟",
  "website.footer.contact": "هل لديك أسئلة؟ راسلنا على",
  "website.footer.copyright": "© 2026 Komplyance. جميع الحقوق محفوظة.",
  "website.footer.or": "أو اتصل بـ",
  "website.footer.privacy": "سياسة الخصوصية",
  "website.footer.sitemap": "خريطة الموقع",
  "website.footer.terms": "الشروط",
  "website.footerNav.cta": "حدد موعداً لمكالمة",
  "website.footerNav.description": "Komplyance هي منصتك الشاملة للامتثال، حيث تساعد الشركات على تصفح اللوائح المعقدة من خلال المساعدة المدعومة بالذكاء الاصطناعي، والتقييمات الآلية، ودعم الخبراء.",
  "website.footerNav.general.aboutUs": "من نحن",
  "website.footerNav.general.faqs": "الأسئلة الشائعة",
  "website.footerNav.general.home": "الرئيسية",
  "website.footerNav.general.platformFeatures": "ميزات المنصة",
  "website.footerNav.general.privacyPolicy": "سياسة الخصوصية",
  "website.footerNav.general.services": "الخدمات",
  "website.footerNav.resources.caseStudies": "دراسات الحالة",
  "website.footerNav.resources.documentation": "الوثائق",
  "website.footerNav.resources.title": "الموارد",
  "website.footerNav.resources.webinars": "الندوات عبر الإنترنت",
  "website.footerNav.support.callUs": "اتصل بنا:",
  "website.footerNav.support.email": "info@komplyance.ai",
  "website.footerNav.support.phone": "+966564332837",
  "website.footerNav.support.title": "الدعم",
  "website.hero.badge": "منصة امتثال مدعومة بالذكاء الاصطناعي",
  "website.hero.cta.primary": "طلب عرض توضيحي",
  "website.hero.cta.secondary": "شاهد كيف تعمل",
  "website.hero.subtitle": "تساعد Komplyance المؤسسات على تحقيق الامتثال  والحفاظ عليه من خلال التقييمات القائمة على الذكاء الاصطناعي، ومراجعة المستندات الآلية، ومراقبة الامتثال في الوقت الفعلي.",
  "website.hero.taglineLeft": "تبسيط الامتثال",
  "website.hero.taglineRight": "منصة امتثال مدعومة بالذكاء الاصطناعي",
  "website.hero.title": "امتثال المؤسسات أصبح بسيطاً",
  "website.hero.trustedBy": "موثوق به من قبل المنظمات الرائدة",
  "website.howItWorks.badge": "كيف تعمل",
  "website.howItWorks.step1.desc": "اطرح أسئلة حول أي لائحة تنظيمية واحصل على إجابات فورية ودقيقة بفضل الذكاء الاصطناعي المتقدم",
  "website.howItWorks.step1.title": "الدردشة مع اللوائح",
  "website.howItWorks.step2.desc": "يقوم الذكاء الاصطناعي لدينا بتحليل وضع الامتثال الخاص بك عبر جميع أطر العمل",
  "website.howItWorks.step2.title": "تقييم الذكاء الاصطناعي",
  "website.howItWorks.step3.desc": "يقوم الذكاء الاصطناعي بتحديث المستندات وملء الفجوات تلقائياً",
  "website.howItWorks.step3.title": "المعالجة التلقائية",
  "website.howItWorks.step4.desc": "سير عمل امتثال آلي يتكيف مع التغييرات التنظيمية",
  "website.howItWorks.step4.title": "أتمتة سير العمل بالذكاء الاصطناعي",
  "website.howItWorks.subtitle": "من الإعداد إلى الجاهزية للامتثال في غضون ساعات، وليس اشهر",
  "website.howItWorks.title": "حقق الامتثال في 4 خطوات سهلة",
  "website.industry.badge": "حلول القطاعات",
  "website.industry.item1.desc": "حماية بيانات المرضى، حوكمة البيانات الصحية، وأطر عمل خاصة بالقطاع.",
  "website.industry.item1.title": "الرعاية الصحية",
  "website.industry.item2.desc": "نظام حماية البيانات الشخصية (PDPL)، والبنك المركزي السعودي (SAMA)، والامتثال للوائح المالية مع تقارير جاهزة للتدقيق.",
  "website.industry.item2.title": "الخدمات المالية",
  "website.industry.item3.desc": "بيانات المستهلك، الموافقة، والامتثال لتدفق البيانات عبر الحدود.",
  "website.industry.item3.title": "التكنولوجيا",
  "website.industry.item4.desc": "حوكمة بيانات القطاع العام ومتطلبات إعداد التقارير التنظيمية.",
  "website.industry.item4.title": "القطاع الحكومي",
  "website.industry.item5.title": "التجزئة",
  "website.industry.item6.title": "التصنيع",
  "website.industry.item7.title": "التعليم",
  "website.industry.item8.title": "الاتصالات",
  "website.industry.subtitle": "حلول امتثال مصممة خصيصاً لكل قطاع",
  "website.industry.title": "صُممت لقطاعك",
  "website.nav.about": "من نحن",
  "website.nav.contact": "اتصل بنا",
  "website.nav.demo": "العرض التوضيحي",
  "website.nav.faqs": "الأسئلة الشائعة",
  "website.nav.login": "تسجيل الدخول",
  "website.nav.requestDemo": "طلب عرض توضيحي",
  "website.nav.services": "الخدمات",
  "website.savingsCalculator.overline": "تعرف على مقدار الوقت والمال الذي يمكن لمؤسستك توفيره مع Komplyance",
  "website.savingsCalculator.stat1.overline": "متوسط الوقت الذي تم توفيره",
  "website.savingsCalculator.stat1.unit": "لكل دورة تقييم",
  "website.savingsCalculator.stat1.value": "8 أسابيع",
  "website.savingsCalculator.stat2.overline": "متوسط خفض التكاليف",
  "website.savingsCalculator.stat2.unit": "سنوياً",
  "website.savingsCalculator.stat2.value": "350 ألف ريال سعودي",
  "website.savingsCalculator.stat3.overline": "امتثال أسرع",
  "website.savingsCalculator.stat3.unit": "تقليص في الإطار الزمني",
  "website.savingsCalculator.stat3.value": "98%",
  "website.savingsCalculator.title": "احسب <br/>توفيرات الامتثال الخاصة بك",
  "website.sections.businessImpact": "تأثير الأعمال",
  "website.sections.industrySolutions": "حلول القطاعات",
  "website.sections.ourServices": "خدماتنا",
  "website.sections.platformFeatures": "ميزات المنصة",
  "website.sections.simpleProcess": "العمليات",
  "website.services.badge": "خدماتنا",
  "website.services.item1.desc": "احصل على إجابات فورية ودقيقة لأي أسئلة متعلقة باللوائح التنظيمية مع مساعدنا المدعوم بالذكاء الاصطناعي. مزود بمراجع وتفسيرات مفصلة.",
  "website.services.item1.title": "مساعد اللوائح بالذكاء الاصطناعي",
  "website.services.item2.desc": "تقييم شامل لنضج الامتثال في مؤسستك من خلال المراجعة الآلية للمستندات وتحليل الفجوات.",
  "website.services.item2.title": "تقييم النضج",
  "website.services.item3.desc": "إنشاء آلي وتعديل ذكي لمستندات الامتثال لضمان تلبية مؤسستك لجميع المتطلبات التنظيمية.",
  "website.services.item3.title": "إنشاء وتعديل المستندات",
  "website.services.item4.desc": "دعم مكتب إدارة البيانات الوطنية (NDMO)، والمعهد الوطني للمعايير والتكنولوجيا (NIST)، والعديد من الأطر التنظيمية الأخرى. ابق ممتثلاً عبر ولايات قضائية ومعايير متعددة.",
  "website.services.item4.title": "دعم أطر عمل متعددة",
  "website.services.item5.desc": "مراقبة مستمرة للتغييرات التنظيمية وتحديثات تلقائية لإبقاء متطلبات الامتثال الخاصة بك مُحدثة.",
  "website.services.item5.title": "مراقبة في الوقت الفعلي",
  "website.services.item6.desc": "الوصول إلى خبراء الامتثال وفريق دعم مخصص لمساعدتك على التعامل مع المشهد التنظيمي المعقد بثقة.",
  "website.services.item6.title": "دعم الخبراء",
  "website.services.learnMore": "اعرف المزيد",
  "website.services.subtitle": "من الاستفسارات التنظيمية المدعومة بالذكاء الاصطناعي إلى الإدارة الكاملة للمستندات",
  "website.services.title": "حلول امتثال شاملة",
  "website.stats.customers": "العملاء",
  "website.stats.fasterCompliance": "امتثال أسرع",
  "website.stats.uptime": "وقت التشغيل",
  "app.layout.sidebar.organizationProfile": "مركز المؤسسة",
  "app.orgProfile.title": "ملف المؤسسة",
  "app.orgProfile.breadcrumbRoot": "مساحة العمل",
  "app.orgProfile.documentHub": "مركز المستندات",
  "app.orgProfile.previewProfile": "معاينة الملف",
  "app.orgProfile.reviewBanner_one": "مستند واحد جاهز للمراجعة",
  "app.orgProfile.reviewBanner_other": "{{count}} مستند جاهز للمراجعة",
  "app.orgProfile.reviewBanner_zero": "لا توجد مستندات جاهزة للمراجعة",
  "app.orgProfile.reviewBanner_two": "مستندان جاهزان للمراجعة",
  "app.orgProfile.reviewBanner_few": "{{count}} مستندات جاهزة للمراجعة",
  "app.orgProfile.reviewBanner_many": "{{count}} مستنداً جاهزاً للمراجعة",
  "app.orgProfile.review": "مراجعة",
  "app.orgProfile.loading": "جارٍ تحميل ملف المؤسسة…",
  "app.orgProfile.noTemplate": "لم يتم إعداد قالب ملف نشط بعد.",
  "app.orgProfile.loadError": "تعذّر تحميل ملف المؤسسة. يُرجى المحاولة مرة أخرى.",
  "app.orgProfile.hero.title": "أخبر Komplyance من أنت. كلما شاركت أكثر، أصبحت تقييماتك ومعالجاتك أكثر تخصيصاً لأعمالك.",
  "app.orgProfile.hero.eyebrow": "لماذا نطلب ذلك",
  "app.orgProfile.hero.dismiss": "إخفاء",
  "app.orgProfile.hero.card1.title": "سياق مؤسستك",
  "app.orgProfile.hero.card1.body": "ثماني فئات يستخدمها Komplyance AI لفهم أعمالك — القطاعات والضوابط والسياسات والأشخاص.",
  "app.orgProfile.hero.card2.title": "مخصّص، لا عام",
  "app.orgProfile.hero.card2.body": "كل تقييم ومعالجة يعكسان نطاقاتك القضائية وقطاعك وضوابطك الحالية — وليس قوالب عامة.",
  "app.orgProfile.hero.card3.title": "ارفع أو املأ يدوياً",
  "app.orgProfile.hero.card3.body": "أسقِط السياسات وسنشغّل الاستخراج بالذكاء الاصطناعي، أو اكتب القيم مباشرة في كل نموذج. يمكنك المزج بين الطريقتين.",
  "app.orgProfile.summary.completion": "اكتمال الملف",
  "app.orgProfile.summary.categoriesApproved": "{{approved}} من {{total}} فئات معتمدة",
  "app.orgProfile.summary.documents": "المستندات المرفوعة",
  "app.orgProfile.summary.viewActivity": "عرض النشاط",
  "app.orgProfile.summary.docBreakdown": "{{approved}} معتمد · {{processing}} قيد المعالجة",
  "app.orgProfile.summary.fieldsFilled": "الحقول المعبأة",
  "app.orgProfile.summary.fieldsRemaining": "{{n}} متبقية",
  "app.orgProfile.summary.reviewsPending": "مراجعات معلّقة",
  "app.orgProfile.summary.reviewAll": "مراجعة الكل",
  "app.orgProfile.summary.reviewsHint": "انقر لفتح مركز المستندات",
  "app.orgProfile.upload.title": "ارفع أي شيء — وسنوجّهه",
  "app.orgProfile.upload.subtitle": "أسقِط الملفات في أي مكان على هذه الصفحة، أو انقر على رفع الملفات للتصفح — سيوجّه Komplyance AI كل ملف ويستخرجه تلقائياً.",
  "app.orgProfile.upload.aiRouted": "توجيه بالذكاء الاصطناعي",
  "app.orgProfile.upload.choose": "اختيار الملفات",
  "app.orgProfile.upload.drop": "أسقِط هنا",
  "app.orgProfile.upload.button": "رفع الملفات",
  "app.orgProfile.upload.dropOverlay": "أسقِط الملفات في أي مكان للرفع",
  "app.orgProfile.upload.dropOverlayHint": "سنصنّف كل ملف ونستخرجه تلقائياً.",
  "app.orgProfile.upload.tray.title": "جارٍ رفع {{count}} ملف",
  "app.orgProfile.upload.extractFailed": "تعذّر بدء الاستخراج. يرجى المحاولة مرة أخرى.",
  "app.orgProfile.upload.retryFailed": "تعذّرت إعادة محاولة التصنيف. يرجى المحاولة مرة أخرى.",
  "app.orgProfile.upload.classification.routedTo": "موجَّه إلى {{category}}",
  "app.orgProfile.upload.classification.valid": "مصدر صالح",
  "app.orgProfile.upload.classification.notValidSource": "ليس مصدرًا صالحًا",
  "app.orgProfile.upload.classification.wontExtract": "لن يتم الاستخراج",
  "app.orgProfile.upload.classification.fieldsPopulated_one": "تم تعبئة حقل واحد",
  "app.orgProfile.upload.classification.fieldsPopulated_other": "تم تعبئة {{count}} حقل",
  "app.orgProfile.upload.classification.fieldsPopulated_zero": "لم يتم تعبئة أي حقل",
  "app.orgProfile.upload.classification.fieldsPopulated_two": "تم تعبئة حقلين",
  "app.orgProfile.upload.classification.fieldsPopulated_few": "تم تعبئة {{count}} حقول",
  "app.orgProfile.upload.classification.fieldsPopulated_many": "تم تعبئة {{count}} حقلاً",
  "app.orgProfile.upload.status.classifying": "جارٍ التصنيف…",
  "app.orgProfile.upload.status.notExtracted": "لم يُستخرج",
  "app.orgProfile.upload.status.extracting": "جارٍ الاستخراج…",
  "app.orgProfile.upload.status.pendingReview": "تم الاستخراج · جاهز للمراجعة",
  "app.orgProfile.upload.status.saved": "محفوظ",
  "app.orgProfile.upload.status.invalid": "مصدر غير صالح",
  "app.orgProfile.upload.status.failed": "فشلت المعالجة",
  "app.orgProfile.upload.uploading": "جارٍ رفع {{fileName}}…",
  "app.orgProfile.upload.uploaded": "تم رفع {{fileName}}",
  "app.orgProfile.upload.failed": "فشل رفع {{fileName}}",
  "app.orgProfile.status.approved": "معتمد",
  "app.orgProfile.status.pendingReview": "بانتظار المراجعة",
  "app.orgProfile.status.processing": "قيد المعالجة",
  "app.orgProfile.status.processingCount": "قيد المعالجة {{done}}/{{total}}",
  "app.orgProfile.status.required": "مطلوب",
  "app.orgProfile.status.fieldCount": "{{filled}}/{{total}} حقل",
  "app.orgProfile.tabs.title": "الفئات",
  "app.orgProfile.tabs.scrollPrev": "الفئات السابقة",
  "app.orgProfile.tabs.scrollNext": "مزيد من الفئات",
  "app.orgProfile.panel.fieldsFilled": "{{filled}} / {{total}} حقول معبأة",
  "app.orgProfile.panel.fieldsFilledSuffix": "/ {{total}} حقول معبأة",
  "app.orgProfile.panel.fieldsNeeded": "{{n}} حقول مطلوبة لتقييمات {{category}} المخصّصة.",
  "app.orgProfile.panel.fieldCount": "{{n}} حقول",
  "app.orgProfile.panel.fieldCountSuffix": "مطلوبة لتقييمات {{category}} المخصّصة.",
  "app.orgProfile.panel.approvedValues": "القيم المعتمدة",
  "app.orgProfile.panel.editableValues": "القيم القابلة للتعديل · انقر للكتابة",
  "app.orgProfile.panel.readOnly": "عرض {{category}} للقراءة فقط · انقر على تعديل الحقول لإجراء التغييرات.",
  "app.orgProfile.panel.editFields": "تعديل الحقول",
  "app.orgProfile.panel.cancel": "إلغاء",
  "app.orgProfile.panel.done": "تم",
  "app.orgProfile.panel.saveChanges": "حفظ التغييرات",
  "app.orgProfile.panel.saving": "جارٍ الحفظ…",
  "app.orgProfile.panel.complete": "اكتملت فئة {{category}} · للعرض فقط",
  "app.orgProfile.panel.completeHint": "{{n}} حقول معتمدة · تُستخدم في كل تقييم لفئة {{category}} من الآن فصاعداً.",
  "app.orgProfile.panel.empty": "لا توجد بيانات بعد — املأ الحقول أدناه، أو ارفع مستندات من رأس الصفحة. سيقوم Komplyance AI بتعبئة الحقول تلقائياً عند وصول مستنداتك.",
  "app.orgProfile.banner.editing": "تعديل {{category}} — يتم التحقق من التغييرات أثناء الكتابة. الحفظ يُنشئ إصداراً جديداً لهذه الفئة؛ وتبقى استشهادات المصدر في مركز المستندات مرتبطة.",
  "app.orgProfile.banner.savingLocked": 'جارٍ حفظ "{{category}}" — التعديل مقفل للحظة. سيُعاد تفعيل زر تعديل الحقول فور اكتمال الحفظ.',
  "app.orgProfile.banner.locked": "يتم حفظ هذه الفئة الآن. يُرجى المحاولة بعد لحظات.",
  "app.orgProfile.banner.saveFailed": "فشل الحفظ. يُرجى المحاولة مرة أخرى.",
  "app.orgProfile.field.required": "مطلوب",
  "app.orgProfile.field.requiredError": "هذا الحقل مطلوب.",
  "app.orgProfile.field.unsaved": "غير محفوظ",
  "app.orgProfile.field.highConfidence": "ثقة عالية",
  "app.orgProfile.field.mediumConfidence": "ثقة متوسطة",
  "app.orgProfile.field.lowConfidence": "منخفضة — تحقّق",
  "app.orgProfile.field.editedByYou": "عدّلته أنت",
  "app.orgProfile.field.notFound": "غير موجود · أضِف يدوياً",
  "app.orgProfile.field.addManually": "أضِف يدوياً",
  "app.orgProfile.field.help.default": "أدخل المعلومات التي يطلبها هذا الحقل. اتركه فارغًا إذا كان لا ينطبق على مؤسستك.",
  "app.orgProfile.field.help.string": "أدخل نصًا قصيرًا — اسمًا أو عنوانًا على سبيل المثال.",
  "app.orgProfile.field.help.textarea": "أدخل إجابة أطول. بضع جمل بأسلوبك الخاص تكفي.",
  "app.orgProfile.field.help.email": "أدخل بريدًا إلكترونيًا، مثل name@company.com.",
  "app.orgProfile.field.help.phone": "أدخل رقم هاتف مع رمز الدولة.",
  "app.orgProfile.field.help.number": "أدخل رقمًا — أرقامًا فقط بدون وحدات أو رموز.",
  "app.orgProfile.field.help.date": "اختر تاريخًا من التقويم.",
  "app.orgProfile.field.help.boolean": "فعّله للإجابة بنعم، وأوقفه للإجابة بلا.",
  "app.orgProfile.field.help.select": "اختر الخيار الأنسب من القائمة.",
  "app.orgProfile.field.help.multiSelect": "اختر كل الخيارات المنطبقة — يمكنك اختيار أكثر من واحد.",
  "app.orgProfile.field.help.list": "أضِف المدخلات واحدًا تلو الآخر. يمكنك إضافة ما تحتاجه.",
  "app.orgProfile.field.help.table": "أضِف صفًا لكل مُدخل واملأ جميع الأعمدة.",
  "app.orgProfile.field.help.reference": "اربط المستند الذي يدعم هذه المعلومة.",
  "app.orgProfile.field.help.file": "ارفع المستند الذي يطلبه هذا الحقل.",
  "app.orgProfile.field.add": "إضافة",
  "app.orgProfile.field.addRow": "إضافة صف",
  "app.orgProfile.field.noItems": "لا عناصر بعد · أضِف يدوياً أو انتظر الاستخراج",
  "app.orgProfile.field.noRows": "لا صفوف بعد · سيقوم الذكاء الاصطناعي بتعبئتها من مستنداتك، أو انقر + إضافة صف أدناه.",
  "app.orgProfile.field.linkArtifact": "ربط مُرفق",
  "app.orgProfile.field.noArtifact": "لا مُرفق مرتبط",
  "app.orgProfile.field.unlink": "إزالة",
  "app.orgProfile.field.removeRow": "إزالة صف",
  "app.orgProfile.field.removeItem": "إزالة",
  "app.orgProfile.field.source": "{{name}} · ص.{{page}}",
  "app.orgProfile.field.yes": "نعم",
  "app.orgProfile.field.no": "لا",
  "app.orgProfile.field.typeBadge.string": "سطر واحد",
  "app.orgProfile.field.typeBadge.textarea": "نص طويل",
  "app.orgProfile.field.typeBadge.email": "بريد إلكتروني",
  "app.orgProfile.field.typeBadge.phone": "هاتف",
  "app.orgProfile.field.typeBadge.number": "رقم",
  "app.orgProfile.field.typeBadge.date": "تاريخ",
  "app.orgProfile.field.typeBadge.boolean": "نعم / لا",
  "app.orgProfile.field.typeBadge.select": "اختيار",
  "app.orgProfile.field.typeBadge.list": "قائمة",
  "app.orgProfile.field.typeBadge.table": "جدول",
  "app.orgProfile.field.typeBadge.reference": "مرجع",
  "app.documentHub.title": "مركز المستندات",
  "app.documentHub.pagination.summary": "صفحة {{page}} من {{totalPages}} · {{totalCount}} في المجموع",
  "app.documentHub.breadcrumb": "مركز المستندات",
  "app.documentHub.fileCount_one": "ملف واحد",
  "app.documentHub.fileCount_other": "{{count}} ملف",
  "app.documentHub.fileCount_zero": "لا توجد ملفات",
  "app.documentHub.fileCount_two": "ملفان",
  "app.documentHub.fileCount_few": "{{count}} ملفات",
  "app.documentHub.fileCount_many": "{{count}} ملفاً",
  "app.documentHub.loadError": "تعذّر تحميل مستنداتك. يرجى المحاولة مرة أخرى.",
  "app.documentHub.allCategories": "كل الفئات",
  "app.documentHub.search": "ابحث في الملفات…",
  "app.documentHub.clearCategory": "مسح",
  "app.documentHub.upload.title": "أسقط المستندات في أي مكان · أو اختر الملفات",
  "app.documentHub.upload.description": "تصنّف Komplyance كل ملف وتقترح فئة ونوع مستند ثم تستخرج الحقول المنظّمة.",
  "app.documentHub.upload.browse": "استعراض",
  "app.documentHub.upload.upload": "رفع",
  "app.documentHub.upload.formats": "PDF · DOCX · XLSX حتى 10 ميغابايت",
  "app.documentHub.empty.title": "لا توجد مستندات بعد",
  "app.documentHub.empty.body": "أسقط ملفًا في الأعلى وستقوم Komplyance بتصنيفه واقتراح فئة ثم استخراج الحقول المنظّمة.",
  "app.documentHub.empty.filtered": "لم يتم العثور على مستندات.",
  "app.documentHub.status.all": "الكل",
  "app.documentHub.status.pendingReview": "بانتظار المراجعة",
  "app.documentHub.status.extracting": "جارٍ الاستخراج",
  "app.documentHub.status.done": "مكتمل",
  "app.documentHub.status.failed": "فشل",
  "app.documentHub.status.irrelevant": "غير ذي صلة",
  "app.documentHub.status.classifying": "جارٍ التصنيف",
  "app.documentHub.status.readyToExtract": "جاهز للاستخراج",
  "app.documentHub.strip.pendingReview": "بانتظار مراجعتك",
  "app.documentHub.strip.extracting": "قيد الاستخراج الآن",
  "app.documentHub.strip.done": "مكتمل",
  "app.documentHub.strip.failed": "فشل",
  "app.documentHub.strip.reviewAll": "مراجعة الكل",
  "app.documentHub.table.document": "المستند",
  "app.documentHub.table.category": "الفئة",
  "app.documentHub.table.status": "الحالة",
  "app.documentHub.table.progress": "التقدّم / التفاصيل",
  "app.documentHub.table.uploaded": "تاريخ الرفع",
  "app.documentHub.table.actions": "إجراءات",
  "app.documentHub.table.uncategorized": "غير مصنّف",
  "app.documentHub.meta.pages_one": "صفحة واحدة",
  "app.documentHub.meta.pages_other": "{{count}} صفحة",
  "app.documentHub.meta.pages_zero": "لا توجد صفحات",
  "app.documentHub.meta.pages_two": "صفحتان",
  "app.documentHub.meta.pages_few": "{{count}} صفحات",
  "app.documentHub.meta.pages_many": "{{count}} صفحة",
  "app.documentHub.meta.uploaded": "رُفع {{when}}",
  "app.documentHub.detail.fields": "{{filled}}/{{total}} حقول",
  "app.documentHub.detail.lowConf_one": "ثقة منخفضة {{count}}",
  "app.documentHub.detail.lowConf_other": "ثقة منخفضة {{count}}",
  "app.documentHub.detail.lowConf_zero": "ثقة منخفضة {{count}}",
  "app.documentHub.detail.lowConf_two": "ثقة منخفضة {{count}}",
  "app.documentHub.detail.lowConf_few": "ثقة منخفضة {{count}}",
  "app.documentHub.detail.lowConf_many": "ثقة منخفضة {{count}}",
  "app.documentHub.detail.classifying": "جارٍ تصنيف المستند…",
  "app.documentHub.detail.readyToExtract": "جاهز للاستخراج",
  "app.documentHub.action.review": "مراجعة",
  "app.documentHub.action.view": "عرض",
  "app.documentHub.action.extract": "استخراج",
  "app.documentHub.action.cancel": "إلغاء",
  "app.documentHub.action.retry": "إعادة المحاولة",
  "app.documentHub.action.reRoute": "إعادة التوجيه",
  "app.documentHub.action.remove": "إزالة",
  "app.documentHub.action.deny": "رفض",
  "app.documentHub.action.delete": "حذف",
  "app.documentHub.action.deletePublished": "لا يمكن حذف المستندات المحفوظة",
  "app.documentHub.toast.extractStarted": "بدأ الاستخراج",
  "app.documentHub.toast.reRouted": "إعادة تصنيف المستند…",
  "app.documentHub.toast.retried": "إعادة المحاولة…",
  "app.documentHub.toast.deleted": "تمت إزالة المستند",
  "app.documentHub.toast.actionFailed": "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
  "app.documentHub.review.breadcrumb": "مراجعة الاستخراج",
  "app.documentHub.review.documentType": "نوع المستند: {{kind}}",
  "app.documentHub.review.sectionTitle": "الحقول المستخرجة",
  "app.documentHub.review.sectionSummary": "{{extracted}} من {{total}} مستخرجة · {{empty}} فارغة",
  "app.documentHub.review.loading": "جارٍ تحميل الاستخراج…",
  "app.documentHub.review.loadError": "تعذّر تحميل هذا الاستخراج. يرجى المحاولة مرة أخرى.",
  "app.documentHub.review.close": "إغلاق",
  "app.documentHub.review.approveSave": "اعتماد وحفظ",
  "app.documentHub.review.saving": "جارٍ الحفظ…",
  "app.documentHub.review.saved": "تم حفظ الاستخراج في ملفك",
  "app.documentHub.review.saveGate_one": "ما زال حقل واحد منخفض الثقة بحاجة إلى المراجعة. عدّله أو حلّه أو تحقّق منه لتفعيل الاعتماد والحفظ.",
  "app.documentHub.review.saveGate_other": "ما زال {{count}} حقل منخفض الثقة بحاجة إلى المراجعة. عدّلها أو حلّها أو تحقّق منها لتفعيل الاعتماد والحفظ.",
  "app.documentHub.review.saveGate_zero": "لا توجد حقول منخفضة الثقة بحاجة إلى المراجعة.",
  "app.documentHub.review.saveGate_two": "ما زال حقلان منخفضا الثقة بحاجة إلى المراجعة. عدّلهما أو حلّهما أو تحقّق منهما لتفعيل الاعتماد والحفظ.",
  "app.documentHub.review.saveGate_few": "ما زالت {{count}} حقول منخفضة الثقة بحاجة إلى المراجعة. عدّلها أو حلّها أو تحقّق منها لتفعيل الاعتماد والحفظ.",
  "app.documentHub.review.saveGate_many": "ما زال {{count}} حقلاً منخفض الثقة بحاجة إلى المراجعة. عدّلها أو حلّها أو تحقّق منها لتفعيل الاعتماد والحفظ.",
  "app.documentHub.review.saveConflict": "يتم حفظ هذه الفئة حاليًا. حاول مرة أخرى بعد لحظات.",
  "app.documentHub.review.saveError": "فشل الحفظ. يرجى المحاولة مرة أخرى.",
  "app.documentHub.review.readOnlyTitle": "الاستخراج (محفوظ)",
  "app.documentHub.review.stat.extracted": "مستخرَج",
  "app.documentHub.review.stat.high": "عالية",
  "app.documentHub.review.stat.medium": "متوسطة",
  "app.documentHub.review.stat.low": "منخفضة",
  "app.documentHub.review.stat.empty": "فارغ",
  "app.documentHub.review.stat.youEdited": "عدّلت",
  "app.documentHub.review.stat.needsAttention": "بحاجة إلى انتباه",
  "app.documentHub.review.stat.rejected": "مرفوضة",
  "app.documentHub.review.stat.reviewLink": "مراجعة",
  "app.documentHub.review.filter.allFields": "كل الحقول",
  "app.documentHub.review.filter.needAttention_one": "عرض {{count}} بحاجة إلى انتباه",
  "app.documentHub.review.filter.needAttention_other": "عرض {{count}} بحاجة إلى انتباه",
  "app.documentHub.review.filter.needAttention_zero": "عرض {{count}} بحاجة إلى انتباه",
  "app.documentHub.review.filter.needAttention_two": "عرض {{count}} بحاجة إلى انتباه",
  "app.documentHub.review.filter.needAttention_few": "عرض {{count}} بحاجة إلى انتباه",
  "app.documentHub.review.filter.needAttention_many": "عرض {{count}} بحاجة إلى انتباه",
  "app.documentHub.review.legend.title": "ماذا تعني هذه الإجراءات",
  "app.documentHub.review.legend.reject.label": "رفض",
  "app.documentHub.review.legend.reject.description": "القيمة غير مقبولة — يبقى الحقل فارغًا ما لم تُدخل بديلاً.",
  "app.documentHub.review.legend.addManually.label": "أضِف يدوياً",
  "app.documentHub.review.legend.addManually.description": "اكتب قيمتك الخاصة، أو استبدل القيمة المستخرجة.",
  "app.documentHub.review.field.verify": "تحقّق",
  "app.documentHub.review.field.verifiedByYou": "تم التحقق منك",
  "app.documentHub.review.field.youEdited": "عدّلته",
  "app.documentHub.review.field.aiExtracted": "مُستخرَج بالذكاء الاصطناعي",
  "app.documentHub.review.field.changed": "اقترح الذكاء الاصطناعي {{value}} · لقد غيّرته",
  "app.documentHub.review.field.rowsSummary": "{{count}} صفوف",
  "app.documentHub.review.field.source": "ص.{{page}}: «{{quote}}»",
  "app.documentHub.review.field.noCitation": "لم يُعثر على اقتباس",
  "app.documentHub.review.field.needsReview": "بحاجة إلى مراجعة",
  "app.documentHub.review.field.empty": "(فارغ)",
  "app.documentHub.review.field.notExtracted": "لم يتم استخراجه",
  "app.documentHub.review.field.reject": "رفض",
  "app.documentHub.review.field.nothingToReject": "لا شيء لرفضه — هذا الحقل لم يتم استخراجه.",
  "app.documentHub.review.field.restore": "استعادة",
  "app.documentHub.review.field.rejected": "مرفوض",
  "app.documentHub.review.validation.maxLength": "يجب ألا يزيد عن {{max}} حرفًا.",
  "app.documentHub.review.validation.minLength": "يجب ألا يقل عن {{min}} حرفًا.",
  "app.documentHub.review.validation.pattern": "تنسيق غير صالح.",
  "app.documentHub.review.validation.email": "أدخل بريدًا إلكترونيًا صالحًا.",
  "app.documentHub.review.validation.number": "أدخل رقمًا صالحًا.",
  "app.documentHub.review.validation.integer": "يجب أن يكون رقمًا صحيحًا.",
  "app.documentHub.review.validation.min": "يجب أن يكون {{min}} أو أكثر.",
  "app.documentHub.review.validation.max": "يجب أن يكون {{max}} أو أقل.",
  "app.documentHub.review.validation.maxItems": "اختر {{max}} أو أقل.",
  "app.documentHub.review.validation.sourceRequired": "يلزم وجود مصدر (رابط أو ملاحظة).",
  "app.documentHub.review.validation.requiredCell": "هذا الحقل مطلوب.",
  "app.documentHub.review.validation.cell": "الصف {{row}} · {{column}}: {{message}}",
  "app.documentHub.review.validationGate": "صحّح الحقول المميّزة قبل الحفظ.",
  "app.documentHub.classif.confidence.high": "ثقة عالية",
  "app.documentHub.classif.confidence.medium": "ثقة متوسطة",
  "app.documentHub.classif.confidence.low": "ثقة منخفضة",
  "app.orgProfile.inFlight.title_one": "مستند واحد قيد المعالجة",
  "app.orgProfile.inFlight.title_other": "{{count}} مستند قيد المعالجة",
  "app.orgProfile.inFlight.title_zero": "لا توجد مستندات قيد المعالجة",
  "app.orgProfile.inFlight.title_two": "مستندان قيد المعالجة",
  "app.orgProfile.inFlight.title_few": "{{count}} مستندات قيد المعالجة",
  "app.orgProfile.inFlight.title_many": "{{count}} مستنداً قيد المعالجة",
  "app.orgProfile.inFlight.classifying": "جارٍ التصنيف…",
  "app.orgProfile.inFlight.extracting": "جارٍ الاستخراج…",
  "app.orgProfile.inFlight.queued": "في قائمة الانتظار",
  "app.orgProfile.inFlight.readyToExtract": "جاهز للاستخراج",
  "app.orgProfile.inFlight.extracted": "جاهز للمراجعة",
  "app.orgProfile.inFlight.viewAll": "عرض كل المستندات",
  "app.orgProfile.inFlight.irrelevant": "غير ذي صلة",
  "app.orgProfile.inFlight.remove": "إزالة المستند",
  "app.orgProfile.inFlight.removeFailed": "تعذّر إزالة المستند — حاول مرة أخرى",
  "app.orgProfile.inFlight.new": "جديد",
  "app.orgProfile.inFlight.reviewHint": "اضغط للمراجعة",
  "app.orgProfile.inFlight.extract": "استخراج",
  "app.orgProfile.inFlight.extractAll": "استخراج الكل ({{count}})",
  "app.orgProfile.inFlight.viewDocuments": "عرض المستندات",
  "app.orgProfile.inFlight.extractionProgress": "{{done}} من {{total}} تم استخراجها",
  "app.orgProfile.inFlight.extractionInProgress": "الاستخراج جارٍ",
  "app.orgProfile.field.uploadDocument": "رفع مستند",
  "app.orgProfile.field.uploading": "جارٍ الرفع…",
  "app.orgProfile.field.uploadFailed": "فشل الرفع — حاول مرة أخرى",
  "app.orgProfile.field.changeDoc": "تغيير المستند",
  "app.orgProfile.field.addAnotherDoc": "إضافة مستند آخر",
  "app.orgProfile.field.pendingSave": "في انتظار الحفظ",
  "app.orgProfile.field.confirmed": "محفوظ",
  "app.orgProfile.field.discard": "تجاهل",
  "app.orgProfile.field.discardFailed": "تعذّر التجاهل — حاول مرة أخرى",
  "app.orgProfile.field.fileTooLarge": "حجم الملف يتجاوز الحد المسموح {{maxMb}} ميغابايت",
  "app.orgProfile.field.fileTypeNotAllowed": "نوع الملف غير مسموح به. المقبول: {{formats}}",
  "app.orgProfile.field.maxFilesReached": "الحد الأقصى {{count}} ملف لهذا الحقل",
  "app.orgProfile.field.maxFileSize": "الحد الأقصى {{maxMb}} ميغابايت",
  "app.orgProfile.field.acceptedFormats": "المقبول: {{formats}}",
  "app.orgProfile.field.noReference": "لم تتم إضافة مرجع",
  "app.orgProfile.field.referenceText": "نص المرجع",
  "app.orgProfile.field.sourceUrl": "رابط المصدر",
  "app.orgProfile.field.sourceNote": "ملاحظة المصدر",
  "app.orgProfile.field.sourceOptional": "المصدر (اختياري)",
  "app.orgProfile.field.sourceRequiredLabel": "المصدر (مطلوب)",
  "app.layout.header.organizationHub": "الملف التنظيمي",
  "app.orgProfile.nudge.badge.tooltip": "اكتمل ملف المؤسسة بنسبة {{percent}}%",
  "app.orgProfile.nudge.badge.completeTooltip": "اكتمل ملف المؤسسة",
  "app.orgProfile.nudge.banner.title": "اكتمل ملف المؤسسة بنسبة {{percent}}%.",
  "app.orgProfile.nudge.banner.body": "أكمله لتحسين دقة تقييم الذكاء الاصطناعي عبر جميع المجالات.",
  "app.orgProfile.nudge.banner.cta": "إكمال الملف",
  "app.orgProfile.nudge.modal.title": "ملف مؤسستك فارغ",
  "app.orgProfile.nudge.modal.body": "إكماله يساعد الذكاء الاصطناعي على فهم سياقك وتقديم تقييمات أكثر دقة لفجوات الامتثال.",
  "app.orgProfile.nudge.modal.subBody": "حقول مثل الاسم القانوني للكيان وبيانات مسؤول حماية البيانات وفئات البيانات يُرجع إليها في كل مجال من مجالات التقييم.",
  "app.orgProfile.nudge.modal.complete": "انتقل إلى المحور التنظيمي",
  "app.orgProfile.nudge.modal.skip": "تخطٍّ الآن",
  "app.orgProfile.nudge.modal.skippedWarning": "قد تقل دقة التقييم بدون ملف مؤسستك. يمكنك إكماله في أي وقت من المحور التنظيمي.",
  "app.orgProfile.nudge.tooltip.greeting": "مرحبًا بعودتك!",
  "app.orgProfile.nudge.tooltip.body": "اكتمل ملف مؤسستك بنسبة {{percent}}%. إكماله يمنح الذكاء الاصطناعي السياق اللازم لإنشاء تقييمات أكثر دقة.",
  "app.orgProfile.nudge.tooltip.complete": "إكمال الملف",
  "app.orgProfile.nudge.tooltip.later": "لاحقًا",
  "app.orgProfile.nudge.domain.missingTitle": "حقول مؤسسية ناقصة لهذا المجال ({{missing}})",
  "app.orgProfile.nudge.domain.completeTitle": "ملف المؤسسة مكتمل لهذا المجال",
  "app.orgProfile.nudge.domain.cta": "أكمل في المحور التنظيمي",
  "app.orgProfile.nudge.domain.showMore": "عرض {{hidden}} المزيد",
  "app.orgProfile.nudge.domain.showLess": "عرض أقل",
  "app.admin.badge": "مشرف",
  "app.admin.panelTitle": "لوحة إدارة النظام",
  "app.admin.queue.healthy": "قائمة المعالجة: سليمة",
  "app.admin.queue.degraded": "قائمة المعالجة: متعثرة",
  "app.admin.signOut": "تسجيل الخروج",
  "app.admin.role.platformAdmin": "مشرف المنصة",
  "app.admin.elevated.title": "جلسة صلاحيات مرتفعة",
  "app.admin.elevated.body": "تم تجاوز عزل بيانات المستأجرين.",
  "app.admin.nav.platform": "المنصة",
  "app.admin.nav.dashboard": "الرئيسية",
  "app.admin.nav.organizations": "المنشآت",
  "app.admin.nav.users": "المستخدمون",
  "app.admin.nav.demoRequests": "طلبات العرض التوضيحي",
  "app.admin.nav.features": "الميزات",
  "app.admin.nav.adminPanel": "لوحة الإدارة",
  "app.admin.nav.backToApp": "العودة إلى التطبيق",
  "app.admin.demo.title": "طلبات العرض التوضيحي",
  "app.admin.demo.subtitle": "الأشخاص الذين طلبوا عرضاً توضيحياً للمنصة.",
  "app.admin.demo.empty": "لا توجد طلبات عرض توضيحي",
  "app.admin.demo.error": "تعذّر تحميل طلبات العرض التوضيحي. حاول مرة أخرى.",
  "app.admin.demo.filter.all": "كل الوقت",
  "app.admin.demo.filter.day": "آخر ٢٤ ساعة",
  "app.admin.demo.filter.week": "آخر ٧ أيام",
  "app.admin.demo.filter.month": "آخر ٣٠ يوماً",
  "app.admin.demo.table.requester": "مقدّم الطلب",
  "app.admin.demo.table.email": "البريد الإلكتروني للعمل",
  "app.admin.demo.table.company": "الشركة",
  "app.admin.demo.table.jobTitle": "المسمى الوظيفي",
  "app.admin.demo.table.requested": "تاريخ الطلب",
  "app.admin.demo.detail.title": "طلب عرض توضيحي",
  "app.admin.demo.field.companySize": "حجم الشركة",
  "app.admin.demo.field.industry": "القطاع",
  "app.admin.demo.field.phone": "الهاتف",
  "app.admin.demo.field.message": "الرسالة",
  "app.admin.features.title": "ميزات النظام",
  "app.admin.features.subtitle": "قم بتفعيل ميزة أو إيقافها في هذه البيئة، مع إمكانية تخصيص ذلك لكل منشأة.",
  "app.admin.features.globalDescription": "الإعداد الافتراضي لهذه البيئة. كل منشأة بلا تخصيص تتبع هذا الإعداد.",
  "app.admin.features.on": "مفعّلة",
  "app.admin.features.off": "متوقفة",
  "app.admin.features.overridesTitle": "تخصيصات المنشآت",
  "app.admin.features.noOverrides": "لا توجد تخصيصات — كل المنشآت تتبع الإعداد الافتراضي أعلاه.",
  "app.admin.features.forceOn": "تفعيل قسري",
  "app.admin.features.forceOff": "إيقاف قسري",
  "app.admin.features.forcedOn": "مفعّلة قسرًا",
  "app.admin.features.forcedOff": "متوقفة قسرًا",
  "app.admin.features.clearOverride": "إزالة التخصيص (اتباع الإعداد الافتراضي)",
  "app.admin.features.loadError": "تعذّر تحميل ميزات النظام. حاول مرة أخرى.",
  "app.admin.features.update.success": "تم تحديث الميزة.",
  "app.admin.features.update.error": "تعذّر تحديث الميزة. حاول مرة أخرى.",
  "app.admin.features.addOverride.searchPlaceholder": "ابحث عن منشأة…",
  "app.admin.features.addOverride.action": "إضافة تخصيص",
  "app.admin.features.flags.remediation": "معالجة المستندات بالذكاء الاصطناعي",
  "app.admin.features.tenantTab.inherit": "اتباع الافتراضي",
  "app.admin.features.tenantTab.inheritsFrom": "تتبع الإعداد الافتراضي للبيئة ({{state}}) ما لم يتم تخصيصها هنا.",
  "app.admin.status.active": "نشطة",
  "app.admin.status.processing": "قيد المعالجة",
  "app.admin.status.provisioning": "قيد التزويد",
  "app.admin.status.suspended": "موقوفة",
  "app.admin.status.failed": "فشلت",
  "app.admin.status.draft": "مسودة",
  "app.admin.status.submitted": "مُرسلة",
  "app.admin.status.completed": "مكتملة",
  "app.admin.status.valid": "صالحة",
  "app.admin.status.invalid": "غير صالحة",
  "app.admin.status.unknown": "غير معروفة",
  "app.admin.confidence.high": "مرتفعة",
  "app.admin.confidence.medium": "متوسطة",
  "app.admin.confidence.low": "منخفضة",
  "app.admin.dashboard.title": "نظرة تشغيلية عامة",
  "app.admin.dashboard.subtitle": "التزويد وتوزيع موارد الذكاء الاصطناعي وصحة المعالجة عبر جميع المستأجرين.",
  "app.admin.dashboard.stats.activeOrgs": "المنشآت النشطة",
  "app.admin.dashboard.stats.activeOrgsSub": "من أصل {{n}} منشأة مزوّدة",
  "app.admin.dashboard.stats.users": "المستخدمون المزوّدون",
  "app.admin.dashboard.stats.usersSub": "عبر جميع نطاقات المستأجرين",
  "app.admin.dashboard.stats.inFlight": "عمليات قيد التنفيذ",
  "app.admin.dashboard.stats.inFlightSub": "{{n}} إضافية في قائمة الانتظار",
  "app.admin.dashboard.stats.failed": "فشل (٢٤ ساعة)",
  "app.admin.dashboard.stats.failedSub": "تتطلب تدخّل المشرف",
  "app.admin.dashboard.queue.title": "قائمة المعالجة العامة",
  "app.admin.dashboard.queue.subtitle": "معالجة الذكاء الاصطناعي الحيّة عبر جميع المستأجرين",
  "app.admin.dashboard.queue.processing": "قيد المعالجة",
  "app.admin.dashboard.queue.queued": "في الانتظار",
  "app.admin.dashboard.queue.completedToday": "اكتملت اليوم",
  "app.admin.dashboard.queue.failed": "فشلت",
  "app.admin.dashboard.queue.inFlightRuns": "العمليات الجارية",
  "app.admin.dashboard.queue.empty": "لا توجد عمليات قيد التنفيذ حالياً",
  "app.admin.dashboard.queue.documents": "{{n}} مستند",
  "app.admin.dashboard.incidents.title": "تتطلب تدخّلاً",
  "app.admin.dashboard.incidents.subtitle": "عمليات فاشلة أو متعثرة",
  "app.admin.dashboard.incidents.open": "{{n}} مفتوحة",
  "app.admin.dashboard.incidents.empty": "لا توجد حوادث — جميع العمليات سليمة",
  "app.admin.dashboard.incidents.openOrg": "فتح المنشأة",
  "app.admin.orgs.title": "مركز إدارة المنشآت",
  "app.admin.orgs.subtitle": "كل منشأة مزوّدة. اختر صفاً للاطلاع على ملفها ومستخدميها وتقييماتها ومستنداتها.",
  "app.admin.orgs.provision": "تزويد منشأة",
  "app.admin.orgs.search": "ابحث عن منشأة أو معرّف مستأجر…",
  "app.admin.orgs.count": "{{shown}} من {{total}}",
  "app.admin.orgs.table.organization": "المنشأة",
  "app.admin.orgs.table.tenantId": "معرّف المستأجر",
  "app.admin.orgs.table.sector": "القطاع",
  "app.admin.orgs.table.assessments": "التقييمات",
  "app.admin.orgs.table.status": "الحالة",
  "app.admin.orgs.table.created": "تاريخ الإنشاء",
  "app.admin.orgs.empty": "لا توجد منشآت",
  "app.admin.detail.back": "العودة إلى المنشآت",
  "app.admin.detail.membersCount": "{{n}} مستخدم",
  "app.admin.detail.assessmentsCount": "{{n}} تقييم",
  "app.admin.detail.tabs.profile": "الملف",
  "app.admin.detail.tabs.orgDetails": "تفاصيل المنشأة",
  "app.admin.detail.tabs.compliance": "ملف الامتثال",
  "app.admin.detail.tabs.users": "المستخدمون",
  "app.admin.detail.tabs.assessments": "التقييمات",
  "app.admin.detail.tabs.documents": "المستندات",
  "app.admin.detail.tabs.features": "الميزات",
  "app.admin.detail.compliance.empty": "لا توجد فئات لملف الامتثال لهذه المنشأة بعد.",
  "app.admin.detail.orgDetails.slug": "المعرّف المختصر للمستأجر",
  "app.admin.detail.orgDetails.slugHint": "المعرّف المختصر غير قابل للتعديل — فهو يحدد المستأجر في رموز المصادقة والنطاقات.",
  "app.admin.detail.orgDetails.displayName": "الاسم النظامي للكيان",
  "app.admin.detail.orgDetails.email": "البريد الإلكتروني الأساسي",
  "app.admin.detail.orgDetails.location": "الموقع",
  "app.admin.detail.orgDetails.sector": "القطاع / المجال",
  "app.admin.detail.orgDetails.dpo": "مسؤول حماية البيانات (DPO)",
  "app.admin.detail.orgDetails.commercialReg": "السجل التجاري",
  "app.admin.detail.orgDetails.edit": "تعديل",
  "app.admin.detail.orgDetails.cancel": "إلغاء",
  "app.admin.detail.orgDetails.save": "حفظ التغييرات",
  "app.admin.detail.orgDetails.validation.required": "هذا الحقل مطلوب",
  "app.admin.detail.orgDetails.createdAt": "تاريخ الإنشاء",
  "app.admin.detail.profile.legalName": "الاسم النظامي للكيان",
  "app.admin.detail.profile.tenantId": "معرّف المستأجر",
  "app.admin.detail.profile.commercialReg": "السجل التجاري",
  "app.admin.detail.profile.sector": "القطاع / المجال",
  "app.admin.detail.profile.location": "الموقع",
  "app.admin.detail.profile.dpo": "مسؤول حماية البيانات (DPO)",
  "app.admin.detail.profile.contact": "جهة الاتصال الرئيسية",
  "app.admin.detail.profile.members": "الأعضاء",
  "app.admin.detail.profile.domains": "النطاقات الموثّقة",
  "app.admin.detail.usersTab.addUser": "إضافة مستخدم",
  "app.admin.detail.usersTab.revoke": "إلغاء الوصول",
  "app.admin.detail.usersTab.search": "ابحث عن المستخدمين بالاسم أو البريد الإلكتروني…",
  "app.admin.detail.usersTab.empty": "لا يوجد أعضاء في هذه المنشأة",
  "app.admin.detail.usersTab.noMatches": "لا يوجد مستخدمون مطابقون لبحثك",
  "app.admin.detail.usersTab.table.user": "المستخدم",
  "app.admin.detail.usersTab.table.email": "البريد الإلكتروني",
  "app.admin.detail.usersTab.table.username": "اسم المستخدم",
  "app.admin.detail.usersTab.table.status": "الحالة",
  "app.admin.detail.usersTab.table.actions": "إجراءات",
  "app.admin.detail.usersTab.revoke.success": "تم إلغاء الوصول",
  "app.admin.detail.usersTab.revoke.error": "تعذّر إلغاء الوصول",
  "app.admin.detail.assessTab.table.id": "التقييم",
  "app.admin.detail.assessTab.table.version": "الإصدار",
  "app.admin.detail.assessTab.table.status": "الحالة",
  "app.admin.detail.assessTab.table.documents": "المستندات",
  "app.admin.detail.assessTab.table.completed": "اكتمل في",
  "app.admin.detail.assessTab.table.updated": "آخر تحديث",
  "app.admin.detail.assessTab.latest": "الأحدث",
  "app.admin.detail.assessTab.empty": "لا توجد تقييمات لهذا المستأجر",
  "app.admin.detail.assessTab.versionsCount": "{{n}} إصدارات",
  "app.admin.detail.assessTab.viewDocuments": "عرض المستندات",
  "app.admin.detail.assessTab.documentsDialog.title": "مستندات التقييم",
  "app.admin.detail.assessTab.documentsDialog.subtitle": "الإصدار {{version}} · المستندات المرفقة",
  "app.admin.detail.assessTab.documentsDialog.empty": "لا توجد مستندات لهذا التقييم",
  "app.admin.detail.assessTab.documentsDialog.downloadAll": "تنزيل الكل (ZIP)",
  "app.admin.detail.assessTab.tabs.documents": "المستندات",
  "app.admin.detail.assessTab.tabs.results": "النتائج",
  "app.admin.detail.assessTab.downloadReport": "تنزيل التقرير",
  "app.admin.detail.assessTab.downloadReport.error": "تعذّر تنزيل التقرير",
  "app.admin.detail.assessTab.results.unavailable": "نتائج هذا التقييم غير متاحة بعد.",
  "app.admin.detail.docsTab.download": "تنزيل",
  "app.admin.detail.docsTab.download.error": "فشل تنزيل المستند",
  "app.admin.detail.docsTab.downloadAll.error": "فشل تنزيل المستندات",
  "app.admin.detail.docsTab.table.file": "الملف",
  "app.admin.detail.docsTab.table.source": "المصدر",
  "app.admin.detail.docsTab.table.classification": "التصنيف",
  "app.admin.detail.docsTab.table.confidence": "مستوى الثقة",
  "app.admin.detail.docsTab.table.size": "الحجم",
  "app.admin.detail.docsTab.table.actions": "إجراءات",
  "app.admin.detail.docsTab.empty": "لا توجد مستندات لهذا المستأجر",
  "app.admin.detail.docsTab.inspect": "عرض البيانات الوصفية",
  "app.admin.users.title": "إدارة المستخدمين",
  "app.admin.users.subtitle": "جميع المستخدمين عبر نطاقات المستأجرين. امنح أو اسحب صلاحية مشرف المنصة، أو أجبِر إعادة المصادقة.",
  "app.admin.users.search": "ابحث عن مستخدم بالاسم أو البريد…",
  "app.admin.users.empty": "لا يوجد مستخدمون",
  "app.admin.users.cancel": "إلغاء",
  "app.admin.users.table.user": "المستخدم",
  "app.admin.users.table.email": "البريد الإلكتروني",
  "app.admin.users.table.role": "دور المنصة",
  "app.admin.users.table.status": "الحالة",
  "app.admin.users.table.created": "تاريخ الإنشاء",
  "app.admin.users.table.actions": "إجراءات",
  "app.admin.users.platformAdmin": "مشرف المنصة",
  "app.admin.users.tenantUser": "مستخدم مستأجر",
  "app.admin.users.grant": "منح صلاحية المشرف",
  "app.admin.users.revoke": "سحب صلاحية المشرف",
  "app.admin.users.logout": "إنهاء الجلسات",
  "app.admin.users.grant.success": "تم منح صلاحية مشرف المنصة",
  "app.admin.users.grant.error": "تعذّر منح صلاحية مشرف المنصة",
  "app.admin.users.revoke.success": "تم سحب صلاحية مشرف المنصة",
  "app.admin.users.revoke.error": "تعذّر سحب صلاحية مشرف المنصة",
  "app.admin.users.logout.success": "تم إنهاء جلسات المستخدم",
  "app.admin.users.logout.error": "تعذّر إنهاء الجلسات",
  "app.admin.users.grantConfirm.title": "منح صلاحية مشرف المنصة؟",
  "app.admin.users.grantConfirm.body": "منح {{name}} صلاحية مشرف منصة كاملة عبر جميع المستأجرين؟",
  "app.admin.users.revokeConfirm.title": "سحب صلاحية مشرف المنصة؟",
  "app.admin.users.revokeConfirm.body": "سحب صلاحية مشرف المنصة من {{name}}؟",
  "app.admin.users.logoutConfirm.title": "إنهاء الجلسات؟",
  "app.admin.users.logoutConfirm.body": "إبطال جميع الجلسات النشطة لـ {{name}}؟ سيحتاج إلى تسجيل الدخول مجدداً.",
  "app.admin.provision.title": "تزويد منشأة",
  "app.admin.provision.subtitle": "يسجّل مستأجراً جديداً ويهيّئ قسم العزل الخاص به.",
  "app.admin.provision.displayName": "الاسم النظامي للكيان",
  "app.admin.provision.displayNamePlaceholder": "مثال: شركة الدمام للطاقة",
  "app.admin.provision.slug": "معرّف المستأجر",
  "app.admin.provision.slugPlaceholder": "tenant-id",
  "app.admin.provision.slugHint": "أحرف إنجليزية صغيرة وأرقام وشرطات فقط.",
  "app.admin.provision.email": "البريد الإلكتروني لجهة الاتصال",
  "app.admin.provision.emailPlaceholder": "dpo@company.sa",
  "app.admin.provision.sector": "القطاع",
  "app.admin.provision.location": "الموقع",
  "app.admin.provision.locationPlaceholder": "مثال: الرياض، المملكة العربية السعودية",
  "app.admin.provision.note": "عند الإرسال تُسجَّل المنشأة ويُطبَّق قالب كتالوج نظام حماية البيانات ويُهيّأ قسم العزل الآمن.",
  "app.admin.provision.cancel": "إلغاء",
  "app.admin.provision.submit": "تزويد المستأجر",
  "app.admin.provision.success": "تم تزويد المنشأة",
  "app.admin.provision.error": "تعذّر تزويد المنشأة",
  "app.admin.provision.validation.required": "هذا الحقل مطلوب",
  "app.admin.provision.validation.slug": "استخدم أحرفاً إنجليزية صغيرة وأرقاماً وشرطات فقط",
  "app.admin.addUser.title": "إضافة مستخدم",
  "app.admin.addUser.subtitle": "ينشئ مستخدماً مرتبطاً بـ {{tenant}}",
  "app.admin.addUser.firstName": "الاسم الأول",
  "app.admin.addUser.lastName": "اسم العائلة",
  "app.admin.addUser.email": "البريد الإلكتروني",
  "app.admin.addUser.emailHint": "تُرسَل دعوة تتضمّن رابطاً لتعيين كلمة المرور.",
  "app.admin.addUser.role": "الدور",
  "app.admin.addUser.roles.Manager": "مدير",
  "app.admin.addUser.roles.Submitter": "مُدخِل",
  "app.admin.addUser.roles.Viewer": "مُطّلِع",
  "app.admin.addUser.note": "ينشئ المستخدم ويضبط سمة المستأجر لديه ليتمكّن من تسجيل الدخول إلى هذه المنشأة.",
  "app.admin.addUser.cancel": "إلغاء",
  "app.admin.addUser.submit": "إنشاء المستخدم",
  "app.admin.addUser.success": "تم إنشاء المستخدم",
  "app.admin.addUser.error": "تعذّر إنشاء المستخدم",
  "app.admin.editTenant.title": "تعديل المنشأة",
  "app.admin.editTenant.subtitle": "تحديث {{tenant}}",
  "app.admin.editTenant.slug": "معرّف المستأجر",
  "app.admin.editTenant.slugHint": "المعرّف جزء من هوية تسجيل الدخول ولا يمكن تغييره.",
  "app.admin.editTenant.displayName": "الاسم المعروض",
  "app.admin.editTenant.email": "البريد الإلكتروني للتواصل",
  "app.admin.editTenant.sector": "القطاع",
  "app.admin.editTenant.dpo": "مسؤول حماية البيانات",
  "app.admin.editTenant.commercialReg": "السجل التجاري",
  "app.admin.editTenant.validation.required": "هذا الحقل مطلوب",
  "app.admin.editTenant.cancel": "إلغاء",
  "app.admin.editTenant.submit": "حفظ التغييرات",
  "app.admin.editTenant.success": "تم تحديث المنشأة",
  "app.admin.editTenant.error": "تعذّر تحديث المنشأة",
  "app.admin.editUser.title": "تعديل المستخدم",
  "app.admin.editUser.subtitle": "تحديث ملف هذا المستخدم",
  "app.admin.editUser.firstName": "الاسم الأول",
  "app.admin.editUser.lastName": "اسم العائلة",
  "app.admin.editUser.email": "البريد الإلكتروني",
  "app.admin.editUser.enabled": "الحساب مُفعّل",
  "app.admin.editUser.cancel": "إلغاء",
  "app.admin.editUser.submit": "حفظ التغييرات",
  "app.admin.editUser.success": "تم تحديث المستخدم",
  "app.admin.editUser.error": "تعذّر تحديث المستخدم",
  "app.admin.setPassword.title": "تعيين كلمة المرور",
  "app.admin.setPassword.subtitle": "لـ {{user}}",
  "app.admin.setPassword.password": "كلمة المرور الجديدة",
  "app.admin.setPassword.hint": "‏{{n}} أحرف على الأقل.",
  "app.admin.setPassword.validation.minLength": "يجب ألّا تقل كلمة المرور عن {{n}} أحرف",
  "app.admin.setPassword.temporary": "مؤقتة",
  "app.admin.setPassword.temporaryOn": "سيُطلب من المستخدم تعيين كلمة مرور جديدة عند تسجيل الدخول التالي.",
  "app.admin.setPassword.temporaryOff": "كلمة المرور دائمة؛ ولن يُطلب من المستخدم تغييرها.",
  "app.admin.setPassword.cancel": "إلغاء",
  "app.admin.setPassword.submit": "تعيين كلمة المرور",
  "app.admin.setPassword.success": "تم تحديث كلمة المرور",
  "app.admin.setPassword.error": "تعذّر تعيين كلمة المرور",
  "app.admin.metadata.title": "البيانات الوصفية للتصنيف",
  "chat.input.deepResearchLabel": "بحذ معمّق",
  "chat.input.deepResearchHint": "يبحذ في كامل مدوّنة PDPL وفي الأدلة التي رفعتها. أبطأ، لكنه يوثّق كل مصدر.",
  "chat.input.deepResearchOnNote": "البحذ المعمّق مفعّل — ستوثّق الإجابات مصادرها",
  "chat.input.deepPlaceholder": "اطرح سؤالًا أعمق…",
  "chat.new.form.deepPlaceholder": "اطرح سؤالًا أعمق عن نزام PDPL…",
  "chat.header.rename": "إعادة تسمية المحادثة",
  "components.copyButton.copy": "نسخ الإجابة",
  "chat.attachment.remove": "إزالة المرفق",
  "chat.attachment.cancelUpload": "إلغاء الرفع",
  "chat.attachment.clearAll": "مسح الكل",
  "chat.attachment.moreCount": "+{{count}} أخرى",
  "chat.input.multiDocumentsPlaceholder": "اسأل عن هذه المستندات ({{count}})…",
  "chat.new.attachedNote": "يتم تحليل المستندات المرفقة مع سؤالك الأول",
  "app.remediation.nav.title": "المعالجة",
  "app.remediation.breadcrumb": "المعالجة",
  "app.remediation.status.pending": "في الانتظار",
  "app.remediation.status.processing": "جارٍ الإنشاء",
  "app.remediation.status.ready_for_review": "جاهز للمراجعة",
  "app.remediation.status.finalizing": "جارٍ الإنهاء",
  "app.remediation.status.completed": "مكتمل",
  "app.remediation.status.discarded": "ملغى",
  "app.remediation.status.failed": "فشل",
  "app.remediation.itemStatus.pending": "في الانتظار",
  "app.remediation.itemStatus.processing": "قيد التنفيذ",
  "app.remediation.itemStatus.review_pending": "بحاجة إلى مراجعة",
  "app.remediation.itemStatus.accepted": "مقبول",
  "app.remediation.itemStatus.rejected": "مرفوض",
  "app.remediation.itemStatus.no_changes": "لا توجد تغييرات",
  "app.remediation.itemStatus.failed": "فشل",
  "app.remediation.itemType.GENERATE": "مستند جديد",
  "app.remediation.itemType.REMEDIATE": "تم تحسينه",
  "app.remediation.toast.startFailed": "تعذر بدء المعالجة. يرجى المحاولة مرة أخرى.",
  "app.remediation.toast.started": "بدأت المعالجة",
  "app.remediation.toast.reviewFailed": "تعذر حفظ قرارك. يرجى المحاولة مرة أخرى.",
  "app.remediation.toast.finalizeFailed": "تعذر إنهاء هذه العملية. يرجى المحاولة مرة أخرى.",
  "app.remediation.toast.finalizeStarted": "جارٍ الإنهاء — نقوم بتجهيز مستنداتك",
  "app.remediation.toast.addFailed": "تعذّرت إضافة تلك المستندات. يرجى المحاولة مرة أخرى.",
  "app.remediation.toast.resolveFailed": "تعذّر تحديث ذلك المستند. يرجى المحاولة مرة أخرى.",
  "app.remediation.toast.placeholdersFailed": "تعذّر حفظ تلك القيم. يرجى المحاولة مرة أخرى.",
  "app.remediation.toast.added_one": "تمت إضافة مستند واحد إلى هذه الجولة",
  "app.remediation.toast.added_other": "تمت إضافة {{count}} مستند إلى هذه الجولة",
  "app.remediation.toast.added_zero": "لم تتم إضافة أي مستند إلى هذه الجولة",
  "app.remediation.toast.added_two": "تمت إضافة مستندين إلى هذه الجولة",
  "app.remediation.toast.added_few": "تمت إضافة {{count}} مستندات إلى هذه الجولة",
  "app.remediation.toast.added_many": "تمت إضافة {{count}} مستنداً إلى هذه الجولة",
  "app.remediation.toast.addedNone": "تلك المستندات موجودة بالفعل في هذه الجولة",
  "app.remediation.toast.addedExhausted_one": "تمت إضافة مستند واحد، لكن هذه الجولة استنفدت محاولاتها. ابدأ جولة جديدة لمعالجته.",
  "app.remediation.toast.addedExhausted_other": "تمت إضافة {{count}} مستند، لكن هذه الجولة استنفدت محاولاتها. ابدأ جولة جديدة لمعالجتها.",
  "app.remediation.toast.addedExhausted_zero": "لم تتم إضافة أي مستند، وقد استنفدت هذه الجولة محاولاتها. ابدأ جولة جديدة.",
  "app.remediation.toast.addedExhausted_two": "تمت إضافة مستندين، لكن هذه الجولة استنفدت محاولاتها. ابدأ جولة جديدة لمعالجتهما.",
  "app.remediation.toast.addedExhausted_few": "تمت إضافة {{count}} مستندات، لكن هذه الجولة استنفدت محاولاتها. ابدأ جولة جديدة لمعالجتها.",
  "app.remediation.toast.addedExhausted_many": "تمت إضافة {{count}} مستنداً، لكن هذه الجولة استنفدت محاولاتها. ابدأ جولة جديدة لمعالجتها.",
  "app.remediation.addDocs.open": "إضافة مستندات",
  "app.remediation.cta.title": "أغلق هذه الفجوات بالذكاء الاصطناعي",
  "app.remediation.cta.body": "يمكننا صياغة {{missing}} من المستندات الناقصة وتحسين {{weak}} من ملفاتك، ثم جمع ما تقبله في نسخة جديدة ترسلها بنفسك.",
  "app.remediation.cta.bodyGenerateOnly": "يمكننا صياغة {{missing}} من المستندات الناقصة، ثم جمع ما تقبله في نسخة جديدة ترسلها بنفسك.",
  "app.remediation.cta.bodyRemediateOnly": "يمكننا تحسين {{weak}} من مستنداتك المرفوعة، ثم جمع ما تقبله في نسخة جديدة ترسلها بنفسك.",
  "app.remediation.cta.legacyTitle": "تتطلب المعالجة إعادة تشغيل التقييم",
  "app.remediation.cta.legacyBody": "إذا كنت ترغب في معالجة مستندات هذا التقييم، يُرجى نسخه من قائمة التقييمات وإعادة تشغيله. فقد اكتمل هذا التقييم قبل إطلاق خاصية المعالجة.",
  "app.remediation.cta.legacyAction": "الانتقال إلى التقييمات",
  "app.remediation.cta.action": "راجع ما سيقوم به الذكاء الاصطناعي",
  "app.remediation.cta.inProgress": "المعالجة قيد التنفيذ",
  "app.remediation.cta.inProgressBody": "هناك عملية معالجة تعمل بالفعل على هذا التقييم.",
  "app.remediation.cta.viewRun": "عرض التقدم",
  "app.remediation.scope.selectAll": "تحديد الكل",
  "app.remediation.scope.selectNone": "إلغاء التحديد",
  "app.remediation.scope.colDocument": "المستند",
  "app.remediation.scope.colDocumentType": "نوع المستند",
  "app.remediation.scope.colScore": "النتيجة",
  "app.remediation.scope.colDomain": "النطاق",
  "app.remediation.scope.colFormat": "الصيغة",
  "app.remediation.scope.willBeGenerated": "سيتم إنشاؤه بالذكاء الاصطناعي",
  "app.remediation.scope.remediateEmptyTitle": "لا توجد ملفات لتحسينها",
  "app.remediation.scope.remediateEmptyBody": "كل مستند مرفوع في هذا التقييم حقق النضج الكامل بالفعل.",
  "app.remediation.scope.generateEmptyTitle": "لا توجد مستندات ناقصة",
  "app.remediation.scope.generateEmptyBody": "تم رفع كل مستند مطلوب لهذا الإطار.",
  "app.remediation.scope.footNothing": "لم يتم تحديد شيء",
  "app.remediation.scope.footImprove_one": "{{count}} للتحسين",
  "app.remediation.scope.footImprove_other": "{{count}} للتحسين",
  "app.remediation.scope.footImprove_zero": "{{count}} للتحسين",
  "app.remediation.scope.footImprove_two": "{{count}} للتحسين",
  "app.remediation.scope.footImprove_few": "{{count}} للتحسين",
  "app.remediation.scope.footImprove_many": "{{count}} للتحسين",
  "app.remediation.scope.footCreate_one": "{{count}} للإنشاء",
  "app.remediation.scope.footCreate_other": "{{count}} للإنشاء",
  "app.remediation.scope.footCreate_zero": "{{count}} للإنشاء",
  "app.remediation.scope.footCreate_two": "{{count}} للإنشاء",
  "app.remediation.scope.footCreate_few": "{{count}} للإنشاء",
  "app.remediation.scope.footCreate_many": "{{count}} للإنشاء",
  "app.remediation.scope.footTime": "الوقت المتوقع ~{{minutes}} دقيقة",
  "app.remediation.scope.cancel": "إلغاء",
  "app.remediation.scope.backToAssessment": "العودة إلى التقييم",
  "app.remediation.scope.title": "معالجة المستندات بالذكاء الاصطناعي",
  "app.remediation.scope.subtitle": "راجع ما سيتم إنتاجه قبل البدء. لن يتغير شيء حتى توافق عليه.",
  "app.remediation.scope.generateTitle": "مستندات سيتم إنشاؤها",
  "app.remediation.scope.generateHint": "مستندات مطلوبة غير موجودة في هذا التقييم.",
  "app.remediation.scope.remediateTitle": "مستندات سيتم تحسينها",
  "app.remediation.scope.remediateHint": "ملفات حصلت على أقل من النضج الكامل. ستراجع كل تغيير قبل تطبيقه.",
  "app.remediation.scope.currentScore": "حاليًا {{score}}٪",
  "app.remediation.scope.start": "ابدأ المعالجة",
  "app.remediation.scope.starting": "جارٍ البدء…",
  "app.remediation.scope.countSummary": "{{total}} مستندًا · {{missing}} إنشاء، {{weak}} تحسين",
  "app.remediation.scope.empty.title": "لا يوجد ما يستدعي المعالجة",
  "app.remediation.scope.empty.body": "لا توجد مستندات ناقصة ولا ملفات دون النضج الكامل في هذا التقييم.",
  "app.remediation.scope.empty.inRunTitle": "لا يوجد ما يمكن إضافته",
  "app.remediation.scope.empty.inRunBody": "كل مستند أشار إليه هذا التقييم موجود بالفعل ضمن الجولة الجارية.",
  "app.remediation.scope.activeRun.title": "المعالجة قيد التشغيل",
  "app.remediation.scope.activeRun.open": "فتح الجولة",
  "app.remediation.scope.activeRun.bodyAppend": "كل ما تختاره هنا ينضم إلى تلك الجولة بدلاً من بدء جولة ثانية.",
  "app.remediation.scope.activeRun.bodyBusy": "جارٍ تطبيق قراراتك الآن، لذا لا يمكنها استقبال مزيد من المستندات. ابدأ جولة جديدة بعد انتهائها.",
  "app.remediation.scope.addToRun": "إضافة إلى الجولة",
  "app.remediation.scope.adding": "جارٍ الإضافة…",
  "app.remediation.scope.profileNote.title": "ملف مؤسستك مكتمل بنسبة {{pct}}٪",
  "app.remediation.scope.profileNote.body": "تم ملء {{filled}} من {{total}} حقلًا. كلما اكتمل الملف قلّت العناصر النائبة التي يتركها الذكاء الاصطناعي لك.",
  "app.remediation.scope.profileNote.openProfile": "أكمل الملف",
  "app.remediation.scope.loadError": "تعذر تحميل نطاق المعالجة.",
  "app.remediation.scope.notEligible": "المعالجة متاحة فقط للتقييمات المكتملة.",
  "app.remediation.progress.statDone": "مكتمل",
  "app.remediation.progress.statProcessing": "قيد المعالجة",
  "app.remediation.progress.statQueued": "في الانتظار",
  "app.remediation.progress.statFailed": "فشل",
  "app.remediation.progress.documents": "المستندات",
  "app.remediation.progress.itemsCount": "{{count}} عناصر",
  "app.remediation.progress.colDocument": "المستند",
  "app.remediation.progress.colDomain": "المجال",
  "app.remediation.progress.colStatus": "الحالة",
  "app.remediation.progress.colProgress": "التقدّم",
  "app.remediation.progress.pageRange": "{{from}}–{{to}} من {{total}}",
  "app.remediation.progress.leave": "يمكنك مغادرة هذه الصفحة",
  "app.remediation.progress.opRewrite": "تحسين",
  "app.remediation.progress.elapsedLabel": "المنقضي",
  "app.remediation.progress.elapsedMinutes": "{{minutes}} دقيقة",
  "app.remediation.progress.elapsedHours": "{{hours}} س {{minutes}} د",
  "app.remediation.progress.reviewDocument": "مراجعة",
  "app.remediation.progress.retryDocument": "حاول مرة أخرى",
  "app.remediation.progress.removeDocument": "إزالة",
  "app.remediation.progress.reviewedDocument": "تمت المراجعة",
  "app.remediation.progress.itemElapsed": "{{minutes}} دقيقة على هذا المستند",
  "app.remediation.progress.opGenerate": "إنشاء",
  "app.remediation.progress.retryAll": "حاول مرة أخرى",
  "app.remediation.progress.title": "جارٍ إنشاء مستنداتك",
  "app.remediation.progress.subtitle": "يستغرق هذا عادة بضع دقائق. يمكنك مغادرة الصفحة — سنتابع العمل.",
  "app.remediation.progress.finalizingTitle": "جارٍ إنهاء مستنداتك",
  "app.remediation.progress.finalizingSubtitle": "نقوم بتجهيز المستندات المعتمدة في نسخة تقييم جديدة.",
  "app.remediation.progress.doneOf": "{{done}} من {{total}} مستندًا",
  "app.remediation.progress.readyTitle": "جاهز لمراجعتك",
  "app.remediation.progress.readyBody": "انتهى الذكاء الاصطناعي. راجع كل تغيير مقترح قبل تطبيق أي شيء.",
  "app.remediation.progress.reviewNow": "راجع التغييرات",
  "app.remediation.progress.failedTitle": "فشلت المعالجة",
  "app.remediation.progress.failedBody": "لم نتمكن من إكمال هذه العملية. لم يتم إجراء أي تغيير على تقييمك.",
  "app.remediation.progress.someFailed_one": "تعذر إنشاء مستند واحد",
  "app.remediation.progress.someFailed_other": "تعذر إنشاء {{count}} مستند",
  "app.remediation.progress.someFailed_zero": "لم يتعذر إنشاء أي مستند",
  "app.remediation.progress.someFailed_two": "تعذر إنشاء مستندين",
  "app.remediation.progress.someFailed_few": "تعذر إنشاء {{count}} مستندات",
  "app.remediation.progress.someFailed_many": "تعذر إنشاء {{count}} مستنداً",
  "app.remediation.progress.andMoreFailed_one": "وواحد آخر",
  "app.remediation.progress.andMoreFailed_other": "و{{count}} آخر",
  "app.remediation.progress.andMoreFailed_zero": "و{{count}} أخرى",
  "app.remediation.progress.andMoreFailed_two": "وآخران",
  "app.remediation.progress.andMoreFailed_few": "و{{count}} أخرى",
  "app.remediation.progress.andMoreFailed_many": "و{{count}} أخرى",
  "app.remediation.progress.loadError": "تعذر تحميل عملية المعالجة هذه.",
  "app.remediation.itemError.artifactsUnavailable": "تعذّر تحميل نتائج التقييم لهذا المستند، فلم يكن هناك أساس للعمل عليه. أعد تشغيل التقييم ثم حاول مجدداً.",
  "app.remediation.itemError.sourceDownloadFailed": "تعذّر فتح الملف المرفوع. تأكّد من توفّره ثم حاول مجدداً.",
  "app.remediation.itemError.extractionFailed": "تعذّر قراءة محتوى هذا الملف. قد يكون ممسوحاً ضوئياً أو فارغاً أو محمياً بكلمة مرور.",
  "app.remediation.itemError.unsupportedFormat": "صيغة هذا الملف غير مدعومة للمعالجة.",
  "app.remediation.itemError.catalogDocumentNotFound": "لم يعد هذا المستند ضمن الإطار، لذا لا يمكن معالجته.",
  "app.remediation.itemError.generationFailed": "لم يتمكّن الذكاء الاصطناعي من إنتاج نسخة صالحة من هذا المستند. يمكنك المحاولة مجدداً.",
  "app.remediation.itemError.llmUnavailable": "خدمة الذكاء الاصطناعي غير متاحة حالياً. يمكنك المحاولة مجدداً.",
  "app.remediation.itemError.unknown": "تعذّرت معالجة هذا المستند. حاول مجدداً أو تواصل مع الدعم إن تكرر ذلك.",
  "app.remediation.figure.untitled": "صورة مدرجة",
  "app.remediation.figure.fromImage": "من صورة",
  "app.remediation.sheet.summary": "{{columns}} أعمدة · {{rows}} صفوف",
  "app.remediation.sheet.noRows": "يحدّد هذا المصنف أعمدته لكن لا توجد صفوف بعد.",
  "app.remediation.sheet.truncated": "عرض أول {{shown}} من {{total}} صف.",
  "app.remediation.review.waitingTitle": "لا يزال المستند الأول قيد الإعداد",
  "app.remediation.review.waitingBody": "يمكنك بدء المراجعة فور اكتمال أول مستند — تتحدّث هذه الصفحة تلقائياً.",
  "app.remediation.review.stillGenerating_one": "لا يزال مستند واحد قيد الإعداد. يمكنك مراجعة المكتمل الآن، وينتظر تطبيق التغييرات اكتمالها جميعاً.",
  "app.remediation.review.stillGenerating_other": "لا يزال {{count}} مستند قيد الإعداد. يمكنك مراجعة المكتمل الآن، وينتظر تطبيق التغييرات اكتمالها جميعاً.",
  "app.remediation.review.stillGenerating_zero": "لا توجد مستندات قيد الإعداد.",
  "app.remediation.review.stillGenerating_two": "لا يزال مستندان قيد الإعداد. يمكنك مراجعة المكتمل الآن، وينتظر تطبيق التغييرات اكتمالها جميعاً.",
  "app.remediation.review.stillGenerating_few": "لا تزال {{count}} مستندات قيد الإعداد. يمكنك مراجعة المكتمل الآن، وينتظر تطبيق التغييرات اكتمالها جميعاً.",
  "app.remediation.review.stillGenerating_many": "لا يزال {{count}} مستنداً قيد الإعداد. يمكنك مراجعة المكتمل الآن، وينتظر تطبيق التغييرات اكتمالها جميعاً.",
  "app.remediation.review.finalizeWaiting": "يصبح تطبيق التغييرات متاحاً بعد اكتمال جميع المستندات.",
  "app.remediation.review.original": "الأصلي",
  "app.remediation.review.proposed": "مقترح من الذكاء الاصطناعي",
  "app.remediation.review.changes": "التغييرات",
  "app.remediation.review.changeLabel": "التغيير {{n}}",
  "app.remediation.review.prev": "السابق",
  "app.remediation.review.next": "التالي",
  "app.remediation.review.filter.all": "الكل",
  "app.remediation.review.filter.pending": "معلّق",
  "app.remediation.review.filter.accepted": "مقبول",
  "app.remediation.review.filter.rejected": "مرفوض",
  "app.remediation.review.acceptAll": "قبول الكل",
  "app.remediation.review.rejectAll": "رفض الكل",
  "app.remediation.review.acceptAllConfirm": "قبول كل التغييرات ({{count}}) في هذا المستند؟ يمكنك تغيير أي قرار لاحقًا.",
  "app.remediation.review.saving": "جارٍ الحفظ…",
  "app.remediation.review.saved": "تم حفظ جميع القرارات",
  "app.remediation.review.progress": "تمت مراجعة {{reviewed}} من {{total}}",
  "app.remediation.review.docPosition": "المستند {{index}} من {{total}}",
  "app.remediation.review.pickAChange": "اختر تغييرًا لمراجعته",
  "app.remediation.review.pickAChangeSub": "انقر على أي تغيير مميز في المستند، أو اختر واحدًا من القائمة أدناه.",
  "app.remediation.review.startReview": "ابدأ بأول تغيير",
  "app.remediation.review.noSourceText": "تمت كتابة هذا المستند من الصفر، لذا لا توجد نسخة سابقة للمقارنة.",
  "app.remediation.review.saveForLater": "احفظ للاحقًا",
  "app.remediation.review.kbdHint": "اختصارات: A قبول · R رفض · ↑ ↓ تنقل",
  "app.remediation.review.title": "راجع التغييرات المقترحة",
  "app.remediation.review.subtitle": "اقبل أو ارفض كل تغيير. سيُكتب ما تقبله فقط في النسخة الجديدة.",
  "app.remediation.review.documents": "المستندات",
  "app.remediation.review.accept": "قبول",
  "app.remediation.review.reject": "رفض",
  "app.remediation.review.accepted": "مقبول",
  "app.remediation.review.rejected": "مرفوض",
  "app.remediation.review.wholeDocumentHint": "تمت كتابة هذا المستند من الصفر، لذا يتم قبوله أو رفضه ككل.",
  "app.remediation.review.generationTitle": "مستند مُنشأ",
  "app.remediation.review.sourceClauses": "استند إلى",
  "app.remediation.review.unaddressedClauses_one": "بند واحد غير مُغطّى",
  "app.remediation.review.unaddressedClauses_other": "{{count}} بند غير مُغطّى",
  "app.remediation.review.unaddressedClauses_zero": "لا توجد بنود غير مُغطّاة",
  "app.remediation.review.unaddressedClauses_two": "بندان غير مُغطّيين",
  "app.remediation.review.unaddressedClauses_few": "{{count}} بنود غير مُغطّاة",
  "app.remediation.review.unaddressedClauses_many": "{{count}} بنداً غير مُغطّى",
  "app.remediation.review.flagsTitle": "يستحق الاطلاع",
  "app.remediation.review.qualityNote": "فحص الجودة",
  "app.remediation.review.noGenerationDetail": "لم يُرجع الذكاء الاصطناعي تفاصيل إضافية لهذا المستند.",
  "app.remediation.review.changeCount_one": "تغيير واحد",
  "app.remediation.review.changeCount_other": "{{count}} تغيير",
  "app.remediation.review.changeCount_zero": "لا توجد تغييرات",
  "app.remediation.review.changeCount_two": "تغييران",
  "app.remediation.review.changeCount_few": "{{count}} تغييرات",
  "app.remediation.review.changeCount_many": "{{count}} تغييراً",
  "app.remediation.review.decidedCount": "تم البت في {{decided}} من {{total}}",
  "app.remediation.review.noChangesTitle": "لا توجد تغييرات مقترحة",
  "app.remediation.review.stillWriting": "قيد الكتابة",
  "app.remediation.review.noChangesBody": "راجع الذكاء الاصطناعي هذا المستند ولم يجد ما يحسّنه.",
  "app.remediation.review.itemFailedTitle": "تعذر إنشاء هذا المستند",
  "app.remediation.review.before": "الحالي",
  "app.remediation.review.after": "المقترح",
  "app.remediation.review.change.modification": "إعادة صياغة",
  "app.remediation.review.change.addition": "إضافة",
  "app.remediation.review.change.deletion": "حذف",
  "app.remediation.review.change.column_addition": "عمود مضاف",
  "app.remediation.review.change.column_deletion": "عمود محذوف",
  "app.remediation.review.references": "سبب هذا التغيير",
  "app.remediation.review.placeholders": "يحتاج إلى مدخلاتك",
  "app.remediation.review.placeholdersHint": "ترك الذكاء الاصطناعي هذه الفراغات لأن ملف مؤسستك لا يحتوي على القيمة بعد.",
  "app.remediation.review.finalize": "طبّق التغييرات المقبولة",
  "app.remediation.review.finalizeHint": "ينشئ نسخة تقييم جديدة بالمستندات المقبولة.",
  "app.remediation.review.finalizeConfirmTitle": "إنشاء نسخة جديدة؟",
  "app.remediation.review.finalizeConfirmBody_one": "ستتم إضافة مستند مقبول واحد إلى نسخة جديدة من هذا التقييم. ويبقى كل ما رفضته كما هو.",
  "app.remediation.review.finalizeConfirmBody_other": "ستتم إضافة {{count}} مستند مقبول إلى نسخة جديدة من هذا التقييم. ويبقى كل ما رفضته كما هو.",
  "app.remediation.review.finalizeConfirmBody_zero": "لا توجد مستندات مقبولة لإضافتها.",
  "app.remediation.review.finalizeConfirmBody_two": "ستتم إضافة مستندين مقبولين إلى نسخة جديدة من هذا التقييم. ويبقى كل ما رفضته كما هو.",
  "app.remediation.review.finalizeConfirmBody_few": "ستتم إضافة {{count}} مستندات مقبولة إلى نسخة جديدة من هذا التقييم. ويبقى كل ما رفضته كما هو.",
  "app.remediation.review.finalizeConfirmBody_many": "ستتم إضافة {{count}} مستنداً مقبولاً إلى نسخة جديدة من هذا التقييم. ويبقى كل ما رفضته كما هو.",
  "app.remediation.review.finalizeConfirmDraft": "تُفتح النسخة الجديدة كمسودة، فيمكنك مراجعتها وإرسالها للتقييم عندما تكون جاهزاً. ولا يمكن التراجع عن إنشائها.",
  "app.remediation.review.finalizeConfirmCta": "أنشئ نسخة جديدة",
  "app.remediation.review.finalizeBlocked": "يمكنك تطبيق التغييرات بعد مراجعة جميع مستندات هذه المعالجة.",
  "app.remediation.review.loadError": "تعذر تحميل بيانات المراجعة.",
  "app.remediation.review.notReady": "هذه العملية ليست جاهزة للمراجعة بعد.",
  "app.remediation.review.selectDocument": "اختر مستندًا لمراجعته",
  "app.remediation.review.reviewPanel": "لوحة المراجعة",
  "app.remediation.review.pageRange": "{{from}}–{{to}} من {{total}}",
  "app.remediation.final.title": "مستنداتك جاهزة",
  "app.remediation.final.body": "أنشأنا نسخة التقييم {{version}} بالمستندات المقبولة. وهي مسودة — راجعها وأرسلها للتقييم عندما تكون جاهزاً.",
  "app.remediation.final.bodyNoVersion": "أنشأنا نسخة تقييم جديدة بالمستندات المقبولة. وهي مسودة — راجعها وأرسلها للتقييم عندما تكون جاهزاً.",
  "app.remediation.final.download": "تنزيل",
  "app.remediation.final.openAssessment": "افتح النسخة الجديدة",
  "app.remediation.final.remediateMore": "معالجة مستندات أخرى",
  "app.remediation.final.documents": "المستندات المنتَجة",
  "app.remediation.final.rejectedNote": "تم ترحيل المستندات المرفوضة وغير المتغيرة كما هي.",
  "app.remediation.final.discardedTitle": "لم يتم تطبيق أي شيء",
  "app.remediation.final.discardedBody": "لقد رفضت كل تغيير مقترح، لذلك لم يتم إنشاء نسخة تقييم جديدة.",
  "app.remediation.final.downloadFailed": "تعذر تجهيز هذا التنزيل.",
  "app.remediation.dashboard.viewAll": "عرض الكل",
  "app.remediation.dashboard.awaitingReview_one": "عملية واحدة بانتظار مراجعتك",
  "app.remediation.dashboard.awaitingReview_other": "{{count}} عملية بانتظار مراجعتك",
  "app.remediation.dashboard.awaitingReview_zero": "لا توجد عمليات بانتظار مراجعتك",
  "app.remediation.dashboard.awaitingReview_two": "عمليتان بانتظار مراجعتك",
  "app.remediation.dashboard.awaitingReview_few": "{{count}} عمليات بانتظار مراجعتك",
  "app.remediation.dashboard.awaitingReview_many": "{{count}} عملية بانتظار مراجعتك",
  "app.remediation.list.searchPlaceholder": "ابحث في التقييمات…",
  "app.remediation.list.filterGaps": "الفجوات",
  "app.remediation.list.filterAll": "الكل",
  "app.remediation.list.filterHasGaps": "بها فجوات",
  "app.remediation.list.filterCompliant": "ملتزم بالكامل",
  "app.remediation.list.sortBy": "ترتيب حسب",
  "app.remediation.list.sortRecent": "الأحدث",
  "app.remediation.list.sortScore": "الأقل تقييمًا",
  "app.remediation.list.pagination.summary": "صفحة {{page}} من {{totalPages}} · {{totalCount}} تقييم",
  "app.remediation.list.col.completed": "اكتمل",
  "app.remediation.list.col.version": "الإصدار",
  "app.remediation.list.col.score": "النتيجة",
  "app.remediation.list.col.gaps": "الفجوات",
  "app.remediation.list.docsUnit": "مستندات",
  "app.remediation.list.view": "عرض التقييم",
  "app.remediation.list.viewAssessment": "عرض التقييم",
  "app.remediation.list.viewDocuments": "عرض المستندات",
  "app.remediation.list.viewSummary": "عرض الملخص",
  "app.remediation.list.addDocuments": "إضافة مستندات",
  "app.remediation.list.aiBadge": "معالجة بالذكاء الاصطناعي",
  "app.remediation.list.state.none": "لم تُعالَج بعد",
  "app.remediation.list.state.partial": "معالَجة جزئياً",
  "app.remediation.list.state.inProgress": "المعالجة جارية",
  "app.remediation.list.state.full": "معالَجة بالكامل",
  "app.remediation.list.stateFilterAll": "كل الحالات",
  "app.remediation.list.remediate": "معالجة",
  "app.remediation.list.resume": "متابعة",
  "app.remediation.list.applyChanges": "تطبيق التغييرات",
  "app.remediation.list.emptyFirst.title": "لا يوجد ما يستدعي المعالجة بعد",
  "app.remediation.list.emptyFirst.body": "أكمل تقييمًا، أو أنشئ نسخة من تقييم موجود، إذا كنت ترغب في المعالجة.",
  "app.remediation.list.emptyFirst.cta": "اذهب إلى التقييمات",
  "app.remediation.list.emptyFilter.title": "لا توجد تقييمات مطابقة",
  "app.remediation.list.emptyFilter.body": "جرّب بحثًا آخر أو امسح عوامل التصفية.",
  "app.remediation.list.emptyFilter.cta": "مسح عوامل التصفية",
  "app.remediation.status.notRemediated": "لم تتم المعالجة",
  "app.remediation.list.title": "معالجة المستندات",
  "app.remediation.list.tab.queue": "بحاجة إلى معالجة",
  "app.remediation.placeholders.title": "أكمِل ما لم يستطع الذكاء الاصطناعي ملءه",
  "app.remediation.placeholders.subtitle": "ترك الذكاء الاصطناعي هذه الفراغات لعدم توفر قيم لها. ما يوجد له حقل في ملف مؤسستك يُحفظ هناك، فتُكتب به المستندات القادمة بدل أن تُسأل مرة أخرى.",
  "app.remediation.placeholders.noneTitle": "لا توجد فراغات",
  "app.remediation.placeholders.noneBody": "كل قيمة احتاجتها هذه المستندات كانت موجودة بالفعل في ملف مؤسستك.",
  "app.remediation.placeholders.savesToProfile": "يُحفظ في ملفك",
  "app.remediation.placeholders.alreadyKnown": "موجود في ملفك",
  "app.remediation.placeholders.usedIn": "مستخدم في: {{documents}}",
  "app.remediation.placeholders.inputHint": "اكتب القيمة",
  "app.remediation.placeholders.skippable_one": "بقي فراغ واحد هنا — يمكنك تعبئته لاحقًا",
  "app.remediation.placeholders.skippable_other": "بقي {{count}} فراغ هنا — يمكنك تعبئتها لاحقًا",
  "app.remediation.placeholders.skippable_zero": "لا توجد فراغات هنا",
  "app.remediation.placeholders.skippable_two": "بقي فراغان هنا — يمكنك تعبئتهما لاحقًا",
  "app.remediation.placeholders.skippable_few": "بقيت {{count}} فراغات هنا — يمكنك تعبئتها لاحقًا",
  "app.remediation.placeholders.skippable_many": "بقي {{count}} فراغاً هنا — يمكنك تعبئتها لاحقًا",
  "app.remediation.placeholders.willStayBlank": "إذا تُرك فارغًا، سيظهر في المستند {{token}}",
  "app.remediation.placeholders.inDocuments_one": "في مستند واحد",
  "app.remediation.placeholders.inDocuments_other": "في {{count}} مستند",
  "app.remediation.placeholders.inDocuments_zero": "في {{count}} مستند",
  "app.remediation.placeholders.inDocuments_two": "في مستندين",
  "app.remediation.placeholders.inDocuments_few": "في {{count}} مستندات",
  "app.remediation.placeholders.inDocuments_many": "في {{count}} مستنداً",
  "app.remediation.placeholders.documentOnly": "هذا المستند فقط",
  "app.remediation.placeholders.previewLabel": "كيف ستظهر",
  "app.remediation.placeholders.noPreview": "هذا الفراغ ليس داخل جملة، لذا لا يوجد ما يمكن معاينته.",
  "app.remediation.placeholders.documentPosition": "المستند {{index}} من {{total}}",
  "app.remediation.placeholders.nextDocument": "المستند التالي",
  "app.remediation.placeholders.previousDocument": "السابق",
  "app.remediation.placeholders.backToReview": "العودة إلى المراجعة",
  "app.remediation.placeholders.readyToSave_one": "قيمة واحدة جاهزة للحفظ",
  "app.remediation.placeholders.readyToSave_other": "{{count}} قيمة جاهزة للحفظ",
  "app.remediation.placeholders.readyToSave_zero": "لا توجد قيم جاهزة للحفظ",
  "app.remediation.placeholders.readyToSave_two": "قيمتان جاهزتان للحفظ",
  "app.remediation.placeholders.readyToSave_few": "{{count}} قيم جاهزة للحفظ",
  "app.remediation.placeholders.readyToSave_many": "{{count}} قيمة جاهزة للحفظ",
  "app.remediation.placeholders.save": "الحفظ في ملف المؤسسة",
  "app.remediation.placeholders.saving": "جارٍ الحفظ…",
  "app.remediation.placeholders.saved_one": "تم حفظ قيمة واحدة في ملف مؤسستك",
  "app.remediation.placeholders.saved_other": "تم حفظ {{count}} قيمة في ملف مؤسستك",
  "app.remediation.placeholders.saved_zero": "لم تُحفظ أي قيمة في ملف مؤسستك",
  "app.remediation.placeholders.saved_two": "تم حفظ قيمتين في ملف مؤسستك",
  "app.remediation.placeholders.saved_few": "تم حفظ {{count}} قيم في ملف مؤسستك",
  "app.remediation.placeholders.saved_many": "تم حفظ {{count}} قيمة في ملف مؤسستك",
  "app.remediation.placeholders.continue": "متابعة",
  "app.remediation.placeholders.submit": "إرسال",
  "app.remediation.placeholders.autosaving": "جارٍ الحفظ…",
  "app.remediation.placeholders.autosaved": "تم حفظ جميع القيم",
  "app.remediation.placeholders.submitting": "جارٍ الإرسال…",
  "app.remediation.placeholders.confirmTitle": "تحديث ملف مؤسستك؟",
  "app.remediation.placeholders.confirmBody_one": "ستُكتب قيمة واحدة في ملف مؤسستك، وهو المصدر لكل مستند مستقبلي:",
  "app.remediation.placeholders.confirmBody_other": "ستُكتب {{count}} قيمة في ملف مؤسستك، وهو المصدر لكل مستند مستقبلي:",
  "app.remediation.placeholders.confirmBody_zero": "لن تُكتب أي قيمة في ملف مؤسستك.",
  "app.remediation.placeholders.confirmBody_two": "ستُكتب قيمتان في ملف مؤسستك، وهو المصدر لكل مستند مستقبلي:",
  "app.remediation.placeholders.confirmBody_few": "ستُكتب {{count}} قيم في ملف مؤسستك، وهو المصدر لكل مستند مستقبلي:",
  "app.remediation.placeholders.confirmBody_many": "ستُكتب {{count}} قيمة في ملف مؤسستك، وهو المصدر لكل مستند مستقبلي:",
  "app.remediation.placeholders.confirmCta": "الحفظ في الملف",
  "app.remediation.placeholders.confirmSkipTitle": "ستبقى بعض الفراغات كنصوص نائبة",
  "app.remediation.placeholders.confirmSkipBody_one": "هناك فراغ واحد بلا قيمة. سيصدر المستند بالنص النائب في موضع القيمة الفعلية. يمكنك العودة وتعبئته قبل تطبيق الدورة.",
  "app.remediation.placeholders.confirmSkipBody_other": "هناك {{count}} فراغ بلا قيمة. ستصدر تلك المستندات بالنص النائب في موضع القيم الفعلية. يمكنك العودة وتعبئتها قبل تطبيق الدورة.",
  "app.remediation.placeholders.confirmSkipBody_zero": "لا توجد فراغات بلا قيمة.",
  "app.remediation.placeholders.confirmSkipBody_two": "هناك فراغان بلا قيمة. ستصدر المستندات بالنص النائب في موضع القيم الفعلية. يمكنك العودة وتعبئتهما قبل تطبيق الدورة.",
  "app.remediation.placeholders.confirmSkipBody_few": "هناك {{count}} فراغات بلا قيمة. ستصدر تلك المستندات بالنص النائب في موضع القيم الفعلية. يمكنك العودة وتعبئتها قبل تطبيق الدورة.",
  "app.remediation.placeholders.confirmSkipBody_many": "هناك {{count}} فراغاً بلا قيمة. ستصدر تلك المستندات بالنص النائب في موضع القيم الفعلية. يمكنك العودة وتعبئتها قبل تطبيق الدورة.",
  "app.remediation.placeholders.confirmSkipBack": "العودة والتعبئة",
  "app.remediation.placeholders.confirmSkipCta": "الإرسال على أي حال",
  "app.remediation.placeholders.warnTitle": "سيكون تقييمك القادم أقل مما يمكن",
  "app.remediation.placeholders.warnPlaceholders_one": "لا يزال فراغ واحد دون تعبئة — سيبقى النص النائب بدل القيمة الحقيقية.",
  "app.remediation.placeholders.warnPlaceholders_other": "لا يزال {{count}} فراغ دون تعبئة — ستبقى النصوص النائبة بدل القيم الحقيقية.",
  "app.remediation.placeholders.warnPlaceholders_zero": "لا توجد فراغات دون تعبئة.",
  "app.remediation.placeholders.warnPlaceholders_two": "لا يزال فراغان دون تعبئة — ستبقى النصوص النائبة بدل القيم الحقيقية.",
  "app.remediation.placeholders.warnPlaceholders_few": "لا تزال {{count}} فراغات دون تعبئة — ستبقى النصوص النائبة بدل القيم الحقيقية.",
  "app.remediation.placeholders.warnPlaceholders_many": "لا يزال {{count}} فراغاً دون تعبئة — ستبقى النصوص النائبة بدل القيم الحقيقية.",
  "app.remediation.placeholders.warnGaps_one": "لا تزال ثغرة واحدة مفتوحة. عالجها لإغلاقها.",
  "app.remediation.placeholders.warnGaps_other": "لا تزال {{count}} ثغرة مفتوحة. عالجها لإغلاقها.",
  "app.remediation.placeholders.warnGaps_zero": "لا توجد ثغرات مفتوحة.",
  "app.remediation.placeholders.warnGaps_two": "لا تزال ثغرتان مفتوحتان. عالجهما لإغلاقهما.",
  "app.remediation.placeholders.warnGaps_few": "لا تزال {{count}} ثغرات مفتوحة. عالجها لإغلاقها.",
  "app.remediation.placeholders.warnGaps_many": "لا تزال {{count}} ثغرة مفتوحة. عالجها لإغلاقها.",
  "app.remediation.placeholders.warnMissingDocuments_one": "لا يزال مستند متوقع واحد مفقوداً. أنشئه أو ارفع مستندك.",
  "app.remediation.placeholders.warnMissingDocuments_other": "لا يزال {{count}} مستند متوقع مفقوداً. أنشئها أو ارفع مستنداتك.",
  "app.remediation.placeholders.warnMissingDocuments_zero": "لا توجد مستندات متوقعة مفقودة.",
  "app.remediation.placeholders.warnMissingDocuments_two": "لا يزال مستندان متوقعان مفقودين. أنشئهما أو ارفع مستنداتك.",
  "app.remediation.placeholders.warnMissingDocuments_few": "لا تزال {{count}} مستندات متوقعة مفقودة. أنشئها أو ارفع مستنداتك.",
  "app.remediation.placeholders.warnMissingDocuments_many": "لا يزال {{count}} مستنداً متوقعاً مفقوداً. أنشئها أو ارفع مستنداتك.",
  "app.remediation.remediated.title": "التقييمات المعالَجة",
  "app.remediation.remediated.subtitle": "تقييمات أنتج لها الذكاء الاصطناعي مستندات بالفعل. افتح أي منها لقراءة ما كُتب أو تنزيله.",
  "app.remediation.remediated.empty": "لم يتم معالجة أي تقييم بعد.",
  "app.remediation.remediated.col.assessment": "التقييم",
  "app.remediation.remediated.col.lastRemediated": "آخر معالجة",
  "app.remediation.remediated.col.score": "النتيجة",
  "app.remediation.remediated.col.improved": "مُحسّنة",
  "app.remediation.remediated.col.created": "مُنشأة",
  "app.remediation.remediated.col.documents": "المستندات",
  "app.remediation.remediated.versionLabel": "الإصدار {{version}}",
  "app.remediation.remediated.viewDocuments": "عرض المستندات",
  "app.remediation.remediated.viewAssessment": "عرض التقييم",
  "app.remediation.produced.title": "مستندات هذه المعالجة",
  "app.remediation.produced.loadError": "تعذّر تحميل مستندات هذه المعالجة.",
  "app.remediation.produced.empty": "لم تنتج هذه المعالجة مستندات احتفظت بها.",
  "app.remediation.produced.untitled": "مستند بلا عنوان",
  "app.remediation.produced.created": "مُنشأ",
  "app.remediation.produced.improved": "مُحسّن",
  "app.remediation.produced.open": "فتح",
  "app.remediation.list.subtitle": "أعد كتابة المستندات الضعيفة وأنشئ المفقودة بالذكاء الاصطناعي، استناداً إلى تقييماتك المكتملة.",
  "app.remediation.list.col.assessment": "التقييم",
  "app.remediation.list.col.status": "حالة المعالجة",
  "app.remediation.list.col.documents": "المستندات",
  "app.remediation.list.col.started": "بدأت",
  "app.remediation.list.open": "افتح",
  "app.remediation.list.loadError": "تعذر تحميل عمليات المعالجة الخاصة بك.",
  "app.remediation.list.untitledAssessment": "تقييم بلا عنوان",
  "app.remediation.list.state.needsReview": "بحاجة إلى مراجعة",
  "app.remediation.list.state.failed": "فشلت المعالجة",
  "app.remediation.list.failedHint": "لم يتم تطبيق أي تغييرات على تقييمك.",
  "app.remediation.list.needsAttention": "يحتاج انتباهي ({{count}})",
  "app.remediation.list.tryAgain": "حاول مرة أخرى",
  "app.remediation.list.seeWhatFailed": "عرض ما فشل",
  "app.remediation.list.outcome.done": "تم تطبيق {{count}}",
  "app.remediation.list.outcome.running": "{{count}} قيد التنفيذ",
  "app.remediation.list.outcome.needsReview": "{{count}} للمراجعة",
  "app.remediation.list.outcome.noChanges": "{{count}} دون تغيير",
  "app.remediation.list.outcome.failed": "{{count}} فشل",
  "app.remediation.list.legend.done": "مُطبَّق — تمت الموافقة عليه وكتابته في التقييم",
  "app.remediation.list.legend.needsReview": "بحاجة إلى مراجعة — أنتجه الذكاء الاصطناعي وينتظر قرارك",
  "app.remediation.list.legend.failed": "فشل — تعذّر إنتاجه",
  "app.remediation.list.legend.noChanges": "دون تغيير — بلغ النضج الكامل بالفعل",
  "app.remediation.list.state.needsReviewCount_zero": "لا توجد مستندات بحاجة إلى مراجعة",
  "app.remediation.list.state.needsReviewCount_one": "مستند واحد بحاجة إلى مراجعة",
  "app.remediation.list.state.needsReviewCount_two": "مستندان بحاجة إلى مراجعة",
  "app.remediation.list.state.needsReviewCount_few": "{{count}} مستندات بحاجة إلى مراجعة",
  "app.remediation.list.state.needsReviewCount_many": "{{count}} مستنداً بحاجة إلى مراجعة",
  "app.remediation.list.state.needsReviewCount_other": "{{count}} مستند بحاجة إلى مراجعة",
  "app.remediation.list.reviewDocuments_zero": "لا توجد مستندات للمراجعة",
  "app.remediation.list.reviewDocuments_one": "مراجعة مستند واحد",
  "app.remediation.list.reviewDocuments_two": "مراجعة مستندين",
  "app.remediation.list.reviewDocuments_few": "مراجعة {{count}} مستندات",
  "app.remediation.list.reviewDocuments_many": "مراجعة {{count}} مستنداً",
  "app.remediation.list.reviewDocuments_other": "مراجعة {{count}} مستند",
  "app.remediation.list.state.reassessing": "إعادة التقييم",
  "app.remediation.list.reassessingHint": "يتم الآن تقييم مستنداتك المعالَجة. سيعود هذا التقييم إلى هنا عند الانتهاء.",
  "app.remediation.list.state.assessing": "التقييم قيد التنفيذ",
  "app.remediation.list.assessingHint": "يمكنك معالجة هذا التقييم بعد انتهاء احتساب درجته.",
  "app.remediation.list.viewHistory": "السجل",
  "app.remediation.history.title": "سجل المعالجة",
  "app.remediation.history.empty": "لم تتم معالجة هذا التقييم بعد.",
  "app.remediation.history.runLabel": "التشغيل {{number}}",
  "app.remediation.history.openLatest": "فتح آخر تشغيل",
  "app.remediation.history.loadRunError": "تعذّر تحميل مستندات هذا التشغيل.",
  "app.remediation.history.noDocuments": "لا توجد مستندات في هذا التشغيل.",
  "app.remediation.history.untitledDocument": "مستند بلا عنوان",
  "app.remediation.history.stat.runs": "التشغيلات",
  "app.remediation.history.stat.applied": "المستندات المحسّنة",
  "app.remediation.history.stat.documents": "المستندات ضمن النطاق",
  "app.remediation.review.figureFallback": "شكل",
  "app.remediation.summary.title": "نتائج المعالجة",
  "app.remediation.summary.subtitle": "ما أنتجه هذا التشغيل، وما سيحدث بعد ذلك.",
  "app.remediation.summary.loadError": "تعذّر تحميل هذا التشغيل.",
  "app.remediation.summary.untitledDocument": "مستند بلا عنوان",
  "app.remediation.summary.stat.accepted": "مقبولة",
  "app.remediation.summary.stat.failed": "فاشلة",
  "app.remediation.summary.stat.outstanding": "ما زالت معلّقة",
  "app.remediation.summary.group.accepted": "مقبولة — ستصبح النسخة الجديدة",
  "app.remediation.summary.group.rejected": "مرفوضة — بقيت كما هي",
  "app.remediation.summary.group.no_changes": "لا تحتاج إلى تغييرات",
  "app.remediation.summary.group.failed": "فشلت — يمكنك معالجتها مرة أخرى",
  "app.remediation.summary.outstandingTitle": "ما زال العمل جاريًا على بعض المستندات",
  "app.remediation.summary.outstandingBody": "تأخذ النسخة الجديدة هذه المستندات كما هي الآن، لذا انتظر انتهاءها أو اتخذ قرارًا بشأنها أولاً.",
  "app.remediation.summary.failedTitle": "تعذّر إنتاج بعض المستندات",
  "app.remediation.summary.failedBody": "يمكنك إنشاء النسخة بدونها ومعالجتها لاحقًا، أو العودة والمحاولة مرة أخرى أولاً.",
  "app.remediation.summary.blanksTitle": "تُركت بعض الفراغات بلا تعبئة",
  "app.remediation.summary.blanksBody_one": "هناك فراغ واحد بلا قيمة، لذا سيحتفظ المستند بنصه النائب. هذه آخر نقطة يمكنك تعبئته فيها.",
  "app.remediation.summary.blanksBody_other": "هناك {{count}} فراغ بلا قيمة، لذا ستحتفظ المستندات بنصوصها النائبة. هذه آخر نقطة يمكنك تعبئتها فيها.",
  "app.remediation.summary.blanksBody_zero": "لا توجد فراغات بلا قيمة.",
  "app.remediation.summary.blanksBody_two": "هناك فراغان بلا قيمة، لذا ستحتفظ المستندات بنصوصها النائبة. هذه آخر نقطة يمكنك تعبئتهما فيها.",
  "app.remediation.summary.blanksBody_few": "هناك {{count}} فراغات بلا قيمة، لذا ستحتفظ المستندات بنصوصها النائبة. هذه آخر نقطة يمكنك تعبئتها فيها.",
  "app.remediation.summary.blanksBody_many": "هناك {{count}} فراغاً بلا قيمة، لذا ستحتفظ المستندات بنصوصها النائبة. هذه آخر نقطة يمكنك تعبئتها فيها.",
  "app.remediation.summary.blanksCta": "تعبئتها الآن",
  "app.remediation.summary.backToReview": "العودة إلى المراجعة",
  "app.remediation.summary.keepRemediating": "معالجة مزيد من المستندات",
  "app.remediation.summary.acceptAndVersion": "قبول وإنشاء نسخة",
  "app.remediation.summary.confirmTitle": "إنشاء نسخة جديدة؟",
  "app.remediation.summary.confirmDraft": "تُفتح النسخة الجديدة كمسودة، فيمكنك مراجعتها وإرسالها للتقييم عندما تكون جاهزاً. ولا يمكن التراجع عن إنشائها.",
  "app.remediation.summary.confirmCta": "إنشاء نسخة جديدة",
  "app.remediation.summary.confirmBody_zero": "لا توجد مستندات مقبولة لإضافتها.",
  "app.remediation.summary.confirmBody_one": "ستتم إضافة مستند مقبول واحد إلى نسخة جديدة من هذا التقييم. وسيبقى ما رفضته كما هو.",
  "app.remediation.summary.confirmBody_two": "ستتم إضافة مستندين مقبولين إلى نسخة جديدة من هذا التقييم. وسيبقى ما رفضته كما هو.",
  "app.remediation.summary.confirmBody_few": "ستتم إضافة {{count}} مستندات مقبولة إلى نسخة جديدة من هذا التقييم. وسيبقى ما رفضته كما هو.",
  "app.remediation.summary.confirmBody_many": "ستتم إضافة {{count}} مستنداً مقبولاً إلى نسخة جديدة من هذا التقييم. وسيبقى ما رفضته كما هو.",
  "app.remediation.summary.confirmBody_other": "ستتم إضافة {{count}} مستند مقبول إلى نسخة جديدة من هذا التقييم. وسيبقى ما رفضته كما هو.",
  "app.remediation.scope.summary.completedOn": "اكتمل في {{date}}",
  "app.remediation.scope.summary.viewAssessment": "عرض التقييم كاملاً",
  "app.remediation.scope.summary.score": "درجة الامتثال",
  "app.remediation.scope.summary.gaps": "الفجوات المفتوحة",
  "app.remediation.scope.summary.missing": "المستندات الناقصة",
  "app.remediation.scope.summary.missingHint": "مطلوبة ولم تُرفع",
  "app.remediation.scope.summary.weak": "المستندات الضعيفة",
  "app.remediation.scope.summary.weakHint": "مرفوعة ودون النضج الكامل",
  "app.assessment.classification.weak.badge": "تطابق ضعيف",
  "app.assessment.classification.weak.title": "تطابق ضعيف — يرجى مراجعة هذا الملف",
  "app.assessment.classification.weak.description": "طابقنا هذا الملف مع أقرب مستند متوقع، لكننا لسنا متأكدين. ما زال مدرجًا في تقييمك. إذا كان أحد البدائل أدناه أنسب، فاختره.",
  "app.assessment.classification.incomplete.title": "يبدو أن هذا المستند غير مكتمل",
  "app.assessment.classification.incomplete.description": "تمت المطابقة، لكن ينقصه كثير مما ينبغي أن يحتويه. ما زال مدرجًا ويُقيّم — وتوقّع أن يحتاج عملًا كبيرًا.",
  "app.assessment.classification.incomplete.missingSections": "مفقود أو فارغ: {{sections}}",
  "app.assessment.classification.candidates.title": "قد يكون أيضًا أحد هذه",
  "app.assessment.classification.candidates.description": "صنّفنا هذا الملف كـ«{{document}}»، لكن أجزاءً منه تنتمي إلى المستندات أدناه، الأقرب أولًا. اختر غيره إن كان أنسب.",
  "app.assessment.classification.candidates.useThis": "استخدم هذا بدلاً منه",
  "app.assessment.classification.candidates.alreadyMatched": "مستخدم بالفعل من مستند آخر",
  "app.assessment.classification.candidates.confidence.high": "تطابق قوي",
  "app.assessment.classification.candidates.confidence.medium": "تطابق محتمل",
  "app.assessment.classification.candidates.confidence.low": "تطابق ضعيف",
  "app.assessment.classification.candidates.confirmTitle": "تغيير المستند المطابق؟",
  "app.assessment.classification.candidates.confirmMessage": "سيتم مطابقة هذا الملف مع «{{to}}» بدلاً من «{{from}}».",
  "app.assessment.classification.candidates.applySuccess": "تم تحديث مطابقة المستند",
  "app.assessment.classification.candidates.applyError": "تعذر تغيير المستند المطابق",
  "app.assessment.classification.matchRow.matched": "مطابق",
  "app.assessment.classification.matchRow.noMatch": "لا توجد مطابقة مؤكدة",
  "app.assessment.classification.candidates.hint": "أكّد أي مستند يوفّره هذا الملف",
  "app.assessment.classification.candidates.current": "الحالي",
  "app.assessment.classification.candidates.currentWhy": "ما طابقنا هذا الملف معه.",
  "app.assessment.classification.candidates.confirm": "تأكيد المطابقة",
  "app.assessment.classification.whyMatched": "سبب المطابقة",
  "app.assessment.workflow.validation.undecidedClassification": "«{{name}}» و{{count}} ملف آخر يحتاج منك تأكيد المستند الذي يوفّره قبل أن تتابع.",
  "app.assessment.classification.actionNeeded": "يتطلب إجراءً",
  "fileUpload.section.uploading": "جارٍ الرفع",
  "fileUpload.section.uploaded": "تم الرفع",
  "app.assessment.classification.incomplete.badge": "غير مكتمل",
  "app.orgProfile.field.phoneError": "أدخل رقم هاتف صالحًا، مثال: +966 50 123 4567.",
  "app.documentHub.review.validation.phone": "أدخل رقم هاتف صالحًا، مثال: +966 50 123 4567.",
  "app.admin.nav.usage": "الاستخدام والتكلفة",
  "app.admin.detail.tabs.usage": "الاستخدام",
  "app.admin.usage.title": "الاستخدام والتكلفة",
  "app.admin.usage.subtitle": "تكلفة المزوّد الداخلية لكل المنشآت",
  "app.admin.usage.range.today": "اليوم",
  "app.admin.usage.range.7d": "آخر ٧ أيام",
  "app.admin.usage.range.30d": "آخر ٣٠ يوماً",
  "app.admin.usage.range.mtd": "من بداية الشهر",
  "app.admin.usage.range.prevMonth": "الشهر السابق",
  "app.admin.usage.range.tzLabel": "الأيام محسوبة بتوقيت {{tz}}",
  "app.admin.usage.stats.totalCost": "إجمالي التكلفة",
  "app.admin.usage.stats.vsPrev": "{{delta}} مقارنة بالفترة السابقة",
  "app.admin.usage.stats.calls": "طلبات الذكاء الاصطناعي",
  "app.admin.usage.stats.tokensSub": "{{tokens}} رمز",
  "app.admin.usage.stats.tokens": "الرموز",
  "app.admin.usage.stats.tenants": "المنشآت",
  "app.admin.usage.stats.tenantsSub": "لديها استخدام في هذه الفترة",
  "app.admin.usage.stats.unpriced": "طلبات بلا تسعير",
  "app.admin.usage.stats.unpricedSub": "محسوبة بصفر، والتكلفة الفعلية أعلى",
  "app.admin.usage.trend.title": "التكلفة عبر الزمن",
  "app.admin.usage.trend.subtitle": "تكلفة المزوّد اليومية",
  "app.admin.usage.trend.empty": "لا توجد تكلفة مسجلة في هذه الفترة",
  "app.admin.usage.byService.title": "حسب الخدمة",
  "app.admin.usage.byService.subtitle": "أين تُنفق الأموال",
  "app.admin.usage.byFeature.title": "حسب الميزة",
  "app.admin.usage.byFeature.subtitle": "أي جزء من المنتج يستهلك التكلفة",
  "app.admin.usage.breakdown.calls": "{{calls}} طلب",
  "app.admin.usage.breakdown.empty": "لا يوجد تسجيل في هذه الفترة",
  "app.admin.usage.service.llm": "النماذج اللغوية",
  "app.admin.usage.service.embedding": "التضمينات",
  "app.admin.usage.service.rerank": "إعادة الترتيب",
  "app.admin.usage.service.compute": "حوسبة المهام",
  "app.admin.usage.feature.chat": "المحادثة",
  "app.admin.usage.feature.deep_research": "البحث المعمّق",
  "app.admin.usage.feature.assessment": "التقييم",
  "app.admin.usage.feature.document_generation": "المعالجة",
  "app.admin.usage.feature.tenant_profile": "ملف المنشأة",
  "app.admin.usage.feature.translation": "الترجمة",
  "app.admin.usage.feature.platform_tooling": "أدوات المنصة",
  "app.admin.usage.feature.unknown": "غير منسوب",
  "app.admin.usage.topTenants.title": "أعلى المنشآت إنفاقاً",
  "app.admin.usage.topTenants.subtitle": "مرتبة حسب التكلفة في هذه الفترة",
  "app.admin.usage.topTenants.col.org": "المنشأة",
  "app.admin.usage.topTenants.col.cost": "التكلفة",
  "app.admin.usage.topTenants.col.calls": "الطلبات",
  "app.admin.usage.topTenants.col.tokens": "الرموز",
  "app.admin.usage.topTenants.empty": "لا يوجد استخدام مسجل بعد",
  "app.admin.usage.topTenants.emptyHint": "تُكتب أحداث الاستخدام بواسطة خدمة الذكاء الاصطناعي. إذا بقيت هذه الصفحة فارغة بعد النشر فإن التتبع لا يصل إلى قاعدة البيانات.",
  "app.admin.usage.topTenants.error": "تعذّر تحميل بيانات الاستخدام",
  "app.admin.usage.topTenants.summary": "{{total}} منشأة",
  "app.admin.usage.tenant.deleted": "منشأة محذوفة",
  "app.admin.usage.tenant.unattributedHint": "فجوة في النسب",
  "app.admin.usage.byModel.title": "حسب النموذج",
  "app.admin.usage.byModel.col.model": "النموذج",
  "app.admin.usage.byModel.col.calls": "الطلبات",
  "app.admin.usage.byModel.col.in": "المدخلات",
  "app.admin.usage.byModel.col.out": "المخرجات",
  "app.admin.usage.byModel.col.cost": "التكلفة",
  "app.admin.usage.byModel.empty": "لا يوجد استخدام للنماذج في هذه الفترة",
  "app.admin.usage.byModel.unpricedNote": "{{calls}} بلا تسعير",
  "app.assessment.document.downloadAllEmpty": "لا توجد مستندات لتنزيلها في هذا التقييم.",
  "app.assessment.document.downloadAllPreparing": "جارٍ تجهيز الملف المضغوط...",
  "app.assessment.document.downloadAllSuccess": "بدأ تنزيل الملف المضغوط",
  "assessments.summary.documentCount": "{{count}} مستند",
  "assessments.summary.download": "تنزيل",
  "assessments.summary.errorMessage": "تعذّر إرسال التقييم. يُرجى المحاولة مرة أخرى.",
  "assessments.summary.successMessage": "تم إرسال تقييمك بنجاح وهو الآن قيد التقييم.",
  "assessments.summary.title": "ملخص التقييم",
  "assessments.summary.view": "عرض",
  "assessments.workflow.header.editAssessmentNameButtonIconColor": "primary",
  "app.assessment.progress.aiAtWork": "الذكاء الاصطناعي يعمل",
  "app.assessment.progress.elapsed": "الوقت المنقضي",
  "app.assessment.progress.lastUpdated": "آخر تحديث",
  "app.assessment.progress.leavePage": "يمكنك مغادرة الصفحة وسنواصل العمل",
  "app.assessment.progress.viewReport": "عرض التقرير",
  "app.assessment.progress.restart": "إعادة تشغيل التقييم",
  "app.assessment.progress.back": "رجوع",
  "app.assessment.progress.hero.early.title": "جارٍ قراءة مستنداتك",
  "app.assessment.progress.hero.early.body": "نفتح كل مستند ونستخرج نصه. لم يبدأ التقييم بعد. يستغرق التقييم الكامل عادةً من 30 إلى 45 دقيقة — يمكنك مغادرة هذه الصفحة والعودة لاحقًا.",
  "app.assessment.progress.hero.grading.title": "جارٍ تقييم مستنداتك مقابل نظام حماية البيانات الشخصية",
  "app.assessment.progress.hero.grading.body": "يتم تقييم عدة مستندات في الوقت نفسه، ويظهر كل مستند أدناه بمجرد اكتمال جميع أقسامه. تستغرق هذه العملية عادةً من 30 إلى 45 دقيقة.",
  "app.assessment.progress.hero.done.title": "اكتمل التقييم",
  "app.assessment.progress.hero.done.body": "تم تقييم جميع المستندات المزوّدة ({{assessed}} مستندًا). يذكر التقرير مستوى النضج المرجّح، بما في ذلك الـ {{missing}} مستندات التي لم يتم تزويدنا بها.",
  "app.assessment.progress.hero.doneNoMissing.body": "تم تقييم جميع المستندات المزوّدة ({{assessed}} مستندًا). يذكر التقرير مستوى النضج المرجّح.",
  "app.assessment.progress.hero.unknown.title": "هذا التقييم لا يرسل بيانات تقدم",
  "app.assessment.progress.hero.unknown.body": "بدأ قبل {{minutes}} دقيقة وما زال قيد التنفيذ. التقييمات التي أُنشئت قبل إضافة تقارير التقدم لا ترسل تحديثات، لذلك لا يمكننا تحديد مدى تقدمها. ستظهر النتيجة هنا بمجرد الانتهاء.",
  "app.assessment.progress.hero.stalled.title": "لا توجد تحديثات منذ {{minutes}} دقيقة",
  "app.assessment.progress.hero.stalled.body": "احتسبنا {{counted}} مستندات ثم توقفت التحديثات من هذا التقييم. كل ما تم احتسابه محفوظ. إذا استمر الانقطاع، أعد تشغيله — سيستكمل من آخر مستند تم احتسابه.",
  "app.assessment.progress.hero.queued.title": "تقييمك في الانتظار",
  "app.assessment.progress.hero.queued.body": "لقد استلمناه وسيبدأ قريبًا. يستغرق التقييم الكامل عادةً من 30 إلى 45 دقيقة — يمكنك مغادرة هذه الصفحة والعودة لاحقًا.",
  "app.assessment.progress.hero.starting.title": "جارٍ بدء تقييمك",
  "app.assessment.progress.hero.starting.body": "تم تسليم التقييم وهو قيد التجهيز الآن. سيرسل حالة كل مستند بمجرد أن يبدأ قراءته، لذلك ستمتلئ هذه الصفحة قريبًا. يستغرق التقييم الكامل عادةً من 30 إلى 45 دقيقة — يمكنك مغادرة هذه الصفحة والعودة لاحقًا.",
  "app.assessment.progress.hero.runFailed.title": "لم يكتمل هذا التقييم",
  "app.assessment.progress.hero.runFailed.body": "حدث خطأ قبل أن يتمكن التقييم من الاكتمال. لم يتم احتساب أي نتيجة. يمكنك بدءه من جديد من صفحة التقييم.",
  "app.assessment.progress.stage.intake": "قراءة المستندات",
  "app.assessment.progress.stage.classification": "المطابقة مع المتطلبات",
  "app.assessment.progress.stage.grading": "تقييم الالتزام",
  "app.assessment.progress.stage.scoring": "حساب مستوى النضج",
  "app.assessment.progress.stage.reporting": "إعداد التقرير",
  "app.assessment.progress.counted": "مُحتسب ومكتمل",
  "app.assessment.progress.inFlight": "قيد التنفيذ",
  "app.assessment.progress.notStarted": "لم يبدأ",
  "app.assessment.progress.barNote": "يمتلئ الشريط فقط بما تم احتسابه فعليًا",
  "app.assessment.progress.stageDone": "مكتمل",
  "app.assessment.progress.documentCount": "{{total}} مستندًا",
  "app.assessment.progress.countedOf": "{{done}} من {{total}}",
  "app.assessment.progress.countedInFlight": "{{done}} من {{total}} · {{flight}} قيد التنفيذ",
  "app.assessment.progress.noProgressData": "لا توجد بيانات تقدم",
  "app.assessment.progress.noProgressNote": "هذا التقييم لا يرسل بيانات تقدم. لا يوجد تعطل.",
  "app.assessment.progress.startingUp": "جارٍ التجهيز",
  "app.assessment.progress.startingUpNote": "تم تسليم التقييم ولم يرسل بيانات بعد. لا يوجد تعطل.",
  "app.assessment.progress.frozenNote": "الشريط متوقف عند آخر مستند تم احتسابه. لم يُضف شيء بعد ذلك.",
  "app.assessment.progress.counter.queued": "في الانتظار",
  "app.assessment.progress.counter.reading": "قيد القراءة",
  "app.assessment.progress.counter.grading": "قيد التقييم الآن",
  "app.assessment.progress.counter.assessed": "تم تقييمها",
  "app.assessment.progress.counter.failed": "فشل",
  "app.assessment.progress.documents": "المستندات",
  "app.assessment.progress.colDocument": "المستند",
  "app.assessment.progress.colStatus": "الحالة",
  "app.assessment.progress.colProgress": "التقدم",
  "app.assessment.progress.colGaps": "الثغرات المكتشفة",
  "app.assessment.progress.gapsFound": "ثغرة مكتشفة",
  "app.assessment.progress.lowerBound": "حد أدنى مؤكد",
  "app.assessment.progress.state.queued": "في الانتظار",
  "app.assessment.progress.state.reading": "قيد القراءة",
  "app.assessment.progress.state.read": "تمت القراءة",
  "app.assessment.progress.state.classified": "تمت المطابقة",
  "app.assessment.progress.state.grading": "قيد التقييم",
  "app.assessment.progress.state.graded": "تم التقييم",
  "app.assessment.progress.state.failed": "فشل",
  "app.assessment.progress.state.nodata": "لا بيانات",
  "app.assessment.progress.state.lastSeen": "آخر ما سُجّل",
  "app.assessment.progress.note.notStarted": "لم يبدأ",
  "app.assessment.progress.note.waitingToMatch": "في انتظار المطابقة",
  "app.assessment.progress.note.waitingToGrade": "في انتظار التقييم",
  "app.assessment.progress.note.allSectionsDone": "اكتملت جميع الأقسام",
  "app.assessment.progress.note.percentComplete": "اكتمل {{percent}}%",
  "app.assessment.progress.note.lastSeenPercent": "آخر ما سُجّل: {{percent}}%",
  "app.assessment.progress.note.notAssessed": "لم يبدأ التقييم",
  "app.assessment.progress.note.willRetry": "سنعيد المحاولة تلقائيًا",
  "app.assessment.progress.note.minutesOnDocument": "{{minutes}} دقيقة على هذا المستند",
  "app.assessment.progress.failure.unreadable": "قد يكون ممسوحًا ضوئيًا أو فارغًا أو محميًا بكلمة مرور",
  "app.assessment.progress.failure.empty": "يبدو أن المستند فارغ",
  "app.assessment.progress.failure.extraction_failed": "لم نتمكن من استخراج النص من هذا المستند",
  "app.assessment.progress.failure.grading_failed": "لم تكتمل خطوة التقييم لهذا المستند",
  "app.assessment.progress.failure.unknown": "لم نتمكن من معالجة هذا المستند",
  "app.assessment.progress.activity": "سجل النشاط",
  "app.assessment.progress.newestFirst": "الأحدث أولًا",
  "app.assessment.progress.timeline.stageChange": "تغيّر المرحلة",
  "app.assessment.progress.timeline.noActivity": "لا يوجد نشاط مُبلّغ عنه لهذا التقييم",
  "app.assessment.progress.timeline.stageCompleted": "{{stage}} — اكتمل",
  "app.assessment.progress.timeline.stageFailed": "{{stage}} — فشل",
  "app.assessment.progress.timeline.reading": "جارٍ قراءة {{document}}",
  "app.assessment.progress.timeline.read": "تمت قراءة {{document}}",
  "app.assessment.progress.timeline.classified": "تمت مطابقة {{document}} مع متطلبات النظام",
  "app.assessment.progress.timeline.grading": "بدأ تقييم {{document}}",
  "app.assessment.progress.timeline.graded": "انتهى تقييم {{document}} — {{met}} من {{total}} متطلبًا مستوفى",
  "app.assessment.progress.timeline.gradedPlain": "انتهى تقييم {{document}}",
  "app.assessment.progress.timeline.failed": "لم نتمكن من قراءة {{document}}",
  "app.assessment.progress.noScoreTitle": "لماذا لا توجد نتيجة بعد",
  "app.assessment.progress.noScoreBody": "الأرقام أعلاه هي عدد الثغرات المكتشفة لكل مستند، وهي عدّ مباشر للمتطلبات غير المستوفاة. أما مستوى النضج فهو حساب مرجّح مختلف يُذكر في التقرير النهائي فقط، ويحتسب المستندات التي لم يتم تزويدنا بها. الرقمان ليسا الشيء نفسه، ولذلك لا يُعرض أي إجمالي هنا.",
  "app.assessment.progress.failedTitle": "{{failed}} مستندات تعذّرت قراءتها",
  "app.assessment.progress.failedBody": "يستمر باقي التقييم بشكل طبيعي ولا يتأثر أي مستند تم تقييمه.",
  "app.assessment.progress.error.title": "تعذّر تحميل هذا التقييم",
  "app.assessment.progress.error.body": "التقييم ما زال قيد التنفيذ. حاول مرة أخرى بعد قليل.",
  "app.assessment.progress.error.retry": "حاول مرة أخرى",
  "app.assessment.progress.emptyDocuments": "لا توجد مستندات مرفقة بهذا التقييم.",
  "app.assessment.progress.list.onCompletion": "عند الاكتمال",
  "app.admin.features.flags.assessment_progress": "تقدّم تشغيل التقييم",
  "app.assessment.progress.list.viewRun": "عرض التقدم"
}, zi = {
  "app.dashboard.error": "We couldn't load your dashboard. Please try again.",
  "app.dashboard.welcome.greeting": "Welcome back, {{name}}",
  "app.dashboard.welcome.subtitle": "PDPL compliance overview",
  "app.dashboard.welcome.today": "Today · {{date}}",
  "app.dashboard.stats.total": "Total assessments",
  "app.dashboard.stats.totalSub": "Created all-time",
  "app.dashboard.stats.completed": "Completed",
  "app.dashboard.stats.completedSub": "Scored & reported",
  "app.dashboard.stats.processing": "Processing",
  "app.dashboard.stats.processingSub": "Being analyzed",
  "app.dashboard.stats.drafts": "Drafts",
  "app.dashboard.stats.draftsSub": "Not yet submitted",
  "app.dashboard.maturity.title": "PDPL Maturity",
  "app.dashboard.maturity.subtitle": "Your compliance system of record",
  "app.dashboard.maturity.latest": "Latest completed · {{date}}",
  "app.dashboard.maturity.label": "Maturity",
  "app.dashboard.maturity.export": "Export report",
  "app.dashboard.maturity.domainBreakdown": "Domain breakdown",
  "app.dashboard.maturity.domainsCount": "{{count}} domains",
  "app.dashboard.maturity.loadMore": "Load {{count}} more",
  "app.dashboard.maturity.showLess": "Show less",
  "app.dashboard.maturity.viewAllDomains": "View all domains",
  "app.dashboard.maturity.criticalGap": "Critical gap",
  "app.dashboard.maturity.completedAssessments": "Completed assessments",
  "app.dashboard.maturity.empty.title": "No completed assessments found",
  "app.dashboard.maturity.empty.body": "Run your first PDPL assessment to see your organization's maturity score and per-domain gap breakdown here.",
  "app.dashboard.maturity.empty.run": "Run first assessment",
  "app.dashboard.activeWork.title": "Active workspace",
  "app.dashboard.activeWork.subtitle": "Your in-flight assessments",
  "app.dashboard.activeWork.processing": "Processing",
  "app.dashboard.activeWork.draft": "Draft",
  "app.dashboard.activeWork.resumeDraft": "Resume draft",
  "app.dashboard.activeWork.launch": "Launch new PDPL assessment",
  "app.dashboard.activeWork.empty": "Nothing in progress. Launch an assessment to get started.",
  "app.dashboard.activeWork.viewAll": "View all",
  "app.dashboard.activeWork.loadMore": "Load {{count}} more",
  "app.dashboard.orgProfile.title": "Organization Profile",
  "app.dashboard.orgProfile.subtitle": "Baseline data that powers your assessments",
  "app.dashboard.orgProfile.open": "Open",
  "app.dashboard.orgProfile.completion": "Profile completion",
  "app.dashboard.orgProfile.categoriesApproved": "{{approved}} of {{total}} categories approved",
  "app.dashboard.orgProfile.documents": "Documents uploaded",
  "app.dashboard.orgProfile.documentsBreakdown": "{{approved}} approved · {{processing}} processing",
  "app.dashboard.orgProfile.fields": "Fields filled",
  "app.dashboard.orgProfile.fieldsRemaining": "{{count}} remaining",
  "app.dashboard.orgProfile.reviews": "Reviews pending",
  "app.dashboard.orgProfile.reviewsHint": "Open Document Hub",
  "app.dashboard.ai.title": "Ask Komplyance AI",
  "app.dashboard.ai.subtitle": "Backed by the PDPL knowledge base",
  "app.dashboard.ai.placeholder": "Ask about PDPL…",
  "app.dashboard.ai.quickPrompts": "Quick prompts",
  "app.dashboard.ai.prompt1": "What are the explicit penalties under PDPL for data breaches?",
  "app.dashboard.ai.prompt2": "What are the documentation requirements for cross-border data transfers?",
  "app.layout.sidebar.dashboard": "Dashboard",
  "app.assessment.classification.aiReasoning": "AI Reasoning",
  "app.assessment.classification.classifiedAt": "Classified at: {{date}}",
  "app.assessment.classification.classifying": "Classifying document...",
  "app.assessment.classification.confidence.high": "High Confidence",
  "app.assessment.classification.confidence.low": "Low Confidence",
  "app.assessment.classification.confidence.medium": "Medium Confidence",
  "app.assessment.classification.confidence.unknown": "Unknown",
  "app.assessment.classification.invalid.description": "This document could not be validated by the AI. It will not be included in your assessment submission. Please remove it and upload the correct document.",
  "app.assessment.classification.invalid.lowConfidenceSuggestion.description": "We've identified this file as part of {{detectedDomain}}, not the current domain. It won't be included in this evaluation.",
  "app.assessment.classification.invalid.title": "Invalid document",
  "app.assessment.classification.matchedBadge": "This file matched an expected document requirement",
  "app.assessment.classification.nonStandardFormat.title": "Accepted — standard format recommended",
  "app.assessment.classification.nonStandardFormat.description": "Matched as {{document}} and fully included in your assessment submission. Uploading it in the standard format gives the assessment more structure to work with, which sharpens the analysis and lets the standard version be produced for you.",
  "app.assessment.classification.unsupportedFormat.title": "Unsupported file format",
  "app.assessment.classification.unsupportedFormat.description": "This file's format can't be validated for this document. It will not be included in your assessment submission. Please re-upload it in one of the accepted formats.",
  "app.assessment.classification.invalid.wrongDomain.description": "This document does not belong to the current domain. We detected that it is more relevant to {{suggestedDomain}}.{{matchedDocumentSection}} It will not be included in this domain submission. Please remove it and upload it in the correct domain.",
  "app.assessment.classification.invalid.wrongDomain.title": "Document doesn't belong to this domain",
  "app.assessment.classification.language": "Language",
  "app.assessment.classification.matched": "Matched:",
  "app.assessment.classification.matchedDomain": "Matched Domain",
  "app.assessment.classification.mismatch.description": "This document was matched to <bold>{{documentName}}</bold>{{domainPart}}, which is <bold>not required</bold> in the current domain. Consider uploading it in the correct domain section.",
  "app.assessment.classification.mismatch.descriptionWithDomain": " (from domain: <bold>{{domainName}}</bold>)",
  "app.assessment.classification.mismatch.infoTooltip": "The AI matched this file to a standard document that is not required in the current domain. It may have been uploaded to the wrong section. Review and move it if needed.",
  "app.assessment.classification.mismatch.title": "Wrong domain",
  "app.assessment.classification.moreInfo": "More info",
  "app.assessment.classification.na": "N/A",
  "app.assessment.classification.pageCount": "Page Count",
  "app.assessment.classification.processing": "AI is analyzing your document...",
  "app.assessment.classification.processingFailed.description": "This document could not be classified by the AI. Please retry or remove it and upload a different document.",
  "app.assessment.classification.processingFailed.timedOut": "Classification is taking longer than expected. Please retry, or check back in a few minutes.",
  "app.assessment.classification.processingFailed.title": "Classification failed",
  "app.assessment.classification.queued": "Queued for classification...",
  "app.assessment.classification.retry": "Retry classification",
  "app.assessment.classification.standardDocument": "Standard Document",
  "app.assessment.classification.standardDocumentKey": "Key: {{key}}",
  "app.assessment.classification.suggestion.description": "The AI couldn't confidently classify this document, but suggests it may belong to a different domain or document type.",
  "app.assessment.classification.suggestion.moveButton": "Move to {{domain}}",
  "app.assessment.classification.suggestion.moveConfirmCta": "Move document",
  "app.assessment.classification.suggestion.moveConfirmMessage": "This document will be moved to {{domain}} and validated against that domain's required documents.",
  "app.assessment.classification.suggestion.moveConfirmTitle": "Move document to suggested domain?",
  "app.assessment.classification.suggestion.moveError": "Failed to move the document to the suggested domain",
  "app.assessment.classification.suggestion.moveSuccess": "Document moved to its suggested domain",
  "app.assessment.classification.suggestion.moving": "Moving…",
  "app.assessment.classification.suggestion.suggestedConfidence": "Suggested Confidence",
  "app.assessment.classification.suggestion.suggestedDocument": "Suggested Document",
  "app.assessment.classification.suggestion.suggestedDomain": "Suggested Domain",
  "app.assessment.classification.suggestion.suggestedReasoning": "Suggested Reasoning",
  "app.assessment.classification.suggestion.title": "AI Suggestion",
  "app.assessment.classification.unknownDocument": "an unknown standard document",
  "app.assessment.classification.warning.cancel": "Cancel",
  "app.assessment.classification.warning.reason.failed.label": "Failed",
  "app.assessment.classification.warning.reason.failed_one": "{{count}} document failed classification",
  "app.assessment.classification.warning.reason.failed_other": "{{count}} documents failed classification",
  "app.assessment.classification.warning.reason.mismatch.label": "Wrong domain",
  "app.assessment.classification.warning.reason.mismatch_one": "{{count}} document uploaded to a wrong domain",
  "app.assessment.classification.warning.reason.mismatch_other": "{{count}} documents uploaded to a wrong domain",
  "app.assessment.classification.warning.reason.unclassified.label": "Not classified",
  "app.assessment.classification.warning.reason.unclassified_one": "{{count}} document not yet classified",
  "app.assessment.classification.warning.reason.unclassified_other": "{{count}} documents not yet classified",
  "app.assessment.classification.warning.saveAnyway": "Save Anyway",
  "app.assessment.classification.warning.summary": "Before saving, we detected {{parts}}. You can save anyway or cancel to review your documents.",
  "app.assessment.classification.warning.title": "Document Classification Issues",
  "app.assessment.classification.wordCount": "Word Count",
  "app.assessment.document.downloadAll": "Download all documents",
  "app.assessment.document.downloadAllEmpty": "This assessment has no documents to download.",
  "app.assessment.document.downloadAllFailed": "Failed to download documents. Please try again.",
  "app.assessment.document.downloadAllPreparing": "Preparing ZIP...",
  "app.assessment.document.downloadAllSuccess": "ZIP download started",
  "app.assessment.document.downloadStarted": "Download started",
  "app.assessment.notStarted": "Assessment not started",
  "app.assessment.summary.changesDiscarded": "Changes discarded",
  "app.assessment.summary.completed": "Assessment completed",
  "app.assessment.summary.deleted": "Assessment deleted",
  "app.assessment.summary.deleting": "Deleting assessment...",
  "app.assessment.summary.documentUploaded": "Document uploaded successfully",
  "app.assessment.summary.domainReopened": "Domain reopened for editing",
  "app.assessment.summary.maxFilesAllowed": "Maximum number of files allowed reached",
  "app.assessment.summary.nameUpdated": "Assessment name updated",
  "app.assessment.summary.noApiDocumentFound": "No API document found",
  "app.assessment.summary.noNextDomain": "No next domain available",
  "app.assessment.summary.notAccessible": "Assessment not accessible",
  "app.assessment.summary.notCompleted": "Assessment not completed",
  "app.assessment.summary.notStarted": "Assessment not started",
  "app.assessment.workflow.changesDiscarded": "Changes discarded successfully",
  "app.assessment.workflow.completed": "Assessment completed successfully",
  "app.assessment.workflow.deleted": "Assessment deleted successfully",
  "app.assessment.workflow.deleting": "Deleting assessment...",
  "app.assessment.workflow.deletionCancelled": "Deletion cancelled",
  "app.assessment.workflow.deletionFailed": "Failed to delete assessment",
  "app.assessment.workflow.documentBadge.fromVersion": "From V{{parentVersion}}",
  "app.assessment.workflow.documentBadge.newInThisVersion": "New",
  "app.assessment.workflow.documentDeleted": "Document deleted successfully",
  "app.assessment.workflow.documentIdNotFound": "Document ID not found",
  "app.assessment.workflow.documentNotFound": "Document not found",
  "app.assessment.workflow.documentUploaded": "Document uploaded successfully",
  "app.assessment.workflow.domain.expectedDocumentsCount_one": "{{count}} expected",
  "app.assessment.workflow.domain.expectedDocumentsCount_other": "{{count}} expected",
  "app.assessment.workflow.domainReopened": "Domain reopened for editing",
  "app.assessment.workflow.duplicate": "Duplicate",
  "app.assessment.workflow.duplicateFileSkipped": "Already uploaded to this domain, so it was skipped: {{fileNames}}",
  "app.assessment.workflow.failedToDeleteAssessment": "Failed to delete assessment",
  "app.assessment.workflow.failedToDeleteDocument": "Failed to delete document",
  "app.assessment.workflow.failedToDiscardChanges": "Failed to discard changes",
  "app.assessment.workflow.failedToSaveAndExit": "Failed to save and exit",
  "app.assessment.workflow.failedToStartEditingDomain": "Failed to start editing domain",
  "app.assessment.workflow.failedToUpdateAssessmentName": "Failed to update assessment name",
  "app.assessment.workflow.fileRestored": "File restored successfully",
  "app.assessment.workflow.maxFilesAllowed": "This domain allows a maximum of {{maxRequiredDocuments}} file(s). Please remove files before uploading more.",
  "app.assessment.workflow.nameUpdated": "Assessment name updated successfully",
  "app.assessment.workflow.needsToSave": "You have unsaved changes",
  "app.assessment.workflow.noApiDocumentFound": "No API document found",
  "app.assessment.workflow.noDomainDetailsData": "No domain details data available",
  "app.assessment.workflow.noDomainId": "Domain ID not found",
  "app.assessment.workflow.noNextDomain": "No next domain available",
  "app.assessment.workflow.notAccessible": "Assessment not accessible",
  "app.assessment.workflow.notCompleted": "Assessment not completed",
  "app.assessment.workflow.notStarted": "Assessment not started",
  "app.assessment.workflow.reassessmentBanner.description": "Documents from V{{parentVersion}} are pre-loaded. Replace, remove or add documents in any domain — untouched ones will keep their V{{parentVersion}} score. V{{parentVersion}} stays intact when you submit.",
  "app.assessment.workflow.reassessmentBanner.fromVersion": "From V{{parentVersion}}",
  "app.assessment.workflow.reassessmentBanner.fromVersionWithDate": "From V{{parentVersion}} · {{parentSubmittedDate}}",
  "app.assessment.workflow.reassessmentBanner.title": "Editing for re-evaluation",
  "app.assessment.workflow.reassessmentBanner.toVersion": "V{{currentVersion}} (draft)",
  "app.assessment.workflow.reassessmentDomainBanner.scoreChip": "V{{parentVersion}} score · {{percentage}}%",
  "app.assessment.workflow.reassessmentDomainBanner.scoreChipPending": "V{{parentVersion}} score · pending",
  "app.assessment.workflow.reassessmentDomainBanner.summary": "{{documentCount}} documents from V{{parentVersion}} are pre-loaded for this domain. You can replace, remove, or add new ones.",
  "app.assessment.workflow.retryUploadFailed": "Cannot retry upload. Original file is no longer available.",
  "app.assessment.workflow.uploadCancelled": "Upload cancelled",
  "app.assessment.workflow.validation.classificationFailed": "Some documents failed to classify. Please retry or remove them before saving.",
  "app.assessment.workflow.validation.classificationInProgress": "Documents are being classified. Please wait before saving.",
  "app.assessment.workflow.validation.classificationPending": "Some documents have not been classified yet. Please wait or retry classification.",
  "app.assessment.workflow.validation.duplicateClassification": "Two or more documents were classified as the same standard document ({{name}}). Each document slot can only be filled once. Please remove the duplicate before saving.",
  "app.assessment.workflow.validation.invalidClassification_one": "{{count}} document has no classification or low confidence and will not be submitted. Please re-classify or remove it before saving.",
  "app.assessment.workflow.validation.invalidClassification_other": "{{count}} documents have no classification or low confidence and will not be submitted. Please re-classify or remove them before saving.",
  "app.assessment.workflow.validation.maxFiles_one": "Maximum {{count}} document is allowed. Please remove some files before saving.",
  "app.assessment.workflow.validation.maxFiles_other": "Maximum {{count}} documents are allowed. Please remove some files before saving.",
  "app.assessment.workflow.validation.minFiles_one": "Please upload at least {{count}} document before saving.",
  "app.assessment.workflow.validation.minFiles_other": "Please upload at least {{count}} documents before saving.",
  "app.assessment.workflow.validation.noFilesOrNoEvidence": "Please upload at least one document, or check 'No evidence available' if you have none.",
  "app.assessment.workflow.validation.noValidClassification": "All uploaded documents are invalid. Please upload at least one document with a valid classification, or remove all invalid documents and skip this domain.",
  "app.assessment.workflow.validation.waitForUploads": "Please wait for all files to finish uploading before saving.",
  "app.assessments.actions.continueAssessment": "Continue",
  "app.assessments.actions.delete": "Delete",
  "app.assessments.actions.deleteAssessment": "Delete Assessment",
  "app.assessments.actions.deleting": "Deleting...",
  "app.assessments.actions.downloadReport": "Download Report",
  "app.assessments.actions.duplicate": "Duplicate",
  "app.assessments.actions.resume": "Resume",
  "app.assessments.actions.retry": "Retry",
  "app.assessments.actions.startNewVersion": "Start New Version",
  "app.assessments.actions.viewFailureReason": "View Failure Reason",
  "app.assessments.actions.viewResults": "View Results",
  "app.assessments.actions.viewSummary": "View Results Summary",
  "app.assessments.ariaLabel.cancelEditName": "Cancel edit assessment name",
  "app.assessments.ariaLabel.confirmEditName": "Confirm assessment name",
  "app.assessments.ariaLabel.downloadDocument": "Download document",
  "app.assessments.ariaLabel.editDomain": "Edit domain",
  "app.assessments.ariaLabel.editTitle": "Edit assessment title",
  "app.assessments.ariaLabel.viewDocument": "View document",
  "app.assessments.clearAll": "Clear All",
  "app.assessments.delete.assessmentTitle": "Assessment Title:",
  "app.assessments.delete.confirmMessage": "Are you sure you want to delete this assessment?",
  "app.assessments.delete.title": "Delete Assessment",
  "app.assessments.delete.warning": "This action cannot be undone. The assessment and all of its versions, results, and uploaded documents will be permanently deleted.",
  "app.assessments.duplicate.confirm": "Duplicate",
  "app.assessments.duplicate.confirmMessage": "Choose a name for the duplicated assessment.",
  "app.assessments.duplicate.duplicating": "Duplicating...",
  "app.assessments.duplicate.error": "Failed to duplicate assessment",
  "app.assessments.duplicate.info": "All uploaded documents and their content will be copied to the new assessment.",
  "app.assessments.duplicate.sourceLabel": "Source:",
  "app.assessments.duplicate.success": "Assessment duplicated successfully",
  "app.assessments.duplicate.title": "Duplicate Assessment",
  "app.assessments.duplicate.titleLabel": "New assessment title",
  "app.assessments.duplicate.titlePrefill": "Copy of {{title}}",
  "app.assessments.duplicate.titleTooLong": "Title must be {{max}} characters or less",
  "app.assessments.emptyState.adjustFilters": "Try adjusting your filters to see more results",
  "app.assessments.emptyState.getStarted": "Get started by creating your first assessment",
  "app.assessments.emptyState.noAssessments": "No assessments found",
  "app.assessments.error.completeAllDomains": "Please complete all domains before finishing the assessment.",
  "app.assessments.error.domainNotFound": "Domain not found",
  "app.assessments.error.domainNotFoundDescription": "The requested domain could not be loaded. Please try again or contact support.",
  "app.assessments.error.domainsNotCompleted": "Not all domains are completed. Please complete all domains before viewing the summary.",
  "app.assessments.error.failedToCreate": "Failed to create assessment. Please try again.",
  "app.assessments.error.failedToLoad": "Failed to load assessment. Please try again.",
  "app.assessments.error.failedToLoadFramework": "Failed to load framework details",
  "app.assessments.error.frameworkLoadError": "There was an error loading the framework. Please try again.",
  "app.assessments.error.genericError": "An error occurred",
  "app.assessments.error.invalidAssessmentId": "Invalid assessment ID.",
  "app.assessments.error.noAssessmentId": "Assessment ID not found",
  "app.assessments.error.noNextDomain": "No next domain available.",
  "app.assessments.error.notDraftStatus": "Assessment status is not draft. Please ensure the assessment is in draft status.",
  "app.assessments.error.retry": "Retry",
  "app.assessments.failureReason.noReason": "No failure reason was recorded for this assessment.",
  "app.assessments.failureReason.title": "Failure Reason",
  "app.assessments.filters.allTime": "All Time",
  "app.assessments.filters.label": "Sort",
  "app.assessments.filters.thisMonth": "This Month",
  "app.assessments.filters.thisQuarter": "This Quarter",
  "app.assessments.filters.thisWeek": "This Week",
  "app.assessments.filters.today": "Today",
  "app.assessments.loading": "Loading assessments...",
  "app.assessments.newVersion.confirm": "Start New Version",
  "app.assessments.newVersion.confirmMessage": 'This will create a new draft version of "{{title}}". You can continue working on it while the previous completed version remains accessible.',
  "app.assessments.newVersion.error": "Failed to start new version",
  "app.assessments.newVersion.starting": "Starting...",
  "app.assessments.newVersion.success": "New draft version started",
  "app.assessments.newVersion.title": "Start New Version",
  "app.assessments.newVersion.blockedTitle": "Finish the remediation first",
  "app.assessments.newVersion.blockedRunning": "A remediation is still open on this assessment. A new version can only start once it has been applied or discarded.",
  "app.assessments.newVersion.blockedNeedsReview_one": "{{count}} remediated document is still waiting on your decision. Review and apply it, then start the new version.",
  "app.assessments.newVersion.blockedNeedsReview_other": "{{count}} remediated documents are still waiting on your decision. Review and apply them, then start the new version.",
  "app.assessments.newVersion.openRemediation": "Open the remediation",
  "app.assessments.pagination.summary": "Page {{page}} of {{totalPages}} · {{totalCount}} total",
  "app.assessments.polling.updating": "Checking for status updates...",
  "app.assessments.preparing": "Preparing your assessment...",
  "app.assessments.prerequisites.pendingUpload.cancel": "Stay on Page",
  "app.assessments.prerequisites.pendingUpload.confirm": "Leave Page",
  "app.assessments.prerequisites.pendingUpload.message": "You have uploads in progress. Leaving this page will cancel them. Are you sure you want to leave?",
  "app.assessments.prerequisites.pendingUpload.title": "Uploads in Progress",
  "app.assessments.retry.confirm": "Retry",
  "app.assessments.retry.confirmMessage": "This will re-submit the assessment for AI processing using the existing domains and documents.",
  "app.assessments.retry.error": "Failed to retry assessment",
  "app.assessments.retry.retrying": "Retrying...",
  "app.assessments.retry.success": "Assessment re-submitted successfully and is now being evaluated.",
  "app.assessments.retry.title": "Retry Assessment",
  "app.assessments.searchPlaceholder": "Search assessments...",
  "app.assessments.showingResults": "Showing {{showing}} of {{total}} assessments",
  "app.assessments.sort.nameAsc": "Name A-Z",
  "app.assessments.sort.nameDesc": "Name Z-A",
  "app.assessments.sort.updatedAsc": "Updated A-Z",
  "app.assessments.sort.updatedDesc": "Updated Z-A",
  "app.assessments.startNew": "Start New Assessment",
  "app.assessments.status.all": "All Status",
  "app.assessments.status.completed": "Completed",
  "app.assessments.status.draft": "Draft",
  "app.assessments.status.failed": "Failed",
  "app.assessments.status.processing": "Processing",
  "app.assessments.status.submitted": "Submitted",
  "app.assessments.table.actions": "Actions",
  "app.assessments.table.created": "Created",
  "app.assessments.table.latest": "Latest",
  "app.assessments.table.name": "Assessment Name",
  "app.assessments.table.progress": "Progress",
  "app.assessments.table.score": "Score",
  "app.assessments.table.status": "Status",
  "app.assessments.table.submitted": "Submitted",
  "app.assessments.table.completed": "Duration",
  "app.assessments.table.updated": "Last Updated",
  "app.assessments.duration.lessThanMinute": "< 1 min",
  "app.assessments.duration.minutes_one": "{{count}} min",
  "app.assessments.duration.minutes_other": "{{count}} min",
  "app.assessments.duration.hours_one": "{{count}} hr",
  "app.assessments.duration.hours_other": "{{count}} hr",
  "app.assessments.duration.hoursMinutes": "{{hours}} hr {{minutes}} min",
  "app.assessments.duration.days_one": "{{count}} day",
  "app.assessments.duration.days_other": "{{count}} days",
  "app.assessments.time.hoursAgo_one": "{{count}} hour ago",
  "app.assessments.time.hoursAgo_other": "{{count}} hours ago",
  "app.assessments.time.minutesAgo_one": "{{count}} minute ago",
  "app.assessments.time.minutesAgo_other": "{{count}} minutes ago",
  "app.assessments.time.now": "now",
  "app.assessments.title": "Assessments",
  "app.assessments.titleDescription": "Run PDPL readiness checks with evidence-based scoring",
  "app.assessments.untitled": "Untitled Assessment",
  "app.assessments.versionHistory.draftInProgress": "Draft version in progress",
  "app.assessments.versionHistory.title": "Version History",
  "app.assessments.versionHistory.versionLabel": "Version {{n}}",
  "app.assessments.versions_one": "{{count}} version",
  "app.assessments.versions_other": "{{count}} versions",
  "app.assessments.workflow.nameDefault": "Assessment",
  "app.assessments.workflow.nameRequired": "Assessment name is required",
  "app.assessments.workflow.removeDocumentsFirst": "Please remove all uploaded documents before marking as 'No evidence available'.",
  "app.common.back": "Back",
  "app.common.cancel": "Cancel",
  "app.common.close": "Close",
  "app.common.continue": "Continue",
  "app.common.goBack": "Go Back",
  "app.common.loading": "Loading...",
  "app.common.min": "min",
  "app.common.next": "Next",
  "app.common.of": "of",
  "app.common.optional": "Optional",
  "app.common.previous": "Previous",
  "app.common.skip": "Skip",
  "app.settings.description": "Manage your account, documents, and preferences",
  "app.settings.section.language.applang": "Current Language",
  "app.settings.section.language.desc": "Choose your preferred language for the interface",
  "app.settings.section.language.title": "Language",
  "app.settings.tabs.ariaLabel": "Settings tabs",
  "app.settings.tabs.language": "Language",
  "app.settings.tabs.myDocuments": "My Documents",
  "app.settings.tabs.notifications": "Notifications",
  "app.settings.tabs.profile": "Profile",
  "app.settings.tabs.security": "Security",
  "app.settings.title": "Settings",
  "assessment.workflow.domain.applicabilityHelper": "Please confirm whether this domain applies to your organization’s operations and data-processing activities.",
  "assessment.workflow.domain.applicabilityNoLabel": "No, not applicable (This domain does not apply to my organization. It will be excluded from scoring.)",
  "assessment.workflow.domain.applicabilityNoTooltip": "Selecting “No” will mark this domain as skipped and it won’t affect your overall score.",
  "assessment.workflow.domain.applicabilityQuestion": "Is this domain applicable to your organization?",
  "assessment.workflow.domain.applicabilityYesLabel": "Yes, it applies (I will complete this domain and upload the required evidence.)",
  "assessment.workflow.domain.applicabilityYesTooltip": "Selecting 'Yes' will mark this domain as applicable and it will be included in your overall assessment score.",
  "assessment.workflow.domain.domainApplicabilityTitle": "Domain Applicability",
  "assessment.workflow.domain.edit": "Edit",
  "assessment.workflow.domain.editToStart": 'Click "Edit" to start this domain before making changes.',
  "assessment.workflow.domain.evidenceFiles": "Evidence Files",
  "assessment.workflow.domain.expectedDocuments": "Expected Documents",
  "assessment.workflow.domain.documentsDone": "{{matched}}/{{total}} done",
  "assessment.workflow.domain.finishAssessment": "Finish Assessment",
  "assessment.workflow.domain.markAsNoEvidenceAvailable": "Mark as 'No evidence available'",
  "assessment.workflow.domain.next": "Next",
  "assessment.workflow.domain.noEvidenceAvailable": "No evidence available",
  "assessment.workflow.domain.noEvidenceTooltip": "Selecting this option will mark this question as complete and may lower your final score.",
  "assessment.workflow.domain.resume": "Resume",
  "assessment.workflow.domain.resumeLater": "Resume Later",
  "assessment.workflow.domain.saveAndNext": "Save & Continue",
  "assessment.workflow.domain.showLess": "Hide",
  "assessment.workflow.domain.showMore": "Show",
  "assessment.workflow.domain.standardFormat": "Standard format:",
  "assessment.workflow.domain.wrongFormat": "Wrong format",
  "assessment.workflow.domain.wrongFormatHint": "Right document, but uploaded as {{uploaded}} — re-upload as {{expected}} for the standard version.",
  "assessment.workflow.domain.unsupportedFormat": "Unsupported file format — can't be validated",
  "assessment.workflow.domain.filterAll": "All",
  "assessment.workflow.domain.filterMissing": "Missing",
  "assessment.workflow.domain.filterMatched": "Matched",
  "assessment.workflow.domain.requiredNotUploaded": "Required — not uploaded yet",
  "assessment.workflow.domain.optionalNotUploaded": "Optional — not uploaded yet",
  "assessment.workflow.domain.optionalShort": "Opt",
  "assessment.workflow.domain.skipAndNext": "Skip ",
  "assessment.workflow.editName.label": "Assessment Name",
  "assessment.workflow.editName.title": "Edit Assessment Name",
  "assessment.workflow.exitAssessment.cancel": "Cancel",
  "assessment.workflow.exitAssessment.deleteAndExit": "Delete all & Exit",
  "assessment.workflow.exitAssessment.domainsCompleted": "Domains Completed",
  "assessment.workflow.exitAssessment.domainsCount": "{{completed}} of {{total}}",
  "assessment.workflow.exitAssessment.evidenceUploaded": "Evidence Uploaded",
  "assessment.workflow.exitAssessment.filesAttachedLabel": "files attached",
  "assessment.workflow.exitAssessment.filesAttached_one": "{{count}} file attached",
  "assessment.workflow.exitAssessment.filesAttached_other": "{{count}} files attached",
  "assessment.workflow.exitAssessment.helpText": "You can save and continue later, or permanently delete your progress.",
  "assessment.workflow.exitAssessment.message": "You have progress that can be saved before leaving.",
  "assessment.workflow.exitAssessment.overallProgress": "Overall Progress",
  "assessment.workflow.exitAssessment.saveAndExit": "Save Progress & Exit",
  "assessment.workflow.exitAssessment.title": "Exit Assessment?",
  "assessment.workflow.unsavedChanges.cancel": "Cancel",
  "assessment.workflow.unsavedChanges.changesInclude": "Unsaved changes include:",
  "assessment.workflow.unsavedChanges.discard": "Discard Changes",
  "assessment.workflow.unsavedChanges.fieldChanges": "Changes to domain fields",
  "assessment.workflow.unsavedChanges.message": "You have unsaved changes in this domain. What would you like to do before you navigate away?",
  "assessment.workflow.unsavedChanges.pendingDeletions": "Documents marked for deletion",
  "assessment.workflow.unsavedChanges.pendingUploads": "Pending document uploads",
  "assessment.workflow.unsavedChanges.save": "Save & Continue",
  "assessment.workflow.unsavedChanges.stay": "Stay Here",
  "assessment.workflow.unsavedChanges.title": "Unsaved Changes",
  "assessments.new.back": "Back to Assessments",
  "assessments.new.button.description": "Assessment will open in a new focused view",
  "assessments.new.button.startAssessment": "Start New Assessment",
  "assessments.new.card.evidenceCount": "evidence documents",
  "assessments.new.description": "Set up your PDPL compliance assessment in one simple step",
  "assessments.new.details.name": "Name",
  "assessments.new.details.note": "This will appear in your assessments list and reports.",
  "assessments.new.details.title": "Assessment Details",
  "assessments.new.languages.description": "Select the language in which you’d like to receive your assessment report and related documentation. ",
  "assessments.new.languages.title": "Assessment Language",
  "assessments.new.list.description": "Select the areas you want to assess",
  "assessments.new.list.title": "Assessment Scope",
  "assessments.new.progressFlow.completed": " completed",
  "assessments.new.progressFlow.domain": "domain",
  "assessments.new.progressFlow.domainNumber": "Domain {{number}} of {{total}}",
  "assessments.new.progressFlow.domains": "domains",
  "assessments.new.progressFlow.optional": "Optional",
  "assessments.new.progressFlow.progress": "Progress",
  "assessments.new.progressFlow.required": "Required",
  "assessments.new.summary.aiTime": "60-75 min",
  "assessments.new.summary.aiTimeDescription": "Estimated Komplyance AI completion time",
  "assessments.new.summary.description": "Complete your PDPL readiness in about 1 hour instead of weeks.",
  "assessments.new.summary.optimizedTip1": "Up to 70% faster than traditional compliance reviews",
  "assessments.new.summary.optimizedTip2": "Only key evidence required",
  "assessments.new.summary.optimizedTip3": "Automated gap analysis",
  "assessments.new.summary.optimizedTitle": "AI-Optimized Assessment:",
  "assessments.new.summary.questions": "evidence documents required",
  "assessments.new.summary.tip1": "Progress is automatically saved",
  "assessments.new.summary.tip2": "Generate reports when complete",
  "assessments.new.summary.title": "Fast AI-Guided Assessment",
  "assessments.new.summary.traditionalReview": "Traditional compliance review",
  "assessments.new.summary.traditionalTime": "4-6 weeks",
  "assessments.new.tips.BeforeAssessment.description1": "Gather relevant documentation",
  "assessments.new.tips.BeforeAssessment.description2": "Involve key stakeholders",
  "assessments.new.tips.BeforeAssessment.description3": "Review current policies",
  "assessments.new.tips.BeforeAssessment.title": "Before you start:",
  "assessments.new.tips.DuringAssessment.description1": "Answer honestly for accurate results",
  "assessments.new.tips.DuringAssessment.description2": "Use “N/A” when not applicable",
  "assessments.new.tips.DuringAssessment.description3": "Add comments for context and all required documents",
  "assessments.new.tips.DuringAssessment.title": "During Assessment:",
  "assessments.new.tips.title": "Assessment Tips",
  "assessments.new.title": "Start New Assessment",
  "assessments.onboarding.button.description": "Takes approximately 15-30 minutes depending on assessment type",
  "assessments.onboarding.button.start": "Start Your First Assessment",
  "assessments.onboarding.card1.description": "Evaluate compliance across all regulatory domains",
  "assessments.onboarding.card1.title": "Comprehensive Analysis",
  "assessments.onboarding.card2.description": "Identify potential compliance gaps and risks early",
  "assessments.onboarding.card2.title": "Risk Identification",
  "assessments.onboarding.card3.description": "Monitor your compliance maturity over time",
  "assessments.onboarding.card3.title": "Progress Tracking",
  "assessments.onboarding.description": "Start your compliance journey by performing your first assessment. Our platform helps you identify gaps, track progress, and maintain regulatory compliance.",
  "assessments.onboarding.footer.item1": "Regulatory Article Review",
  "assessments.onboarding.footer.item2": "Maturity Assessment",
  "assessments.onboarding.footer.item3": "Gap Analysis",
  "assessments.onboarding.footer.title": "What to expect:",
  "assessments.onboarding.title": "Welcome to Compliance Assessments",
  "assessments.overview.NewAssessment": "New Assessment",
  "assessments.overview.charts.domainScoresSubtitle": "Maturity score per compliance domain",
  "assessments.overview.charts.domainScoresTitle": "Domain Maturity Scores",
  "assessments.overview.charts.maturityDistSubtitle": "Domains grouped by maturity level",
  "assessments.overview.charts.maturityDistTitle": "Maturity Level Distribution",
  "assessments.overview.charts.levelDistTitle": "Domain Maturity Distribution",
  "assessments.overview.charts.levelDistSubtitle": "Number of domains at each maturity level",
  "assessments.overview.charts.noData": "No domain data available",
  "assessments.overview.charts.domain": "domain",
  "assessments.overview.charts.domains": "domains",
  "assessments.overview.charts.settings.title": "Chart Settings",
  "assessments.overview.charts.settings.subtitle": "Customize what and how charts display",
  "assessments.overview.charts.settings.visibility": "Visibility",
  "assessments.overview.charts.settings.showRadar": "Radar Chart",
  "assessments.overview.charts.settings.showBar": "Bar Chart",
  "assessments.overview.charts.settings.barSection": "Bar Chart Options",
  "assessments.overview.charts.settings.filterGaps": "Domains with gaps only",
  "assessments.overview.charts.settings.filterGapsHint": "Hide fully compliant domains",
  "assessments.overview.charts.settings.sortLabel": "Sort order",
  "assessments.overview.charts.settings.sortScoreDesc": "Score ↓",
  "assessments.overview.charts.settings.sortScoreAsc": "Score ↑",
  "assessments.overview.charts.settings.sortName": "Name",
  "assessments.overview.charts.settings.noChartsVisible": "All charts hidden — enable one above",
  "assessments.overview.charts.gapsTitle": "Gaps Overview",
  "assessments.overview.charts.gapsSubtitle": "Critical vs. other identified gaps",
  "assessments.overview.charts.noGaps": "No gaps found",
  "assessments.overview.charts.noGapsSubtitle": "All domains meet compliance requirements",
  "assessments.overview.charts.totalGaps": "total",
  "assessments.overview.charts.criticalGaps": "Critical",
  "assessments.overview.charts.otherGaps": "Other",
  "assessments.overview.charts.stat.domainsCovered": "Domains Covered",
  "assessments.overview.charts.stat.maturityScore": "Overall Maturity Score",
  "assessments.overview.charts.stat.missingDocs": "Missing Documents",
  "assessments.overview.charts.stat.totalGaps": "Total Gaps Identified",
  "assessments.overview.radar.subtitle": "Maturity coverage across all compliance domains",
  "assessments.overview.radar.subtitleComparing": "Comparing maturity coverage between versions",
  "assessments.overview.radar.title": "Domain Coverage Radar",
  "assessments.overview.tabs.detailedGaps": "Detailed Gaps",
  "assessments.overview.tabs.overview": "Overview",
  "assessments.overview.acrossAllDomains": "Across all domains",
  "assessments.overview.articlesAssessed": "Articles Assessed",
  "assessments.overview.assessedDocuments": "Assessed Documents",
  "assessments.overview.assessmentCompletedSuccessfully": "Assessment Completed Successfully",
  "assessments.overview.classifiedAs": "Classified as",
  "assessments.overview.completedOn": "Completed on • {{date}}",
  "assessments.overview.completionSummary": "We identified {{gaps}} gaps out of {{controlPoints}} control points assessed",
  "assessments.overview.comprehensiveBreakdownByDomain": "Comprehensive breakdown by compliance domain",
  "assessments.overview.criticalGapsIdentified_one": "{{count}} critical gap identified",
  "assessments.overview.criticalGapsIdentified_other": "{{count}} critical gaps identified",
  "assessments.overview.dashboardViewComingSoon": "Dashboard view will be available soon",
  "assessments.overview.detailedDomainBreakdown": "Detailed Domain Breakdown",
  "assessments.overview.documentsAssessed": "{{count}} documents assessed",
  "assessments.overview.documentsBadge_one": "{{count}} / {{total}} Uploaded document",
  "assessments.overview.documentsBadge_other": "{{count}} / {{total}} Uploaded documents",
  "assessments.overview.domainNotApplicableBadge": "Not Applicable",
  "assessments.overview.domainNotApplicableCaption": "Marked as not applicable to your organization",
  "assessments.overview.domainNotApplicableDescription": "This domain was marked as not applicable to your organization at the start of the assessment. It was excluded from scoring and gap analysis, and no documents were requested.",
  "assessments.overview.domainNotApplicableTitle": "Not applicable to your organization",
  "assessments.overview.domainNotAssessed": "Domain not assessed — no documents submitted",
  "assessments.overview.domainSkippedDescription": "No documents were submitted for this domain, so individual gaps weren't evaluated. Upload the standard documents below to run a full assessment and surface gaps, risk and improvement priorities.",
  "assessments.overview.domainSkippedTitle": "This domain was skipped",
  "assessments.overview.domainWeight": "Domain weight {{weight}}%",
  "assessments.overview.domainsCovered": "{{count}} domains covered",
  "assessments.overview.downloadDetailedGaps": "Download Detailed Gaps",
  "assessments.overview.downloadDetailedGapsOrStartNew": "Download Detailed Gaps or Start New",
  "assessments.overview.duplicate.confirmButton": "Yes, duplicate it",
  "assessments.overview.duplicate.confirmDescription": "A new assessment will be created with all uploaded documents copied across.",
  "assessments.overview.duplicate.confirmTitle": "Duplicate this assessment?",
  "assessments.overview.duplicate.loadingDescription": "Copying documents and preparing your new assessment.",
  "assessments.overview.duplicate.loadingTitle": "Duplicating your assessment…",
  "assessments.overview.duplicate.menuItem": "Duplicate Assessment",
  "assessments.overview.duplicate.statDocuments": "Documents",
  "assessments.overview.duplicate.statDomains": "Domains",
  "assessments.overview.duplicate.statLanguage": "Language",
  "assessments.overview.duplicate.warningText": "Previous results, gaps, risk and priorities will <bold>not</bold> be carried over — only your uploaded documents are copied.",
  "assessments.overview.editDomain.button": "Edit",
  "assessments.overview.editDomain.tooltip": "Open draft V{{version}} to re-upload documents for this domain",
  "assessments.overview.editDomain.tooltipNoDraft": "Start a new version first to edit and re-upload documents",
  "assessments.overview.editDomain.startVersionHint": 'Click "Start New Version" to create a draft you can edit, then re-upload your documents.',
  "assessments.overview.error.failedToLoadResults": "Failed to load assessment results",
  "assessments.overview.exportFunctionalityComingSoon": "Export functionality will be available soon",
  "assessments.overview.gapsCount": "Gaps: {{count}}",
  "assessments.overview.gapsCount_one": "Gap: {{count}}",
  "assessments.overview.gapsCount_other": "Gaps: {{count}}",
  "assessments.overview.gapsIdentified": "Gaps in Uploaded Documents",
  "assessments.overview.gapsIdentifiedSubtitle": "From documents you uploaded — missing documents are tracked separately",
  "assessments.overview.gapsSummary": "Gaps Summary",
  "assessments.overview.ifLeftUnaddressed": "If left unaddressed",
  "assessments.overview.improvementPriorities": "Improvement Priorities",
  "assessments.overview.charts.howToRead": "How to read this chart",
  "assessments.overview.contentLanguage.ar": "Arabic",
  "assessments.overview.contentLanguage.en": "English",
  "assessments.overview.resultsGeneratedIn": "Results in {{language}}",
  "assessments.overview.resultsGeneratedInHelp": "This assessment was run in {{language}}, so its findings and recommendations were written in that language. Switching the app language translates the interface — it does not re-translate results that have already been generated.",
  "assessments.overview.resultsNotReady.body": "This assessment has not been completed, or is still being processed. Results appear here once processing finishes.",
  "assessments.overview.resultsNotReady.title": "Assessment results are not available yet",
  "assessments.overview.maturityLevel": "{{levelName}} (Level {{level}} of {{maxLevel}})",
  "assessments.overview.missingBadge": "Missing",
  "assessments.overview.missingDocuments": "Missing Documents",
  "assessments.overview.missingDocumentsBadge_one": "{{count}} Missing Document",
  "assessments.overview.missingDocumentsBadge_other": "{{count}} Missing Documents",
  "assessments.overview.missingDocumentsCount": "{{count}} missing documents",
  "assessments.overview.missingStandardDocuments": "Missing documents",
  "assessments.overview.overallMaturityScore": "Overall Maturity Score",
  "assessments.overview.overallResults": "Overall Results",
  "assessments.overview.readyToContinue": "Ready to continue?",
  "assessments.overview.reportDownloadComingSoon": "Report download will be available soon",
  "assessments.overview.standardsAwaitingUpload_one": "{{count}} standard awaiting upload",
  "assessments.overview.standardsAwaitingUpload_other": "{{count}} standards awaiting upload",
  "assessments.overview.theRisk": "The Risk",
  "assessments.overview.uploadedFile": "Uploaded file",
  "assessments.overview.uploadedOn": "Uploaded {{date}} · {{size}} KB",
  "assessments.overview.versioning.compareTo.label": "Compare to:",
  "assessments.overview.versioning.compareTo.none": "— None —",
  "assessments.overview.versioning.documents.removedFromBaseline": "Removed since {{baseline}} · {{size}} KB",
  "assessments.overview.versioning.documents.tag.carriedOver": "Carried over",
  "assessments.overview.versioning.documents.tag.new": "New",
  "assessments.overview.versioning.documents.tag.removed": "Removed",
  "assessments.overview.versioning.domainBreakdown.comparingSubtitle": "Comparing {{active}} vs {{baseline}} · ▲ improvement, ▼ regression",
  "assessments.overview.versioning.domainBreakdown.editedIn": "Edited in {{version}}",
  "assessments.overview.versioning.domainBreakdown.sameAs": "Same as {{version}}",
  "assessments.overview.versioning.header.menu.startNewVersion": "Start New Version",
  "assessments.overview.versioning.header.subtitle.reassessment": "Review your latest results, or start a new version to re-evaluate",
  "assessments.overview.versioning.hero.domainsEditedFromPrev_one": "{{count}} domain edited from {{version}}",
  "assessments.overview.versioning.hero.domainsEditedFromPrev_other": "{{count}} domains edited from {{version}}",
  "assessments.overview.versioning.hero.reassessmentCompleted": "Re-assessment Completed Successfully",
  "assessments.overview.versioning.kpi.deltaFlat": "Same as {{baseline}} ({{baselineValue}})",
  "assessments.overview.versioning.kpi.deltaVs": "{{sign}}{{value}} vs {{baseline}} ({{baselineValue}})",
  "assessments.overview.versioning.oldVersionBanner.jumpToLatest": "Jump to latest",
  "assessments.overview.versioning.oldVersionBanner.text": "You're viewing {{activeVersion}} — {{latestVersion}} ({{latestDate}}) is the latest",
  "assessments.overview.versioning.versionSelector.heading": "Versions",
  "assessments.overview.versioning.versionSelector.initial": "Initial",
  "assessments.overview.versioning.versionSelector.latest": "Latest",
  "assessments.overview.viewDashboard": "View Dashboard",
  "assessments.overview.weightBadge": "Weight {{weight}}%",
  "assessments.overview.whatIsNeeded": "What is Needed",
  "assessments.overview.gaps.critical": "Critical",
  "assessments.overview.gaps.regulatoryExposure": "Regulatory exposure risk",
  "assessments.overview.gaps.noCritical": "No critical gaps",
  "assessments.overview.gaps.viewDetailed": "View gaps →",
  "assessments.overview.missingDocs.summary_one": "{{count}} missing document across {{domains}} domain",
  "assessments.overview.missingDocs.summary_other": "{{count}} missing documents across {{domains}} domains",
  "assessments.overview.charts.barView": "Bar chart view:",
  "assessments.overview.charts.versions": "Versions",
  "assessments.overview.charts.filter": "Filter",
  "assessments.overview.charts.barStacked": "Stacked",
  "assessments.overview.charts.barGrouped": "Grouped",
  "assessments.overview.charts.worstFive": "Worst 5",
  "assessments.overview.charts.bestFive": "Best 5",
  "assessments.overview.charts.versionCurrent": "V{{version}} (current)",
  "assessments.overview.charts.versionBaseline": "V{{version}} (baseline)",
  "assessments.overview.charts.addComparison": "Add Comparison",
  "assessments.overview.radar.maxOverlays": "Max {{count}} overlays",
  "assessments.overview.charts.empty.title": "No domain data yet",
  "assessments.overview.charts.empty.subtitle": "Once domains are assessed, scores and gap analysis will appear here.",
  "assessments.overview.charts.radar.needMoreDomains": "Radar view needs at least 3 assessed domains",
  "assessments.overview.charts.radar.needMoreDomainsSubtitle": "Showing a score list instead — {{count}} domain assessed so far",
  "assessments.overview.charts.radar.needMoreDomainsSubtitle_other": "Showing a score list instead — {{count}} domains assessed so far",
  "assessments.overview.charts.radar.needMoreDomainsSubtitle_one": "Showing a score list instead — {{count}} domain assessed so far",
  "assessments.overview.charts.domainsShown_one": "Showing {{shown}} of {{total}} domain",
  "assessments.overview.charts.domainsShown_other": "Showing {{shown}} of {{total}} domains",
  "assessments.overview.charts.noScore": "Not assessed",
  "assessments.overview.charts.notAssessedSuffix": "(not assessed)",
  "assessments.overview.charts.notAssessedCount_one": "{{count}} not yet assessed",
  "assessments.overview.charts.notAssessedCount_other": "{{count}} not yet assessed",
  "assessments.overview.gapsFilter.all": "All ({{count}})",
  "assessments.overview.gapsFilter.hasGaps": "Has Gaps ({{count}})",
  "assessments.overview.gapsFilter.missingDocs": "Missing Docs ({{count}})",
  "assessments.overview.gapsFilter.complete": "Complete ({{count}})",
  "assessments.overview.gapsFilter.empty": "No domains match this filter.",
  "assessments.overview.showAll": "Show all {{count}} domains",
  "assessments.overview.showLess": "Show less",
  "assessments.overview.priorityActions.title": "Priority Actions",
  "assessments.overview.priorityActions.subtitle": "AI-generated remediation steps for your {{count}} weakest domains — ranked by urgency",
  "assessments.overview.priorityActions.show": "Show",
  "assessments.overview.priorityActions.hide": "Hide",
  "assessments.overview.priorityActions.recommendedActions": "Recommended Actions",
  "assessments.overview.priorityActions.noActions": "No specific actions available yet.",
  "assessments.overview.priorityActions.urgency.critical": "Critical",
  "assessments.overview.priorityActions.urgency.high": "High",
  "assessments.overview.priorityActions.urgency.medium": "Medium",
  "assessments.overview.priorityActions.urgency.low": "Low",
  "assessments.overview.priorityActions.effort": "~{{time}} est.",
  "assessments.overview.priorityActions.effortRange": "Estimated range: {{range}} — varies by team size and existing documentation",
  "app.layout.sidebar.expand": "Expand",
  "app.layout.sidebar.ask": "Ask",
  "app.layout.sidebar.assessments": "Assessments",
  "app.layout.sidebar.documentsRemediation": "Documents Remediation — New",
  "app.layout.sidebar.newChat": "New Chat",
  "app.layout.sidebar.settings": "Settings",
  "assessments.progressFlow.progress": "Progress",
  "assessments.summary.allComplete": "All complete",
  "assessments.summary.back": "Back",
  "assessments.summary.classification.invalidDocument": "Invalid document",
  "assessments.summary.classification.noMatch": "No standard document matched",
  "assessments.summary.classification.wontBeSubmitted": "Won't be submitted",
  "assessments.summary.completion": "Completion",
  "assessments.summary.completionMessage": "Congratulations! Your assessment is complete and ready for submission.",
  "assessments.summary.completionSubtitle": "You've successfully answered across {{domainCount}} domains and uploaded {{documentCount}} supporting documents. Please review your responses below and submit when ready.",
  "assessments.summary.confirmModal.cancel": "Cancel",
  "assessments.summary.confirmModal.confirm": "Submit Assessment",
  "assessments.summary.confirmModal.evaluationInfo": "The system will begin evaluating your responses and documents.",
  "assessments.summary.confirmModal.submitting": "Submitting...",
  "assessments.summary.confirmModal.title": "Submit Assessment for Evaluation?",
  "assessments.summary.confirmModal.warningMessage": "Once submitted, you cannot edit this assessment. If you need to make changes later, you'll need to start a new version of the assessment.",
  "assessments.summary.documentCount": "{{count}} documents",
  "assessments.summary.documents": "Documents",
  "assessments.summary.domainSummary": "Domain Summary",
  "assessments.summary.domainsEdited": "Domains Edited",
  "assessments.summary.domainsKept": "{{count}} kept as-is",
  "assessments.summary.download": "Download",
  "assessments.summary.edit": "Edit",
  "assessments.summary.editedForVersion": "Edited for V{{version}}",
  "assessments.summary.errorMessage": "Failed to submit assessment. Please try again.",
  "assessments.summary.evidenceUploaded": "Evidence uploaded",
  "assessments.summary.fewerMissing": "{{count}} fewer missing",
  "assessments.summary.generateWithAI": "Generate Documents with AI",
  "assessments.summary.mandatory": "{{mandatoryDomains}} mandatory, {{optionalDomains}} optional",
  "assessments.summary.missingBadge": "Missing",
  "assessments.summary.missingDocsLegend.better": "Fewer missing than V{{version}} (improving)",
  "assessments.summary.missingDocsLegend.title": "Missing docs indicator:",
  "assessments.summary.missingDocsLegend.worse": "More missing than V{{version}} (needs attention)",
  "assessments.summary.missingDocumentsBadge_one": "{{count}} Missing Document",
  "assessments.summary.missingDocumentsBadge_other": "{{count}} Missing Documents",
  "assessments.summary.missingDocumentsCard": "Missing Documents",
  "assessments.summary.missingDocumentsCardSubtitle": "Across all domains",
  "assessments.summary.missingDocumentsImproving": "Was {{parentTotalMissing}} previously · improving",
  "assessments.summary.missingDocumentsRegressing": "Was {{parentTotalMissing}} previously · needs attention",
  "assessments.summary.missingDocumentsSection": "Missing standard documents",
  "assessments.summary.missingDocumentsUnchanged": "Unchanged from previous version",
  "assessments.summary.missingDocuments_one": "{{count}} missing",
  "assessments.summary.missingDocuments_other": "{{count}} missing",
  "assessments.summary.moreMissing": "{{count}} more missing",
  "assessments.summary.noDocuments": "No documents uploaded",
  "assessments.summary.parentDomainScore": "V{{version}}: {{percentage}}%",
  "assessments.summary.removedFromParent": "{{count}} removed since V{{version}}",
  "assessments.summary.skipped": "Skipped",
  "assessments.summary.skippedDocumentsBadge_one": "{{count}} Skipped Document",
  "assessments.summary.skippedDocumentsBadge_other": "{{count}} Skipped Documents",
  "assessments.summary.submitAssessment": "Submit Assessment",
  "assessments.summary.successMessage": "Your assessment has been successfully submitted and is now being evaluated.",
  "assessments.summary.title": "Assessment Summary",
  "assessments.summary.totalDomains": "Total Domains",
  "assessments.summary.uploadedOn": "Uploaded {{date}}",
  "assessments.summary.view": "View",
  "assessments.summary.warningMessage": "Please review all domains carefully before submission. Once submitted, you cannot edit this assessment. If you need to make changes later, you'll need to start a new assessment.",
  "assessments.summary.wasInParent": "Was in V{{version}}",
  "assessments.workflow.domain.applicabilityNoTooltip": "Selecting 'No' will mark this domain as skipped and it won't affect your overall assessment score.",
  "assessments.workflow.domain.applicabilityQuestion": "Domain Applicability",
  "assessments.workflow.domain.applicabilityYesTooltip": "This domain applies to your organization and you need to complete it and provide evidence.",
  "assessments.workflow.domain.edit": "Edit",
  "assessments.workflow.domain.evidenceFiles": "Evidence Files",
  "assessments.workflow.domain.finishAssessment": "Finish Assessment",
  "assessments.workflow.domain.goToSummary": "Go to Summary",
  "assessments.workflow.domain.markAsNoEvidenceAvailable": "Mark as 'No evidence available'",
  "assessments.workflow.domain.next": "Next",
  "assessments.workflow.domain.noEvidenceAvailable": "No evidence available",
  "assessments.workflow.domain.noEvidenceTooltip": "Selecting this option will mark this question as complete and may lower your final score.",
  "assessments.workflow.domain.resume": "Resume",
  "assessments.workflow.domain.resumeLater": "Resume Later",
  "assessments.workflow.domain.saveAndNext": "Save & Continue",
  "assessments.workflow.header.editAssessmentName": "Edit Assessment Name",
  "assessments.workflow.header.editAssessmentNameButton": "Edit",
  "assessments.workflow.header.editAssessmentNameButtonIcon": "Edit",
  "assessments.workflow.header.editAssessmentNameButtonIconColor": "primary",
  "assessments.workflow.header.editAssessmentNamePlaceholder": "Enter assessment name",
  "assessments.workflow.header.exitAssessment": "Exit Assessment",
  "auth.internalLogin.backToHome": "Back to Home",
  "auth.internalLogin.form.button.signIn": "Continue with Email",
  "auth.internalLogin.form.description": "Select your sign-in method",
  "auth.internalLogin.form.title": "Sign In",
  "auth.login.description1": "Simplify Compliance",
  "auth.login.description2": "AI That Understands Compliance",
  "auth.login.failed": "Login failed. Please try again.",
  "auth.login.form.button.google": "Continue with Google",
  "auth.login.form.button.loading": "Signing in...",
  "auth.login.form.button.submit": "Sign In",
  "auth.login.form.description": "Let’s sign in to create powerful Komplyance account for you.",
  "auth.login.form.email.label": "Email",
  "auth.login.form.email.placeholder": "Enter your email",
  "auth.login.form.password.label": "Password",
  "auth.login.form.password.placeholder": "Enter your password",
  "auth.login.form.title": "Sign In Your Komplyance Power",
  "auth.login.form.validation.email.invalid": "Please enter a valid email address",
  "auth.login.form.validation.password.required": "Password is required",
  "auth.login.instruction": "Sign in to your compliance dashboard",
  "auth.login.title": "Powerful Enterprise Compliance Management",
  "auth.login.welcome": "Welcome to AI-Driven Legal Intelligence",
  "auth.profilePanel.button.logout": "Log out",
  "auth.profilePanel.button.settings": "Settings",
  "auth.profilePanel.email.fallback": "No email",
  "auth.profilePanel.user.fallback": "User",
  "chat.attachment.download": "Download",
  "chat.attachment.downloadError": "Failed to download file",
  "chat.empty.title": "No messages yet. Start a conversation!",
  "chat.errors.genericError": "An error occurred",
  "chat.errors.rateLimitCountdown": "You can send again in {{seconds}}s",
  "chat.errors.rateLimitExceeded": "You're sending messages too fast. Please wait {{seconds}} seconds.",
  "chat.errors.retry": "Retry",
  "chat.errors.serviceUnavailable": "AI service is temporarily unavailable. Please try again shortly.",
  "chat.errors.unexpectedError": "An unexpected error occurred",
  "chat.file.type.document": "Document",
  "chat.file.type.excel": "Excel document",
  "chat.file.type.pdf": "PDF document",
  "chat.file.type.word": "Word document",
  "chat.input.addFilesAndDocuments": "Add Files & Documents",
  "chat.input.attachFile": "Attach files",
  "chat.input.checkDocumentsPlaceholder": "Ask about the document...",
  "chat.input.deepResearch": "Advanced search",
  "chat.input.dropFilesHere": "Drop files here to upload",
  "chat.input.placeholder": "Type your message...",
  "chat.input.send": "Send message",
  "chat.input.stop": "Stop generation",
  "chat.input.uploadFailed": "Upload failed",
  "chat.input.uploading": "Uploading",
  "chat.loadError.button": "Retry",
  "chat.loadError.description": "Please check your connection and try again.",
  "chat.loadError.title": "Something went wrong while loading this conversation.",
  "chat.loading.title": "Loading conversation...",
  "chat.new.description": "Ask questions about PDPL and get answers from your AI Compliance Assistant",
  "chat.new.form.placeholder": "Ask about PDPL…",
  "chat.new.title": "Your AI Compliance Assistant",
  "chat.references.title": "References Checked",
  "chat.scrollToBottom.ariaLabel": "Scroll down",
  "chat.scrollToBottom.newMessage": "New message",
  "chat.scrollToBottom.scrollDown": "Scroll down",
  "chat.streaming.stage.assessing": "Evaluating your document...",
  "chat.streaming.stage.assessment_completed": "Assessment complete...",
  "chat.streaming.stage.assessment_started": "Starting assessment...",
  "chat.streaming.stage.classifying": "Classifying document...",
  "chat.streaming.stage.completing": "Generating response...",
  "chat.streaming.stage.deep_researching": "Searching the latest public sources…",
  "chat.streaming.stage.downloading": "Downloading document...",
  "chat.streaming.stage.extracting": "Extracting content...",
  "chat.streaming.stage.filtering_kb": "Selecting the most relevant sources…",
  "chat.streaming.stage.finalizing_answer": "Finalizing your answer…",
  "chat.streaming.stage.generating_response": "Composing your answer…",
  "chat.streaming.stage.grading": "Grading document...",
  "chat.streaming.stage.indexing": "Indexing document...",
  "chat.streaming.stage.ingesting": "Ingesting document...",
  "chat.streaming.stage.processing": "Thinking...",
  "chat.streaming.stage.quality_check": "Reviewing answer quality…",
  "chat.streaming.stage.retrieving_kb": "Exploring the knowledge base…",
  "chat.streaming.stage.summarizing": "Summarizing document...",
  "chat.streaming.stage.understanding_query": "Understanding your question…",
  "chat.suggestedQuestions.question1": "What is PDPL?",
  "chat.suggestedQuestions.question2": "Who regulates PDPL in KSA?",
  "chat.suggestedQuestions.question3": "What does PDPL mandate for organizations?",
  "chatHistory.delete.body": `"{{name}}" and all of its messages will be permanently deleted. This can't be undone.`,
  "chatHistory.delete.confirm": "Delete",
  "chatHistory.delete.menuItem": "Delete",
  "chatHistory.delete.title": "Delete conversation?",
  "chatHistory.emptyState.noConversations": "No conversations yet. Start a new chat to see it here.",
  "chatHistory.emptyState.noSearchResults": "No conversations match your search.",
  "chatHistory.errors.failedToLoad": "Failed to load conversations",
  "chatHistory.loadingConversations": "Loading conversations...",
  "chatHistory.moreActions": "More actions",
  "chatHistory.sidePanel.title": "Chat History",
  "chatHistory.toast.deleteFailed": "Failed to delete conversation",
  "chatHistory.toast.deleted": "Conversation deleted",
  "common.cancelButton": "Cancel",
  "common.no": "No",
  "common.saveButton": "Save",
  "common.new": "New",
  "common.soon": "Soon",
  "common.yes": "Yes",
  "components.copyButton.failedToCopy": "Failed to copy text",
  "components.loading.text": "Loading...",
  "errors.ASSESSMENT.AI_RESPONSE_INVALID": "The assessment processing service returned an invalid response.",
  "errors.ASSESSMENT.CREATION_FAILED": "Failed to create assessment. Please try again.",
  "errors.ASSESSMENT.DOMAINS_INCOMPLETE": "All domains must be completed before submitting the assessment.",
  "errors.ASSESSMENT.HAS_PENDING_DOCUMENTS": "Assessment has pending or deleted documents. Please finalize all documents before submission.",
  "errors.ASSESSMENT.INVALID_STATUS": "This action cannot be performed in the current assessment status.",
  "errors.ASSESSMENT.NOT_FOUND": "Assessment not found or you do not have access to it.",
  "errors.ASSESSMENT.STATUS_CHECK_FAILED": "Failed to check assessment processing status. The service may be temporarily unavailable.",
  "errors.ASSESSMENT.UNSUPPORTED_LANGUAGE": "The selected language is not supported for this assessment.",
  "errors.COMMON.FORBIDDEN": "You do not have permission to perform this action.",
  "errors.COMMON.INTERNAL_ERROR": "An internal error occurred. Please try again later.",
  "errors.COMMON.NOT_FOUND": "Resource not found",
  "errors.COMMON.UNAUTHORIZED": "Unauthorized. Please log in to continue.",
  "errors.COMMON.TOO_MANY_REQUESTS": "Too many requests. Please wait a moment and try again.",
  "errors.COMMON.VALIDATION_ERROR": "Validation error. Please check your input.",
  "errors.DOCUMENT.ALREADY_IN_TARGET_DOMAIN": "This file is already in that domain. Open the domain to review the copy that is there, then delete this one if you no longer need it.",
  "errors.DOCUMENT.DUPLICATE_FILE_IN_DOMAIN": "You have already uploaded this file to this domain. Delete the existing one first if you want to replace it.",
  "errors.DOCUMENT.DUPLICATE_FILE_IN_TARGET_DOMAIN": "That domain already has a file with this name and size. Remove the copy there first if you want to move this one, or delete this one if it is a duplicate.",
  "errors.DOCUMENT.INVALID_FORMAT": "Document has an invalid format. Please upload a file in one of the accepted formats.",
  "errors.DOCUMENT.SIZE_EXCEEDED": "Document exceeds the maximum allowed file size.",
  "errors.DOCUMENT.STANDARD_DOCUMENT_TAKEN": "Another file is already matched to that standard document. One standard document can have one file, so pick a different match or change the other file first.",
  "errors.DOMAIN.APPLICABILITY_REQUIRED": "Please specify whether this optional domain is applicable or not.",
  "errors.DOMAIN.CANNOT_START": "You can only start the next available domain or reopen a completed domain.",
  "errors.DOMAIN.DOCUMENTS_INVALID_CLASSIFICATION": "Some of your uploaded documents could not be recognized by the system. Please delete them and re-upload the correct documents, or delete them and mark this domain as skipped.",
  "errors.DOMAIN.DOCUMENTS_NOT_ACCEPTED": "This domain does not accept documents. Please remove all uploaded documents.",
  "errors.DOMAIN.DOCUMENTS_REQUIRED": "At least one document is required. Please upload a document or mark the domain as skipped.",
  "errors.DOMAIN.HAS_PENDING_CHANGES": "Current domain has pending changes. Please save or cancel before starting another domain.",
  "errors.DOMAIN.INAPPLICABLE_AND_SKIPPED": "A domain cannot be marked as both inapplicable and skipped at the same time.",
  "errors.DOMAIN.INAPPLICABLE_HAS_DOCUMENTS": "Cannot mark domain as inapplicable while documents are attached. Please remove all documents first.",
  "errors.DOMAIN.NOT_FOUND": "Domain not found or you do not have access to it.",
  "errors.DOMAIN.NOT_IN_PROGRESS": "This action can only be performed on a domain that is currently in progress.",
  "errors.DOMAIN.RELOAD_FAILED": "Failed to reload domain data. Please try again.",
  "errors.DOMAIN.REQUIRED_NOT_INAPPLICABLE": "Required domains cannot be marked as inapplicable. You must either skip or provide the required documents.",
  "errors.DOMAIN.SKIPPED_HAS_DOCUMENTS": "Cannot skip a domain while documents are attached. Please remove all documents before skipping.",
  "errors.DOMAIN.STATUS_TRANSITION_FAILED": "Previous domain cannot be transitioned. Please save or cancel changes before starting a new domain.",
  "errors.DOMAIN.VALIDATION_FAILED": "Domain validation failed. Please check the domain requirements.",
  "errors.FRAMEWORK.NOT_FOUND": "Framework not found.",
  "errors.FRAMEWORK.NO_DOMAINS": "This framework has no domains configured.",
  "fileUpload.ariaLabel.cancelDeletion": "Cancel deletion of {{fileName}}",
  "fileUpload.ariaLabel.cancelUpload": "Cancel upload of {{fileName}}",
  "fileUpload.ariaLabel.delete": "Delete {{fileName}}",
  "fileUpload.ariaLabel.deleting": "Deleting {{fileName}}",
  "fileUpload.ariaLabel.file": "File {{fileName}}",
  "fileUpload.ariaLabel.fileDropZone": "File drop zone",
  "fileUpload.ariaLabel.fileInput": "File input",
  "fileUpload.ariaLabel.preparing": "Preparing",
  "fileUpload.ariaLabel.removeFailedUpload": "Remove failed upload {{fileName}}",
  "fileUpload.ariaLabel.retryDeletion": "Retry deletion of {{fileName}}",
  "fileUpload.ariaLabel.retryUpload": "Retry upload of {{fileName}}",
  "fileUpload.ariaLabel.undoDeletion": "Undo deletion of {{fileName}}",
  "fileUpload.ariaLabel.uploaded": "Uploaded",
  "fileUpload.dragDrop.dropHere": "Drop files here",
  "fileUpload.dragDrop.text": "Drag & drop files here or browse file",
  "fileUpload.errors.fileDuplicateFound": 'File "{{fileName}}" already uploaded',
  "fileUpload.errors.fileSizeExceeded": 'File "{{fileName}}" exceeds the maximum size limit of {{maxSize}}MB',
  "fileUpload.errors.fileTypeNotAllowed": 'File type "{{fileExtension}}" is not allowed. Supported formats: {{allowedTypes}}',
  "fileUpload.errors.maxFilesExceeded": "Maximum number of files ({{maxFiles}}) reached. Please remove a file before uploading more.",
  "fileUpload.errors.maxFilesExceededPerDomain": "it is excessded the limit of the number of file per domain",
  "fileUpload.errors.uploadFailed": "Upload failed",
  "fileUpload.messages.fileRemoved": 'File "{{fileName}}" removed',
  "fileUpload.messages.fileUploaded": 'File "{{fileName}}" uploaded',
  "fileUpload.messages.uploadCancelled": 'Upload cancelled for "{{fileName}}"',
  "fileUpload.status.deleteFailed": "Delete Failed",
  "fileUpload.status.deleted": "Removed",
  "fileUpload.status.deleting": "Deleting...",
  "fileUpload.status.failed": "Failed",
  "fileUpload.status.notSaved": "Not Saved",
  "fileUpload.status.pendingDelete": "Deleting",
  "fileUpload.status.queued": "Preparing",
  "fileUpload.status.uploaded": "Uploaded",
  "fileUpload.status.uploading": "Uploading",
  "fileUpload.supportedFormats": "Supports {{fileTypes}} (max {{maxFileSize}}MB each)",
  "home.title": "Home",
  "search.panel.button.ask": "Ask",
  "search.panel.button.assesments": "Assessments",
  "search.panel.button.documentsRemediation": "Documents Remediation",
  "search.panel.button.organizationHub": "Organization Hub",
  "search.panel.button.newchat": "New Chat",
  "search.panel.search.placeholder": "Search",
  "section.descriptionKey": "Section description",
  "section.titleKey": "Section title",
  "tenant.prerequisites.description": "Help us understand your organization better",
  "tenant.prerequisites.errors.deleteFailed": "Failed to delete document",
  "tenant.prerequisites.errors.documentExists": "Document already exists. Please delete it first to upload a new one.",
  "tenant.prerequisites.errors.uploadFailed": "Upload failed: {{error}}",
  "tenant.prerequisites.info.description": "These documents help us understand your organization's structure, policies, and current compliance posture. This information allows us to provide more accurate recommendations and tailor the assessment to your specific context.",
  "tenant.prerequisites.info.item1": "Enhanced accuracy",
  "tenant.prerequisites.info.item2": "Tailored recommendations",
  "tenant.prerequisites.info.item3": "No impact on score",
  "tenant.prerequisites.info.note": "Note: These documents are different from evidence files and will not contribute to your compliance score. They are stored securely and accessible anytime via Settings → My Documents.",
  "tenant.prerequisites.info.title": "Why do we need these documents?",
  "tenant.prerequisites.progress": "document types uploaded",
  "tenant.prerequisites.skip.benefits.item1": "Contextual recommendations based on your org structure",
  "tenant.prerequisites.skip.benefits.item2": "More accurate gap identification",
  "tenant.prerequisites.skip.benefits.item3": "Tailored compliance roadmap",
  "tenant.prerequisites.skip.benefits.title": "Benefits you'll miss:",
  "tenant.prerequisites.skip.button.skip": "Skip Anyway",
  "tenant.prerequisites.skip.description": "Uploading these documents significantly enhances the accuracy of your assessment results and helps us provide more tailored recommendations for your organization.",
  "tenant.prerequisites.skip.footer": "You can always upload these documents later via Settings → My Documents.",
  "tenant.prerequisites.skip.title": "Skip Prerequisites?",
  "tenant.prerequisites.success.documentDeleted": 'Document "{{fileName}}" deleted successfully',
  "tenant.prerequisites.success.documentUploaded": 'Document "{{fileName}}" uploaded successfully',
  "tenant.prerequisites.title": "Assessment Prerequisites",
  "tenant.prerequisites.upload.cybersecurity.description": "Security protocols, incident response plans, and security frameworks",
  "tenant.prerequisites.upload.cybersecurity.title": "Cybersecurity Policies",
  "tenant.prerequisites.upload.dataManagement.description": "Data retention, classification, and lifecycle management policies",
  "tenant.prerequisites.upload.dataManagement.title": "Data Management Policies",
  "tenant.prerequisites.upload.dpoPlacement.description": "Documentation of Data Protection Officer appointment and responsibilities",
  "tenant.prerequisites.upload.dpoPlacement.title": "DPO Placement Decision",
  "tenant.prerequisites.upload.itPolicy.description": "IT governance, access control, and technology usage policies",
  "tenant.prerequisites.upload.itPolicy.title": "IT Policy",
  "tenant.prerequisites.upload.orgStructure.description": "Org chart, department breakdown, or company structure document",
  "tenant.prerequisites.upload.orgStructure.title": "Organization Structure",
  "testing.button.default": "Default (EN)",
  "testing.button.error": "Error (AR)",
  "testing.button.info": "Info (EN)",
  "testing.button.success": "Success (AR)",
  "testing.button.warning": "Warning (EN)",
  "testing.message": "Testing",
  "testing.title": "Notification testing",
  "website.aiPowered.badge": "AI-Powered",
  "website.aiPowered.ctaPrimary": "Request a Demo",
  "website.aiPowered.ctaSecondary": "Learn More",
  "website.aiPowered.feature1": "Dedicated support",
  "website.aiPowered.feature2": "Rapid deployment",
  "website.aiPowered.feature3": "Expert support",
  "website.aiPowered.feature4": "No setup fees",
  "website.aiPowered.subtitle": "Join thousands of enterprises who trust Komplyance for their compliance needs. Experience the power of AI-driven regulatory management today.",
  "website.aiPowered.tagline": "Trusted by leading enterprises worldwide",
  "website.aiPowered.title": "Ready to Transform Your Compliance Process?",
  "website.businessImpact.badge": "Business Impact",
  "website.businessImpact.cta": "Get Started Today",
  "website.businessImpact.item1.desc": "Dramatically reduce the time spent on compliance research and documentation. What used to take weeks now takes hours.",
  "website.businessImpact.item1.title": "85% Time Reduction",
  "website.businessImpact.item2.desc": "AI-powered analysis ensures compliance accuracy while reducing human error and oversight risks.",
  "website.businessImpact.item2.title": "99.9% Accuracy Rate",
  "website.businessImpact.item3.desc": "Reduce compliance costs by up to 70% through automated processes and reduced dependency on external consultants.",
  "website.businessImpact.item3.title": "Cost Savings",
  "website.businessImpact.item4.desc": "Access to compliance experts and dedicated support ensures you're never navigating regulations alone.",
  "website.businessImpact.item4.title": "Expert Support",
  "website.businessImpact.title": "Transform Your Compliance Process",
  "website.comingSoon": "Soon",
  "website.contact.demo.step1": "Live Platform Walkthrough",
  "website.contact.demo.step1.desc": "See Komplyance in action with a personalized demo based on your compliance needs and frameworks",
  "website.contact.demo.step2": "AI Remediation Demo",
  "website.contact.demo.step2.desc": "Watch how our AI automatically updates your compliance documents in real-time",
  "website.contact.demo.step3": "Assessment Deep Dive",
  "website.contact.demo.step3.desc": "Experience our bilingual assessment system with maturity level scoring",
  "website.contact.demo.step4": "Custom Implementation Plan",
  "website.contact.demo.step4.desc": "Get a tailored roadmap for implementing Komplyance in your organization",
  "website.contact.demo.subtitle": "From setup to compliance-ready in hours, not months",
  "website.contact.demo.title": "What You'll See in Your Demo",
  "website.contact.form.company": "Company Name",
  "website.contact.form.company.required": "Company name is required",
  "website.contact.form.companyIndustry": "Company Industry",
  "website.contact.form.companyIndustry.required": "Company industry is required",
  "website.contact.form.companyIndustryEducation": "Education",
  "website.contact.form.companyIndustryFinance": "Finance",
  "website.contact.form.companyIndustryGovernment": "Government",
  "website.contact.form.companyIndustryHealthcare": "Healthcare",
  "website.contact.form.companyIndustryOther": "Other",
  "website.contact.form.companyIndustryPlaceholder": "Select company industry",
  "website.contact.form.companyIndustryTechnology": "Technology",
  "website.contact.form.companyPlaceholder": "Acme Corporation",
  "website.contact.form.companySize": "Company Size",
  "website.contact.form.companySizePlaceholder": "Enter company size",
  "website.contact.form.email": "Work Email",
  "website.contact.form.email.invalid": "Invalid email address",
  "website.contact.form.email.required": "Work email is required",
  "website.contact.form.emailPlaceholder": "Enter your work email address",
  "website.contact.form.errorFallback": "Something went wrong. Please try again.",
  "website.contact.form.fullName": "Full Name",
  "website.contact.form.fullName.required": "Full name is required",
  "website.contact.form.fullNamePlaceholder": "Enter full name",
  "website.contact.form.goals": "What are you looking to achieve?",
  "website.contact.form.goalsPlaceholder": "Tell us about your compliance goals and challenges...",
  "website.contact.form.jobTitle": "Job Title",
  "website.contact.form.jobTitlePlaceholder": "e.g., Compliance Officer, Privacy Lead, Legal Counsel",
  "website.contact.form.phone": "Phone",
  "website.contact.form.phonePlaceholder": "+1 (555) 123-4567",
  "website.contact.form.privacy": "By submitting this form, you agree to our",
  "website.contact.form.privacyNote": "We'll use your information to contact you about our products and services. You can unsubscribe at any time.",
  "website.contact.form.privacyPolicy": "Privacy Policy.",
  "website.contact.form.responseTime": "We're excited to show you what we've built. Expect to hear from us within 2 business days.",
  "website.contact.form.submit": "Request Demo",
  "website.contact.form.submitting": "Submitting...",
  "website.contact.subtitle": "See how Komplyance can streamline your compliance journey in just 30 minutes",
  "website.contact.success.title": "Thank you!",
  "website.contact.title": "Request Your Personalized Demo",
  "website.contactUs.ctaA11y": "Go to contact",
  "website.contactUs.subtitle": "We'd love to hear it! We'll add it to this FAQ to help others find the information they need.",
  "website.contactUs.title": "Have Some <br/>Questions For Us?",
  "website.cta.primary": "Request a Demo",
  "website.cta.secondary": "Learn More",
  "website.cta.subtitle": "Join 100+ organizations already using Komplyance to achieve compliance faster.",
  "website.cta.title": "Ready to streamline your compliance journey?",
  "website.features.badge": "Platform Features",
  "website.features.item1.badge": "99% Accuracy",
  "website.features.item1.desc": "Advanced machine learning algorithms analyze regulations and provide contextual, accurate answers with complete source references.",
  "website.features.item1.title": "AI-Powered Intelligence",
  "website.features.item2.badge": "Save 100+ hours",
  "website.features.item2.desc": "Comprehensive maturity assessments that automatically review your documents and identify compliance gaps.",
  "website.features.item2.title": "Automated Assessments",
  "website.features.item3.badge": "AI-Powered",
  "website.features.item3.desc": "Intelligent document generation and editing that ensures compliance across multiple regulatory frameworks.",
  "website.features.item3.title": "Smart Document Creation",
  "website.features.item4.badge": "50+ Frameworks",
  "website.features.item4.badge2": "Coming Soon",
  "website.features.item4.desc": "Support for multiple compliance frameworks in one platform, with more frameworks coming soon.",
  "website.features.item4.title": "Multi-Framework Support",
  "website.features.item5.desc": "Generate audit-ready reports with maturity scoring and actionable roadmaps.",
  "website.features.item5.title": "Detailed Reports",
  "website.features.item6.desc": "Bank-grade security with role-based access control and full audit trails.",
  "website.features.item6.title": "Enterprise Security",
  "website.features.subtitle": "From setup to compliance-ready in hours, not months",
  "website.features.tagline1": "See AI document remediation in action",
  "website.features.tagline2": "Explore the compliance dashboard",
  "website.features.tagline3": "Discover automated assessment workflows",
  "website.features.title": "Why Choose Komplyance?",
  "website.footer.contact": "Questions? Email us at",
  "website.footer.copyright": "© 2026 Komplyance. All rights reserved.",
  "website.footer.or": "or call",
  "website.footer.privacy": "Privacy Policy",
  "website.footer.sitemap": "Sitemap",
  "website.footer.terms": "Terms",
  "website.footerNav.cta": "Schedule a Call",
  "website.footerNav.description": "Komplyance is your one-stop compliance platform, helping enterprises navigate complex regulations with AI-powered assistance, automated assessments, and expert support.",
  "website.footerNav.general.aboutUs": "About Us",
  "website.footerNav.general.faqs": "FAQs",
  "website.footerNav.general.home": "Home",
  "website.footerNav.general.platformFeatures": "Platform Features",
  "website.footerNav.general.privacyPolicy": "Privacy Policy",
  "website.footerNav.general.services": "Services",
  "website.footerNav.resources.caseStudies": "Case Studies",
  "website.footerNav.resources.documentation": "Documentation",
  "website.footerNav.resources.title": "Resources",
  "website.footerNav.resources.webinars": "Webinars",
  "website.footerNav.support.callUs": "Call us:",
  "website.footerNav.support.email": "info@komplyance.ai",
  "website.footerNav.support.phone": "+966564332837",
  "website.footerNav.support.title": "Support",
  "website.hero.badge": "AI-Powered Compliance Platform",
  "website.hero.cta.primary": "Request a Demo",
  "website.hero.cta.secondary": "See How It Works",
  "website.hero.subtitle": "Komplyance helps organizations achieve and maintain regulatory compliance with AI-driven assessments, automated document review, and real-time compliance monitoring.",
  "website.hero.taglineLeft": "Simplify Compliance",
  "website.hero.taglineRight": "AI-Powered Compliance Platform",
  "website.hero.title": "Enterprise Compliance Made Simple",
  "website.hero.trustedBy": "Trusted by leading organizations",
  "website.howItWorks.badge": "How It Works",
  "website.howItWorks.step1.desc": "Ask questions about any regulation and get instant, accurate answers with AI-powered intelligence",
  "website.howItWorks.step1.title": "Chat with Regulations",
  "website.howItWorks.step2.desc": "Our AI analyzes your compliance posture across all frameworks",
  "website.howItWorks.step2.title": "AI Assessment",
  "website.howItWorks.step3.desc": "AI updates documents and fills gaps automatically",
  "website.howItWorks.step3.title": "Auto-Remediation",
  "website.howItWorks.step4.desc": "Automated compliance workflows that adapt to regulatory changes",
  "website.howItWorks.step4.title": "AI Workflow Automation",
  "website.howItWorks.subtitle": "From setup to compliance-ready in hours, not months",
  "website.howItWorks.title": "Get Compliant in 4 Easy Steps",
  "website.industry.badge": "Industry Solutions",
  "website.industry.item1.desc": "Patient data protection, health data governance, and sector-specific frameworks.",
  "website.industry.item1.title": "Healthcare",
  "website.industry.item2.desc": "PDPL, SAMA, and financial regulatory compliance with audit-ready reporting.",
  "website.industry.item2.title": "Financial Services",
  "website.industry.item3.desc": "Consumer data, consent, and cross-border data flow compliance.",
  "website.industry.item3.title": "Technology",
  "website.industry.item4.desc": "Public sector data governance and regulatory reporting requirements.",
  "website.industry.item4.title": "Government",
  "website.industry.item5.title": "Retail",
  "website.industry.item6.title": "Manufacturing",
  "website.industry.item7.title": "Education",
  "website.industry.item8.title": "Telecommunications",
  "website.industry.subtitle": "Tailored compliance solutions for every sector",
  "website.industry.title": "Built for Your Industry",
  "website.nav.about": "About",
  "website.nav.contact": "Contact",
  "website.nav.demo": "Demo",
  "website.nav.faqs": "FAQs",
  "website.nav.login": "Login",
  "website.nav.requestDemo": "Request Demo",
  "website.nav.services": "Services",
  "website.savingsCalculator.overline": "See how much time and money your organization could save with Komplyance",
  "website.savingsCalculator.stat1.overline": "Average Time Saved",
  "website.savingsCalculator.stat1.unit": "per assessment cycle",
  "website.savingsCalculator.stat1.value": "8 weeks",
  "website.savingsCalculator.stat2.overline": "Average Cost Reduction",
  "website.savingsCalculator.stat2.unit": "annually",
  "website.savingsCalculator.stat2.value": "350k SAR",
  "website.savingsCalculator.stat3.overline": "Faster Compliance",
  "website.savingsCalculator.stat3.unit": "reduction in timeline",
  "website.savingsCalculator.stat3.value": "98%",
  "website.savingsCalculator.title": "Calculate Your <br/>Compliance Savings",
  "website.sections.businessImpact": "Business Impact",
  "website.sections.industrySolutions": "Industry Solutions",
  "website.sections.ourServices": "Our Services",
  "website.sections.platformFeatures": "Platform Features",
  "website.sections.simpleProcess": "Simple Process",
  "website.services.badge": "Our Services",
  "website.services.item1.desc": "Get instant, accurate answers to any regulation-related questions with our AI-powered assistant. Complete with references and detailed explanations.",
  "website.services.item1.title": "AI Regulation Assistant",
  "website.services.item2.desc": "Comprehensive evaluation of your organization's compliance maturity through automated document review and gap analysis.",
  "website.services.item2.title": "Maturity Assessment",
  "website.services.item3.desc": "Automated creation and intelligent editing of compliance documents to ensure your organization meets all regulatory requirements.",
  "website.services.item3.title": "Document Creation & Editing",
  "website.services.item4.desc": "Support for NDMO, NIST, and numerous other regulatory frameworks. Stay compliant across multiple jurisdictions and standards.",
  "website.services.item4.title": "Multi-Framework Support",
  "website.services.item5.desc": "Continuous monitoring of regulatory changes and automatic updates to keep your compliance requirements current.",
  "website.services.item5.title": "Real-time Monitoring",
  "website.services.item6.desc": "Access to compliance experts and dedicated support team to help you navigate complex regulatory landscapes with confidence.",
  "website.services.item6.title": "Expert Support",
  "website.services.learnMore": "Learn More",
  "website.services.subtitle": "From AI-powered regulation queries to complete document management",
  "website.services.title": "Comprehensive Compliance Solutions",
  "website.stats.customers": "Customers",
  "website.stats.fasterCompliance": "Faster Compliance",
  "website.stats.uptime": "Uptime",
  "app.layout.sidebar.organizationProfile": "Organization Hub",
  "app.orgProfile.title": "Organization Profile",
  "app.orgProfile.breadcrumbRoot": "Workspace",
  "app.orgProfile.documentHub": "Document Hub",
  "app.orgProfile.previewProfile": "Preview profile",
  "app.orgProfile.reviewBanner_one": "{{count}} document ready for your review",
  "app.orgProfile.reviewBanner_other": "{{count}} documents ready for your review",
  "app.orgProfile.review": "Review",
  "app.orgProfile.loading": "Loading organization profile…",
  "app.orgProfile.noTemplate": "No active profile template has been set up yet.",
  "app.orgProfile.loadError": "We couldn't load your organization profile. Please try again.",
  "app.orgProfile.hero.title": "Tell Komplyance who you are. The more you share, the more your assessments and remediations are tailored to your business.",
  "app.orgProfile.hero.eyebrow": "Why we ask for this",
  "app.orgProfile.hero.dismiss": "Dismiss",
  "app.orgProfile.hero.card1.title": "Your organization context",
  "app.orgProfile.hero.card1.body": "Eight categories Komplyance AI uses to understand your business — sectors, controls, policies, and people.",
  "app.orgProfile.hero.card2.title": "Tailored, not generic",
  "app.orgProfile.hero.card2.body": "Every assessment and remediation reflects your jurisdictions, sector, and existing controls — never generic boilerplate.",
  "app.orgProfile.hero.card3.title": "Upload or fill manually",
  "app.orgProfile.hero.card3.body": "Drop policies and let our AI extract, or type values straight into each form. You can mix both as you go.",
  "app.orgProfile.summary.completion": "Profile completion",
  "app.orgProfile.summary.categoriesApproved": "{{approved}} of {{total}} categories approved",
  "app.orgProfile.summary.documents": "Documents uploaded",
  "app.orgProfile.summary.viewActivity": "View activity",
  "app.orgProfile.summary.docBreakdown": "{{approved}} approved · {{processing}} processing",
  "app.orgProfile.summary.fieldsFilled": "Fields filled",
  "app.orgProfile.summary.fieldsRemaining": "{{n}} remaining",
  "app.orgProfile.summary.reviewsPending": "Reviews pending",
  "app.orgProfile.summary.reviewAll": "Review all",
  "app.orgProfile.summary.reviewsHint": "Click to open Document Hub",
  "app.orgProfile.upload.title": "Upload anything — we'll route it",
  "app.orgProfile.upload.subtitle": "Drop files anywhere on this page, or click Upload files to browse — Komplyance AI routes each one and extracts it automatically.",
  "app.orgProfile.upload.aiRouted": "AI routed",
  "app.orgProfile.upload.choose": "Choose files",
  "app.orgProfile.upload.drop": "Drop here",
  "app.orgProfile.upload.button": "Upload files",
  "app.orgProfile.upload.dropOverlay": "Drop files anywhere to upload",
  "app.orgProfile.upload.dropOverlayHint": "We'll classify each file and extract it automatically.",
  "app.orgProfile.upload.tray.title": "Uploading {{count}} file(s)",
  "app.orgProfile.upload.extractFailed": "We couldn't start extraction. Please try again.",
  "app.orgProfile.upload.retryFailed": "We couldn't retry classification. Please try again.",
  "app.orgProfile.upload.classification.routedTo": "Routed to {{category}}",
  "app.orgProfile.upload.classification.valid": "Valid source",
  "app.orgProfile.upload.classification.notValidSource": "Not a valid source",
  "app.orgProfile.upload.classification.wontExtract": "Won't be extracted",
  "app.orgProfile.upload.classification.fieldsPopulated_one": "{{count}} profile field populated",
  "app.orgProfile.upload.classification.fieldsPopulated_other": "{{count}} profile fields populated",
  "app.orgProfile.upload.status.classifying": "Classifying…",
  "app.orgProfile.upload.status.notExtracted": "Not extracted",
  "app.orgProfile.upload.status.extracting": "Extracting…",
  "app.orgProfile.upload.status.pendingReview": "Extracted · ready to review",
  "app.orgProfile.upload.status.saved": "Saved",
  "app.orgProfile.upload.status.invalid": "Not a valid source",
  "app.orgProfile.upload.status.failed": "Processing failed",
  "app.orgProfile.upload.uploading": "Uploading {{fileName}}…",
  "app.orgProfile.upload.uploaded": "{{fileName}} uploaded",
  "app.orgProfile.upload.failed": "{{fileName}} failed to upload",
  "app.orgProfile.status.approved": "Approved",
  "app.orgProfile.status.pendingReview": "Pending review",
  "app.orgProfile.status.processing": "Processing",
  "app.orgProfile.status.processingCount": "Processing {{done}}/{{total}}",
  "app.orgProfile.status.required": "Required",
  "app.orgProfile.status.fieldCount": "{{filled}}/{{total}} fields",
  "app.orgProfile.tabs.title": "Categories",
  "app.orgProfile.tabs.scrollPrev": "Previous categories",
  "app.orgProfile.tabs.scrollNext": "More categories",
  "app.orgProfile.panel.fieldsFilled": "{{filled}} / {{total}} fields filled",
  "app.orgProfile.panel.fieldsFilledSuffix": "/ {{total}} fields filled",
  "app.orgProfile.panel.fieldsNeeded": "{{n}} fields needed for tailored {{category}} assessments.",
  "app.orgProfile.panel.fieldCount": "{{n}} fields",
  "app.orgProfile.panel.fieldCountSuffix": "needed for tailored {{category}} assessments.",
  "app.orgProfile.panel.approvedValues": "Approved values",
  "app.orgProfile.panel.editableValues": "Editable values · click to type",
  "app.orgProfile.panel.readOnly": "Viewing {{category}} in read-only · click Edit fields to make changes.",
  "app.orgProfile.panel.editFields": "Edit fields",
  "app.orgProfile.panel.cancel": "Cancel",
  "app.orgProfile.panel.done": "Done",
  "app.orgProfile.panel.saveChanges": "Save changes",
  "app.orgProfile.panel.saving": "Saving…",
  "app.orgProfile.panel.complete": "{{category}} is complete · viewing in read-only",
  "app.orgProfile.panel.completeHint": "{{n}} fields approved · used in every {{category}} assessment from now on.",
  "app.orgProfile.panel.empty": "No data yet — fill the fields below, or upload documents from the page header. Komplyance AI will populate fields automatically as your documents arrive.",
  "app.orgProfile.banner.editing": "Editing {{category}} — changes are validated as you type. Saving mints a new version of this category; the Document Hub's source citations stay linked.",
  "app.orgProfile.banner.savingLocked": 'Saving "{{category}}" — editing is locked for a moment. The Edit fields button will re-enable as soon as the save completes.',
  "app.orgProfile.banner.locked": "This category is being saved right now. Try again in a moment.",
  "app.orgProfile.banner.saveFailed": "Save failed. Please try again.",
  "app.orgProfile.field.required": "Required",
  "app.orgProfile.field.requiredError": "This field is required.",
  "app.orgProfile.field.unsaved": "Unsaved",
  "app.orgProfile.field.highConfidence": "High confidence",
  "app.orgProfile.field.mediumConfidence": "Medium confidence",
  "app.orgProfile.field.lowConfidence": "Low — verify",
  "app.orgProfile.field.editedByYou": "Edited by you",
  "app.orgProfile.field.notFound": "Not found · add manually",
  "app.orgProfile.field.addManually": "Add manually",
  "app.orgProfile.field.help.default": "Enter the information this field asks for. Leave it empty if it doesn't apply to your organisation.",
  "app.orgProfile.field.help.string": "Enter a short piece of text — a name or a title, for example.",
  "app.orgProfile.field.help.textarea": "Enter a longer answer. A few sentences in your own words are enough.",
  "app.orgProfile.field.help.email": "Enter an email address, for example name@company.com.",
  "app.orgProfile.field.help.phone": "Enter a phone number, including the country code.",
  "app.orgProfile.field.help.number": "Enter a number — digits only, without units or symbols.",
  "app.orgProfile.field.help.date": "Pick a date from the calendar.",
  "app.orgProfile.field.help.boolean": "Switch it on for Yes, off for No.",
  "app.orgProfile.field.help.select": "Choose the one option that fits best.",
  "app.orgProfile.field.help.multiSelect": "Choose every option that applies — you can pick more than one.",
  "app.orgProfile.field.help.list": "Add entries one at a time. You can add as many as you need.",
  "app.orgProfile.field.help.table": "Add one row per entry and fill in each column.",
  "app.orgProfile.field.help.reference": "Link the document that backs this up.",
  "app.orgProfile.field.help.file": "Upload the document this field asks for.",
  "app.orgProfile.field.add": "Add",
  "app.orgProfile.field.addRow": "Add row",
  "app.orgProfile.field.noItems": "No items yet · add manually or wait for extraction",
  "app.orgProfile.field.noRows": "No rows yet · the AI will populate this from your documents, or click + Add row below.",
  "app.orgProfile.field.linkArtifact": "Link an artifact",
  "app.orgProfile.field.noArtifact": "No artifact linked",
  "app.orgProfile.field.unlink": "Remove",
  "app.orgProfile.field.removeRow": "Remove row",
  "app.orgProfile.field.removeItem": "Remove",
  "app.orgProfile.field.source": "{{name}} · p.{{page}}",
  "app.orgProfile.field.yes": "Yes",
  "app.orgProfile.field.no": "No",
  "app.orgProfile.field.typeBadge.string": "Single line",
  "app.orgProfile.field.typeBadge.textarea": "Long text",
  "app.orgProfile.field.typeBadge.email": "Email",
  "app.orgProfile.field.typeBadge.phone": "Phone",
  "app.orgProfile.field.typeBadge.number": "Number",
  "app.orgProfile.field.typeBadge.date": "Date",
  "app.orgProfile.field.typeBadge.boolean": "Yes / No",
  "app.orgProfile.field.typeBadge.select": "Select",
  "app.orgProfile.field.typeBadge.list": "List",
  "app.orgProfile.field.typeBadge.table": "Table",
  "app.orgProfile.field.typeBadge.reference": "Reference",
  "app.documentHub.title": "Document Hub",
  "app.documentHub.pagination.summary": "Page {{page}} of {{totalPages}} · {{totalCount}} total",
  "app.documentHub.breadcrumb": "Document Hub",
  "app.documentHub.fileCount_one": "{{count}} file",
  "app.documentHub.fileCount_other": "{{count}} files",
  "app.documentHub.loadError": "We couldn't load your documents. Please try again.",
  "app.documentHub.allCategories": "All categories",
  "app.documentHub.search": "Search files…",
  "app.documentHub.clearCategory": "Clear",
  "app.documentHub.upload.title": "Drop documents anywhere · or pick files",
  "app.documentHub.upload.description": "Komplyance classifies each file, suggests a category and document type, then extracts the structured fields.",
  "app.documentHub.upload.browse": "Browse",
  "app.documentHub.upload.upload": "Upload",
  "app.documentHub.upload.formats": "PDF · DOCX · XLSX up to 10 MB",
  "app.documentHub.empty.title": "No documents yet",
  "app.documentHub.empty.body": "Drop a file above and Komplyance will classify it, suggest a category, then extract structured fields.",
  "app.documentHub.empty.filtered": "No documents found.",
  "app.documentHub.status.all": "All",
  "app.documentHub.status.pendingReview": "Pending review",
  "app.documentHub.status.extracting": "Extracting",
  "app.documentHub.status.done": "Done",
  "app.documentHub.status.failed": "Failed",
  "app.documentHub.status.irrelevant": "Irrelevant",
  "app.documentHub.status.classifying": "Classifying",
  "app.documentHub.status.readyToExtract": "Ready to extract",
  "app.documentHub.strip.pendingReview": "Pending your review",
  "app.documentHub.strip.extracting": "Extracting right now",
  "app.documentHub.strip.done": "Done",
  "app.documentHub.strip.failed": "Failed",
  "app.documentHub.strip.reviewAll": "Review all",
  "app.documentHub.table.document": "Document",
  "app.documentHub.table.category": "Category",
  "app.documentHub.table.status": "Status",
  "app.documentHub.table.progress": "Progress / Detail",
  "app.documentHub.table.uploaded": "Uploaded",
  "app.documentHub.table.actions": "Actions",
  "app.documentHub.table.uncategorized": "Uncategorized",
  "app.documentHub.meta.pages_one": "{{count}} page",
  "app.documentHub.meta.pages_other": "{{count}} pages",
  "app.documentHub.meta.uploaded": "Uploaded {{when}}",
  "app.documentHub.detail.fields": "{{filled}}/{{total}} fields",
  "app.documentHub.detail.lowConf_one": "{{count}} low conf",
  "app.documentHub.detail.lowConf_other": "{{count}} low conf",
  "app.documentHub.detail.classifying": "Classifying document…",
  "app.documentHub.detail.readyToExtract": "Ready to extract",
  "app.documentHub.action.review": "Review",
  "app.documentHub.action.view": "View",
  "app.documentHub.action.extract": "Extract",
  "app.documentHub.action.cancel": "Cancel",
  "app.documentHub.action.retry": "Retry",
  "app.documentHub.action.reRoute": "Re-route",
  "app.documentHub.action.remove": "Remove",
  "app.documentHub.action.deny": "Deny",
  "app.documentHub.action.delete": "Delete",
  "app.documentHub.action.deletePublished": "Saved documents can't be deleted",
  "app.documentHub.toast.extractStarted": "Extraction started",
  "app.documentHub.toast.reRouted": "Re-classifying document…",
  "app.documentHub.toast.retried": "Retrying…",
  "app.documentHub.toast.deleted": "Document removed",
  "app.documentHub.toast.actionFailed": "Something went wrong. Please try again.",
  "app.documentHub.review.breadcrumb": "Review extraction",
  "app.documentHub.review.documentType": "Document type: {{kind}}",
  "app.documentHub.review.sectionTitle": "Extracted fields",
  "app.documentHub.review.sectionSummary": "{{extracted}} of {{total}} extracted · {{empty}} empty",
  "app.documentHub.review.loading": "Loading extraction…",
  "app.documentHub.review.loadError": "We couldn't load this extraction. Please try again.",
  "app.documentHub.review.close": "Close",
  "app.documentHub.review.approveSave": "Approve & save",
  "app.documentHub.review.saving": "Saving…",
  "app.documentHub.review.saved": "Extraction saved to your profile",
  "app.documentHub.review.saveGate_one": "{{count}} low-confidence field still needs review. Edit, resolve, or verify it to enable Approve & save.",
  "app.documentHub.review.saveGate_other": "{{count}} low-confidence fields still need review. Edit, resolve, or verify them to enable Approve & save.",
  "app.documentHub.review.saveConflict": "This category is currently being saved. Try again in a moment.",
  "app.documentHub.review.saveError": "Save failed. Please try again.",
  "app.documentHub.review.readOnlyTitle": "Extraction (saved)",
  "app.documentHub.review.stat.extracted": "Extracted",
  "app.documentHub.review.stat.high": "High",
  "app.documentHub.review.stat.medium": "Medium",
  "app.documentHub.review.stat.low": "Low",
  "app.documentHub.review.stat.empty": "Empty",
  "app.documentHub.review.stat.youEdited": "You edited",
  "app.documentHub.review.stat.needsAttention": "Needs attention",
  "app.documentHub.review.stat.rejected": "Rejected",
  "app.documentHub.review.stat.reviewLink": "Review",
  "app.documentHub.review.filter.allFields": "All fields",
  "app.documentHub.review.filter.needAttention_one": "Show {{count}} need attention",
  "app.documentHub.review.filter.needAttention_other": "Show {{count}} need attention",
  "app.documentHub.review.legend.title": "What these actions mean",
  "app.documentHub.review.legend.reject.label": "Reject",
  "app.documentHub.review.legend.reject.description": "Value not accepted — field stays empty unless you type a replacement.",
  "app.documentHub.review.legend.addManually.label": "Add manually",
  "app.documentHub.review.legend.addManually.description": "Type your own value, or replace the extracted one.",
  "app.documentHub.review.field.verify": "Verify",
  "app.documentHub.review.field.verifiedByYou": "Verified by you",
  "app.documentHub.review.field.youEdited": "You edited",
  "app.documentHub.review.field.aiExtracted": "AI extracted",
  "app.documentHub.review.field.changed": "AI suggested {{value}} · you changed it",
  "app.documentHub.review.field.rowsSummary": "{{count}} rows",
  "app.documentHub.review.field.source": "p.{{page}}: “{{quote}}”",
  "app.documentHub.review.field.noCitation": "No citation found",
  "app.documentHub.review.field.needsReview": "Needs review",
  "app.documentHub.review.field.empty": "(empty)",
  "app.documentHub.review.field.notExtracted": "Not extracted",
  "app.documentHub.review.field.reject": "Reject",
  "app.documentHub.review.field.nothingToReject": "Nothing to reject — this field wasn't extracted.",
  "app.documentHub.review.field.restore": "Restore",
  "app.documentHub.review.field.rejected": "Rejected",
  "app.documentHub.review.validation.maxLength": "Must be {{max}} characters or fewer.",
  "app.documentHub.review.validation.minLength": "Must be at least {{min}} characters.",
  "app.documentHub.review.validation.pattern": "Invalid format.",
  "app.documentHub.review.validation.email": "Enter a valid email address.",
  "app.documentHub.review.validation.number": "Enter a valid number.",
  "app.documentHub.review.validation.integer": "Must be a whole number.",
  "app.documentHub.review.validation.min": "Must be {{min}} or more.",
  "app.documentHub.review.validation.max": "Must be {{max}} or less.",
  "app.documentHub.review.validation.maxItems": "Select {{max}} or fewer.",
  "app.documentHub.review.validation.sourceRequired": "A source (URL or note) is required.",
  "app.documentHub.review.validation.requiredCell": "This field is required.",
  "app.documentHub.review.validation.cell": "Row {{row}} · {{column}}: {{message}}",
  "app.documentHub.review.validationGate": "Fix the highlighted fields before saving.",
  "app.documentHub.classif.confidence.high": "High confidence",
  "app.documentHub.classif.confidence.medium": "Medium confidence",
  "app.documentHub.classif.confidence.low": "Low confidence",
  "app.orgProfile.inFlight.title_one": "{{count}} document in progress",
  "app.orgProfile.inFlight.title_other": "{{count}} documents in progress",
  "app.orgProfile.inFlight.classifying": "Classifying…",
  "app.orgProfile.inFlight.extracting": "Extracting…",
  "app.orgProfile.inFlight.queued": "Queued",
  "app.orgProfile.inFlight.readyToExtract": "Ready to extract",
  "app.orgProfile.inFlight.extracted": "Ready to review",
  "app.orgProfile.inFlight.viewAll": "View all documents",
  "app.orgProfile.inFlight.irrelevant": "Not relevant",
  "app.orgProfile.inFlight.remove": "Remove document",
  "app.orgProfile.inFlight.removeFailed": "Could not remove the document — try again",
  "app.orgProfile.inFlight.new": "New",
  "app.orgProfile.inFlight.reviewHint": "Click to review",
  "app.orgProfile.inFlight.extract": "Extract",
  "app.orgProfile.inFlight.extractAll": "Extract all ({{count}})",
  "app.orgProfile.inFlight.viewDocuments": "View documents",
  "app.orgProfile.inFlight.extractionProgress": "{{done}} of {{total}} extracted",
  "app.orgProfile.inFlight.extractionInProgress": "Extraction in progress",
  "app.orgProfile.field.uploadDocument": "Upload document",
  "app.orgProfile.field.uploading": "Uploading…",
  "app.orgProfile.field.uploadFailed": "Upload failed — try again",
  "app.orgProfile.field.changeDoc": "Change document",
  "app.orgProfile.field.addAnotherDoc": "Add another document",
  "app.orgProfile.field.pendingSave": "Pending save",
  "app.orgProfile.field.confirmed": "Saved",
  "app.orgProfile.field.discard": "Discard",
  "app.orgProfile.field.discardFailed": "Could not discard — try again",
  "app.orgProfile.field.fileTooLarge": "File exceeds the {{maxMb}} MB limit",
  "app.orgProfile.field.fileTypeNotAllowed": "File type not allowed. Accepted: {{formats}}",
  "app.orgProfile.field.maxFilesReached": "Maximum {{count}} file(s) allowed for this field",
  "app.orgProfile.field.maxFileSize": "Max {{maxMb}} MB",
  "app.orgProfile.field.acceptedFormats": "Accepted: {{formats}}",
  "app.orgProfile.field.noReference": "No reference added",
  "app.orgProfile.field.referenceText": "Reference text",
  "app.orgProfile.field.sourceUrl": "Source URL",
  "app.orgProfile.field.sourceNote": "Source note",
  "app.orgProfile.field.sourceOptional": "Source (optional)",
  "app.orgProfile.field.sourceRequiredLabel": "Source (required)",
  "app.layout.header.organizationHub": "Organization Profile",
  "app.orgProfile.nudge.badge.tooltip": "Organization Profile is {{percent}}% complete",
  "app.orgProfile.nudge.badge.completeTooltip": "Organization Profile is complete",
  "app.orgProfile.nudge.banner.title": "Organization Profile is {{percent}}% complete.",
  "app.orgProfile.nudge.banner.body": "Complete it to improve AI assessment accuracy across all domains.",
  "app.orgProfile.nudge.banner.cta": "Complete Profile",
  "app.orgProfile.nudge.modal.title": "Your Organization Profile is empty",
  "app.orgProfile.nudge.modal.body": "Filling it in helps the AI understand your context and deliver significantly more accurate compliance gap assessments.",
  "app.orgProfile.nudge.modal.subBody": "Fields like legal entity name, DPO contact, and data categories are referenced across every assessment domain.",
  "app.orgProfile.nudge.modal.complete": "Take me to Organization Hub",
  "app.orgProfile.nudge.modal.skip": "Skip for now",
  "app.orgProfile.nudge.modal.skippedWarning": "Assessment accuracy may be reduced without your Organization Profile. You can complete it anytime in the Organization Hub.",
  "app.orgProfile.nudge.tooltip.greeting": "Welcome back!",
  "app.orgProfile.nudge.tooltip.body": "Your Organization Profile is {{percent}}% complete. Filling it out gives the AI the context to generate more accurate assessments.",
  "app.orgProfile.nudge.tooltip.complete": "Complete Profile",
  "app.orgProfile.nudge.tooltip.later": "Later",
  "app.orgProfile.nudge.domain.missingTitle": "Missing organization fields for this domain ({{missing}})",
  "app.orgProfile.nudge.domain.completeTitle": "Organization profile complete for this domain",
  "app.orgProfile.nudge.domain.cta": "Fill in Organization Hub",
  "app.orgProfile.nudge.domain.showMore": "Show {{hidden}} more",
  "app.orgProfile.nudge.domain.showLess": "Show less",
  "app.admin.badge": "ADMIN",
  "app.admin.panelTitle": "System Admin Panel",
  "app.admin.queue.healthy": "Queue: Healthy",
  "app.admin.queue.degraded": "Queue: Degraded",
  "app.admin.signOut": "Log out",
  "app.admin.role.platformAdmin": "Platform Admin",
  "app.admin.elevated.title": "Elevated session",
  "app.admin.elevated.body": "Tenant isolation middleware bypassed.",
  "app.admin.nav.platform": "PLATFORM",
  "app.admin.nav.dashboard": "Dashboard",
  "app.admin.nav.organizations": "Organizations",
  "app.admin.nav.users": "Users",
  "app.admin.nav.demoRequests": "Demo requests",
  "app.admin.nav.features": "Features",
  "app.admin.nav.adminPanel": "Admin panel",
  "app.admin.nav.backToApp": "Back to app",
  "app.admin.demo.title": "Demo requests",
  "app.admin.demo.subtitle": "People who requested a demo of the platform.",
  "app.admin.demo.empty": "No demo requests found",
  "app.admin.demo.error": "Couldn't load demo requests. Please try again.",
  "app.admin.demo.filter.all": "All time",
  "app.admin.demo.filter.day": "Last 24 hours",
  "app.admin.demo.filter.week": "Last 7 days",
  "app.admin.demo.filter.month": "Last 30 days",
  "app.admin.demo.table.requester": "Requester",
  "app.admin.demo.table.email": "Work email",
  "app.admin.demo.table.company": "Company",
  "app.admin.demo.table.jobTitle": "Job title",
  "app.admin.demo.table.requested": "Requested",
  "app.admin.demo.detail.title": "Demo request",
  "app.admin.demo.field.companySize": "Company size",
  "app.admin.demo.field.industry": "Industry",
  "app.admin.demo.field.phone": "Phone",
  "app.admin.demo.field.message": "Message",
  "app.admin.features.title": "Feature flags",
  "app.admin.features.subtitle": "Turn a feature on or off in this environment, with optional per-organization overrides.",
  "app.admin.features.globalDescription": "Environment-wide default. Every tenant without an override follows this.",
  "app.admin.features.on": "On",
  "app.admin.features.off": "Off",
  "app.admin.features.overridesTitle": "ORGANIZATION OVERRIDES",
  "app.admin.features.noOverrides": "No organization overrides — every tenant follows the default above.",
  "app.admin.features.forceOn": "Force on",
  "app.admin.features.forceOff": "Force off",
  "app.admin.features.forcedOn": "Forced on",
  "app.admin.features.forcedOff": "Forced off",
  "app.admin.features.clearOverride": "Remove override (inherit default)",
  "app.admin.features.loadError": "Couldn't load feature flags. Please try again.",
  "app.admin.features.update.success": "Feature flag updated.",
  "app.admin.features.update.error": "Couldn't update the feature flag. Please try again.",
  "app.admin.features.addOverride.searchPlaceholder": "Search organizations…",
  "app.admin.features.addOverride.action": "Add override",
  "app.admin.features.flags.remediation": "AI document remediation",
  "app.admin.features.tenantTab.inherit": "Inherit",
  "app.admin.features.tenantTab.inheritsFrom": "Inherits the environment default ({{state}}) unless overridden here.",
  "app.admin.status.active": "Active",
  "app.admin.status.processing": "Processing",
  "app.admin.status.provisioning": "Provisioning",
  "app.admin.status.suspended": "Suspended",
  "app.admin.status.failed": "Failed",
  "app.admin.status.draft": "Draft",
  "app.admin.status.submitted": "Submitted",
  "app.admin.status.completed": "Completed",
  "app.admin.status.valid": "Valid",
  "app.admin.status.invalid": "Invalid",
  "app.admin.status.unknown": "Unknown",
  "app.admin.confidence.high": "High",
  "app.admin.confidence.medium": "Medium",
  "app.admin.confidence.low": "Low",
  "app.admin.dashboard.title": "Operations overview",
  "app.admin.dashboard.subtitle": "Provisioning, AI resource allocation and pipeline health across every tenant.",
  "app.admin.dashboard.stats.activeOrgs": "Active organizations",
  "app.admin.dashboard.stats.activeOrgsSub": "of {{n}} provisioned tenants",
  "app.admin.dashboard.stats.users": "Users provisioned",
  "app.admin.dashboard.stats.usersSub": "across all tenant realms",
  "app.admin.dashboard.stats.inFlight": "Pipelines in flight",
  "app.admin.dashboard.stats.inFlightSub": "{{n}} more queued",
  "app.admin.dashboard.stats.failed": "Failed (24h)",
  "app.admin.dashboard.stats.failedSub": "require admin action",
  "app.admin.dashboard.queue.title": "Global pipeline queue",
  "app.admin.dashboard.queue.subtitle": "Live AI processing across all tenants",
  "app.admin.dashboard.queue.processing": "Processing",
  "app.admin.dashboard.queue.queued": "Queued",
  "app.admin.dashboard.queue.completedToday": "Completed today",
  "app.admin.dashboard.queue.failed": "Failed",
  "app.admin.dashboard.queue.inFlightRuns": "IN-FLIGHT RUNS",
  "app.admin.dashboard.queue.empty": "No pipelines currently in flight",
  "app.admin.dashboard.queue.documents": "{{n}} documents",
  "app.admin.dashboard.incidents.title": "Needs intervention",
  "app.admin.dashboard.incidents.subtitle": "Failed or stalled pipelines",
  "app.admin.dashboard.incidents.open": "{{n}} open",
  "app.admin.dashboard.incidents.empty": "No incidents — all pipelines healthy",
  "app.admin.dashboard.incidents.openOrg": "Open org",
  "app.admin.orgs.title": "Organizations control hub",
  "app.admin.orgs.subtitle": "Every provisioned tenant. Select a row to drill into its profile, users, assessments and documents.",
  "app.admin.orgs.provision": "Provision Organization",
  "app.admin.orgs.search": "Search organizations, tenant IDs…",
  "app.admin.orgs.count": "{{shown}} of {{total}}",
  "app.admin.orgs.table.organization": "Organization",
  "app.admin.orgs.table.tenantId": "Tenant ID",
  "app.admin.orgs.table.sector": "Sector",
  "app.admin.orgs.table.assessments": "Assessments",
  "app.admin.orgs.table.status": "Status",
  "app.admin.orgs.table.created": "Created",
  "app.admin.orgs.empty": "No organizations found",
  "app.admin.detail.back": "Back to organizations",
  "app.admin.detail.membersCount": "{{n}} users",
  "app.admin.detail.assessmentsCount": "{{n}} assessments",
  "app.admin.detail.tabs.profile": "Profile",
  "app.admin.detail.tabs.orgDetails": "Organization Details",
  "app.admin.detail.tabs.compliance": "Compliance Profile",
  "app.admin.detail.tabs.users": "Users",
  "app.admin.detail.tabs.assessments": "Assessments",
  "app.admin.detail.tabs.documents": "Documents",
  "app.admin.detail.tabs.features": "Features",
  "app.admin.detail.compliance.empty": "This organization has no compliance profile categories yet.",
  "app.admin.detail.orgDetails.slug": "Tenant slug",
  "app.admin.detail.orgDetails.slugHint": "The slug is immutable — it identifies the tenant in auth tokens and domains.",
  "app.admin.detail.orgDetails.displayName": "Legal entity name",
  "app.admin.detail.orgDetails.email": "Primary email",
  "app.admin.detail.orgDetails.location": "Location",
  "app.admin.detail.orgDetails.sector": "Industry / sector",
  "app.admin.detail.orgDetails.dpo": "Data Protection Officer (DPO)",
  "app.admin.detail.orgDetails.commercialReg": "Commercial registration",
  "app.admin.detail.orgDetails.edit": "Edit",
  "app.admin.detail.orgDetails.cancel": "Cancel",
  "app.admin.detail.orgDetails.save": "Save changes",
  "app.admin.detail.orgDetails.validation.required": "This field is required",
  "app.admin.detail.orgDetails.createdAt": "Created",
  "app.admin.detail.profile.legalName": "Legal entity name",
  "app.admin.detail.profile.tenantId": "Tenant identifier",
  "app.admin.detail.profile.commercialReg": "Commercial registration",
  "app.admin.detail.profile.sector": "Industry / sector",
  "app.admin.detail.profile.location": "Location",
  "app.admin.detail.profile.dpo": "Data Protection Officer (DPO)",
  "app.admin.detail.profile.contact": "Primary contact",
  "app.admin.detail.profile.members": "Members",
  "app.admin.detail.profile.domains": "Verified domains",
  "app.admin.detail.usersTab.addUser": "Add user",
  "app.admin.detail.usersTab.revoke": "Revoke access",
  "app.admin.detail.usersTab.search": "Search users by name or email…",
  "app.admin.detail.usersTab.empty": "No members in this organization",
  "app.admin.detail.usersTab.noMatches": "No users match your search",
  "app.admin.detail.usersTab.table.user": "User",
  "app.admin.detail.usersTab.table.email": "Email",
  "app.admin.detail.usersTab.table.username": "Username",
  "app.admin.detail.usersTab.table.status": "Status",
  "app.admin.detail.usersTab.table.actions": "Actions",
  "app.admin.detail.usersTab.revoke.success": "Access revoked",
  "app.admin.detail.usersTab.revoke.error": "Failed to revoke access",
  "app.admin.detail.assessTab.table.id": "Assessment",
  "app.admin.detail.assessTab.table.version": "Version",
  "app.admin.detail.assessTab.table.status": "Status",
  "app.admin.detail.assessTab.table.documents": "Documents",
  "app.admin.detail.assessTab.table.completed": "Completed",
  "app.admin.detail.assessTab.table.updated": "Updated",
  "app.admin.detail.assessTab.latest": "latest",
  "app.admin.detail.assessTab.empty": "No assessments for this tenant",
  "app.admin.detail.assessTab.versionsCount": "{{n}} versions",
  "app.admin.detail.assessTab.viewDocuments": "View documents",
  "app.admin.detail.assessTab.documentsDialog.title": "Assessment documents",
  "app.admin.detail.assessTab.documentsDialog.subtitle": "Version {{version}} · attached documents",
  "app.admin.detail.assessTab.documentsDialog.empty": "No documents for this assessment",
  "app.admin.detail.assessTab.documentsDialog.downloadAll": "Download all (ZIP)",
  "app.admin.detail.assessTab.tabs.documents": "Documents",
  "app.admin.detail.assessTab.tabs.results": "Results",
  "app.admin.detail.assessTab.downloadReport": "Download report",
  "app.admin.detail.assessTab.downloadReport.error": "Failed to download the report",
  "app.admin.detail.assessTab.results.unavailable": "Results are not available for this assessment yet.",
  "app.admin.detail.docsTab.download": "Download",
  "app.admin.detail.docsTab.download.error": "Failed to download document",
  "app.admin.detail.docsTab.downloadAll.error": "Failed to download documents",
  "app.admin.detail.docsTab.table.file": "File",
  "app.admin.detail.docsTab.table.source": "Source",
  "app.admin.detail.docsTab.table.classification": "Classification",
  "app.admin.detail.docsTab.table.confidence": "Confidence",
  "app.admin.detail.docsTab.table.size": "Size",
  "app.admin.detail.docsTab.table.actions": "Actions",
  "app.admin.detail.docsTab.empty": "No documents for this tenant",
  "app.admin.detail.docsTab.inspect": "Inspect metadata",
  "app.admin.users.title": "Users administration",
  "app.admin.users.subtitle": "Every user across all tenant realms. Grant or revoke platform-admin, or force a re-authentication.",
  "app.admin.users.search": "Search users by name or email…",
  "app.admin.users.empty": "No users found",
  "app.admin.users.cancel": "Cancel",
  "app.admin.users.table.user": "User",
  "app.admin.users.table.email": "Email",
  "app.admin.users.table.role": "Platform role",
  "app.admin.users.table.status": "Status",
  "app.admin.users.table.created": "Created",
  "app.admin.users.table.actions": "Actions",
  "app.admin.users.platformAdmin": "Platform Admin",
  "app.admin.users.tenantUser": "Tenant user",
  "app.admin.users.grant": "Grant admin",
  "app.admin.users.revoke": "Revoke admin",
  "app.admin.users.logout": "Force logout",
  "app.admin.users.grant.success": "Platform admin granted",
  "app.admin.users.grant.error": "Failed to grant platform admin",
  "app.admin.users.revoke.success": "Platform admin revoked",
  "app.admin.users.revoke.error": "Failed to revoke platform admin",
  "app.admin.users.logout.success": "User sessions cleared",
  "app.admin.users.logout.error": "Failed to force logout",
  "app.admin.users.grantConfirm.title": "Grant platform admin?",
  "app.admin.users.grantConfirm.body": "Give {{name}} full platform-admin access across all tenants?",
  "app.admin.users.revokeConfirm.title": "Revoke platform admin?",
  "app.admin.users.revokeConfirm.body": "Remove platform-admin access from {{name}}?",
  "app.admin.users.logoutConfirm.title": "Force logout?",
  "app.admin.users.logoutConfirm.body": "Invalidate all active sessions for {{name}}? They will need to sign in again.",
  "app.admin.provision.title": "Provision Organization",
  "app.admin.provision.subtitle": "Registers a new tenant and prepares its isolation partition.",
  "app.admin.provision.displayName": "Legal entity name",
  "app.admin.provision.displayNamePlaceholder": "e.g. Dammam Energy Company",
  "app.admin.provision.slug": "Tenant identifier",
  "app.admin.provision.slugPlaceholder": "tenant-id",
  "app.admin.provision.slugHint": "Lowercase letters, numbers and hyphens only.",
  "app.admin.provision.email": "Primary contact email",
  "app.admin.provision.emailPlaceholder": "dpo@company.sa",
  "app.admin.provision.sector": "Industry vertical",
  "app.admin.provision.location": "Location",
  "app.admin.provision.locationPlaceholder": "e.g. Riyadh, Saudi Arabia",
  "app.admin.provision.note": "On submit a transaction registers the tenant, applies the default PDPL catalog template and prepares the secure isolation partition.",
  "app.admin.provision.cancel": "Cancel",
  "app.admin.provision.submit": "Provision tenant",
  "app.admin.provision.success": "Organization provisioned",
  "app.admin.provision.error": "Failed to provision organization",
  "app.admin.provision.validation.required": "This field is required",
  "app.admin.provision.validation.slug": "Use lowercase letters, numbers and hyphens only",
  "app.admin.addUser.title": "Add user",
  "app.admin.addUser.subtitle": "Creates a user mapped to {{tenant}}",
  "app.admin.addUser.firstName": "First name",
  "app.admin.addUser.lastName": "Last name",
  "app.admin.addUser.email": "Email address",
  "app.admin.addUser.emailHint": "An invitation with a set-password link is sent.",
  "app.admin.addUser.role": "Role",
  "app.admin.addUser.roles.Manager": "Manager",
  "app.admin.addUser.roles.Submitter": "Submitter",
  "app.admin.addUser.roles.Viewer": "Viewer",
  "app.admin.addUser.note": "Creates the user and sets their tenant attribute so they can sign in to this organization.",
  "app.admin.addUser.cancel": "Cancel",
  "app.admin.addUser.submit": "Create user",
  "app.admin.addUser.success": "User created",
  "app.admin.addUser.error": "Failed to create user",
  "app.admin.editTenant.title": "Edit organization",
  "app.admin.editTenant.subtitle": "Update {{tenant}}",
  "app.admin.editTenant.slug": "Tenant slug",
  "app.admin.editTenant.slugHint": "The slug is part of the sign-in identity and cannot be changed.",
  "app.admin.editTenant.displayName": "Display name",
  "app.admin.editTenant.email": "Contact email",
  "app.admin.editTenant.sector": "Sector",
  "app.admin.editTenant.dpo": "Data protection officer",
  "app.admin.editTenant.commercialReg": "Commercial registration",
  "app.admin.editTenant.validation.required": "This field is required",
  "app.admin.editTenant.cancel": "Cancel",
  "app.admin.editTenant.submit": "Save changes",
  "app.admin.editTenant.success": "Organization updated",
  "app.admin.editTenant.error": "Failed to update organization",
  "app.admin.editUser.title": "Edit user",
  "app.admin.editUser.subtitle": "Update this user's profile",
  "app.admin.editUser.firstName": "First name",
  "app.admin.editUser.lastName": "Last name",
  "app.admin.editUser.email": "Email address",
  "app.admin.editUser.enabled": "Account enabled",
  "app.admin.editUser.cancel": "Cancel",
  "app.admin.editUser.submit": "Save changes",
  "app.admin.editUser.success": "User updated",
  "app.admin.editUser.error": "Failed to update user",
  "app.admin.setPassword.title": "Set password",
  "app.admin.setPassword.subtitle": "For {{user}}",
  "app.admin.setPassword.password": "New password",
  "app.admin.setPassword.hint": "At least {{n}} characters.",
  "app.admin.setPassword.validation.minLength": "Password must be at least {{n}} characters",
  "app.admin.setPassword.temporary": "Temporary",
  "app.admin.setPassword.temporaryOn": "The user must set a new password at next login.",
  "app.admin.setPassword.temporaryOff": "The password is permanent; the user won't be asked to change it.",
  "app.admin.setPassword.cancel": "Cancel",
  "app.admin.setPassword.submit": "Set password",
  "app.admin.setPassword.success": "Password updated",
  "app.admin.setPassword.error": "Failed to set password",
  "app.admin.metadata.title": "Classification metadata",
  "chat.input.deepResearchLabel": "Deep research",
  "chat.input.deepResearchHint": "Searches the full PDPL corpus and your uploaded evidence. Slower, but cites every source.",
  "chat.input.deepResearchOnNote": "Deep research is on — answers will cite sources",
  "chat.input.deepPlaceholder": "Ask a deeper question…",
  "chat.new.form.deepPlaceholder": "Ask a deeper question about PDPL…",
  "chat.header.rename": "Rename conversation",
  "components.copyButton.copy": "Copy answer",
  "chat.attachment.remove": "Remove attachment",
  "chat.attachment.cancelUpload": "Cancel upload",
  "chat.attachment.clearAll": "Clear all",
  "chat.attachment.moreCount": "+{{count}} more",
  "chat.input.multiDocumentsPlaceholder": "Ask about these {{count}} documents…",
  "chat.new.attachedNote": "Attached documents are analysed with your first question",
  "app.remediation.nav.title": "Remediation",
  "app.remediation.breadcrumb": "Remediation",
  "app.remediation.status.pending": "Queued",
  "app.remediation.status.processing": "Generating",
  "app.remediation.status.ready_for_review": "Ready for review",
  "app.remediation.status.finalizing": "Finalizing",
  "app.remediation.status.completed": "Completed",
  "app.remediation.status.discarded": "Discarded",
  "app.remediation.status.failed": "Failed",
  "app.remediation.itemStatus.pending": "Queued",
  "app.remediation.itemStatus.processing": "In progress",
  "app.remediation.itemStatus.review_pending": "Needs review",
  "app.remediation.itemStatus.accepted": "Accepted",
  "app.remediation.itemStatus.rejected": "Rejected",
  "app.remediation.itemStatus.no_changes": "No changes needed",
  "app.remediation.itemStatus.failed": "Failed",
  "app.remediation.itemType.GENERATE": "New document",
  "app.remediation.itemType.REMEDIATE": "Improved",
  "app.remediation.toast.startFailed": "We couldn't start remediation. Please try again.",
  "app.remediation.toast.started": "Remediation started",
  "app.remediation.toast.reviewFailed": "We couldn't save your decision. Please try again.",
  "app.remediation.toast.finalizeFailed": "We couldn't finalize this run. Please try again.",
  "app.remediation.toast.finalizeStarted": "Finalizing — we are preparing your documents",
  "app.remediation.toast.addFailed": "We couldn't add those documents. Please try again.",
  "app.remediation.toast.resolveFailed": "We couldn't update that document. Please try again.",
  "app.remediation.toast.placeholdersFailed": "We couldn't save those values. Please try again.",
  "app.remediation.toast.added_one": "{{count}} document added to this run",
  "app.remediation.toast.added_other": "{{count}} documents added to this run",
  "app.remediation.toast.addedNone": "Those documents are already in this run",
  "app.remediation.toast.addedExhausted_one": "{{count}} document was added, but this run has had too many attempts. Start a new one to remediate it.",
  "app.remediation.toast.addedExhausted_other": "{{count}} documents were added, but this run has had too many attempts. Start a new one to remediate them.",
  "app.remediation.addDocs.open": "Add documents",
  "app.remediation.cta.title": "Close these gaps with AI",
  "app.remediation.cta.body": "We can draft the {{missing}} missing documents and improve {{weak}} of your uploads, then collect what you accept into a new version for you to submit.",
  "app.remediation.cta.bodyGenerateOnly": "We can draft the {{missing}} missing documents, then collect what you accept into a new version for you to submit.",
  "app.remediation.cta.bodyRemediateOnly": "We can improve {{weak}} of your uploaded documents, then collect what you accept into a new version for you to submit.",
  "app.remediation.cta.legacyTitle": "Remediation requires an updated assessment run",
  "app.remediation.cta.legacyBody": "If you would like to remediate the documents in this assessment, please duplicate it from your assessments list and run it again. This assessment was completed before the remediation feature was released.",
  "app.remediation.cta.legacyAction": "Go to assessments",
  "app.remediation.cta.action": "Review what AI will do",
  "app.remediation.cta.inProgress": "Remediation in progress",
  "app.remediation.cta.inProgressBody": "A remediation run is already working on this assessment.",
  "app.remediation.cta.viewRun": "View progress",
  "app.remediation.scope.selectAll": "Select all",
  "app.remediation.scope.selectNone": "Clear",
  "app.remediation.scope.colDocument": "Document",
  "app.remediation.scope.colDocumentType": "Document type",
  "app.remediation.scope.colScore": "Score",
  "app.remediation.scope.colDomain": "Domain",
  "app.remediation.scope.colFormat": "Format",
  "app.remediation.scope.willBeGenerated": "Will be written by AI",
  "app.remediation.scope.remediateEmptyTitle": "No uploads to improve",
  "app.remediation.scope.remediateEmptyBody": "Every uploaded document in this assessment already scores full maturity.",
  "app.remediation.scope.generateEmptyTitle": "No missing documents",
  "app.remediation.scope.generateEmptyBody": "Every required document for this framework has been uploaded.",
  "app.remediation.scope.footNothing": "Nothing selected",
  "app.remediation.scope.footImprove_one": "{{count}} to improve",
  "app.remediation.scope.footImprove_other": "{{count}} to improve",
  "app.remediation.scope.footCreate_one": "{{count}} to create",
  "app.remediation.scope.footCreate_other": "{{count}} to create",
  "app.remediation.scope.footTime": "Estimated ~{{minutes}} min",
  "app.remediation.scope.cancel": "Cancel",
  "app.remediation.scope.backToAssessment": "Back to assessment",
  "app.remediation.scope.title": "AI document remediation",
  "app.remediation.scope.subtitle": "Review what will be produced before you start. Nothing is changed until you approve it.",
  "app.remediation.scope.generateTitle": "Documents to be created",
  "app.remediation.scope.generateHint": "Required documents that are missing from this assessment.",
  "app.remediation.scope.remediateTitle": "Documents to be improved",
  "app.remediation.scope.remediateHint": "Uploads that scored below full maturity. You review every change before it is applied.",
  "app.remediation.scope.currentScore": "Currently {{score}}%",
  "app.remediation.scope.start": "Start remediation",
  "app.remediation.scope.starting": "Starting…",
  "app.remediation.scope.countSummary": "{{total}} documents · {{missing}} created, {{weak}} improved",
  "app.remediation.scope.empty.title": "Nothing to remediate",
  "app.remediation.scope.empty.body": "This assessment has no missing documents and no uploads scoring below full maturity.",
  "app.remediation.scope.empty.inRunTitle": "Nothing left to add",
  "app.remediation.scope.empty.inRunBody": "Every document this assessment flagged is already part of the run in progress.",
  "app.remediation.scope.activeRun.title": "Remediation already running",
  "app.remediation.scope.activeRun.open": "Open the run",
  "app.remediation.scope.activeRun.bodyAppend": "Anything you pick here joins that run instead of starting a second one.",
  "app.remediation.scope.activeRun.bodyBusy": "It is applying your decisions right now, so it cannot take more documents. Start a new run once it finishes.",
  "app.remediation.scope.addToRun": "Add to the run",
  "app.remediation.scope.adding": "Adding…",
  "app.remediation.scope.profileNote.title": "Your organization profile is {{pct}}% complete",
  "app.remediation.scope.profileNote.body": "{{filled}} of {{total}} fields are filled. The more complete it is, the fewer placeholders the AI leaves for you to fill in.",
  "app.remediation.scope.profileNote.openProfile": "Complete profile",
  "app.remediation.scope.loadError": "We couldn't load the remediation scope.",
  "app.remediation.scope.notEligible": "Remediation is only available for completed assessments.",
  "app.remediation.progress.statDone": "Complete",
  "app.remediation.progress.statProcessing": "Processing",
  "app.remediation.progress.statQueued": "Queued",
  "app.remediation.progress.statFailed": "Failed",
  "app.remediation.progress.documents": "Documents",
  "app.remediation.progress.itemsCount": "{{count}} items",
  "app.remediation.progress.colDocument": "Document",
  "app.remediation.progress.colDomain": "Domain",
  "app.remediation.progress.colStatus": "Status",
  "app.remediation.progress.colProgress": "Progress",
  "app.remediation.progress.pageRange": "{{from}}–{{to}} of {{total}}",
  "app.remediation.progress.leave": "You can leave this page",
  "app.remediation.progress.opRewrite": "Improve",
  "app.remediation.progress.elapsedLabel": "Elapsed",
  "app.remediation.progress.elapsedMinutes": "{{minutes}} min",
  "app.remediation.progress.elapsedHours": "{{hours}}h {{minutes}}m",
  "app.remediation.progress.reviewDocument": "Review",
  "app.remediation.progress.retryDocument": "Try again",
  "app.remediation.progress.removeDocument": "Remove",
  "app.remediation.progress.reviewedDocument": "Reviewed",
  "app.remediation.progress.itemElapsed": "{{minutes}} min on this document",
  "app.remediation.progress.opGenerate": "Generate",
  "app.remediation.progress.retryAll": "Try again",
  "app.remediation.progress.title": "Generating your documents",
  "app.remediation.progress.subtitle": "This usually takes a few minutes. You can leave this page — we will keep working.",
  "app.remediation.progress.finalizingTitle": "Finalizing your documents",
  "app.remediation.progress.finalizingSubtitle": "We are rendering the approved documents into a new assessment version.",
  "app.remediation.progress.doneOf": "{{done}} of {{total}} documents",
  "app.remediation.progress.readyTitle": "Ready for your review",
  "app.remediation.progress.readyBody": "The AI has finished. Review each proposed change before anything is applied.",
  "app.remediation.progress.reviewNow": "Review changes",
  "app.remediation.progress.failedTitle": "Remediation failed",
  "app.remediation.progress.failedBody": "We could not finish this run. No changes were made to your assessment.",
  "app.remediation.progress.someFailed_one": "{{count}} document could not be generated",
  "app.remediation.progress.someFailed_other": "{{count}} documents could not be generated",
  "app.remediation.progress.andMoreFailed_one": "and {{count}} more",
  "app.remediation.progress.andMoreFailed_other": "and {{count}} more",
  "app.remediation.progress.loadError": "We couldn't load this remediation run.",
  "app.remediation.itemError.artifactsUnavailable": "We could not load this document's assessment findings, so there was nothing to work from. Re-run the assessment and try again.",
  "app.remediation.itemError.sourceDownloadFailed": "We could not open the uploaded file. Check that it is still available and try again.",
  "app.remediation.itemError.extractionFailed": "We could not read the contents of this file. It may be scanned, empty or password protected.",
  "app.remediation.itemError.unsupportedFormat": "This file format is not supported for remediation.",
  "app.remediation.itemError.catalogDocumentNotFound": "This document is no longer part of the framework, so it cannot be remediated.",
  "app.remediation.itemError.generationFailed": "The AI could not produce a usable version of this document. You can try again.",
  "app.remediation.itemError.llmUnavailable": "The AI service was unavailable while working on this document. You can try again.",
  "app.remediation.itemError.unknown": "This document could not be remediated. You can try again, or contact support if it keeps happening.",
  "app.remediation.figure.untitled": "Embedded image",
  "app.remediation.figure.fromImage": "From image",
  "app.remediation.sheet.summary": "{{columns}} columns · {{rows}} rows",
  "app.remediation.sheet.noRows": "This workbook defines its columns but has no rows yet.",
  "app.remediation.sheet.truncated": "Showing the first {{shown}} of {{total}} rows.",
  "app.remediation.review.waitingTitle": "The first document is still being written",
  "app.remediation.review.waitingBody": "You can start reviewing as soon as one is finished — this page updates on its own.",
  "app.remediation.review.stillGenerating_one": "{{count}} more document is still being written. You can review the finished ones now; applying changes waits for all of them.",
  "app.remediation.review.stillGenerating_other": "{{count}} more documents are still being written. You can review the finished ones now; applying changes waits for all of them.",
  "app.remediation.review.finalizeWaiting": "Applying changes becomes available once every document has finished.",
  "app.remediation.review.original": "Original",
  "app.remediation.review.proposed": "Proposed by AI",
  "app.remediation.review.changes": "Changes",
  "app.remediation.review.changeLabel": "Change {{n}}",
  "app.remediation.review.prev": "Previous",
  "app.remediation.review.next": "Next",
  "app.remediation.review.filter.all": "All",
  "app.remediation.review.filter.pending": "Pending",
  "app.remediation.review.filter.accepted": "Accepted",
  "app.remediation.review.filter.rejected": "Rejected",
  "app.remediation.review.acceptAll": "Accept all",
  "app.remediation.review.rejectAll": "Reject all",
  "app.remediation.review.acceptAllConfirm": "Accept all {{count}} changes in this document? You can still change individual decisions afterwards.",
  "app.remediation.review.saving": "Saving…",
  "app.remediation.review.saved": "All decisions saved",
  "app.remediation.review.progress": "{{reviewed}} of {{total}} reviewed",
  "app.remediation.review.docPosition": "Document {{index}} of {{total}}",
  "app.remediation.review.pickAChange": "Select a change to review",
  "app.remediation.review.pickAChangeSub": "Click any highlighted change in the document, or pick one from the list below.",
  "app.remediation.review.startReview": "Start with the first change",
  "app.remediation.review.noSourceText": "This document was written from scratch, so there is no earlier version to compare against.",
  "app.remediation.review.saveForLater": "Save for later",
  "app.remediation.review.kbdHint": "Keyboard: A accept · R reject · ↑ ↓ move",
  "app.remediation.review.title": "Review proposed changes",
  "app.remediation.review.subtitle": "Accept or reject each change. Only what you accept is written into the new version.",
  "app.remediation.review.documents": "Documents",
  "app.remediation.review.accept": "Accept",
  "app.remediation.review.reject": "Reject",
  "app.remediation.review.accepted": "Accepted",
  "app.remediation.review.rejected": "Rejected",
  "app.remediation.review.wholeDocumentHint": "This document was written from scratch, so it is accepted or rejected as a whole.",
  "app.remediation.review.generationTitle": "Generated document",
  "app.remediation.review.sourceClauses": "Written against",
  "app.remediation.review.unaddressedClauses_one": "{{count}} clause not covered",
  "app.remediation.review.unaddressedClauses_other": "{{count}} clauses not covered",
  "app.remediation.review.flagsTitle": "Worth a look",
  "app.remediation.review.qualityNote": "Quality check",
  "app.remediation.review.noGenerationDetail": "The AI returned no extra detail for this document.",
  "app.remediation.review.changeCount_one": "{{count}} change",
  "app.remediation.review.changeCount_other": "{{count}} changes",
  "app.remediation.review.decidedCount": "{{decided}} of {{total}} decided",
  "app.remediation.review.noChangesTitle": "No changes proposed",
  "app.remediation.review.stillWriting": "Still being written",
  "app.remediation.review.noChangesBody": "The AI reviewed this document and found nothing to improve.",
  "app.remediation.review.itemFailedTitle": "This document could not be generated",
  "app.remediation.review.before": "Current",
  "app.remediation.review.after": "Proposed",
  "app.remediation.review.change.modification": "Reworded",
  "app.remediation.review.change.addition": "Added",
  "app.remediation.review.change.deletion": "Removed",
  "app.remediation.review.change.column_addition": "Column added",
  "app.remediation.review.change.column_deletion": "Column removed",
  "app.remediation.review.references": "Why this change",
  "app.remediation.review.placeholders": "Needs your input",
  "app.remediation.review.placeholdersHint": "The AI left these blanks because your organization profile does not have the value yet.",
  "app.remediation.review.finalize": "Apply accepted changes",
  "app.remediation.review.finalizeHint": "Creates a new assessment version with the accepted documents.",
  "app.remediation.review.finalizeConfirmTitle": "Create a new version?",
  "app.remediation.review.finalizeConfirmBody_one": "{{count}} accepted document will be added to a new version of this assessment. Anything you rejected is left as it was.",
  "app.remediation.review.finalizeConfirmBody_other": "{{count}} accepted documents will be added to a new version of this assessment. Anything you rejected is left as it was.",
  "app.remediation.review.finalizeConfirmDraft": "The new version opens as a draft, so you can review it and submit it for assessment when you are ready. Creating it cannot be undone.",
  "app.remediation.review.finalizeConfirmCta": "Create new version",
  "app.remediation.review.finalizeBlocked": "You can apply the changes once you have reviewed every document in this remediation.",
  "app.remediation.review.loadError": "We couldn't load the review payload.",
  "app.remediation.review.notReady": "This run is not open for review yet.",
  "app.remediation.review.selectDocument": "Select a document to review",
  "app.remediation.review.reviewPanel": "Review panel",
  "app.remediation.review.pageRange": "{{from}}–{{to}} of {{total}}",
  "app.remediation.final.title": "Your documents are ready",
  "app.remediation.final.body": "We created assessment version {{version}} with the accepted documents. It is a draft — review it and submit it for assessment when you are ready.",
  "app.remediation.final.bodyNoVersion": "We created a new assessment version with the accepted documents. It is a draft — review it and submit it for assessment when you are ready.",
  "app.remediation.final.download": "Download",
  "app.remediation.final.openAssessment": "Open new version",
  "app.remediation.final.remediateMore": "Remediate more documents",
  "app.remediation.final.documents": "Produced documents",
  "app.remediation.final.rejectedNote": "Rejected and unchanged documents were carried over as they were.",
  "app.remediation.final.discardedTitle": "Nothing was applied",
  "app.remediation.final.discardedBody": "You rejected every proposed change, so no new assessment version was created.",
  "app.remediation.final.downloadFailed": "We couldn't prepare that download.",
  "app.remediation.dashboard.viewAll": "View all",
  "app.remediation.dashboard.awaitingReview_one": "{{count}} run is waiting for your review",
  "app.remediation.dashboard.awaitingReview_other": "{{count}} runs are waiting for your review",
  "app.remediation.list.searchPlaceholder": "Search assessments…",
  "app.remediation.list.filterGaps": "Gaps",
  "app.remediation.list.filterAll": "All",
  "app.remediation.list.filterHasGaps": "Has gaps",
  "app.remediation.list.filterCompliant": "Fully compliant",
  "app.remediation.list.sortBy": "Sort by",
  "app.remediation.list.sortRecent": "Most recent",
  "app.remediation.list.sortScore": "Lowest score",
  "app.remediation.list.pagination.summary": "Page {{page}} of {{totalPages}} · {{totalCount}} assessments",
  "app.remediation.list.col.completed": "Completed",
  "app.remediation.list.col.version": "Version",
  "app.remediation.list.col.score": "Score",
  "app.remediation.list.col.gaps": "Gaps",
  "app.remediation.list.docsUnit": "documents",
  "app.remediation.list.view": "View assessment",
  "app.remediation.list.remediate": "Remediate",
  "app.remediation.list.resume": "Resume",
  "app.remediation.list.applyChanges": "Apply changes",
  "app.remediation.list.viewAssessment": "View assessment",
  "app.remediation.list.viewDocuments": "View documents",
  "app.remediation.list.viewSummary": "View summary",
  "app.remediation.list.addDocuments": "Add documents",
  "app.remediation.list.aiBadge": "AI Remediation",
  "app.remediation.list.state.none": "Not yet remediated",
  "app.remediation.list.state.partial": "Partially remediated",
  "app.remediation.list.state.inProgress": "Remediation in progress",
  "app.remediation.list.state.full": "Fully remediated",
  "app.remediation.list.stateFilterAll": "All statuses",
  "app.remediation.list.emptyFirst.title": "Nothing to remediate yet",
  "app.remediation.list.emptyFirst.body": "Complete an assessment or create a copy of an existing one if you want to remediate",
  "app.remediation.list.emptyFirst.cta": "Go to assessments",
  "app.remediation.list.emptyFilter.title": "No assessments match",
  "app.remediation.list.emptyFilter.body": "Try a different search or clear the filters.",
  "app.remediation.list.emptyFilter.cta": "Clear filters",
  "app.remediation.status.notRemediated": "Not remediated",
  "app.remediation.list.title": "Documents Remediation",
  "app.remediation.list.tab.queue": "Needs remediation",
  "app.remediation.placeholders.title": "Fill in what the AI could not",
  "app.remediation.placeholders.subtitle": "The AI left these blanks because it had no value for them. Anything your organization profile has a field for is saved there, so future documents are written with it instead of asking again.",
  "app.remediation.placeholders.noneTitle": "Nothing left blank",
  "app.remediation.placeholders.noneBody": "Every value these documents needed was already in your organization profile.",
  "app.remediation.placeholders.savesToProfile": "Saves to your profile",
  "app.remediation.placeholders.alreadyKnown": "Already in your profile",
  "app.remediation.placeholders.usedIn": "Used in: {{documents}}",
  "app.remediation.placeholders.inputHint": "Type the value",
  "app.remediation.placeholders.skippable_one": "{{count}} blank left here — you can fill it later",
  "app.remediation.placeholders.skippable_other": "{{count}} blanks left here — you can fill them later",
  "app.remediation.placeholders.willStayBlank": "Left blank, the document will read {{token}}",
  "app.remediation.placeholders.inDocuments_one": "in {{count}} document",
  "app.remediation.placeholders.inDocuments_other": "in {{count}} documents",
  "app.remediation.placeholders.documentOnly": "This document only",
  "app.remediation.placeholders.previewLabel": "How it will read",
  "app.remediation.placeholders.noPreview": "This blank is not inside a sentence, so there is nothing to preview.",
  "app.remediation.placeholders.documentPosition": "Document {{index}} of {{total}}",
  "app.remediation.placeholders.nextDocument": "Next document",
  "app.remediation.placeholders.previousDocument": "Previous",
  "app.remediation.placeholders.backToReview": "Back to review",
  "app.remediation.placeholders.readyToSave_one": "{{count}} value ready to save",
  "app.remediation.placeholders.readyToSave_other": "{{count}} values ready to save",
  "app.remediation.placeholders.save": "Save to organization profile",
  "app.remediation.placeholders.saving": "Saving…",
  "app.remediation.placeholders.saved_one": "{{count}} value saved to your organization profile",
  "app.remediation.placeholders.saved_other": "{{count}} values saved to your organization profile",
  "app.remediation.placeholders.continue": "Continue",
  "app.remediation.placeholders.submit": "Submit",
  "app.remediation.placeholders.autosaving": "Saving…",
  "app.remediation.placeholders.autosaved": "All values saved",
  "app.remediation.placeholders.submitting": "Submitting…",
  "app.remediation.placeholders.confirmTitle": "Update your organization profile?",
  "app.remediation.placeholders.confirmBody_one": "This writes {{count}} value into your organization profile, which every future document is generated from:",
  "app.remediation.placeholders.confirmBody_other": "This writes {{count}} values into your organization profile, which every future document is generated from:",
  "app.remediation.placeholders.confirmCta": "Save to profile",
  "app.remediation.placeholders.confirmSkipTitle": "Some blanks will stay as placeholders",
  "app.remediation.placeholders.confirmSkipBody_one": "{{count}} blank has no value. The document will be produced with the placeholder text where a real value should be. You can come back and fill it before you apply the run.",
  "app.remediation.placeholders.confirmSkipBody_other": "{{count}} blanks have no value. Those documents will be produced with the placeholder text where a real value should be. You can come back and fill them before you apply the run.",
  "app.remediation.placeholders.confirmSkipBack": "Go back and fill",
  "app.remediation.placeholders.confirmSkipCta": "Submit anyway",
  "app.remediation.placeholders.warnTitle": "Your next assessment will score lower than it could",
  "app.remediation.placeholders.warnPlaceholders_one": "{{count}} blank is still unfilled — the document keeps the placeholder text instead of a real value.",
  "app.remediation.placeholders.warnPlaceholders_other": "{{count}} blanks are still unfilled — the documents keep the placeholder text instead of real values.",
  "app.remediation.placeholders.warnGaps_one": "{{count}} gap is still open. Remediate it to close it.",
  "app.remediation.placeholders.warnGaps_other": "{{count}} gaps are still open. Remediate them to close them.",
  "app.remediation.placeholders.warnMissingDocuments_one": "{{count}} expected document is still missing. Generate it or upload your own.",
  "app.remediation.placeholders.warnMissingDocuments_other": "{{count}} expected documents are still missing. Generate them or upload your own.",
  "app.remediation.remediated.title": "Remediated assessments",
  "app.remediation.remediated.subtitle": "Assessments the AI has already produced documents for. Open one to read or download what it wrote.",
  "app.remediation.remediated.empty": "No assessment has been remediated yet.",
  "app.remediation.remediated.col.assessment": "Assessment",
  "app.remediation.remediated.col.lastRemediated": "Last remediated",
  "app.remediation.remediated.col.score": "Score",
  "app.remediation.remediated.col.improved": "Improved",
  "app.remediation.remediated.col.created": "Created",
  "app.remediation.remediated.col.documents": "Documents",
  "app.remediation.remediated.versionLabel": "Version {{version}}",
  "app.remediation.remediated.viewDocuments": "View documents",
  "app.remediation.remediated.viewAssessment": "View assessment",
  "app.remediation.produced.title": "Documents from this remediation",
  "app.remediation.produced.loadError": "We couldn't load the documents for this remediation.",
  "app.remediation.produced.empty": "This remediation produced no documents you kept.",
  "app.remediation.produced.untitled": "Untitled document",
  "app.remediation.produced.created": "Created",
  "app.remediation.produced.improved": "Improved",
  "app.remediation.produced.open": "Open",
  "app.remediation.list.subtitle": "Rewrite weak documents and generate missing ones with AI, grounded in your completed assessments.",
  "app.remediation.list.col.assessment": "Assessment",
  "app.remediation.list.col.status": "Remediation status",
  "app.remediation.list.col.documents": "Documents",
  "app.remediation.list.col.started": "Started",
  "app.remediation.list.open": "Open",
  "app.remediation.list.loadError": "We couldn't load your remediation runs.",
  "app.remediation.list.untitledAssessment": "Untitled assessment",
  "app.remediation.list.state.needsReview": "Needs review",
  "app.remediation.list.state.failed": "Remediation failed",
  "app.remediation.list.failedHint": "No changes were applied to your assessment.",
  "app.remediation.list.needsAttention": "Needs my attention ({{count}})",
  "app.remediation.list.tryAgain": "Try again",
  "app.remediation.list.seeWhatFailed": "See what failed",
  "app.remediation.list.outcome.done": "{{count}} applied",
  "app.remediation.list.outcome.running": "{{count}} running",
  "app.remediation.list.outcome.needsReview": "{{count}} to review",
  "app.remediation.list.outcome.noChanges": "{{count}} no change",
  "app.remediation.list.outcome.failed": "{{count}} failed",
  "app.remediation.list.legend.done": "Applied — accepted and written back to the assessment",
  "app.remediation.list.legend.needsReview": "Needs review — produced by AI, waiting on your decision",
  "app.remediation.list.legend.failed": "Failed — could not be produced",
  "app.remediation.list.legend.noChanges": "No change — already at full maturity",
  "app.remediation.list.state.needsReviewCount_one": "{{count}} document needs review",
  "app.remediation.list.state.needsReviewCount_other": "{{count}} documents need review",
  "app.remediation.list.reviewDocuments_one": "Review {{count}} document",
  "app.remediation.list.reviewDocuments_other": "Review {{count}} documents",
  "app.remediation.list.state.reassessing": "Re-assessing",
  "app.remediation.list.reassessingHint": "Your remediated documents are being scored. This assessment comes back here when it finishes.",
  "app.remediation.list.state.assessing": "Assessment running",
  "app.remediation.list.assessingHint": "You can remediate this assessment once it has finished being scored.",
  "app.remediation.list.viewHistory": "History",
  "app.remediation.history.title": "Remediation history",
  "app.remediation.history.empty": "This assessment has not been remediated yet.",
  "app.remediation.history.runLabel": "Run {{number}}",
  "app.remediation.history.openLatest": "Open the most recent run",
  "app.remediation.history.loadRunError": "We couldn't load this run's documents.",
  "app.remediation.history.noDocuments": "This run has no documents.",
  "app.remediation.history.untitledDocument": "Untitled document",
  "app.remediation.history.stat.runs": "Runs",
  "app.remediation.history.stat.applied": "Documents improved",
  "app.remediation.history.stat.documents": "Documents in scope",
  "app.remediation.review.figureFallback": "Figure",
  "app.remediation.summary.title": "Remediation results",
  "app.remediation.summary.subtitle": "What this run produced, and what happens next.",
  "app.remediation.summary.loadError": "We couldn't load this run.",
  "app.remediation.summary.untitledDocument": "Untitled document",
  "app.remediation.summary.stat.accepted": "Accepted",
  "app.remediation.summary.stat.failed": "Failed",
  "app.remediation.summary.stat.outstanding": "Still outstanding",
  "app.remediation.summary.group.accepted": "Accepted — these become the new version",
  "app.remediation.summary.group.rejected": "Rejected — left exactly as they were",
  "app.remediation.summary.group.no_changes": "No changes needed",
  "app.remediation.summary.group.failed": "Failed — you can remediate these again",
  "app.remediation.summary.outstandingTitle": "Some documents are still being worked on",
  "app.remediation.summary.outstandingBody": "The new version takes these documents as they stand, so wait for them to finish or decide them first.",
  "app.remediation.summary.failedTitle": "Some documents could not be produced",
  "app.remediation.summary.failedBody": "You can create the version without them and remediate them later, or go back and try them again first.",
  "app.remediation.summary.blanksTitle": "Some blanks were left unfilled",
  "app.remediation.summary.blanksBody_one": "{{count}} blank has no value, so the document will keep its placeholder text. This is the last point where you can fill it.",
  "app.remediation.summary.blanksBody_other": "{{count}} blanks have no value, so the documents will keep their placeholder text. This is the last point where you can fill them.",
  "app.remediation.summary.blanksCta": "Fill them in",
  "app.remediation.summary.backToReview": "Back to review",
  "app.remediation.summary.keepRemediating": "Remediate more documents",
  "app.remediation.summary.acceptAndVersion": "Accept and create version",
  "app.remediation.summary.confirmTitle": "Create a new version?",
  "app.remediation.summary.confirmDraft": "The new version opens as a draft, so you can review it and submit it for assessment when you are ready. Creating it cannot be undone.",
  "app.remediation.summary.confirmCta": "Create new version",
  "app.remediation.summary.confirmBody_one": "{{count}} accepted document will be added to a new version of this assessment. Anything you rejected is left as it was.",
  "app.remediation.summary.confirmBody_other": "{{count}} accepted documents will be added to a new version of this assessment. Anything you rejected is left as it was.",
  "app.remediation.scope.summary.completedOn": "Completed {{date}}",
  "app.remediation.scope.summary.viewAssessment": "View full assessment",
  "app.remediation.scope.summary.score": "Compliance score",
  "app.remediation.scope.summary.gaps": "Open gaps",
  "app.remediation.scope.summary.missing": "Missing documents",
  "app.remediation.scope.summary.missingHint": "Required but never uploaded",
  "app.remediation.scope.summary.weak": "Weak documents",
  "app.remediation.scope.summary.weakHint": "Uploaded, below full maturity",
  "app.assessment.classification.weak.badge": "Weak match",
  "app.assessment.classification.weak.title": "Weak match — please check this one",
  "app.assessment.classification.weak.description": "We matched this file to the closest expected document, but we are not certain. It is still included in your assessment. If one of the alternatives below fits better, choose it.",
  "app.assessment.classification.incomplete.title": "This document looks incomplete",
  "app.assessment.classification.incomplete.description": "It matched, but a lot of what this document should contain is missing. It is still included and scored — expect it to need substantial work.",
  "app.assessment.classification.incomplete.missingSections": "Missing or empty: {{sections}}",
  "app.assessment.classification.candidates.title": "It could also be one of these",
  "app.assessment.classification.candidates.description": "We classified this file as “{{document}}”, but parts of it belong to the documents below, closest fit first. Pick a different one if it suits better.",
  "app.assessment.classification.candidates.useThis": "Use this instead",
  "app.assessment.classification.candidates.alreadyMatched": "Already used by another document",
  "app.assessment.classification.candidates.confidence.high": "Strong fit",
  "app.assessment.classification.candidates.confidence.medium": "Possible fit",
  "app.assessment.classification.candidates.confidence.low": "Weak fit",
  "app.assessment.classification.candidates.confirmTitle": "Change the matched document?",
  "app.assessment.classification.candidates.confirmMessage": "This file will be matched to “{{to}}” instead of “{{from}}”.",
  "app.assessment.classification.candidates.applySuccess": "Document match updated",
  "app.assessment.classification.candidates.applyError": "Could not change the matched document",
  "app.assessment.classification.matchRow.matched": "Matched",
  "app.assessment.classification.matchRow.noMatch": "No confident match",
  "app.assessment.classification.candidates.hint": "Confirm which document this file provides",
  "app.assessment.classification.candidates.current": "Current",
  "app.assessment.classification.candidates.currentWhy": "What we matched this file to.",
  "app.assessment.classification.candidates.confirm": "Confirm match",
  "app.assessment.classification.whyMatched": "Why it matched",
  "app.assessment.workflow.validation.undecidedClassification": "“{{name}}” and {{count}} other file(s) need you to confirm which document they provide before you can continue.",
  "app.assessment.classification.actionNeeded": "Action needed",
  "fileUpload.section.uploading": "Uploading",
  "fileUpload.section.uploaded": "Uploaded",
  "app.assessment.classification.incomplete.badge": "Incomplete",
  "app.orgProfile.field.phoneError": "Enter a valid phone number, for example +966 50 123 4567.",
  "app.documentHub.review.validation.phone": "Enter a valid phone number, for example +966 50 123 4567.",
  "app.admin.nav.usage": "Usage & cost",
  "app.admin.detail.tabs.usage": "Usage",
  "app.admin.usage.title": "Usage & cost",
  "app.admin.usage.subtitle": "Internal provider cost (COGS) across every organization",
  "app.admin.usage.range.today": "Today",
  "app.admin.usage.range.7d": "Last 7 days",
  "app.admin.usage.range.30d": "Last 30 days",
  "app.admin.usage.range.mtd": "Month to date",
  "app.admin.usage.range.prevMonth": "Previous month",
  "app.admin.usage.range.tzLabel": "Days bucketed in {{tz}}",
  "app.admin.usage.stats.totalCost": "Total cost",
  "app.admin.usage.stats.vsPrev": "{{delta}} vs previous period",
  "app.admin.usage.stats.calls": "AI calls",
  "app.admin.usage.stats.tokensSub": "{{tokens}} tokens",
  "app.admin.usage.stats.tokens": "Tokens",
  "app.admin.usage.stats.tenants": "Organizations",
  "app.admin.usage.stats.tenantsSub": "with usage in this period",
  "app.admin.usage.stats.unpriced": "Unpriced calls",
  "app.admin.usage.stats.unpricedSub": "counted at zero, so true cost is higher",
  "app.admin.usage.trend.title": "Cost over time",
  "app.admin.usage.trend.subtitle": "Daily provider cost",
  "app.admin.usage.trend.empty": "No cost recorded in this period",
  "app.admin.usage.byService.title": "By service",
  "app.admin.usage.byService.subtitle": "Where the money goes",
  "app.admin.usage.byFeature.title": "By feature",
  "app.admin.usage.byFeature.subtitle": "Which product surface drives spend",
  "app.admin.usage.breakdown.calls": "{{calls}} calls",
  "app.admin.usage.breakdown.empty": "Nothing recorded in this period",
  "app.admin.usage.service.llm": "LLM",
  "app.admin.usage.service.embedding": "Embeddings",
  "app.admin.usage.service.rerank": "Rerank",
  "app.admin.usage.service.compute": "Job compute",
  "app.admin.usage.feature.chat": "Chat",
  "app.admin.usage.feature.deep_research": "Deep research",
  "app.admin.usage.feature.assessment": "Assessment",
  "app.admin.usage.feature.document_generation": "Remediation",
  "app.admin.usage.feature.tenant_profile": "Organization profile",
  "app.admin.usage.feature.translation": "Translation",
  "app.admin.usage.feature.platform_tooling": "Platform tooling",
  "app.admin.usage.feature.unknown": "Unattributed",
  "app.admin.usage.topTenants.title": "Top spending organizations",
  "app.admin.usage.topTenants.subtitle": "Ranked by cost in this period",
  "app.admin.usage.topTenants.col.org": "Organization",
  "app.admin.usage.topTenants.col.cost": "Cost",
  "app.admin.usage.topTenants.col.calls": "AI calls",
  "app.admin.usage.topTenants.col.tokens": "Tokens",
  "app.admin.usage.topTenants.empty": "No usage recorded yet",
  "app.admin.usage.topTenants.emptyHint": "Usage events are written by the AI service. If this stays empty after a deploy, instrumentation is not reaching the database.",
  "app.admin.usage.topTenants.error": "Could not load usage data",
  "app.admin.usage.topTenants.summary": "{{total}} organizations",
  "app.admin.usage.tenant.deleted": "Deleted org",
  "app.admin.usage.tenant.unattributedHint": "attribution gap",
  "app.admin.usage.byModel.title": "By model",
  "app.admin.usage.byModel.col.model": "Model",
  "app.admin.usage.byModel.col.calls": "Calls",
  "app.admin.usage.byModel.col.in": "Input",
  "app.admin.usage.byModel.col.out": "Output",
  "app.admin.usage.byModel.col.cost": "Cost",
  "app.admin.usage.byModel.empty": "No model usage in this period",
  "app.admin.usage.byModel.unpricedNote": "{{calls}} unpriced",
  "app.assessment.progress.aiAtWork": "AI at work",
  "app.assessment.progress.elapsed": "Elapsed",
  "app.assessment.progress.lastUpdated": "Last updated",
  "app.assessment.progress.leavePage": "You can leave this page — we keep working",
  "app.assessment.progress.viewReport": "View the report",
  "app.assessment.progress.restart": "Restart this run",
  "app.assessment.progress.back": "Back",
  "app.assessment.progress.hero.early.title": "Reading your documents",
  "app.assessment.progress.hero.early.body": "We are opening each document and pulling out its text. Nothing is assessed yet. A full run usually takes 30 to 45 minutes — you can leave this page and come back.",
  "app.assessment.progress.hero.grading.title": "Assessing your documents against PDPL",
  "app.assessment.progress.hero.grading.body": "Several documents are being assessed at the same time. Each one appears below the moment all of its sections are done. This usually takes 30 to 45 minutes.",
  "app.assessment.progress.hero.done.title": "Assessment complete",
  "app.assessment.progress.hero.done.body": "All {{assessed}} supplied documents were assessed. The report states the weighted maturity score, including the {{missing}} documents that were not supplied.",
  "app.assessment.progress.hero.doneNoMissing.body": "All {{assessed}} supplied documents were assessed. The report states the weighted maturity score.",
  "app.assessment.progress.hero.unknown.title": "This run is not reporting progress",
  "app.assessment.progress.hero.unknown.body": "It was started {{minutes}} minutes ago and is still running. Runs created before progress reporting was added send no updates, so we cannot say how far along it is. The result will appear here as soon as it finishes.",
  "app.assessment.progress.hero.stalled.title": "No update for {{minutes}} minutes",
  "app.assessment.progress.hero.stalled.body": "We counted {{counted}} documents and then stopped hearing from this run. Everything already counted is safe. If it stays quiet, restart it — the run resumes from the last counted document.",
  "app.assessment.progress.hero.queued.title": "Your assessment is queued",
  "app.assessment.progress.hero.queued.body": "We have received it and it will start shortly. A full run usually takes 30 to 45 minutes — you can leave this page and come back.",
  "app.assessment.progress.hero.starting.title": "Starting your assessment",
  "app.assessment.progress.hero.starting.body": "The run has been handed off and is warming up. It reports each document the moment it starts reading it, so this page fills in shortly. A full run usually takes 30 to 45 minutes — you can leave this page and come back.",
  "app.assessment.progress.hero.runFailed.title": "This run did not finish",
  "app.assessment.progress.hero.runFailed.body": "Something went wrong before the assessment could complete. Nothing was scored. You can start it again from the assessment.",
  "app.assessment.progress.stage.intake": "Reading documents",
  "app.assessment.progress.stage.classification": "Matching to requirements",
  "app.assessment.progress.stage.grading": "Assessing compliance",
  "app.assessment.progress.stage.scoring": "Calculating maturity",
  "app.assessment.progress.stage.reporting": "Preparing the report",
  "app.assessment.progress.counted": "Counted complete",
  "app.assessment.progress.inFlight": "In flight",
  "app.assessment.progress.notStarted": "Not started",
  "app.assessment.progress.barNote": "The bar only fills for work we have counted",
  "app.assessment.progress.stageDone": "Done",
  "app.assessment.progress.documentCount": "{{total}} documents",
  "app.assessment.progress.countedOf": "{{done}} of {{total}}",
  "app.assessment.progress.countedInFlight": "{{done}} of {{total}} · {{flight}} in flight",
  "app.assessment.progress.noProgressData": "No progress data",
  "app.assessment.progress.noProgressNote": "This run does not report progress. Nothing is stuck.",
  "app.assessment.progress.startingUp": "Starting up",
  "app.assessment.progress.startingUpNote": "The run has been handed off and has not reported yet. Nothing is stuck.",
  "app.assessment.progress.frozenNote": "The fill below is frozen at the last document we counted. Nothing has been added since.",
  "app.assessment.progress.counter.queued": "Queued",
  "app.assessment.progress.counter.reading": "Reading",
  "app.assessment.progress.counter.grading": "Grading now",
  "app.assessment.progress.counter.assessed": "Assessed",
  "app.assessment.progress.counter.failed": "Failed",
  "app.assessment.progress.documents": "Documents",
  "app.assessment.progress.colDocument": "Document",
  "app.assessment.progress.colStatus": "Status",
  "app.assessment.progress.colProgress": "Progress",
  "app.assessment.progress.colGaps": "Gaps found",
  "app.assessment.progress.gapsFound": "gaps found",
  "app.assessment.progress.lowerBound": "Confident lower bound",
  "app.assessment.progress.state.queued": "Queued",
  "app.assessment.progress.state.reading": "Reading",
  "app.assessment.progress.state.read": "Read",
  "app.assessment.progress.state.classified": "Matched",
  "app.assessment.progress.state.grading": "Grading",
  "app.assessment.progress.state.graded": "Assessed",
  "app.assessment.progress.state.failed": "Failed",
  "app.assessment.progress.state.nodata": "No data",
  "app.assessment.progress.state.lastSeen": "Last seen",
  "app.assessment.progress.note.notStarted": "Not started",
  "app.assessment.progress.note.waitingToMatch": "Waiting to be matched",
  "app.assessment.progress.note.waitingToGrade": "Waiting to be assessed",
  "app.assessment.progress.note.allSectionsDone": "All sections done",
  "app.assessment.progress.note.percentComplete": "{{percent}}% complete",
  "app.assessment.progress.note.lastSeenPercent": "Last seen at {{percent}}%",
  "app.assessment.progress.note.notAssessed": "Assessment not started",
  "app.assessment.progress.note.willRetry": "We will retry it automatically",
  "app.assessment.progress.note.minutesOnDocument": "{{minutes}} min on this document",
  "app.assessment.progress.failure.unreadable": "It may be scanned, empty or password protected",
  "app.assessment.progress.failure.empty": "The document appears to be empty",
  "app.assessment.progress.failure.extraction_failed": "We could not pull text out of this document",
  "app.assessment.progress.failure.grading_failed": "The assessment step did not complete for this document",
  "app.assessment.progress.failure.unknown": "We could not process this document",
  "app.assessment.progress.activity": "Activity",
  "app.assessment.progress.newestFirst": "Newest first",
  "app.assessment.progress.timeline.stageChange": "Stage change",
  "app.assessment.progress.timeline.noActivity": "No activity has been reported for this run",
  "app.assessment.progress.timeline.stageCompleted": "{{stage}} — done",
  "app.assessment.progress.timeline.stageFailed": "{{stage}} — failed",
  "app.assessment.progress.timeline.reading": "Reading {{document}}",
  "app.assessment.progress.timeline.read": "Finished reading {{document}}",
  "app.assessment.progress.timeline.classified": "Matched {{document}} to PDPL requirements",
  "app.assessment.progress.timeline.grading": "Started assessing {{document}}",
  "app.assessment.progress.timeline.graded": "Finished assessing {{document}} — {{met}} of {{total}} requirements met",
  "app.assessment.progress.timeline.gradedPlain": "Finished assessing {{document}}",
  "app.assessment.progress.timeline.failed": "Could not read {{document}}",
  "app.assessment.progress.noScoreTitle": "Why there is no score yet",
  "app.assessment.progress.noScoreBody": "Per-document figures above are gaps found — a plain count of unmet requirements. Maturity is a separate weighted calculation, stated only in the final report, and it also counts documents you have not supplied. The two are not the same number, so no total is shown here.",
  "app.assessment.progress.failedTitle": "{{failed}} documents could not be read",
  "app.assessment.progress.failedBody": "The rest of the run is continuing normally and nothing already assessed is affected.",
  "app.assessment.progress.error.title": "We could not load this run",
  "app.assessment.progress.error.body": "The run is still going. Try again in a moment.",
  "app.assessment.progress.error.retry": "Try again",
  "app.assessment.progress.emptyDocuments": "No documents are attached to this assessment.",
  "app.assessment.progress.list.onCompletion": "On completion",
  "app.admin.features.flags.assessment_progress": "Assessment run progress",
  "app.assessment.progress.list.viewRun": "View progress"
};
H.use(Qa).use(Hn).init({
  resources: {
    en: { translation: zi },
    ar: { translation: Sp }
  },
  fallbackLng: "en",
  debug: process.env.NODE_ENV !== "production",
  keySeparator: !1,
  interpolation: {
    escapeValue: !1
  }
});
const Op = ji(({ children: s }) => /* @__PURE__ */ pt(qn, { i18n: H, children: s })), kp = ji(({ i18nKey: s, ...e }) => {
  const { i18n: a } = Wa();
  return a.language ? /* @__PURE__ */ pt(na, { i18nKey: s, ...e }) : /* @__PURE__ */ pt(na, { i18nKey: s, ...e });
});
function Ep(s) {
  return s in zi;
}
const Tp = () => {
  const [s, e, a] = Wa();
  return {
    t: s,
    i18n: e,
    ready: a
  };
};
export {
  Op as I18nProvider,
  kp as Trans,
  Ep as isTransKey,
  Tp as useTrans
};
